/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './graphql-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql-types';
export type AccountStatementTemplateOutputFieldsFragment = { state: string | null, errorReason: string | null, outputFiles: Array<{ v2Url: string | null }> | null };

export type GenerateAccountStatementOutputFilesMutationVariables = Exact<{
  companyId: string | number;
  contactId: string | number;
  fromDate?: string | null | undefined;
}>;


export type GenerateAccountStatementOutputFilesMutation = { generateAccountStatementOutputFiles: { accountStatement: { id: string | null, templateOutput: { state: string | null, errorReason: string | null, outputFiles: Array<{ v2Url: string | null }> | null } | null } | null } | null };

export type OnAccountStatementStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAccountStatementStateChangeSubscription = { onAccountStatementStateChange: { id: string | null, templateOutput: { state: string | null, errorReason: string | null, outputFiles: Array<{ v2Url: string | null }> | null } | null } };

export type AccountStatementQueryVariables = Exact<{
  id: string | number;
}>;


export type AccountStatementQuery = { accountStatement: { id: string | null, templateOutput: { state: string | null, errorReason: string | null, outputFiles: Array<{ v2Url: string | null }> | null } | null } | null };

export type ExportErrorFieldsFragment = { invoiceId: string, invoiceNumber: string | null, errorMessage: string, errorType: Types.AccountingExportErrorTypeEnum };

export type GenerateAccountingExportMutationVariables = Exact<{
  invoiceIds: Array<string | number> | string | number;
}>;


export type GenerateAccountingExportMutation = { generateAccountingExport: { accountingExport: { id: string } | null } | null };

export type AccountingExportQueryVariables = Exact<{
  id: string | number;
}>;


export type AccountingExportQuery = { accountingExport: { id: string, exportStatus: string, exportedAt: string | null, exportFile: { v2Url: string | null }, exportErrors: Array<{ invoiceId: string, invoiceNumber: string | null, errorMessage: string, errorType: Types.AccountingExportErrorTypeEnum }> | null } | null };

export type OnAccountingExportStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAccountingExportStateChangeSubscription = { onAccountingExportStateChange: { id: string, exportStatus: string, exportedAt: string | null, exportFile: { v2Url: string | null }, exportErrors: Array<{ invoiceId: string, invoiceNumber: string | null, errorMessage: string, errorType: Types.AccountingExportErrorTypeEnum }> | null } };

export type CreateAdditionalFieldMutationVariables = Exact<{
  attributes: Types.CreateAdditionalFieldAttributes;
}>;


export type CreateAdditionalFieldMutation = { createAdditionalField: { additionalField: { id: number | null, companyId: number | null, name: string | null, description: string | null, fieldType: string | null, parameters: string | null, isPackingInstruction: boolean | null, private: boolean | null } | null } | null };

export type DeleteAdditionalFieldMutationVariables = Exact<{
  id: number;
}>;


export type DeleteAdditionalFieldMutation = { deleteAdditionalField: { id: number | null } | null };

export type UpdateAdditionalFieldMutationVariables = Exact<{
  id: number;
  attributes: Types.UpdateAdditionalFieldAttributes;
}>;


export type UpdateAdditionalFieldMutation = { updateAdditionalField: { additionalField: { id: number | null, name: string | null, description: string | null, fieldType: string | null, parameters: string | null, isPackingInstruction: boolean | null, private: boolean | null } | null } | null };

export type AdditionalFieldsQueryVariables = Exact<{
  companyids: Array<number> | number;
}>;


export type AdditionalFieldsQuery = { additionalFields: Array<{ id: number | null, name: string | null, description: string | null, fieldType: string | null, parameters: string | null, isPackingInstruction: boolean | null, private: boolean | null }> | null };

export type NetReturnFieldsQueryVariables = Exact<{
  packingWeek: string;
}>;


export type NetReturnFieldsQuery = { netReturnStandardFields: Array<string> | null, netReturnAdditionalFields: Array<{ companyId: number | null, createdAt: string | null, description: string | null, fieldType: string | null, id: number | null, isPackingInstruction: boolean | null, name: string | null, parameters: string | null, updatedAt: string | null }> | null };

export type GenerateAg1TableOutputFileMutationVariables = Exact<{
  data: any;
  fields: Array<Types.Ag1TableFieldAttribute> | Types.Ag1TableFieldAttribute;
  fileformat: Types.TemplateFileFormatEnum;
  tablename: string;
  filtervalues?: string | null | undefined;
  requestId: string;
}>;


export type GenerateAg1TableOutputFileMutation = { generateAg1TableOutputFile: { requestId: string } | null };

export type OnAg1TableOutputFileCompleteSubscriptionVariables = Exact<{
  requestId: string;
}>;


export type OnAg1TableOutputFileCompleteSubscription = { onAg1TableOutputFileComplete: { requestId: string } };

export type Ag1TableOutputFileResultQueryVariables = Exact<{
  requestId: string;
}>;


export type Ag1TableOutputFileResultQuery = { ag1TableOutputFileResult: { fileUrl: string | null, requestId: string, tableName: string, error: string | null } | null };

export type AirAddendumHeaderByIdQueryVariables = Exact<{
  id: number;
}>;


export type AirAddendumHeaderByIdQuery = { addendumHeaderById: { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, exportCertificateNumber: string | null, exportFromCapeTown: string | null, exportFromDurban: string | null, exportFromMaputo: string | null, exportFromOther: string | null, exportFromPortElizabeth: string | null, exporterAgentDate: string | null, exporterAgentName: string | null, forwardingAgentDate: string | null, forwardingAgentName: string | null, disAgentDate: string | null, disAgentName: string | null, inlandInspectorDate: string | null, inlandInspectorName: string | null, portInspectorDate: string | null, portInspectorName: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, regimeCode: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, printedName: string | null, ppecbCertificateNumber: string | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null, fleshColor: string | null, inspectionManifestNumber: string | null }> | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, palletOut: { id: string | null, addendumHeaderId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null } | null };

export type AddendumsOnAirFreightShipmentQueryVariables = Exact<{
  airFreightShipmentId: number;
}>;


export type AddendumsOnAirFreightShipmentQuery = { addendumsOnAirFreightShipment: Array<{ id: string, loadOutInstructions: Array<{ id: string | null, loadOutReference: string | null, airFreightShipmentLineItem: { externalShipmentId: string, airFreightShipment: { masterWaybillNumber: string | null } | null } | null }> | null }> | null };

export type AirFreightShipmentLoisQueryVariables = Exact<{
  airFreightShipmentId: string | number;
}>;


export type AirFreightShipmentLoisQuery = { airFreightShipmentLois: Array<{ id: string | null, loadOutReference: string | null, airWaybillNo: string | null }> | null };

export type GenerateAirAddendumMutationVariables = Exact<{
  loiIds: Array<string | number> | string | number;
}>;


export type GenerateAirAddendumMutation = { generateAirAddendum: { errors: string | null, addendumHeader: { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, exportCertificateNumber: string | null, exportFromCapeTown: string | null, exportFromDurban: string | null, exportFromMaputo: string | null, exportFromOther: string | null, exportFromPortElizabeth: string | null, exporterAgentDate: string | null, exporterAgentName: string | null, forwardingAgentDate: string | null, forwardingAgentName: string | null, disAgentDate: string | null, disAgentName: string | null, inlandInspectorDate: string | null, inlandInspectorName: string | null, portInspectorDate: string | null, portInspectorName: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, regimeCode: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, printedName: string | null, ppecbCertificateNumber: string | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null, fleshColor: string | null, inspectionManifestNumber: string | null }> | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, palletOut: { id: string | null, addendumHeaderId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null } | null } | null };

export type UpdateAirAddendumMutationVariables = Exact<{
  addendumLineItems: Array<Types.AddendumLineItemAttributes> | Types.AddendumLineItemAttributes;
  addendumHeader: Types.AddendumHeaderAttributes;
}>;


export type UpdateAirAddendumMutation = { updateAirAddendum: { errors: string | null } | null };

export type CancelAirAddendumMutationVariables = Exact<{
  id: number;
}>;


export type CancelAirAddendumMutation = { cancelAirAddendum: { id: number | null, message: string | null } | null };

export type GenerateAddendumHeaderOutputFilesMutationVariables = Exact<{
  addendumHeaderId: string | number;
}>;


export type GenerateAddendumHeaderOutputFilesMutation = { generateAddendumHeaderOutputFiles: { templateOutput: Array<{ errorReason: string | null, id: string | null, state: string | null }> | null } | null };

export type GeneratePalletOutOutputFilesMutationVariables = Exact<{
  addendumHeaderId: string | number;
}>;


export type GeneratePalletOutOutputFilesMutation = { generatePalletOutOutputFiles: { palletOutId: string | null } | null };

export type OnPalletOutOutputStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPalletOutOutputStateChangeSubscription = { onPalletOutOutputStateChange: { id: string | null, addendumHeaderId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } };

export type PalletOutFieldsFragment = { id: string | null, addendumHeaderId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null };

export type AirAddendumHeaderFieldsFragment = { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, exportCertificateNumber: string | null, exportFromCapeTown: string | null, exportFromDurban: string | null, exportFromMaputo: string | null, exportFromOther: string | null, exportFromPortElizabeth: string | null, exporterAgentDate: string | null, exporterAgentName: string | null, forwardingAgentDate: string | null, forwardingAgentName: string | null, disAgentDate: string | null, disAgentName: string | null, inlandInspectorDate: string | null, inlandInspectorName: string | null, portInspectorDate: string | null, portInspectorName: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, regimeCode: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, printedName: string | null, ppecbCertificateNumber: string | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, palletOut: { id: string | null, addendumHeaderId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null };

export type AirAddendumLineItemFieldsFragment = { id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null, fleshColor: string | null, inspectionManifestNumber: string | null };

export type AirFreightShipmentsQueryVariables = Exact<{
  filterAttributes: Types.AirFreightShipmentsFilter;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type AirFreightShipmentsQuery = { airFreightShipments: { totalCount: number, nodes: Array<{ id: string, externalTransportMasterId: string | null, createdAt: string | null, updatedAt: string | null, shipmentType: string | null, carrierName: string | null, flightNumber: string | null, masterWaybillNumber: string | null, shipper: string | null, consignor: string | null, consignee: string | null, portOfLoadingCode: string | null, portOfLoadingLocation: string | null, forwarderName: string | null, departureAirport: string | null, estimatedDepartureTime: string | null, actualDepartureTime: string | null, portOfDestination: string | null, estimatedArrivalTime: string | null, actualArrivalTime: string | null, controller: string | null, userName: string | null, phoneNumber: string | null, state: string | null, billToParty: string | null, exporterCode: string | null, fboCode: string | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type AirFreightShipmentsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type AirFreightShipmentsFilterAttributesQuery = { airFreightShipmentsFilterAttributes: { carrierNames: Array<string> | null, controllers: Array<string> | null, flightNumbers: Array<string> | null, states: Array<string> | null, shippers: Array<string> | null, masterWaybillNumbers: Array<string> | null } | null };

export type AirFreightShipmentLineItemsByShipmentQueryVariables = Exact<{
  id: number;
}>;


export type AirFreightShipmentLineItemsByShipmentQuery = { airFreightShipmentLineItemsByShipment: Array<{ id: string, externalShipmentId: string, orderReference: string | null, bookingReference: string | null, consignee: string | null, consignor: string | null, finalPortOfDischargeCode: string | null, finalPortOfDischargeLocation: string | null, finalDestinationCode: string | null, finalDestinationLocation: string | null, eta: string | null, collectionDate: string | null, isTransshipment: boolean | null, transshipmentCarrierName: string | null, transshipmentFlightNumber: string | null, transshipmentPort: string | null, specialHandling: string | null, comments: string | null, packageType: string | null, packageQuantity: string | null, commodityCode: string | null, goodsDescription: string | null, natureOfGoods: string | null, grossWeight: string | null, volume: string | null, grossDimensions: string | null, housebill: string | null, lastStatusMessage: string | null, state: string | null, airFreightShipment: { id: string } | null }> | null };

export type AirFreightShipmentByIdQueryVariables = Exact<{
  id: number;
}>;


export type AirFreightShipmentByIdQuery = { airFreightShipmentById: { id: string, externalTransportMasterId: string | null, createdAt: string | null, updatedAt: string | null, shipmentType: string | null, carrierName: string | null, flightNumber: string | null, masterWaybillNumber: string | null, shipper: string | null, consignor: string | null, consignee: string | null, portOfLoadingCode: string | null, portOfLoadingLocation: string | null, forwarderName: string | null, departureAirport: string | null, estimatedDepartureTime: string | null, actualDepartureTime: string | null, portOfDestination: string | null, estimatedArrivalTime: string | null, actualArrivalTime: string | null, controller: string | null, userName: string | null, phoneNumber: string | null, state: string | null, billToParty: string | null, exporterCode: string | null, fboCode: string | null, airFreightShipmentLineItems: Array<{ id: string, externalShipmentId: string, orderReference: string | null, bookingReference: string | null, consignee: string | null, consignor: string | null, finalPortOfDischargeCode: string | null, finalPortOfDischargeLocation: string | null, finalDestinationCode: string | null, finalDestinationLocation: string | null, eta: string | null, collectionDate: string | null, isTransshipment: boolean | null, transshipmentCarrierName: string | null, transshipmentFlightNumber: string | null, transshipmentPort: string | null, specialHandling: string | null, comments: string | null, packageType: string | null, packageQuantity: string | null, commodityCode: string | null, goodsDescription: string | null, natureOfGoods: string | null, grossWeight: string | null, volume: string | null, grossDimensions: string | null, housebill: string | null, lastStatusMessage: string | null, state: string | null }> | null } | null };

export type NestedAirFreightShipmentLineItemsQueryVariables = Exact<{
  airFreightShipmentId: string | number;
}>;


export type NestedAirFreightShipmentLineItemsQuery = { nestedAirFreightShipmentLineItems: Array<{ bookingReference: string | null, collectionDate: string | null, comments: string | null, commodityCode: string | null, consignee: string | null, consignor: string | null, eta: string | null, externalShipmentId: string, finalDestinationCode: string | null, finalDestinationLocation: string | null, finalPortOfDischargeCode: string | null, finalPortOfDischargeLocation: string | null, goodsDescription: string | null, grossDimensions: string | null, grossWeight: string | null, housebill: string | null, id: string, isTransshipment: boolean | null, natureOfGoods: string | null, packageQuantity: string | null, packageType: string | null, orderReference: string | null, specialHandling: string | null, transshipmentPort: string | null, transshipmentCarrierName: string | null, transshipmentFlightNumber: string | null, volume: string | null, lastStatusMessage: string | null, state: string | null }> | null };

export type UnallocatedAirFreightShipmentLineItemsQueryVariables = Exact<{
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type UnallocatedAirFreightShipmentLineItemsQuery = { unallocatedAirFreightShipmentLineItems: { totalCount: number, nodes: Array<{ bookingReference: string | null, collectionDate: string | null, comments: string | null, commodityCode: string | null, consignee: string | null, consignor: string | null, createdAt: string, eta: string | null, externalShipmentId: string, finalDestinationCode: string | null, finalDestinationLocation: string | null, finalPortOfDischargeCode: string | null, finalPortOfDischargeLocation: string | null, goodsDescription: string | null, grossDimensions: string | null, grossWeight: string | null, housebill: string | null, id: string, isTransshipment: boolean | null, natureOfGoods: string | null, packageQuantity: string | null, packageType: string | null, orderReference: string | null, specialHandling: string | null, lastStatusMessage: string | null, state: string | null, transshipmentPort: string | null, transshipmentCarrierName: string | null, transshipmentFlightNumber: string | null, updatedAt: string, volume: string | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type EmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeesQuery = { employees: Array<{ id: number | null, userFirstName: string | null, userLastName: string | null }> | null };

export type AirFreightShipmentFieldsFragment = { id: string, externalTransportMasterId: string | null, createdAt: string | null, updatedAt: string | null, shipmentType: string | null, carrierName: string | null, flightNumber: string | null, masterWaybillNumber: string | null, shipper: string | null, consignor: string | null, consignee: string | null, portOfLoadingCode: string | null, portOfLoadingLocation: string | null, forwarderName: string | null, departureAirport: string | null, estimatedDepartureTime: string | null, actualDepartureTime: string | null, portOfDestination: string | null, estimatedArrivalTime: string | null, actualArrivalTime: string | null, controller: string | null, userName: string | null, phoneNumber: string | null, state: string | null, billToParty: string | null, exporterCode: string | null, fboCode: string | null };

export type AirFreightShipmentLineItemFieldsFragment = { id: string, externalShipmentId: string, orderReference: string | null, bookingReference: string | null, consignee: string | null, consignor: string | null, finalPortOfDischargeCode: string | null, finalPortOfDischargeLocation: string | null, finalDestinationCode: string | null, finalDestinationLocation: string | null, eta: string | null, collectionDate: string | null, isTransshipment: boolean | null, transshipmentCarrierName: string | null, transshipmentFlightNumber: string | null, transshipmentPort: string | null, specialHandling: string | null, comments: string | null, packageType: string | null, packageQuantity: string | null, commodityCode: string | null, goodsDescription: string | null, natureOfGoods: string | null, grossWeight: string | null, volume: string | null, grossDimensions: string | null, housebill: string | null, lastStatusMessage: string | null, state: string | null };

export type CompleteAirFreightShipmentMutationVariables = Exact<{
  completeAirFreightShipmentId: number;
}>;


export type CompleteAirFreightShipmentMutation = { completeAirFreightShipment: { errors: string | null } | null };

export type UpdateAirFreightShipmentControllerMutationVariables = Exact<{
  airFreightShipmentId: number;
  controllerId?: number | null | undefined;
  controllerName?: string | null | undefined;
}>;


export type UpdateAirFreightShipmentControllerMutation = { updateAirFreightShipmentController: { errors: string | null } | null };

export type FetchTransnetVisitsByShipmentIdMutationVariables = Exact<{
  shipmentId: string | number;
}>;


export type FetchTransnetVisitsByShipmentIdMutation = { fetchTransnetVisitsByShipment: { visitList: Array<{ arrivalNumber: string | null, vesselName: string | null, port: string | null, vesselCallSign: string | null, imoNumber: string | null, arrivalDate: string | null, departureDate: string | null, voyageNumberIn: string | null, voyageNumberOut: string | null }> | null } | null };

export type FetchTransnetContainerOperatorsMutationVariables = Exact<{ [key: string]: never; }>;


export type FetchTransnetContainerOperatorsMutation = { fetchTransnetContainerOperators: { containerOperators: Array<any> | null } | null };

export type FetchTransnetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchTransnetAccountsQuery = { transnetAccounts: Array<{ id: string, number: string, seaPort: { id: number | null, unLocode: string | null, name: string | null, country: string | null } }> | null };

export type CreateCargoDueMutationVariables = Exact<{
  cargoDueData: any;
  sliIds: Array<string | number> | string | number;
  transnetVisit: any;
}>;


export type CreateCargoDueMutation = { createCargoDue: { errors: Array<string> | null, cargoDue: { id: string, status: string | null } | null } | null };

export type CargoDuesQueryVariables = Exact<{
  filterAttributes: Types.CargoDuesFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type CargoDuesQuery = { cargoDues: { totalCount: number, nodes: Array<{ shipmentId: number | null, clientReference: string | null, shippingLineReference: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, numberOfContainers: number | null, sliContainer: { id: string } | null, cargoDue: { id: string, status: string | null, submissionDate: string | null } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } | null };

export type TransnetTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransnetTerminalsQuery = { transnetTerminals: Array<{ name: string | null, code: string | null, portName: string | null }> | null };

export type CartonCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CartonCountsQuery = { cartonCounts: Array<{ id: number | null, name: string | null, commodityId: number | null, cartonTypeId: number | null, counts: Array<string> | null, priceMetric: string | null, stackSizes: Array<number | null> | null }> | null };

export type BaseCartonGroupingFieldsFragment = { id: number | null, containerNumber: string | null, state: string | null, cartons: number | null, palletNumber: string | null, grade: string | null, batchNumber: string | null, sizeCount: string | null, advancePrice: number | null, finalPrice: number | null, advanceDueDate: string | null, finalDueDate: string | null, lineItem: { currency: string | null, incoterm: string | null, mark: string | null, orderId: number | null, priceMinorUnit: number | null, priceUnit: string | null, referenceNumber: string | null } | null, buyer: { id: number | null, name: string | null } | null, seller: { id: number | null, name: string | null } | null };

export type CartonGroupingFragment = { targetRegion: string | null, targetMarket: string | null, targetCountry: string | null, pack: string | null, palletStack: number | null, packhouseCode: string | null, orchard: string | null, containerNumber: string | null, exporterCode: string | null, farmCode: string | null, packingWeek: string | null, lineItemId: number | null, consignmentNumber: string | null, inventoryCode: string | null, sequenceNumber: number | null, coldStore: string | null, productCharacteristic: string | null, id: number | null, state: string | null, cartons: number | null, palletNumber: string | null, grade: string | null, batchNumber: string | null, sizeCount: string | null, advancePrice: number | null, finalPrice: number | null, advanceDueDate: string | null, finalDueDate: string | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, lineItem: { currency: string | null, incoterm: string | null, mark: string | null, orderId: number | null, priceMinorUnit: number | null, priceUnit: string | null, referenceNumber: string | null } | null, buyer: { id: number | null, name: string | null } | null, seller: { id: number | null, name: string | null } | null };

export type CashFlowCartonGroupingFragment = { targetRegion: string | null, targetMarket: string | null, palletGrossMass: number | null, id: number | null, containerNumber: string | null, state: string | null, cartons: number | null, palletNumber: string | null, grade: string | null, batchNumber: string | null, sizeCount: string | null, advancePrice: number | null, finalPrice: number | null, advanceDueDate: string | null, finalDueDate: string | null, lineItem: { currency: string | null, incoterm: string | null, mark: string | null, orderId: number | null, priceMinorUnit: number | null, priceUnit: string | null, referenceNumber: string | null } | null, buyer: { id: number | null, name: string | null } | null, seller: { id: number | null, name: string | null } | null };

export type CartonGroupingsQueryVariables = Exact<{
  attributes: Types.CartonGroupingSearchAttributes;
}>;


export type CartonGroupingsQuery = { cartonGroupingsSearch: { cartonGroupings: Array<{ targetRegion: string | null, targetMarket: string | null, targetCountry: string | null, pack: string | null, palletStack: number | null, packhouseCode: string | null, orchard: string | null, containerNumber: string | null, exporterCode: string | null, farmCode: string | null, packingWeek: string | null, lineItemId: number | null, consignmentNumber: string | null, inventoryCode: string | null, sequenceNumber: number | null, coldStore: string | null, productCharacteristic: string | null, id: number | null, state: string | null, cartons: number | null, palletNumber: string | null, grade: string | null, batchNumber: string | null, sizeCount: string | null, advancePrice: number | null, finalPrice: number | null, advanceDueDate: string | null, finalDueDate: string | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, lineItem: { currency: string | null, incoterm: string | null, mark: string | null, orderId: number | null, priceMinorUnit: number | null, priceUnit: string | null, referenceNumber: string | null } | null, buyer: { id: number | null, name: string | null } | null, seller: { id: number | null, name: string | null } | null }> } | null };

export type CashFlowCartonGroupingsQueryVariables = Exact<{
  attributes: Types.CartonGroupingSearchAttributes;
}>;


export type CashFlowCartonGroupingsQuery = { cartonGroupingsSearch: { cartonGroupings: Array<{ targetRegion: string | null, targetMarket: string | null, palletGrossMass: number | null, id: number | null, containerNumber: string | null, state: string | null, cartons: number | null, palletNumber: string | null, grade: string | null, batchNumber: string | null, sizeCount: string | null, advancePrice: number | null, finalPrice: number | null, advanceDueDate: string | null, finalDueDate: string | null, lineItem: { currency: string | null, incoterm: string | null, mark: string | null, orderId: number | null, priceMinorUnit: number | null, priceUnit: string | null, referenceNumber: string | null } | null, buyer: { id: number | null, name: string | null } | null, seller: { id: number | null, name: string | null } | null }> } | null };

export type ContainerClaimFieldsFragment = { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null };

export type ClaimLineItemGroupingFieldsFragment = { id: string, palletCount: number | null, farmCode: string | null, sizeCount: string | null, grade: string | null, arrivalQcGrade: Types.ArrivalQcGradeEnum | null, expectedClaims: Array<Types.ExpectedClaimEnum> | null, comment: string | null, progressiveDefectPercentage: number | null, cosmeticDefectPercentage: number | null, otherDefectPercentage: number | null, commodity: { id: number | null, name: string | null } | null, variety: { name: string | null } | null, progressiveClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, progressiveDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, cosmeticClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, cosmeticDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, otherClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, otherDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null };

export type DefectFieldsFragment = { id: number, name: string | null, category: Types.DefectCategoryEnum | null };

export type ClaimLineItemDefectFieldsFragment = { defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } };

export type ContainerClaimsQueryVariables = Exact<{
  containerClaimId?: string | number | null | undefined;
  claimLineItemGroupingId?: string | number | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  tab: Types.ArrivalQcTabEnum;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type ContainerClaimsQuery = { claims: { containerClaims: { totalCount: number, nodes: Array<{ id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } } | null };

export type ClaimLineItemGroupingsQueryVariables = Exact<{
  containerClaimId?: string | number | null | undefined;
  claimLineItemGroupingId?: string | number | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  tab: Types.ArrivalQcTabEnum;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type ClaimLineItemGroupingsQuery = { claims: { containerClaims: { totalCount: number, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } }, claimLineItemGroupings: Array<{ id: string, palletCount: number | null, farmCode: string | null, sizeCount: string | null, grade: string | null, arrivalQcGrade: Types.ArrivalQcGradeEnum | null, expectedClaims: Array<Types.ExpectedClaimEnum> | null, comment: string | null, progressiveDefectPercentage: number | null, cosmeticDefectPercentage: number | null, otherDefectPercentage: number | null, commodity: { id: number | null, name: string | null } | null, variety: { name: string | null } | null, progressiveClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, progressiveDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, cosmeticClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, cosmeticDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, otherClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, otherDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null }> } | null };

export type ClaimLineItemPalletsQueryVariables = Exact<{
  containerClaimId?: string | number | null | undefined;
  claimLineItemGroupingId?: string | number | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  tab: Types.ArrivalQcTabEnum;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type ClaimLineItemPalletsQuery = { claims: { containerClaims: { totalCount: number, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } }, claimLineItemPallets: Array<{ id: string, palletNumber: string, arrivalQcGrade: Types.ArrivalQcGradeEnum | null, expectedClaim: Types.ExpectedClaimEnum | null, claimLineItemGroupingId: string | null, claimLineItems: Array<{ id: string }> | null, progressiveClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, progressiveDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, cosmeticClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, cosmeticDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, otherClaimLineItemDefects: Array<{ defectPercentage: number | null, defect: { id: number, name: string | null, category: Types.DefectCategoryEnum | null } }> | null, otherDefectOptions: Array<{ id: number, name: string | null, category: Types.DefectCategoryEnum | null }> | null, commodity: { id: number | null, name: string | null } | null }> } | null };

export type ContainersForArrivalQcQueryVariables = Exact<{
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type ContainersForArrivalQcQuery = { containersForArrivalQc: Array<{ id: string, containerNumber: string | null, vesselName: string | null, voyageNumber: string | null }> | null };

export type BreakBulkContainersForArrivalQcQueryVariables = Exact<{
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type BreakBulkContainersForArrivalQcQuery = { breakBulkContainersForArrivalQc: Array<{ id: string, voyageNumber: string | null, vesselName: string | null, counterParty: { id: number | null, name: string | null } | null }> | null };

export type UpdateArrivalQcClaimLineItemPalletGradeMutationVariables = Exact<{
  claimLineItemIds: Array<string | number> | string | number;
  arrivalQcGrade: Types.ArrivalQcGradeEnum;
}>;


export type UpdateArrivalQcClaimLineItemPalletGradeMutation = { updateArrivalQcClaimLineItemPalletGrade: { errors: string | null, containerClaim: { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null } | null };

export type UpdateArrivalQcClaimLineItemGroupingGradeMutationVariables = Exact<{
  claimLineItemGroupingId: string | number;
  arrivalQcGrade: Types.ArrivalQcGradeEnum;
}>;


export type UpdateArrivalQcClaimLineItemGroupingGradeMutation = { updateArrivalQcClaimLineItemGroupingGrade: { errors: string | null, containerClaim: { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null } | null };

export type UpdateClaimLineItemGroupingExpectedClaimMutationVariables = Exact<{
  claimLineItemGroupingId: string | number;
  expectedClaim: Types.ExpectedClaimEnum;
}>;


export type UpdateClaimLineItemGroupingExpectedClaimMutation = { updateClaimLineItemGroupingExpectedClaim: { errors: string | null } | null };

export type UpdateClaimLineItemPalletExpectedClaimMutationVariables = Exact<{
  claimLineItemIds: Array<string | number> | string | number;
  expectedClaim: Types.ExpectedClaimEnum;
}>;


export type UpdateClaimLineItemPalletExpectedClaimMutation = { updateClaimLineItemPalletExpectedClaim: { errors: string | null } | null };

export type UpdateClaimLineItemGroupingCommentMutationVariables = Exact<{
  claimLineItemGroupingId: string | number;
  comment?: string | null | undefined;
}>;


export type UpdateClaimLineItemGroupingCommentMutation = { updateClaimLineItemGroupingComment: { errors: string | null } | null };

export type UpdateClaimLineItemGroupingDefectMutationVariables = Exact<{
  claimLineItemGroupingId: string | number;
  defectId: string | number;
}>;


export type UpdateClaimLineItemGroupingDefectMutation = { updateClaimLineItemGroupingDefect: { errors: string | null } | null };

export type UpdateClaimLineItemPalletDefectMutationVariables = Exact<{
  claimLineItemIds: Array<string | number> | string | number;
  defectId: string | number;
}>;


export type UpdateClaimLineItemPalletDefectMutation = { updateClaimLineItemPalletDefect: { errors: string | null } | null };

export type UpdateContainerClaimNoteMutationVariables = Exact<{
  containerClaimId: string | number;
  note?: string | null | undefined;
}>;


export type UpdateContainerClaimNoteMutation = { updateContainerClaimNote: { errors: string | null, containerClaim: { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null } | null };

export type UpdateArrivalQcCaptureDatetimeMutationVariables = Exact<{
  containerClaimId: string | number;
  arrivalQcCaptureDatetime?: string | null | undefined;
}>;


export type UpdateArrivalQcCaptureDatetimeMutation = { updateArrivalQcCaptureDatetime: { errors: string | null, containerClaim: { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null } | null };

export type MarkContainerClaimAsCompletedMutationVariables = Exact<{
  containerClaimId: string | number;
}>;


export type MarkContainerClaimAsCompletedMutation = { markContainerClaimAsCompleted: { errors: Array<string> | null, containerClaimId: string | null } | null };

export type UpdateContainerClaimGradeMutationVariables = Exact<{
  containerClaimId: string | number;
  arrivalQcState: Types.ArrivalQcStateEnum;
  arrivalQcGrade: Types.ArrivalQcGradeEnum;
}>;


export type UpdateContainerClaimGradeMutation = { updateContainerClaimGrade: { errors: string | null, containerClaim: { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null } | null };

export type CaptureDefectPercentagesMutationVariables = Exact<{
  attributes: Types.DefectPercentageCaptureAttributes;
}>;


export type CaptureDefectPercentagesMutation = { captureDefectPercentages: { errors: string | null } | null };

export type RemoveClaimLineItemGroupingDefectMutationVariables = Exact<{
  claimLineItemGroupingId: string | number;
  defectId: string | number;
}>;


export type RemoveClaimLineItemGroupingDefectMutation = { removeClaimLineItemGroupingDefect: { errors: string | null } | null };

export type RemoveClaimLineItemPalletDefectMutationVariables = Exact<{
  claimLineItemIds: Array<string | number> | string | number;
  defectId: string | number;
  claimLineItemGroupingId: string | number;
}>;


export type RemoveClaimLineItemPalletDefectMutation = { removeClaimLineItemPalletDefect: { errors: string | null } | null };

export type RemoveClaimLineItemGroupingExpectedClaimMutationVariables = Exact<{
  claimLineItemGroupingId: string | number;
  expectedClaim: Types.ExpectedClaimEnum;
}>;


export type RemoveClaimLineItemGroupingExpectedClaimMutation = { removeClaimLineItemGroupingExpectedClaim: { errors: string | null } | null };

export type RemoveClaimLineItemPalletExpectedClaimMutationVariables = Exact<{
  claimLineItemIds: Array<string | number> | string | number;
}>;


export type RemoveClaimLineItemPalletExpectedClaimMutation = { removeClaimLineItemPalletExpectedClaim: { errors: string | null } | null };

export type SoftDeleteContainerClaimMutationVariables = Exact<{
  containerClaimId: string | number;
}>;


export type SoftDeleteContainerClaimMutation = { softDeleteContainerClaim: { error: string | null, containerClaimId: string | null } | null };

export type UploadClaimFilesMutationVariables = Exact<{
  containerClaimId: string | number;
  files: Array<File> | File;
}>;


export type UploadClaimFilesMutation = { uploadClaimFiles: { errors: Array<string> | null, containerClaim: { id: string, completedAt: string | null, state: Types.ArrivalQcStateEnum | null, companyId: string, containerArrivalDate: string | null, notes: string | null, arrivalQcDatetime: string | null, updatedAt: string, containerableType: Types.ContainerableTypeEnum, vesselName: string | null, voyageNumber: string | null, containerableId: string, container: { containerNumber: string | null } | null, photos: Array<{ id: number | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, documents: Array<{ id: string | null, filename: string | null, v2Url: string | null, contentType: string | null }> | null, counterParty: { id: number | null, name: string | null } | null } | null } | null };

export type GenerateArrivalQcsMutationVariables = Exact<{
  containerableIds: Array<string | number> | string | number;
  containerableType: Types.ContainerableTypeEnum;
}>;


export type GenerateArrivalQcsMutation = { generateArrivalQcs: { success: boolean, errors: Array<string> } | null };

export type OnArrivalQcGenerationStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnArrivalQcGenerationStateChangeSubscription = { onArrivalQcGenerationStateChange: { containerableId: string, containerableType: Types.ContainerableTypeEnum | null, containerNumber: string | null, vesselName: string | null, voyageNumber: string | null, status: Types.ArrivalQcGenerationStatesEnum, errorMessage: string | null, containerClaimId: string | null, counterParty: { id: number | null, name: string | null } | null } };

export type CommentFieldsFragment = { id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  attributes: Types.CreateCommentAttributes;
}>;


export type CreateCommentMutation = { createComment: { comment: { id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null } | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  commentid: number;
}>;


export type DeleteCommentMutation = { deleteComment: { comment: { id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null } | null } | null };

export type CommercialTermChangeRequestFieldsFragment = { id: number | null, message: string | null, flag: string | null, commercialTerm: { id: number | null } | null };

export type CreateCommercialTermChangeRequestMutationVariables = Exact<{
  attributes: Types.CreateCommercialTermChangeRequestAttributes;
}>;


export type CreateCommercialTermChangeRequestMutation = { createCommercialTermChangeRequest: { changeRequest: { id: number | null } | null } | null };

export type CommercialTermFragment = { id: number | null, startDate: string | null, endDate: string | null, targetRegion: string | null, advanceType: string | null, advanceUnit: string | null, buyerId: number | null, deleted: boolean, pack: string | null, grade: string | null, paymentTerm: string | null, advanceCreditTerm: number | null, finalCreditTerm: number | null, advanceEvent: string | null, finalEvent: string | null, advanceAmount: number | null, rankOneAdvanceEvent: string | null, rankOneFinalEvent: string | null, advanceCurrency: string | null, finalCurrency: string | null, targetCountry: string | null, exporterCode: string | null, commodityName: string | null, varietyName: string | null, buyerName: string | null, commodity: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, variety: { id: number | null, name: string | null } | null };

export type CommercialTermsQueryVariables = Exact<{
  filterAttributes: Types.CommercialTermFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type CommercialTermsQuery = { commercialTerms: { totalCount: number, nodes: Array<{ id: number | null, startDate: string | null, endDate: string | null, targetRegion: string | null, advanceType: string | null, advanceUnit: string | null, buyerId: number | null, deleted: boolean, pack: string | null, grade: string | null, paymentTerm: string | null, advanceCreditTerm: number | null, finalCreditTerm: number | null, advanceEvent: string | null, finalEvent: string | null, advanceAmount: number | null, rankOneAdvanceEvent: string | null, rankOneFinalEvent: string | null, advanceCurrency: string | null, finalCurrency: string | null, targetCountry: string | null, exporterCode: string | null, commodityName: string | null, varietyName: string | null, buyerName: string | null, commodity: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, variety: { id: number | null, name: string | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type CommercialTermFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommercialTermFilterAttributesQuery = { commercialTermFilterAttributes: { targetRegions: Array<string> | null, advanceTypes: Array<string> | null, advanceUnits: Array<string> | null, events: Array<string> | null, commodities: Array<{ id: number | null, name: string | null }> | null, buyers: Array<{ id: number | null, name: string | null }> | null } | null };

export type CartonTypesByCommodityQueryVariables = Exact<{
  commodityId: string | number;
}>;


export type CartonTypesByCommodityQuery = { cartonTypesByCommodity: Array<{ id: number, name: string }> | null };

export type UpsertCommercialTermMutationVariables = Exact<{
  attributes: Types.CommercialTermAttributes;
}>;


export type UpsertCommercialTermMutation = { upsertCommercialTerm: { errors: Array<string> | null, commercialTerm: { id: number | null, startDate: string | null, endDate: string | null, targetRegion: string | null, advanceType: string | null, advanceUnit: string | null, buyerId: number | null, deleted: boolean, pack: string | null, grade: string | null, paymentTerm: string | null, advanceCreditTerm: number | null, finalCreditTerm: number | null, advanceEvent: string | null, finalEvent: string | null, advanceAmount: number | null, rankOneAdvanceEvent: string | null, rankOneFinalEvent: string | null, advanceCurrency: string | null, finalCurrency: string | null, targetCountry: string | null, exporterCode: string | null, commodityName: string | null, varietyName: string | null, buyerName: string | null, commodity: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, variety: { id: number | null, name: string | null } | null } | null } | null };

export type CommoditiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommoditiesQuery = { commodities: Array<{ id: number | null, name: string | null, varieties: Array<{ id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null }> | null }> | null };

export type ExportersQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportersQuery = { supplierExporters: { supplierExporters: Array<{ id: number | null, name: string | null, exporterLogoImageUrl: string | null, isPackhouseContainerised: boolean | null, exporterCodes: Array<{ id: number | null, exporterCode: string | null }> | null, exporter: { id: number | null, name: string | null } | null, foodBusinessOperators: Array<{ id: number | null, fboCode: string | null, createdAt: string, updatedAt: string }> | null, coldStores: Array<{ id: number | null, name: string | null, fboCode: string | null, createdAt: string, updatedAt: string }> | null, coldStoreClientChangeRequests: Array<{ id: number | null, status: string | null, companyAssociation: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, coldStore: { id: number | null, name: string | null, fboCode: string | null, createdAt: string, updatedAt: string } | null }> | null, masterfileConfig: { id: string | null, state: Types.MasterfileConfigStateEnum | null } | null }>, clientChangeRequests: Array<{ id: number | null, exporterLogoImageUrl: string | null, relation: string | null, oneswitchFacilitated: boolean | null, exporterName: string | null, fboId: number | null, isPackhouseContainerised: boolean | null, createdAt: string | null, updatedAt: string | null, supplier: { id: number | null, name: string | null } | null, exporter: { id: number | null, name: string | null } | null, exporterCodes: Array<{ id: number | null, exporterCode: string | null }> | null, foodBusinessOperators: Array<{ id: number | null, fboCode: string | null, createdAt: string, updatedAt: string }> | null, coldStores: Array<{ id: number | null, name: string | null, fboCode: string | null, createdAt: string, updatedAt: string }> | null }> } | null };

export type ExporterFbosQueryVariables = Exact<{ [key: string]: never; }>;


export type ExporterFbosQuery = { exporterFbos: Array<{ id: number | null, name: string | null, fboCode: string | null, company: { id: number | null, companyLogoImageUrl: string | null, name: string | null, exporterCodes: Array<{ id: number | null, exporterCode: string | null }> | null } | null }> | null };

export type CreateExporterAndColdStoreClientRequestMutationVariables = Exact<{
  exporterFboId: string | number;
  coldStoreIds: Array<string | number> | string | number;
  isPackhouseContainerised?: boolean | null | undefined;
}>;


export type CreateExporterAndColdStoreClientRequestMutation = { createExporterAndColdStoreClientRequest: { errors: Array<string> | null, clientChangeRequest: { id: number | null, fboId: number | null, isPackhouseContainerised: boolean | null, coldStores: Array<{ id: number | null }> | null } | null } | null };

export type ConfirmMasterfileConfigCompanyAssociationsMutationVariables = Exact<{
  masterfileConfigs: Array<Types.MasterfileConfigCompanyAssociationInput> | Types.MasterfileConfigCompanyAssociationInput;
}>;


export type ConfirmMasterfileConfigCompanyAssociationsMutation = { confirmMasterfileConfigCompanyAssociations: { errors: Array<string> | null, masterfileConfigs: Array<{ id: string | null, state: Types.MasterfileConfigStateEnum | null }> | null } | null };

export type CreateSupplierExporterRequestMutationVariables = Exact<{
  attributes: Types.CreateSupplierExporterRequestAttribute;
}>;


export type CreateSupplierExporterRequestMutation = { createSupplierExporterRequest: { errors: Array<string> | null, clientChangeRequests: Array<{ id: number | null, exporterLogoImageUrl: string | null, exporterName: string | null, relation: string | null, oneswitchFacilitated: boolean | null, isPackhouseContainerised: boolean | null, fboId: number | null, createdAt: string | null, updatedAt: string | null, supplier: { id: number | null, name: string | null } | null, exporter: { id: number | null, name: string | null } | null, exporterCodes: Array<{ id: number | null, exporterCode: string | null }> | null, foodBusinessOperators: Array<{ id: number | null, fboCode: string | null, createdAt: string, updatedAt: string }> | null }> | null } | null };

export type ConfirmExporterColdStoresMutationVariables = Exact<{
  companyAssociationExportColdStoreAttributes: Array<Types.CompanyAssociationExportColdStoreAttributes> | Types.CompanyAssociationExportColdStoreAttributes;
  clientChangeRequestExportColdStoreAttributes: Array<Types.ClientChangeRequestExportColdStoreAttributes> | Types.ClientChangeRequestExportColdStoreAttributes;
}>;


export type ConfirmExporterColdStoresMutation = { confirmExporterColdStores: { errors: Array<string> | null, success: boolean | null } | null };

export type CreateExporterColdStoreRequestMutationVariables = Exact<{
  companyAssociationId: string | number;
  coldStoreIds: Array<string | number> | string | number;
  isPackhouseContainerisation: boolean;
}>;


export type CreateExporterColdStoreRequestMutation = { createExporterColdStoreRequest: { success: boolean | null, errors: Array<string> | null, clientChangeRequests: Array<{ status: string | null, companyAssociation: { id: number | null } | null, coldStore: { id: number | null } | null }> | null } | null };

export type UploadCompanyCertificateMutationVariables = Exact<{
  file: File;
  expirydate: string;
  companyid: number;
  certificatetypeid: number;
}>;


export type UploadCompanyCertificateMutation = { uploadCompanyCertificate: { certificate: { id: number | null, expiryDate: string | null, createdAt: string | null, certificate: { id: string | null, filename: string | null, url: string | null, v2Url: string | null } | null, certificateType: { name: string | null, id: number | null } | null } | null } | null };

export type DeleteCompanyCertificateMutationVariables = Exact<{
  id: number;
}>;


export type DeleteCompanyCertificateMutation = { deleteCompanyCertificate: { id: number | null } | null };

export type CertificateTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificateTypeQuery = { certificateTypes: Array<{ id: number | null, name: string | null }> | null };

export type CommoditySeasonFragment = { id: number | null, startDate: string | null, endDate: string | null, createdAt: string | null, updatedAt: string | null, commodity: { id: number | null, name: string | null, commodityGroup: Types.CommodityGroupEnum | null, icon: { v2Url: string | null } | null } | null };

export type MyCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCompanyQuery = { myCompany: { id: number | null, name: string | null, about: string | null, registrationNumber: string | null, vatNumber: string | null, createdAt: string | null, state: Types.CompanyStateEnum | null, onboardingStep: Types.CompanyOnboardingStepEnum | null, defaultLocale: string | null, isSeller: boolean | null, isBuyer: boolean | null, logoFile: { id: string | null, filename: string | null, url: string | null } | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null } | null, tradeRegions: Array<{ id: number | null, name: string | null, code: string | null, countries: Array<{ id: number | null, name: string | null, code: string | null }> | null }> | null, certificates: Array<{ id: number | null, expiryDate: string | null, createdAt: string | null, updatedAt: string | null, certificate: { id: string | null, filename: string | null, url: string | null, v2Url: string | null } | null, certificateType: { name: string | null, id: number | null } | null }> | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, variety: { id: number | null, name: string | null, varietyCode: string | null } | null, commodity: { id: number | null, name: string | null, icon: { v2Url: string | null } | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, companyId: number | null, name: string | null, description: string | null, fieldType: string | null, parameters: string | null, createdAt: string | null, updatedAt: string | null, isPackingInstruction: boolean | null, private: boolean | null }> | null, activeUsers: Array<{ id: number | null, firstName: string | null, lastName: string | null, phoneNumber: string | null, email: string | null, state: string | null, role: string | null, roles: Array<{ id: number | null, name: string | null, resourceType: string | null, resourceId: number | null, createdAt: string | null, updatedAt: string | null }> | null, employee: { id: number | null } | null }> | null, invites: Array<{ id: number | null, email: string | null, state: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, buyers: Array<{ id: number | null, name: string | null }> | null, commoditySeasons: Array<{ id: number | null, startDate: string | null, endDate: string | null, createdAt: string | null, updatedAt: string | null, commodity: { id: number | null, name: string | null, commodityGroup: Types.CommodityGroupEnum | null, icon: { v2Url: string | null } | null } | null }> | null } | null };

export type TradePartnersForMyCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type TradePartnersForMyCompanyQuery = { myCompany: { isBuyer: boolean | null, isSeller: boolean | null, buyers: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null } | null };

export type UpdateCompanyDetailsMutationVariables = Exact<{
  attributes: Types.UpdateCompanyAttributes;
}>;


export type UpdateCompanyDetailsMutation = { updateCompanyDetails: { company: { id: number | null, name: string | null, about: string | null, registrationNumber: string | null, vatNumber: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null } | null };

export type UploadCompanyLogoMutationVariables = Exact<{
  file: File;
  companyid: number;
}>;


export type UploadCompanyLogoMutation = { uploadCompanyLogo: { company: { logoFile: { id: string | null, filename: string | null, url: string | null } | null } | null } | null };

export type UpdateCompanyTradeRegionsMutationVariables = Exact<{
  addtraderegions: Array<Types.TradeRegionAttributes> | Types.TradeRegionAttributes;
  removetraderegions: Array<Types.TradeRegionAttributes> | Types.TradeRegionAttributes;
}>;


export type UpdateCompanyTradeRegionsMutation = { updateCompanyTradeRegions: { company: { tradeRegions: Array<{ id: number | null, name: string | null, code: string | null }> | null } | null } | null };

export type CurrencyConversionQueryVariables = Exact<{
  currencyConversionAttributes: Types.CurrencyConversionAttributes;
}>;


export type CurrencyConversionQuery = { currencyConversion: { id: string | null, rates: any, timestamp: string | null } | null };

export type CurrencyConversionByIdQueryVariables = Exact<{
  currencyConversionId: string | number;
}>;


export type CurrencyConversionByIdQuery = { currencyConversionById: { id: string | null, rates: any, timestamp: string | null } | null };

export type UpsertCurrencyExchangeRateMutationVariables = Exact<{
  currencyExchangeRateAttributes: Types.CurrencyExchangeRateAttributes;
}>;


export type UpsertCurrencyExchangeRateMutation = { upsertCurrencyExchangeRate: { errors: Array<string> | null, currencyExchangeRate: { id: string, toCurrency: string, fromCurrency: string, exchangeRate: string, exchangeRateType: string, exchangeRateDate: string, currencyConversionId: string | null, exchangeableId: string, exchangeableType: string } | null } | null };

export type DeleteCurrencyExchangeRateMutationVariables = Exact<{
  currencyExchangeRateId: string | number;
}>;


export type DeleteCurrencyExchangeRateMutation = { deleteCurrencyExchangeRate: { currencyExchangeRateId: string | null, errors: Array<string> | null } | null };

export type CurrencyExchangeRateQueryVariables = Exact<{
  exchangeableId: string | number;
  exchangeableType: string;
}>;


export type CurrencyExchangeRateQuery = { currencyExchangeRate: { id: string, toCurrency: string, fromCurrency: string, exchangeRate: string, exchangeRateType: string, exchangeRateDate: string, currencyConversionId: string | null, exchangeableId: string, exchangeableType: string } | null };

export type DashboardQueryQueryVariables = Exact<{
  locationId?: number | null | undefined;
  containerId?: number | null | undefined;
  commoditygroups?: Array<Types.CommodityGroupEnum> | Types.CommodityGroupEnum | null | undefined;
  forExport?: boolean | null | undefined;
}>;


export type DashboardQueryQuery = { dashboardTrackingData: { cartonGroupings: Array<{ batchNumber: string | null, cartons: number | null, commodityName: string | null, consignmentNumber: string | null, containerId: number | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inspectionDate: string | null, inventoryCode: string | null, locationId: number | null, mark: string | null, netMass: number | null, orchard: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, productCharacteristic: string | null, sequenceNumber: number | null, state: string | null, targetMarket: string | null, targetCountry: string | null, targetRegion: string | null, varietyName: string | null }> | null, containers: Array<{ arrivalDate: string | null, arrivalEventClassifier: string | null, cartons: number | null, cartonsInTransit: number | null, containerId: number | null, containerNumber: string | null, containerType: string | null, departureDate: string | null, departureEventClassifier: string | null, finalDestinationId: number | null, finalDeliveryDatetime: string | null, finalDestinationName: string | null, finalDestinationType: string | null, locationId: number | null, id: number | null, nextDeliveryDatetime: string | null, nextDestinationId: number | null, nextDestinationName: string | null, nextDestinationType: string | null, pallets: number | null, palletsInTransit: number | null, state: string | null, stateInTransit: string | null }> | null, locations: Array<{ id: number | null, cartons: number | null, cartonsInTransit: number | null, containers: number | null, containersInTransit: number | null, locationId: number | null, locationType: string | null, name: string | null, pallets: number | null, palletsInTransit: number | null, unallocated: number | null, unallocatedInTransit: number | null, geoLocation: { lat: number | null, lon: number | null } | null }> | null } | null };

export type DashboardSearchQueryVariables = Exact<{
  fields?: Array<Types.DashboardSearchFieldsEnum> | Types.DashboardSearchFieldsEnum | null | undefined;
  searchTerm?: string | null | undefined;
  commodityGroups?: Array<Types.CommodityGroupEnum> | Types.CommodityGroupEnum | null | undefined;
}>;


export type DashboardSearchQuery = { dashboardSearch: { raw: any, hits: Array<{ score: number | null, highlight: any, source:
        | { batchNumber: string | null, cartons: number | null, commodityName: string | null, consignmentNumber: string | null, containerId: number | null, containerNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inspectionDate: string | null, inventoryCode: string | null, locationId: number | null, mark: string | null, netMass: number | null, orchard: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, productCharacteristic: string | null, sequenceNumber: number | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, varietyName: string | null }
        | { arrivalDate: string | null, cartons: number | null, cartonsInTransit: number | null, collectionDatetime: string | null, containerId: number | null, containerNumber: string | null, containerType: string | null, departureDate: string | null, finalDeliveryDatetime: string | null, finalDestinationId: number | null, finalDestinationLatitude: number | null, finalDestinationLongitude: number | null, finalDestinationName: string | null, finalDestinationType: string | null, id: number | null, locationId: number | null, nextDeliveryDatetime: string | null, nextDestinationId: number | null, nextDestinationLatitude: number | null, nextDestinationLongitude: number | null, nextDestinationName: string | null, nextDestinationType: string | null, pallets: number | null, palletsInTransit: number | null, state: string | null, stateInTransit: string | null }
        | { cartons: number | null, cartonsInTransit: number | null, containers: number | null, containersInTransit: number | null, id: number | null, locationId: number | null, locationType: string | null, name: string | null, pallets: number | null, palletsInTransit: number | null, unallocated: number | null, unallocatedInTransit: number | null }
       | null }> | null, total: { relation: string | null, value: number | null } | null } | null };

export type DashboardFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardFiltersQuery = { dashboardFilters: { commodities: Array<{ id: number | null, name: string | null, commodityGroup: Types.CommodityGroupEnum | null }> | null } | null };

export type DataPreparationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataPreparationsQuery = { dataPreparations: Array<{ id: string | null, name: string | null }> | null };

export type DataPreparationQueryVariables = Exact<{
  id: string | number;
}>;


export type DataPreparationQuery = { dataPreparation: { error: string | null, id: string | null, description: string | null, name: string | null, status: string | null, updatedAt: string | null, dataOutputs: Array<{ createdAt: string | null, downloadedAt: string | null, fileType: string | null, id: string | null, outputFile: { contentType: string | null, filename: string | null, id: string | null, url: string | null, v2Url: string | null } | null }> | null } | null };

export type GenerateDataOutputFilesMutationVariables = Exact<{
  id: string | number;
}>;


export type GenerateDataOutputFilesMutation = { generateDataOutputFiles: { dataPreparation: { status: string | null } | null } | null };

export type UpdateDataOutputMutationVariables = Exact<{
  attributes: Types.DataOutputAttributes;
}>;


export type UpdateDataOutputMutation = { updateDataOutput: { errors: string | null, dataOutput: { id: string | null, downloadedAt: string | null } | null } | null };

export type DefaultCostsQueryVariables = Exact<{
  filterAttributes?: Types.DefaultCostFilters | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type DefaultCostsQuery = { defaultCosts: { totalCount: number, nodes: Array<{ cartonGroupingTransaction: { id: number | null, currency: Types.CurrencyEnum | null, amountMajorUnit: string | null, isActual: boolean, quantityPriceMajorUnit: string | null, quantityAmount: string | null, quantityType: string | null, cartonGrouping: { palletNumber: string | null, containerNumber: string | null } | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type FinanceRuleQueryVariables = Exact<{
  id: string | number;
}>;


export type FinanceRuleQuery = { financeRule: { id: string, name: string, amountCents: number | null, ruleDescription: string | null, createdAt: string, endDate: string | null, enabled: boolean | null, isDefaultCost: boolean, defaultCgtsFinalised: number | null, defaultCgtsPendingReview: number | null, currency: string | null, unit: Types.FinanceRuleUnitEnum | null, percentage: number | null, humanReadableExpression: string | null, incotermForPercentageCalculation: string | null, costCode: { id: number, name: string } | null, groupedCostCodes: Array<{ startDate: string, endDate: string | null, costCode: { id: number, name: string } }> | null } | null };

export type RemoveDefaultCostsMutationVariables = Exact<{
  attributes: Types.RemoveDefaultCostAttributes;
}>;


export type RemoveDefaultCostsMutation = { removeDefaultCosts: { errors: string | null, cgtIds: Array<string> | null } | null };

export type FinaliseDefaultCostsMutationVariables = Exact<{
  attributes: Types.FinaliseDefaultCostAttributes;
}>;


export type FinaliseDefaultCostsMutation = { finaliseDefaultCosts: { errors: string | null, cgtIds: Array<string> | null } | null };

export type ContainersForFinanceRuleQueryVariables = Exact<{
  financeRuleId: string | number;
}>;


export type ContainersForFinanceRuleQuery = { containersForFinanceRule: Array<{ id: number | null, containerNumber: string | null }> | null };

export type DownloadDocumentsMutationVariables = Exact<{
  documentAttributes: Array<Types.DownloadDocumentAttributes> | Types.DownloadDocumentAttributes;
  zippedFilename: string;
}>;


export type DownloadDocumentsMutation = { downloadDocuments: { url: string | null, errors: Array<string> } | null };

export type SendEmailMutationVariables = Exact<{
  attributes: Types.SendEmailAttributes;
}>;


export type SendEmailMutation = { sendEmail: { errors: string | null, message: string } | null };

export type EmailDocumentsMutationVariables = Exact<{
  attributes: Types.EmailDocumentsAttributes;
}>;


export type EmailDocumentsMutation = { emailDocuments: { errors: string | null, message: string } | null };

export type EmailTaskDocumentsMutationVariables = Exact<{
  attributes: Types.EmailTaskDocumentsAttributes;
}>;


export type EmailTaskDocumentsMutation = { emailTaskDocuments: { errors: string | null, message: string } | null };

export type DuplicateEphytoMutationVariables = Exact<{
  id: number;
  applicationType: number;
}>;


export type DuplicateEphytoMutation = { duplicateEphyto: { id: number | null } | null };

export type DeleteEphytoMutationVariables = Exact<{
  id: number;
}>;


export type DeleteEphytoMutation = { deleteEphyto: { message: string | null } | null };

export type UpdateEphytoDocumentMutationVariables = Exact<{
  id: number;
  type: string;
}>;


export type UpdateEphytoDocumentMutation = { updateEphytoDocument: { errors: string | null } | null };

export type UploadEphytoDocumentMutationVariables = Exact<{
  ephytoId: number;
  file: File;
}>;


export type UploadEphytoDocumentMutation = { uploadEphytoDocument: { errors: string | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null };

export type DeleteEphytoDocumentMutationVariables = Exact<{
  id: number;
}>;


export type DeleteEphytoDocumentMutation = { deleteEphytoDocument: { id: number | null } | null };

export type UpdateDraftEphytoMutationVariables = Exact<{
  ephytoId: number;
}>;


export type UpdateDraftEphytoMutation = { updateDraftEphyto: { errors: string | null, ephyto: { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null, ephytoConsignmentItems: Array<{ id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null }> | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type SubmitEphytoMutationVariables = Exact<{
  ephytoId: number;
}>;


export type SubmitEphytoMutation = { submitEphyto: { errors: string | null, ephyto: { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null, ephytoConsignmentItems: Array<{ id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null }> | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type DraftEphytoMutationVariables = Exact<{
  ephytoId: number;
}>;


export type DraftEphytoMutation = { draftEphyto: { errors: string | null, ephyto: { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null, ephytoConsignmentItems: Array<{ id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null }> | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type FetchEphytoStatusMutationVariables = Exact<{
  ephytoId: number;
}>;


export type FetchEphytoStatusMutation = { fetchEphytoStatus: { errors: string | null, ephyto: { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null, ephytoConsignmentItems: Array<{ id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null }> | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type GenerateEphytoMutationVariables = Exact<{
  isEntireBooking: boolean;
  shipmentType: string;
  bookingReference?: string | null | undefined;
  ephytoId?: number | null | undefined;
  sliIds?: Array<number> | number | null | undefined;
}>;


export type GenerateEphytoMutation = { generateEphyto: { errors: string | null, ephyto: { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null, ephytoConsignmentItems: Array<{ id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null }> | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type GenerateEphytoTradeUnitMutationVariables = Exact<{
  shipmentType: string;
  ephytoId?: number | null | undefined;
}>;


export type GenerateEphytoTradeUnitMutation = { generateEphytoTradeUnit: { errors: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null } | null };

export type UpdateEphytoMutationVariables = Exact<{
  ephyto: Types.EphytoAttributes;
  ephytoConsignmentItems: Array<Types.EphytoConsignmentItemAttributes> | Types.EphytoConsignmentItemAttributes;
}>;


export type UpdateEphytoMutation = { updateEphyto: { errors: string | null } | null };

export type EphytoPackageTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoPackageTypesQuery = { ephytoPackageTypes: Array<{ name: string | null, code: string | null }> | null };

export type EphytoAppliedChemicalsQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoAppliedChemicalsQuery = { ephytoAppliedChemicals: Array<string> | null };

export type EphytoTransportMeansQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoTransportMeansQuery = { ephytoTransportMeans: Array<string> | null };

export type EphytoUnitOfMeasureCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoUnitOfMeasureCodesQuery = { ephytoUnitOfMeasureCodes: Array<string> | null };

export type EphytoTreatmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoTreatmentsQuery = { ephytoTreatments: Array<{ firstLevel: string | null, firstLevelCode: string | null, secondLevel: string | null, secondLevelCode: string | null }> | null };

export type EphytoCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoCountriesQuery = { ephytoCountries: Array<{ isoCode: string | null, name: string | null }> | null };

export type EphytoAgreementCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoAgreementCodesQuery = { ephytoAgreementCodes: Array<{ agreementCode: string | null, agreementName: string | null }> | null };

export type EphytoLocationsQueryVariables = Exact<{
  countryCodes: Array<string> | string;
}>;


export type EphytoLocationsQuery = { ephytoLocations: Array<{ name: string | null, code: string | null }> | null };

export type EphytoPortOfEntriesQueryVariables = Exact<{
  countryCodes: Array<string> | string;
}>;


export type EphytoPortOfEntriesQuery = { ephytoPortOfEntries: Array<{ name: string | null, code: string | null }> | null };

export type EphytoContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoContactsQuery = { contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null }> | null };

export type NonEphytoShipmentLineItemsQueryVariables = Exact<{
  shipmentId: number;
  type: string;
}>;


export type NonEphytoShipmentLineItemsQuery = { nonEphytoShipmentLineItems: Array<{ id: number, labelDisplay: string | null, type: string | null }> | null };

export type EphytosQueryVariables = Exact<{
  filterAttributes: Types.EphytoFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type EphytosQuery = { ephytos: { totalCount: number, nodes: Array<{ id: string, agreementCode: string | null, applicationStatus: string | null, state: string | null, targetCountry: string | null, unloadingBaseportLocation: string | null, customReferenceNo: string | null, applicationReferenceNo: string | null, desiredIssueLocation: string | null, departureDate: string | null, applicationType: number | null, consignorName: string | null, consigneeName: string | null, updatedAt: string | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type EphytoFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoFilterAttributesQuery = { ephytoFilterAttributes: { statuses: Array<string> | null, customerReferences: Array<string> | null, entryPorts: Array<string> | null, consignees: Array<string> | null, consignors: Array<string> | null, vessels: Array<string> | null } | null };

export type EphytoCertificateUrlQueryVariables = Exact<{
  id: number;
}>;


export type EphytoCertificateUrlQuery = { ephytoCertificateUrl: string | null };

export type ExportDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportDocumentTypesQuery = { exportDocumentTypes: Array<string> | null };

export type EphytoDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EphytoDocumentTypesQuery = { ephytoDocumentTypes: Array<string> | null };

export type EphytoByIdQueryVariables = Exact<{
  id: number;
}>;


export type EphytoByIdQuery = { ephytoById: { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null, ephytoTradeUnits: Array<{ id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null }> | null, ephytoConsignmentItems: Array<{ id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null }> | null, ephytoDocuments: Array<{ id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null };

export type EphytoCommonFieldsFragment = { id: string, applicationReferenceNo: string | null, applicationType: number | null, applicationStatus: string | null, cbrId: number | null, cbrBillingId: number | null, customReferenceNo: string | null, agreementCode: string | null, desiredIssueLocation: string | null, notificationEmail: string | null, consignorId: string | null, consignorName: string | null, consignorAddressLine1: string | null, consignorAddressLine2: string | null, consignorAddressLine3: string | null, consigneeId: string | null, consigneeName: string | null, consigneeAddressLine1: string | null, consigneeAddressLine2: string | null, consigneeAddressLine3: string | null, consigneeCountryId: string | null, importCountryId: string | null, targetCountryId: string | null, unloadingBaseportLocation: string | null, transportModeCode: number | null, transportMeans: string | null, paymentType: string | null, dalrrdAccNum: string | null, loadSeaPoint: string | null, targetCountry: string | null, targetRegion: string | null, portOfEntry: string | null, bookingRef: string | null, vessel: string | null, voyageNumber: string | null, departureDate: string | null, numberAndDescriptionOfPackage: string | null, botanicalName: string | null, distinguishingMarks: string | null, placeOfOrigin: string | null, declaredMeansOfConveyance: string | null, declaredPointOfEntry: string | null, nameOfProductAndDeclaredQuantity: string | null, treatmentDate: string | null, treatment: string | null, chemical: string | null, durationAndTemperature: string | null, concentration: string | null, additionalInformation: string | null, state: string | null, errorReason: string | null, stuffDate: string | null, temperatureRegime: string | null, originalPhytoDate: string | null, originalPhytoNo: string | null, reexportPlaceOfOrigin: string | null, originalPhyto: boolean | null, rePacked: boolean | null, originalContainer: boolean | null, basedOnOriginalPhyto: boolean | null, additionalInspection: boolean | null, cbsFreeArea: string | null, vatNo: string | null, regimeCode: string | null, importPermitNo: string | null, importPermitDate: string | null };

export type EphytoTradeUnitCommonFieldsFragment = { id: string, tradeUnitId: string | null, clientRef: string | null, orchard: string | null, phc: string | null, productionArea: string | null, commodity: string | null, marketingIndication: string | null, fleshColour: string | null, tuClass: string | null, containerNumber: string | null, numberOfPackagedItems: string | null, netTradeUnitWeight: string | null, nettPalletWeight: string | null, ppecbInspectionDate: string | null, stuffDate: string | null, inspectionManifestNo: string | null, inspectionPointLocationCode: string | null };

export type EphytoConsignmentItemCommonFieldsFragment = { id: string, description: string | null, commonName: string | null, scientificName: string | null, netWeightMeasureCode: string | null, netWeightMeasure: string | null, grossWeightMeasureCode: string | null, grossWeightMeasure: string | null, customsHarmonizedSystemClass: string | null, commodityVegetablePart: string | null, commodityConditionClass: string | null, commodityIntentOfUseClass: string | null, appliedProcessStartDate: string | null, appliedProcessEndDate: string | null, durationMeasureCode: string | null, durationMeasure: string | null, appliedProcessTreatmentTypeLevel1: string | null, appliedProcessTreatmentTypeLevel2: string | null, appliedProcessChemicalCode: string | null, appliedProcessTemperatureUnitCode: string | null, appliedProcessTemperature: string | null, appliedProcessConcentrationUnitCode: string | null, appliedProcessConcentration: string | null, appliedProcessAdditionalNote: string | null, fullTreatmentInformation: string | null, packageLevelCode: string | null, packageTypeCode: string | null, packageItemUnitCode: string | null, packageItemQuantity: string | null, packageShippingMarks: string | null, additionalConsignmentNotes: string | null, sequenceNumeric: string | null };

export type EphytoDocumentFieldsFragment = { id: string | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null };

export type EstimateConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type EstimateConfigQuery = { uiConfigs: Array<{ id: number, data: any }> | null };

export type EstimateOptionsQueryVariables = Exact<{
  season: number;
}>;


export type EstimateOptionsQuery = { myCompany: { id: number | null, name: string | null, sellers: Array<{ id: number | null, name: string | null }> | null, allCompanies: Array<{ id: number | null, name: string | null }> | null } | null, commodities: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null } | null }> | null, productionUnits: Array<{ id: number | null, name: string | null, typeOfBusiness: string | null, fboCode: string | null, company: { id: number | null, name: string | null } | null }> | null, packhouses: Array<{ id: number | null, name: string | null, typeOfBusiness: string | null, fboCode: string | null, company: { id: number | null } | null }> | null, fboOrchards: Array<{ id: number, hectares: number | null, orchard: string, block: string | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }, foodBusinessOperator: { id: number | null, fboCode: string | null, name: string | null, company: { id: number | null, name: string | null } | null } }> | null, cartonCounts: Array<{ id: number | null, name: string | null, commodityId: number | null, cartonTypeId: number | null, counts: Array<string> | null, priceMetric: string | null, stackSizes: Array<number | null> | null }> | null, commodityDefaultSeasons: Array<{ commodityId: number, minWeek: string, maxWeek: string }> | null };

export type EstimatesQueryVariables = Exact<{
  endWeek?: string | null | undefined;
  startWeek?: string | null | undefined;
  weeks?: boolean | null | undefined;
  season?: number | null | undefined;
  matchCols?: Array<Types.EstimateMatchModeEnum> | Types.EstimateMatchModeEnum | null | undefined;
  commodityIds?: Array<number> | number | null | undefined;
  subCommodityIds?: Array<number> | number | null | undefined;
  varietyIds?: Array<number> | number | null | undefined;
  onlyEditableEstimates?: boolean | null | undefined;
}>;


export type EstimatesQuery = { estimates: Array<{ id: number, week: string | null, season: number, provider: { id: number | null, name: string | null } | null, fboOrchard: { id: number, orchard: string, hectares: number | null, foodBusinessOperator: { company: { id: number | null } | null } } | null, cartonType: { id: number, name: string }, commodity: { id: number | null, name: string | null }, variety: { id: number | null, name: string | null, subCommodity: { name: string | null } | null } | null, productionUnit: { id: number | null, name: string | null, fboCode: string | null, typeOfBusiness: string | null } | null, packHouse: { id: number | null, name: string | null, fboCode: string | null, typeOfBusiness: string | null } | null, visibleCompanies: Array<{ id: number | null, name: string | null }> | null, estimateValues: Array<{ id: number, estType: Types.EstimateValueTypeEnum, value: number, conversionWeight: number | null, grade: string | null, sizeCounts: Array<string> | null, acceptedValue: number, inSeasonValue: number | null }> | null }> | null };

export type OrchardSeasonsQueryVariables = Exact<{
  season: number;
}>;


export type OrchardSeasonsQuery = { orchardSeasons: Array<{ id: number, startDate: string | null, endDate: string | null, hectares: number, plantedDate: string | null, fboOrchard: { orchard: string, foodBusinessOperator: { fboCode: string | null }, variety: { name: string | null, commodity: { id: number | null } | null } } }> | null };

export type OrchardYieldsQueryVariables = Exact<{
  orchardSeasonId?: string | number | null | undefined;
  capturedBefore: string;
  capturedAfter: string;
}>;


export type OrchardYieldsQuery = { orchardYields: Array<{ id: number, weight: number, weightPerBin: number | null, orchardSeasonId: number, captureDate: string | null }> | null };

export type UpdateOrchardSeasonsMutationVariables = Exact<{
  updateData?: Array<Types.OrchardSeasonAttributes> | Types.OrchardSeasonAttributes | null | undefined;
  deleteData?: Array<number> | number | null | undefined;
}>;


export type UpdateOrchardSeasonsMutation = { updateOrchardSeasons: { createSummary: { succeeded: number, failed: number, errors: Array<string> } | null, updateSummary: { succeeded: number, failed: number, errors: Array<string> } | null, deleteSummary: { succeeded: number, failed: number, errors: Array<string> } | null } | null };

export type GenerateCommoditySeasonsMutationVariables = Exact<{
  season: number;
}>;


export type GenerateCommoditySeasonsMutation = { generateCommoditySeasons: { error: string | null, failures: number | null, successes: number | null } | null };

export type UpdateOrchardYieldsMutationVariables = Exact<{
  createData?: Array<Types.OrchardYieldAttributes> | Types.OrchardYieldAttributes | null | undefined;
  updateData?: Array<Types.OrchardYieldAttributes> | Types.OrchardYieldAttributes | null | undefined;
  deleteData?: Array<number> | number | null | undefined;
}>;


export type UpdateOrchardYieldsMutation = { updateOrchardYields: { createSummary: { errors: Array<string>, failed: number, succeeded: number } | null, updateSummary: { succeeded: number, failed: number, errors: Array<string> } | null, deleteSummary: { succeeded: number, failed: number, errors: Array<string> } | null } | null };

export type UpdateEstimatesMutationVariables = Exact<{
  createData?: Array<Types.EstimateAttributes> | Types.EstimateAttributes | null | undefined;
  deleteData?: Array<number> | number | null | undefined;
  updateData?: Array<Types.EstimateAttributes> | Types.EstimateAttributes | null | undefined;
}>;


export type UpdateEstimatesMutation = { updateEstimates: { createSummary: { succeeded: number, failed: number, errors: Array<string> } | null, updateSummary: { succeeded: number, failed: number, errors: Array<string> } | null, deleteSummary: { succeeded: number, failed: number, errors: Array<string> } | null } | null };

export type DocumentsQueryVariables = Exact<{
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  dateAfter?: string | null | undefined;
  dateBefore?: string | null | undefined;
  states?: Array<Types.EtlDocumentStateEnum> | Types.EtlDocumentStateEnum | null | undefined;
  emailFrom?: string | null | undefined;
  emailTo?: string | null | undefined;
  documentTypes?: Array<string> | string | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type DocumentsQuery = { documents: { totalCount: number, nodes: Array<{ createdAt: string, updatedAt: string, errorReason: string | null, erroredRows: number | null, fileUrl: string | null, filename: string, id: number, processedRows: number | null, rows: number | null, state: Types.EtlDocumentStateEnum, source: string | null, documentType: string | null, invoices: Array<{ id: string | null, invoiceNumber: string | null, invoiceDate: string | null, state: Types.InvoiceStateEnum | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null, remittableAmountMajorUnit: number | null, documentType: Types.InvoiceDocumentTypeEnum | null }> | null, invoiceEtlStates: Array<{ invoiceId: number, state: Types.EtlDocumentRowStateEnum | null, processOutput: string | null }> | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } };

export type DocumentQueryVariables = Exact<{
  documentId: number;
}>;


export type DocumentQuery = { document: { createdAt: string, updatedAt: string, errorReason: string | null, erroredRows: number | null, fileUrl: string | null, filename: string, id: number, processedRows: number | null, rows: number | null, state: Types.EtlDocumentStateEnum, source: string | null, documentType: string | null, invoices: Array<{ id: string | null, invoiceNumber: string | null, invoiceDate: string | null, state: Types.InvoiceStateEnum | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null, remittableAmountMajorUnit: number | null, documentType: Types.InvoiceDocumentTypeEnum | null }> | null, invoiceEtlStates: Array<{ invoiceId: number, state: Types.EtlDocumentRowStateEnum | null, processOutput: string | null }> | null } };

export type DocumentRowsQueryVariables = Exact<{
  after?: string | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  documentId: number;
  states?: Array<Types.EtlDocumentRowStateEnum> | Types.EtlDocumentRowStateEnum | null | undefined;
}>;


export type DocumentRowsQuery = { documentRows: { totalCount: number, nodes: Array<{ createdAt: string, errorReason: string | null, id: number, processOutput: string | null, state: Types.EtlDocumentRowStateEnum, value: any } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } };

export type UploadEtlDocumentMutationVariables = Exact<{
  documentId: number;
  file: File;
}>;


export type UploadEtlDocumentMutation = { uploadEtlDocument: { document: { createdAt: string, updatedAt: string, errorReason: string | null, erroredRows: number | null, fileUrl: string | null, filename: string, id: number, processedRows: number | null, rows: number | null, state: Types.EtlDocumentStateEnum, source: string | null, documentType: string | null, invoices: Array<{ id: string | null, invoiceNumber: string | null, invoiceDate: string | null, state: Types.InvoiceStateEnum | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null, remittableAmountMajorUnit: number | null, documentType: Types.InvoiceDocumentTypeEnum | null }> | null, invoiceEtlStates: Array<{ invoiceId: number, state: Types.EtlDocumentRowStateEnum | null, processOutput: string | null }> | null } | null } | null };

export type ProcessEtlDocumentMutationVariables = Exact<{
  documentId: number;
}>;


export type ProcessEtlDocumentMutation = { processEtlDocument: { document: { createdAt: string, updatedAt: string, errorReason: string | null, erroredRows: number | null, fileUrl: string | null, filename: string, id: number, processedRows: number | null, rows: number | null, state: Types.EtlDocumentStateEnum, source: string | null, documentType: string | null, invoices: Array<{ id: string | null, invoiceNumber: string | null, invoiceDate: string | null, state: Types.InvoiceStateEnum | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null, remittableAmountMajorUnit: number | null, documentType: Types.InvoiceDocumentTypeEnum | null }> | null, invoiceEtlStates: Array<{ invoiceId: number, state: Types.EtlDocumentRowStateEnum | null, processOutput: string | null }> | null } | null } | null };

export type DocumentFieldsFragment = { createdAt: string, updatedAt: string, errorReason: string | null, erroredRows: number | null, fileUrl: string | null, filename: string, id: number, processedRows: number | null, rows: number | null, state: Types.EtlDocumentStateEnum, source: string | null, documentType: string | null, invoices: Array<{ id: string | null, invoiceNumber: string | null, invoiceDate: string | null, state: Types.InvoiceStateEnum | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null, remittableAmountMajorUnit: number | null, documentType: Types.InvoiceDocumentTypeEnum | null }> | null, invoiceEtlStates: Array<{ invoiceId: number, state: Types.EtlDocumentRowStateEnum | null, processOutput: string | null }> | null };

export type FarmVarietyFragment = { id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, commodity: { id: number | null, name: string | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null };

export type CreateFarmVarietyMutationVariables = Exact<{
  attributes: Types.CreateFarmVarietyAttributes;
}>;


export type CreateFarmVarietyMutation = { createFarmVariety: { farmVariety: { id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, commodity: { id: number | null, name: string | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null } | null } | null };

export type UpdateFarmVarietyMutationVariables = Exact<{
  attributes: Types.UpdateFarmVarietyAttributes;
}>;


export type UpdateFarmVarietyMutation = { updateFarmVariety: { farmVariety: { id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, commodity: { id: number | null, name: string | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null } | null } | null };

export type DeleteFarmVarietyMutationVariables = Exact<{
  varietyid: number;
  companyId: number;
}>;


export type DeleteFarmVarietyMutation = { deleteFarmVariety: { farmVariety: { id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, commodity: { id: number | null, name: string | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null } | null } | null };

export type UploadFarmVarietyImageMutationVariables = Exact<{
  id: number;
  image: File;
}>;


export type UploadFarmVarietyImageMutation = { uploadFarmVarietyImage: { farmVariety: { id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, commodity: { id: number | null, name: string | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null } | null } | null };

export type DeleteFarmVarietyImageMutationVariables = Exact<{
  varietyid: number;
  imageid: number;
}>;


export type DeleteFarmVarietyImageMutation = { deleteFarmVarietyImage: { farmVariety: { id: number | null, varietyId: number | null, name: string | null, peakCount: string | null, hectares: number | null, packingStart: string | null, packingEnd: string | null, commodity: { id: number | null, name: string | null } | null, images: Array<{ id: number | null, url: string | null, v2Url: string | null, filename: string | null, thumbnailUrl: string | null, v2ThumbnailUrl: string | null }> | null } | null } | null };

export type FinanceReportQueryVariables = Exact<{
  attributes: Types.FinanceReportFilterAttributes;
}>;


export type FinanceReportQuery = { financeReport: { items: Array<{ commodity: string | null, variety: string | null, amount: number | null, amountPerCarton: number | null, batchNumber: string | null, buyer: string | null, packType: string | null, cartons: number | null, stdCartons: number | null, containerNumber: string | null, currency: string | null, exchangeRate: number | null, exporterCode: string | null, farmCode: string | null, grade: string | null, incoterm: string | null, isActual: boolean | null, palletNumber: string | null, liReferenceNumber: string | null, txReferenceNumber: string | null, seller: string | null, sizeCount: string | null, state: string | null, targetMarket: string | null, targetRegion: string | null, transactionDate: string | null, transactionType: string | null, transactionWeek: string | null, shippingWeek: string | null, packingWeek: string | null, generalLedgerName: string | null, secondaryCategory: string | null, primaryCategory: string | null, zarAmount: number | null, zarPerCarton: number | null }> | null } | null };

export type LatestCurrencyConversionQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestCurrencyConversionQuery = { latestCurrencyConversion: { rates: any, timestamp: string | null } | null };

export type GetFinanceRulesQueryVariables = Exact<{
  filterAttributes: Types.FinanceRuleFilters;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  grouped?: boolean | null | undefined;
  groupType?: string | null | undefined;
}>;


export type GetFinanceRulesQuery = { financeRules: { totalCount: number, nodes: Array<{ id: string, name: string, amountCents: number | null, createdAt: string, currency: string | null, enabled: boolean | null, endDate: string | null, incotermForPercentageCalculation: string | null, simpleExpression: string | null, simpleExpressionFields: Array<string> | null, simpleExpressionMatchTypes: Array<string> | null, simpleExpressionValues: Array<string> | null, humanReadableExpression: string | null, percentage: number | null, startDate: string | null, unit: Types.FinanceRuleUnitEnum | null, isDefaultCost: boolean, ruleDescription: string | null, updatedAt: string, defaultCgtsPendingReview: number | null, defaultCgtsFinalised: number | null, formattedCost: string | null, company: { id: number | null, name: string | null } | null, costCode: { id: number, name: string } | null, matchCondition: { id: string } | null, groupedCostCodes: Array<{ financeRuleId: string | null, startDate: string, endDate: string | null, costCode: { id: number, name: string } }> | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type FinanceRulesFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceRulesFilterAttributesQuery = { financeRulesFilterAttributes: { ruleNames: Array<string> | null, currencies: Array<string> | null, units: Array<string> | null, startDates: Array<string> | null, endDates: Array<string> | null, enabled: Array<boolean> | null, isDefaultCost: boolean | null, costCodes: Array<{ id: number, name: string }> | null } | null };

export type UpsertFinanceRulesMutationVariables = Exact<{
  attributesList: Array<Types.FinanceRuleAttributes> | Types.FinanceRuleAttributes;
}>;


export type UpsertFinanceRulesMutation = { upsertFinanceRule: { success: boolean, errors: Array<{ message: string }> | null, financeRules: Array<{ id: string, name: string, unit: Types.FinanceRuleUnitEnum | null, amountCents: number | null, currency: string | null, incotermForPercentageCalculation: string | null, percentage: number | null, startDate: string | null, endDate: string | null, createdAt: string, updatedAt: string }> | null } | null };

export type DeleteFinanceRuleMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type DeleteFinanceRuleMutation = { deleteFinanceRule: { success: boolean, errors: string | null } | null };

export type GetAllowedOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedOptionsQuery = { allowedUnits: Array<string>, allowedIncoterms: Array<string>, allowedCurrencies: Array<string>, allowedMatchTypes: Array<string> };

export type CreateFinanceRuleMutationVariables = Exact<{
  attributes: Array<Types.FinanceRuleAttributes> | Types.FinanceRuleAttributes;
}>;


export type CreateFinanceRuleMutation = { createFinanceRule: { errors: string | null, financeRules: Array<{ id: string }> | null } | null };

export type UpdateFinanceRuleMutationVariables = Exact<{
  attributes: Array<Types.FinanceRuleAttributes> | Types.FinanceRuleAttributes;
  deleteIds?: Array<string | number> | string | number | null | undefined;
}>;


export type UpdateFinanceRuleMutation = { updateFinanceRule: { errors: string | null, financeRules: Array<{ id: string }> | null } | null };

export type UpdateFinanceRuleEnabledStateMutationVariables = Exact<{
  updateIds: Array<string | number> | string | number;
  state: boolean;
}>;


export type UpdateFinanceRuleEnabledStateMutation = { updateFinanceRuleEnabledState: { errors: string | null, financeRules: Array<{ id: string }> | null } | null };

export type TradeCompaniesQueryVariables = Exact<{
  id: string | number;
}>;


export type TradeCompaniesQuery = { company: { id: number | null, buyers: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, tradeRegions: Array<{ id: number | null, name: string | null, code: string | null, countries: Array<{ id: number | null, name: string | null, code: string | null }> | null }> | null } | null };

export type GenerateProducerStatementMutationVariables = Exact<{
  cartonGroupingIds: Array<number> | number;
  fileFormat: Types.TemplateFileFormatEnum;
  reportingCurrency?: string | null | undefined;
}>;


export type GenerateProducerStatementMutation = { generateProducerStatement: { fileUrl: string | null, statementNumber: string } | null };

export type InviteUserMutationVariables = Exact<{
  email: string;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
}>;


export type InviteUserMutation = { inviteUser: { invite: { id: number | null, email: string | null, state: string | null, message: string | null, createdAt: string | null, updatedAt: string | null } | null } | null };

export type RevokeInviteMutationVariables = Exact<{
  id: number;
}>;


export type RevokeInviteMutation = { revokeInvite: { id: number | null } | null };

export type ResendInviteMutationVariables = Exact<{
  id: number;
}>;


export type ResendInviteMutation = { resendInvite: { id: number | null } | null };

export type InvoicesSummaryQueryVariables = Exact<{
  filterAttributes: Types.InvoicesFilters;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  page: string;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type InvoicesSummaryQuery = { invoices: { totalCount: number, nodes: Array<{ invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, id: string | null, currency: Types.CurrencyEnum | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, advancePayment: string | null, finalPayment: string | null, exchangeRate: string | null, allocatedAmountMajorUnit: number | null, remainingAmountMajorUnit: number | null, remittableAmountMajorUnit: number | null, palletCount: number | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, updatedAt: string | null, createdAt: string | null, costs: string | null, dueDate: string | null, dueDateFinal: string | null, dueDateAdvance: string | null, poNumber: string | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, containers: Array<{ containerNumber: string | null }> | null, contacts: Array<{ name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, linkedRecords: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null, invoiceDate: string | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null }> | null, invoicePayments: Array<{ id: string, amountMajorUnit: number, createdAt: string, payment: { id: string | null, description: string | null, paymentDate: string | null, totalAmountMajorUnit: string | null, currency: string | null, paymentType: Types.PaymentTypeEnum | null, state: Types.PaymentStateEnum | null } }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null } | null, sentEmailList: Array<{ id: string, createdAt: string, recipient: string | null, attachments: any }> | null, attachedDocuments: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null, uploadedAt: string | null }> | null, accountingExports: Array<{ id: string, exportedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null } }> | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type PopulateInvoiceContainerDataQueryVariables = Exact<{
  containerId: number;
  selectedCurrency: string;
  invoiceType: string;
  cgIds: Array<number> | number;
  commercialTermId?: number | null | undefined;
}>;


export type PopulateInvoiceContainerDataQuery = { populateInvoiceContainerData: { voyage: string | null, invoiceLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, commercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null, finalCreditTerm: number | null } | null } | null };

export type InvoicesSummaryFieldsFragment = { invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, id: string | null, currency: Types.CurrencyEnum | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, advancePayment: string | null, finalPayment: string | null, exchangeRate: string | null, allocatedAmountMajorUnit: number | null, remainingAmountMajorUnit: number | null, remittableAmountMajorUnit: number | null, palletCount: number | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, updatedAt: string | null, createdAt: string | null, costs: string | null, dueDate: string | null, dueDateFinal: string | null, dueDateAdvance: string | null, poNumber: string | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, containers: Array<{ containerNumber: string | null }> | null, contacts: Array<{ name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, linkedRecords: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null, invoiceDate: string | null, currency: Types.CurrencyEnum | null, netAmountMajorUnit: string | null }> | null, invoicePayments: Array<{ id: string, amountMajorUnit: number, createdAt: string, payment: { id: string | null, description: string | null, paymentDate: string | null, totalAmountMajorUnit: string | null, currency: string | null, paymentType: Types.PaymentTypeEnum | null, state: Types.PaymentStateEnum | null } }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null } | null, sentEmailList: Array<{ id: string, createdAt: string, recipient: string | null, attachments: any }> | null, attachedDocuments: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null, uploadedAt: string | null }> | null, accountingExports: Array<{ id: string, exportedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null } }> | null };

export type InvoiceQueryVariables = Exact<{
  id: number;
}>;


export type InvoiceQuery = { invoice: { cartonCount: number | null, convertTonToKg: boolean | null, currency: Types.CurrencyEnum | null, localCosts: number | null, insuranceCost: number | null, freightCost: number | null, invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, totalFob: number | null, advancePayment: string | null, advanceCreditTerm: number | null, finalPayment: string | null, allocatedAmountMajorUnit: number | null, finalCreditTerm: number | null, dueDateFinal: string | null, subTotal: number | null, vat: number | null, id: string | null, palletCount: number | null, poNumber: string | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, ucrNumber: string | null, voyage: string | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, vehicleNumber: string | null, saleType: string | null, parentInvoiceId: number | null, invoiceLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null, currencyExchangeRate: { id: string, fromCurrency: string, toCurrency: string, exchangeRate: string, exchangeRateDate: string, exchangeRateType: string, currencyConversion: { id: string | null, rates: any, timestamp: string | null } | null } | null, attachedDocuments: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null, linkedAdvanceInvoice: { id: string | null, invoiceNumber: string | null, advancePayment: string | null } | null, overRecoveryCreditNote: { id: string | null, invoiceNumber: string | null, totalIncoterm: string | null } | null, invoiceCustomFields: Array<{ customFieldId: number | null, name: string | null, required: boolean | null, value: string | null, defaultValue: string | null, isDefault: boolean | null, customFieldDeleted: boolean }> | null, countryOfOrigin: { id: number | null, name: string | null } | null, contacts: Array<{ id: number | null, info: string | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, containers: Array<{ containerNumber: string | null, id: number | null }> | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, stuffLocation: { id: number | null, name: string | null } | null, loadingPoint: { id: number | null, name: string | null } | null, offloadingPoint: { id: number | null, name: string | null } | null, vatType: { id: string, name: string | null, percentage: number | null } | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, advancePayment: string | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null } | null, commercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null, finalCreditTerm: number | null } | null } | null };

export type PopulateInvoiceFromParentQueryVariables = Exact<{
  parentInvoiceId: number;
  documentType: string;
}>;


export type PopulateInvoiceFromParentQuery = { populateInvoiceFromParent: { errors: Array<string> | null, invoice: { cartonCount: number | null, convertTonToKg: boolean | null, currency: Types.CurrencyEnum | null, localCosts: number | null, insuranceCost: number | null, freightCost: number | null, invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, totalFob: number | null, advancePayment: string | null, advanceCreditTerm: number | null, finalPayment: string | null, allocatedAmountMajorUnit: number | null, finalCreditTerm: number | null, dueDateFinal: string | null, subTotal: number | null, vat: number | null, id: string | null, palletCount: number | null, poNumber: string | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, ucrNumber: string | null, voyage: string | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, vehicleNumber: string | null, saleType: string | null, parentInvoiceId: number | null, invoiceCustomFields: Array<{ customFieldId: number | null, name: string | null, required: boolean | null, value: string | null, defaultValue: string | null, isDefault: boolean | null, customFieldDeleted: boolean }> | null, countryOfOrigin: { id: number | null, name: string | null } | null, contacts: Array<{ id: number | null, info: string | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, containers: Array<{ containerNumber: string | null, id: number | null }> | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, stuffLocation: { id: number | null, name: string | null } | null, loadingPoint: { id: number | null, name: string | null } | null, offloadingPoint: { id: number | null, name: string | null } | null, vatType: { id: string, name: string | null, percentage: number | null } | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, advancePayment: string | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null } | null, commercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null, finalCreditTerm: number | null } | null } | null, revenueLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null } | null };

export type IncomeInvoiceLineItemsQueryVariables = Exact<{
  id: string | number;
}>;


export type IncomeInvoiceLineItemsQuery = { incomeInvoiceLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null };

export type CostInvoiceLineItemsQueryVariables = Exact<{
  id: string | number;
}>;


export type CostInvoiceLineItemsQuery = { costInvoiceLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null };

export type InvoiceCartonGroupingTransactionsQueryVariables = Exact<{
  id: number;
}>;


export type InvoiceCartonGroupingTransactionsQuery = { invoiceCartonGroupingTransactions: Array<{ amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, quantityType: string | null, quantityPriceMajorUnit: string | null, cartonGrouping: { palletNumber: string | null, cartons: number | null } | null }> | null };

export type InvoiceFilterAttributesQueryVariables = Exact<{
  page: string;
}>;


export type InvoiceFilterAttributesQuery = { invoicesFilterAttributes: { incoterms: Array<Types.IncotermEnum> | null, states: Array<string> | null, targetCountries: Array<string>, invoiceNumbers: Array<string> | null, transportTypes: Array<string> | null, containers: Array<string> | null, palletNumbers: Array<string> | null, costCodes: Array<string> | null, exportStatuses: Array<Types.InvoiceAccountingExportFilterEnum> | null, vessels: Array<{ id: number | null, vesselName: string | null }> | null, contacts: Array<{ id: number | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, varieties: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, documentTypes: Array<{ type: string, name: string }>, financialYearOptions: Array<{ year: number, label: string, startDate: string, endDate: string }> | null } | null };

export type InvoiceNumberQueryVariables = Exact<{
  documenttype?: string | null | undefined;
}>;


export type InvoiceNumberQuery = { invoiceNumber: string | null };

export type InvoiceSeaPortsQueryVariables = Exact<{
  limit?: number | null | undefined;
  seaportname?: string | null | undefined;
  isportofloading?: boolean | null | undefined;
  orderbyinv?: boolean | null | undefined;
}>;


export type InvoiceSeaPortsQuery = { seaPorts: Array<{ id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string }> | null };

export type InvoiceScrollTradeCountriesQueryVariables = Exact<{
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  searchTerm?: string | null | undefined;
}>;


export type InvoiceScrollTradeCountriesQuery = { invoiceScrollTradeCountries: { nodes: Array<{ id: number | null, name: string | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type InvoiceVesselsQueryVariables = Exact<{
  limit?: number | null | undefined;
  seaportid?: number | null | undefined;
  vesselname?: string | null | undefined;
}>;


export type InvoiceVesselsQuery = { vessels: Array<{ id: number | null, vesselName: string | null }> | null };

export type InvoiceVoyagesQueryVariables = Exact<{
  vesselid: number;
  seaportid?: number | null | undefined;
}>;


export type InvoiceVoyagesQuery = { voyages: Array<string> | null };

export type InvoiceContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoiceContactsQuery = { contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null };

export type VatTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type VatTypesQuery = { vatTypes: Array<{ id: string, name: string | null, percentage: number | null }> | null };

export type InvoiceContainersQueryVariables = Exact<{
  limit?: number | null | undefined;
  port?: number | null | undefined;
  containernumber?: string | null | undefined;
  excludesassignedinvlis?: boolean | null | undefined;
  onlytrackingenabled?: boolean | null | undefined;
}>;


export type InvoiceContainersQuery = { containers: Array<{ containerNumber: string | null, id: number | null, stuffDate: string | null }> | null };

export type InvoiceUnassignedCGsQueryVariables = Exact<{
  attributes: Types.CartonGroupingSearchAttributes;
}>;


export type InvoiceUnassignedCGsQuery = { cartonGroupingsSearch: { cartonGroupings: Array<{ batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null }>, filterValues: { batchNumber: Array<string> | null, consignmentNumber: Array<string> | null, packingWeek: Array<string> | null, targetMarket: Array<string> | null, exporterCode: Array<string> | null, voyageNumber: Array<string> | null, vessel: Array<{ id: number | null, vesselName: string | null }> | null, variety: Array<{ id: number | null, name: string | null }> | null, seller: Array<{ id: number | null, name: string | null }> | null, buyer: Array<{ id: number | null, name: string | null }> | null } | null } | null };

export type FetchCgCommercialTermQueryVariables = Exact<{
  cgId: string | number;
}>;


export type FetchCgCommercialTermQuery = { fetchCgCommercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null } | null };

export type InvoiceCustomFieldsQueryVariables = Exact<{
  excludedCustomFieldIds?: Array<number> | number | null | undefined;
}>;


export type InvoiceCustomFieldsQuery = { customFields: Array<{ id: number | null, name: string | null, required: boolean | null, isDefault: boolean | null, defaultValue: string | null }> | null };

export type CompanyCostCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyCostCodesQuery = { companyCostCodes: Array<{ id: number, name: string }> | null };

export type CreateQuickCostMutationVariables = Exact<{
  attributes: Types.QuickCostAttributes;
}>;


export type CreateQuickCostMutation = { createQuickCost: { errors: string | null } | null };

export type CalculatePalletCostsMutationVariables = Exact<{
  cgIds: Array<number> | number;
  costId: number;
}>;


export type CalculatePalletCostsMutation = { calculatePalletCosts: { estimatePalletCosts: number, errors: string | null } | null };

export type CreateContactMutationVariables = Exact<{
  attributes: Types.ContactAttributes;
}>;


export type CreateContactMutation = { createContact: { errors: string | null, contact: { id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null } | null } | null };

export type UpdateContactMutationVariables = Exact<{
  attributes: Types.ContactAttributes;
}>;


export type UpdateContactMutation = { updateContact: { errors: string | null, contact: { id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null } | null } | null };

export type DeleteContactMutationVariables = Exact<{
  id: number;
}>;


export type DeleteContactMutation = { deleteContact: { success: boolean | null, errors: string | null } | null };

export type CreateCustomFieldMutationVariables = Exact<{
  attributes: Types.CustomFieldAttributes;
}>;


export type CreateCustomFieldMutation = { createCustomField: { errors: string | null, customField: { id: number | null, name: string | null, required: boolean | null, isDefault: boolean | null, defaultValue: string | null } | null } | null };

export type UpdateCustomFieldMutationVariables = Exact<{
  attributes: Types.CustomFieldAttributes;
}>;


export type UpdateCustomFieldMutation = { updateCustomField: { errors: string | null, customField: { id: number | null, name: string | null, required: boolean | null, isDefault: boolean | null, defaultValue: string | null } | null } | null };

export type DeleteCustomFieldMutationVariables = Exact<{
  id: number;
}>;


export type DeleteCustomFieldMutation = { deleteCustomField: { success: boolean | null, errors: string | null } | null };

export type CreateInvoiceMutationVariables = Exact<{
  attributes: Types.InvoiceAttributes;
  currencyExchangeRateAttributes?: Types.CurrencyExchangeRateAttributes | null | undefined;
}>;


export type CreateInvoiceMutation = { createInvoice: { errors: string | null, invoice: { cartonCount: number | null, convertTonToKg: boolean | null, currency: Types.CurrencyEnum | null, localCosts: number | null, insuranceCost: number | null, freightCost: number | null, invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, totalFob: number | null, advancePayment: string | null, advanceCreditTerm: number | null, finalPayment: string | null, allocatedAmountMajorUnit: number | null, finalCreditTerm: number | null, dueDateFinal: string | null, subTotal: number | null, vat: number | null, id: string | null, palletCount: number | null, poNumber: string | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, ucrNumber: string | null, voyage: string | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, vehicleNumber: string | null, saleType: string | null, parentInvoiceId: number | null, cartonGroupings: Array<{ batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null }> | null, invoiceLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null, invoiceCustomFields: Array<{ customFieldId: number | null, name: string | null, required: boolean | null, value: string | null, defaultValue: string | null, isDefault: boolean | null, customFieldDeleted: boolean }> | null, countryOfOrigin: { id: number | null, name: string | null } | null, contacts: Array<{ id: number | null, info: string | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, containers: Array<{ containerNumber: string | null, id: number | null }> | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, stuffLocation: { id: number | null, name: string | null } | null, loadingPoint: { id: number | null, name: string | null } | null, offloadingPoint: { id: number | null, name: string | null } | null, vatType: { id: string, name: string | null, percentage: number | null } | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, advancePayment: string | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null } | null, commercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null, finalCreditTerm: number | null } | null } | null } | null };

export type CalculateCommercialsMutationVariables = Exact<{
  attributes: Types.InvoiceAttributes;
}>;


export type CalculateCommercialsMutation = { calculateCommercials: { errors: string | null, advancePayment: string | null, finalPayment: string | null, advanceCreditTerm: number | null, finalCreditTerm: number | null } | null };

export type DuplicateInvoiceMutationVariables = Exact<{
  id: string | number;
  documentType: string;
  shouldDuplicateLineItems: boolean;
}>;


export type DuplicateInvoiceMutation = { duplicateInvoice: { errors: string | null, id: string | null } | null };

export type CaptureAccountSaleMutationVariables = Exact<{
  id: string | number;
}>;


export type CaptureAccountSaleMutation = { captureAccountSale: { errors: string | null, id: string | null } | null };

export type CreateInvoiceFromBatchMutationVariables = Exact<{
  invoiceIds: Array<string | number> | string | number;
  documentType: string;
}>;


export type CreateInvoiceFromBatchMutation = { createInvoiceFromBatch: { errors: string | null, invoice: { id: string | null } | null } | null };

export type UpdateInvoiceMutationVariables = Exact<{
  attributes: Types.InvoiceAttributes;
  currencyExchangeRateAttributes?: Types.CurrencyExchangeRateAttributes | null | undefined;
}>;


export type UpdateInvoiceMutation = { updateInvoice: { errors: string | null, invoice: { cartonCount: number | null, convertTonToKg: boolean | null, currency: Types.CurrencyEnum | null, localCosts: number | null, insuranceCost: number | null, freightCost: number | null, invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, totalFob: number | null, advancePayment: string | null, advanceCreditTerm: number | null, finalPayment: string | null, allocatedAmountMajorUnit: number | null, finalCreditTerm: number | null, dueDateFinal: string | null, subTotal: number | null, vat: number | null, id: string | null, palletCount: number | null, poNumber: string | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, ucrNumber: string | null, voyage: string | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, vehicleNumber: string | null, saleType: string | null, parentInvoiceId: number | null, cartonGroupings: Array<{ batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null }> | null, invoiceLineItems: Array<{ id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null }> | null, invoiceCustomFields: Array<{ customFieldId: number | null, name: string | null, required: boolean | null, value: string | null, defaultValue: string | null, isDefault: boolean | null, customFieldDeleted: boolean }> | null, countryOfOrigin: { id: number | null, name: string | null } | null, contacts: Array<{ id: number | null, info: string | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, containers: Array<{ containerNumber: string | null, id: number | null }> | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, stuffLocation: { id: number | null, name: string | null } | null, loadingPoint: { id: number | null, name: string | null } | null, offloadingPoint: { id: number | null, name: string | null } | null, vatType: { id: string, name: string | null, percentage: number | null } | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, advancePayment: string | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null } | null, commercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null, finalCreditTerm: number | null } | null } | null, reconciliationDocuments: Array<{ id: string, invoiceNumber: string, documentType: string }> | null } | null };

export type DeleteInvoiceMutationVariables = Exact<{
  id: number;
}>;


export type DeleteInvoiceMutation = { deleteInvoice: { errors: string | null } | null };

export type CalculateInvoiceTotalsMutationVariables = Exact<{
  attributes: Types.InvoiceIncotermAttributes;
}>;


export type CalculateInvoiceTotalsMutation = { calculateInvoiceIncoterm: { invoice: { id: string | null, cartonCount: number | null, currency: Types.CurrencyEnum | null, freightCost: number | null, insuranceCost: number | null, localCosts: number | null, palletCount: number | null, totalFob: number | null, totalIncoterm: string | null, incoterm: Types.IncotermEnum | null, invoiceDate: string | null, advancePayment: string | null, advanceCreditTerm: number | null, finalPayment: string | null, finalCreditTerm: number | null, state: Types.InvoiceStateEnum | null } | null } | null };

export type GenerateInvoiceOutputFilesMutationVariables = Exact<{
  invoiceId: string | number;
}>;


export type GenerateInvoiceOutputFilesMutation = { generateInvoiceOutputFiles: { templateOutput: Array<{ errorReason: string | null, id: string | null, state: string | null, templateVariant: string | null }> | null } | null };

export type CgtCommonFieldsFragment = { id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null };

export type InvliCommonFieldsFragment = { id: string | null, cartons: number | null, currency: Types.CurrencyEnum | null, netMass: number | null, palletGrossMass: number | null, priceUnit: string | null, targetMarket: string | null, sizeCount: string | null, grade: string | null, mark: string | null, pack: string | null, priceMinorUnit: number | null, quantityAmount: number | null, amount: number | null, cartonGroupingTransactions: Array<{ id: number | null, transactionDate: string | null, amountMajorUnit: string | null, currency: Types.CurrencyEnum | null, exchangeRate: number | null, exchangeCurrency: string | null, externalReferenceNum: string | null, isActual: boolean, createdAt: string | null, updatedAt: string | null, quantityType: string | null, quantityPriceMajorUnit: string | null, quantityAmount: string | null, netMass: number | null, palletGrossMass: number | null, accountType: string | null, cartons: number | null, targetMarket: string | null, advanceTransactionUnitPrice: string | null, cartonGrouping: { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null } | null }> | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null } | null, costCode: { id: number, name: string, costType: string, fieldName: string } | null, vatType: { id: string, name: string | null } | null };

export type InvCommonFieldsFragment = { cartonCount: number | null, convertTonToKg: boolean | null, currency: Types.CurrencyEnum | null, localCosts: number | null, insuranceCost: number | null, freightCost: number | null, invoiceNumber: string | null, invoiceDate: string | null, incoterm: Types.IncotermEnum | null, totalFob: number | null, advancePayment: string | null, advanceCreditTerm: number | null, finalPayment: string | null, allocatedAmountMajorUnit: number | null, finalCreditTerm: number | null, dueDateFinal: string | null, subTotal: number | null, vat: number | null, id: string | null, palletCount: number | null, poNumber: string | null, totalIncoterm: string | null, totalCostsMajorUnit: string | null, netAmountMajorUnit: string | null, ucrNumber: string | null, voyage: string | null, transportType: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, state: Types.InvoiceStateEnum | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, vehicleNumber: string | null, saleType: string | null, parentInvoiceId: number | null, invoiceCustomFields: Array<{ customFieldId: number | null, name: string | null, required: boolean | null, value: string | null, defaultValue: string | null, isDefault: boolean | null, customFieldDeleted: boolean }> | null, countryOfOrigin: { id: number | null, name: string | null } | null, contacts: Array<{ id: number | null, info: string | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, containers: Array<{ containerNumber: string | null, id: number | null }> | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: Array<{ id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null }> | null, childInvoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null }> | null, stuffLocation: { id: number | null, name: string | null } | null, loadingPoint: { id: number | null, name: string | null } | null, offloadingPoint: { id: number | null, name: string | null } | null, vatType: { id: string, name: string | null, percentage: number | null } | null, parentInvoice: { id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, advancePayment: string | null, finalPayment: string | null, state: Types.InvoiceStateEnum | null } | null, commercialTerm: { id: number | null, paymentTerm: string | null, advanceAmount: number | null, advanceCreditTerm: number | null, advanceType: string | null, advanceUnit: string | null, finalCreditTerm: number | null } | null };

export type InvCommonCgFieldsFragment = { batchNumber: string | null, containerNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, advancePrice: number | null, finalPrice: number | null, buyer: { name: string | null } | null, invoiceLineItems: Array<{ invoiceId: string | null, priceUnit: string | null, currency: Types.CurrencyEnum | null, documentType: string | null }> | null, lineItem: { priceUnit: string | null, priceMinorUnit: number | null, currency: string | null, orderId: number | null } | null, seller: { name: string | null } | null, variety: { id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { name: string | null } | null } | null };

export type InvPortFieldsFragment = { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string };

export type UpdateInvoiceStateMutationVariables = Exact<{
  id: number;
  state: string;
}>;


export type UpdateInvoiceStateMutation = { updateInvoiceState: { errors: Array<string> | null, invoice: { id: string | null, state: Types.InvoiceStateEnum | null } | null } | null };

export type UploadInvoiceDocumentsMutationVariables = Exact<{
  invoiceId: string | number;
  files: Array<File> | File;
}>;


export type UploadInvoiceDocumentsMutation = { uploadInvoiceDocuments: { errors: Array<string>, warnings: Array<string> | null, invoice: { id: string | null } | null } | null };

export type DeleteInvoiceDocumentMutationVariables = Exact<{
  invoiceId: string | number;
  documentId: string | number;
}>;


export type DeleteInvoiceDocumentMutation = { deleteInvoiceDocument: { errors: Array<string>, invoice: { id: string | null } | null } | null };

export type LineItemQueryVariables = Exact<{
  lineItemId: string | number;
  unit?: string | null | undefined;
  currency?: Types.CurrencyEnum | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type LineItemQuery = { lineItem: { expectedReturnSummary: { unit: string | null, error: string | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } }, chargesApplied: Array<{ name: string, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } } }> | null }> | null } | null } | null };

export type HistoricalMarketVolumesQueryVariables = Exact<{
  companyId: string | number;
  commodityId: string | number;
  regionCode: string;
}>;


export type HistoricalMarketVolumesQuery = { historicalMarketVolumes: Array<{ companyName: string | null, targetRegion: string | null, commodityName: string | null, grade: string | null }> | null };

export type ExpectedReturnSummaryFieldsFragment = { unit: string | null, error: string | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } }, chargesApplied: Array<{ name: string, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } } }> | null }> | null };

export type CreateIncotermLineItemMutationVariables = Exact<{
  attributes: Types.CreateLineItemAttributes;
  buyerId?: string | number | null | undefined;
  sellerId?: string | number | null | undefined;
  currency?: Types.CurrencyEnum | null | undefined;
  unit?: string | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type CreateIncotermLineItemMutation = { createIncotermLineItem: { errors: string | null, lineItem: { expectedReturnSummary: { unit: string | null, error: string | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } }, chargesApplied: Array<{ name: string, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } } }> | null }> | null } | null } | null } | null };

export type CreateIncotermLineItemsMutationVariables = Exact<{
  lineItemAttributes: Array<Types.CreateLineItemAttributes> | Types.CreateLineItemAttributes;
  currency?: Types.CurrencyEnum | null | undefined;
  unit?: string | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type CreateIncotermLineItemsMutation = { createIncotermLineItems: { errors: Array<string> | null, lineItems: Array<{ expectedReturnSummary: { unit: string | null, error: string | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } }, chargesApplied: Array<{ name: string, moneyAmount: { displayString: string, fractional: number, amount: number, currency: { symbol: string, isoCode: Types.Iso4217, smallestDenomination: number, subunitToUnit: number } } }> | null }> | null } | null }> | null } | null };

export type LoisSummaryQueryVariables = Exact<{
  filterAttributes?: Types.LoadOutInstructionsFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type LoisSummaryQuery = { loadOutInstructions: { totalCount: number, nodes: Array<{ loadOutReference: string | null, bookingReference: string | null, containerNumber: string | null, transportType: Types.TransportTypeEnum | null, exportersReference: string | null, shippingLine: string | null, clientReference: string | null, voyage: string | null, portOfLoadingName: string | null, portOfDestinationName: string | null, estimatedTimeOfDelivery: string | null, exporterName: string | null, stuffDate: string | null, vesselName: string | null, truckReference: string | null, consignmentReference: string | null, orderReference: string | null, loadDate: string | null, id: string | null, fileNumber: string | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, flightDate: string | null, updatedAt: string | null, createdAt: string | null, palletCount: string | null, stackDates: string | null, stackDatesClose: string | null, contacts: Array<{ name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, loadingPoint: { name: string | null } | null, offloadingPoint: { name: string | null } | null, sentEmailList: Array<{ id: string, createdAt: string, recipient: string | null, attachments: any }> | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null }> | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type LoiFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type LoiFilterAttributesQuery = { loadOutInstructionsFilterAttributes: { commodities: Array<{ id: number | null, name: string | null }> | null, vessels: Array<{ id: number | null, vesselName: string | null }> | null, varieties: Array<{ id: number | null, name: string | null }> | null, exporters: Array<{ id: number | null, name: string | null }> | null, contacts: Array<{ id: number | null, name: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, loadingPoints: Array<{ id: number | null, name: string | null }> | null, offloadingPoints: Array<{ id: number | null, name: string | null }> | null } | null };

export type LoiReferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type LoiReferenceQuery = { loadOutInstructionReference: string | null };

export type AirFreightShipmentLineItemsWithNoLoiQueryVariables = Exact<{ [key: string]: never; }>;


export type AirFreightShipmentLineItemsWithNoLoiQuery = { airFreightShipmentLineItemsWithNoLoi: Array<{ id: string, orderReference: string | null, bookingReference: string | null, finalDestinationLocation: string | null, externalShipmentId: string, eta: string | null, finalDestinationCode: string | null, goodsDescription: string | null, company: { id: number | null, name: string | null } | null, airFreightShipment: { masterWaybillNumber: string | null, shipper: string | null, estimatedDepartureTime: string | null, controller: string | null, portOfLoadingCode: string | null } | null }> | null };

export type LoiExportersQueryVariables = Exact<{
  limit?: number | null | undefined;
  orderbyloi?: boolean | null | undefined;
  companyname?: string | null | undefined;
}>;


export type LoiExportersQuery = { exporters: Array<{ id: number | null, name: string | null }> | null };

export type LoiStuffLocationsQueryVariables = Exact<{
  limit?: number | null | undefined;
  orderbyloi?: boolean | null | undefined;
  fboname?: string | null | undefined;
}>;


export type LoiStuffLocationsQuery = { stuffLocations: Array<{ id: number | null, name: string | null, createdAt: string, updatedAt: string }> | null };

export type LoiTruckingLoadingPointsQueryVariables = Exact<{
  limit?: number | null | undefined;
  orderByLoi?: boolean | null | undefined;
  fboName?: string | null | undefined;
}>;


export type LoiTruckingLoadingPointsQuery = { truckingLoadingPoints: Array<{ id: number | null, name: string | null, createdAt: string, updatedAt: string }> | null };

export type LoiTruckingOffloadingPointsQueryVariables = Exact<{
  limit?: number | null | undefined;
  orderByLoi?: boolean | null | undefined;
  fboName?: string | null | undefined;
}>;


export type LoiTruckingOffloadingPointsQuery = { truckingOffloadingPoints: Array<{ id: number | null, name: string | null, createdAt: string, updatedAt: string }> | null };

export type LoiSeaPortsQueryVariables = Exact<{
  limit?: number | null | undefined;
  orderbyloi?: boolean | null | undefined;
  seaportname?: string | null | undefined;
  isportofloading?: boolean | null | undefined;
  stufflocationid?: number | null | undefined;
}>;


export type LoiSeaPortsQuery = { seaPorts: Array<{ id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string }> | null };

export type LoiVesselsQueryVariables = Exact<{
  limit?: number | null | undefined;
  vesselname?: string | null | undefined;
  seaportid?: number | null | undefined;
}>;


export type LoiVesselsQuery = { vessels: Array<{ id: number | null, vesselName: string | null }> | null };

export type LoiVoyagesQueryVariables = Exact<{
  vesselid: number;
  seaportid?: number | null | undefined;
}>;


export type LoiVoyagesQuery = { voyages: Array<string> | null };

export type LoiContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoiContactsQuery = { contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null };

export type LoiUnassignedCgFilterAttributesQueryVariables = Exact<{
  attributes: Types.CartonGroupingSearchAttributes;
}>;


export type LoiUnassignedCgFilterAttributesQuery = { cartonGroupingsSearch: { filterValues: { batchNumber: Array<string> | null, consignmentNumber: Array<string> | null, packingWeek: Array<string> | null, targetMarket: Array<string> | null, variety: Array<{ id: number | null, name: string | null }> | null, seller: Array<{ id: number | null, name: string | null }> | null } | null } | null };

export type LoiUnassignedCartonGroupingsQueryVariables = Exact<{
  attributes: Types.CartonGroupingSearchAttributes;
}>;


export type LoiUnassignedCartonGroupingsQuery = { loadOutInstructionCgs: Array<{ id: string, batchNumber: string | null, buyerName: string | null, cartons: number | null, consignmentNumber: string | null, commodityName: string | null, exporterCode: string | null, farmCode: string | null, inventoryCode: string | null, mark: string | null, orchard: string | null, grade: string | null, pack: string | null, packingWeek: string | null, palletNumber: string | null, sellerName: string | null, sequenceNumber: string | null, sizeCount: string | null, state: string | null, subCommodityName: string | null, targetMarket: string | null, targetRegion: string | null, varietyName: string | null, palletAge: number | null, netMass: number | null, palletGrossMass: number | null }> };

export type LoiUnassignedCGsQueryVariables = Exact<{
  attributes: Types.CartonGroupingSearchAttributes;
}>;


export type LoiUnassignedCGsQuery = { cartonGroupingsSearch: { totalCount: number | null, totalCountPallets: number | null, cartonGroupings: Array<{ batchNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, palletAge: number | null, buyer: { name: string | null } | null, seller: { name: string | null } | null, variety: { name: string | null, commodity: { name: string | null } | null, subCommodity: { name: string | null } | null } | null, loadOutInstructions: Array<{ loadOutReference: string | null, transportType: Types.TransportTypeEnum | null, loadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }>, filterValues: { batchNumber: Array<string> | null, consignmentNumber: Array<string> | null, packingWeek: Array<string> | null, targetMarket: Array<string> | null, variety: Array<{ id: number | null, name: string | null }> | null, seller: Array<{ id: number | null, name: string | null }> | null } | null } | null };

export type LoiQueryVariables = Exact<{
  id: number;
}>;


export type LoiQuery = { loadOutInstruction: { bookingReference: string | null, transportType: Types.TransportTypeEnum | null, containerNumber: string | null, estimatedTimeOfDelivery: string | null, exportersReference: string | null, id: string | null, loadOutReference: string | null, notes: string | null, portOfDestinationName: string | null, portOfLoadingName: string | null, printedDate: string | null, q67Reference: string | null, shippingLine: string | null, stuffDate: string | null, temperatureSetting: string | null, voyage: string | null, truckReference: string | null, fileNumber: string | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, equipment: string | null, phytoCertificate: string | null, orderPreparedBy: string | null, orderPickedBy: string | null, checked: string | null, stockTransfer: boolean | null, consignmentReference: string | null, transporterCompany: string | null, estimatedDispatchDate: string | null, loadDate: string | null, orderReference: string | null, airFreightShipmentLineItem: { id: string, orderReference: string | null, bookingReference: string | null, externalShipmentId: string, updatedAt: string, createdAt: string } | null, shipmentLineItem: { id: string, updatedAt: string, createdAt: string } | null, cartonGroupings: Array<{ batchNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, palletAge: number | null, buyer: { name: string | null } | null, seller: { name: string | null } | null, variety: { name: string | null, commodity: { name: string | null } | null, subCommodity: { name: string | null } | null } | null }> | null, loiCartonGroupings: Array<{ id: string, batchNumber: string | null, buyerName: string | null, cartons: number | null, consignmentNumber: string | null, commodityName: string | null, exporterCode: string | null, farmCode: string | null, inventoryCode: string | null, mark: string | null, orchard: string | null, grade: string | null, pack: string | null, packingWeek: string | null, palletNumber: string | null, sellerName: string | null, sequenceNumber: string | null, sizeCount: string | null, state: string | null, subCommodityName: string | null, targetMarket: string | null, targetRegion: string | null, varietyName: string | null, palletAge: number | null, netMass: number | null, palletGrossMass: number | null }> | null, contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, exporter: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, stuffLocation: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: { id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null, palletIn: { id: string | null, loadOutInstructionId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null, loadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, offloadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null } | null };

export type CreateLoiMutationVariables = Exact<{
  attributes: Types.LoadOutAttributes;
}>;


export type CreateLoiMutation = { createLoadOutInstruction: { errors: Array<{ attribute: string, type: string, cartonGroupingIds: Array<string> | null, orchards: Array<string> | null, orchardResults: Array<{ id: string | null, farmCode: string, orchardName: string, currentEuStatus: string, eu: string, bd: string, cbs: string, fms: string, applied: string, verified: string, phytoData: string }> | null }> | null, loadOutInstruction: { bookingReference: string | null, transportType: Types.TransportTypeEnum | null, containerNumber: string | null, estimatedTimeOfDelivery: string | null, exportersReference: string | null, id: string | null, loadOutReference: string | null, notes: string | null, portOfDestinationName: string | null, portOfLoadingName: string | null, printedDate: string | null, q67Reference: string | null, shippingLine: string | null, stuffDate: string | null, temperatureSetting: string | null, voyage: string | null, truckReference: string | null, fileNumber: string | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, equipment: string | null, phytoCertificate: string | null, orderPreparedBy: string | null, orderPickedBy: string | null, checked: string | null, stockTransfer: boolean | null, consignmentReference: string | null, transporterCompany: string | null, estimatedDispatchDate: string | null, loadDate: string | null, orderReference: string | null, cartonGroupings: Array<{ id: number | null }> | null, contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, exporter: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, stuffLocation: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: { id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null, palletIn: { id: string | null, loadOutInstructionId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null, loadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, offloadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null } | null } | null };

export type UpdateLoiMutationVariables = Exact<{
  attributes: Types.LoadOutAttributes;
}>;


export type UpdateLoiMutation = { updateLoadOutInstruction: { errors: Array<{ attribute: string, type: string, cartonGroupingIds: Array<string> | null, orchards: Array<string> | null, orchardResults: Array<{ id: string | null, farmCode: string, orchardName: string, currentEuStatus: string, eu: string, bd: string, cbs: string, fms: string, applied: string, verified: string, phytoData: string }> | null }> | null, loadOutInstruction: { bookingReference: string | null, transportType: Types.TransportTypeEnum | null, containerNumber: string | null, estimatedTimeOfDelivery: string | null, exportersReference: string | null, id: string | null, loadOutReference: string | null, notes: string | null, portOfDestinationName: string | null, portOfLoadingName: string | null, printedDate: string | null, q67Reference: string | null, shippingLine: string | null, stuffDate: string | null, temperatureSetting: string | null, voyage: string | null, truckReference: string | null, fileNumber: string | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, equipment: string | null, phytoCertificate: string | null, orderPreparedBy: string | null, orderPickedBy: string | null, checked: string | null, stockTransfer: boolean | null, consignmentReference: string | null, transporterCompany: string | null, estimatedDispatchDate: string | null, loadDate: string | null, orderReference: string | null, cartonGroupings: Array<{ id: number | null }> | null, contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, exporter: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, stuffLocation: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: { id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null, palletIn: { id: string | null, loadOutInstructionId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null, loadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, offloadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null } | null } | null };

export type DeleteLoiMutationVariables = Exact<{
  id: number;
}>;


export type DeleteLoiMutation = { deleteLoadOutInstruction: { success: boolean } | null };

export type GenerateLoadOutInstructionOutputFilesMutationVariables = Exact<{
  loadoutinstructionid: string | number;
}>;


export type GenerateLoadOutInstructionOutputFilesMutation = { generateLoadOutInstructionOutputFiles: { templateOutput: Array<{ errorReason: string | null, id: string | null, state: string | null }> | null } | null };

export type GeneratePalletInOutputFilesMutationVariables = Exact<{
  loadOutInstructionId: string | number;
}>;


export type GeneratePalletInOutputFilesMutation = { generatePalletInOutputFiles: { palletInId: string | null } | null };

export type OnPalletInOutputStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnPalletInOutputStateChangeSubscription = { onPalletInOutputStateChange: { id: string | null, loadOutInstructionId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } };

export type EvaluateShipmentImpactQueryVariables = Exact<{
  sliId: string | number;
  loiAttributes: Types.LoadOutAttributes;
}>;


export type EvaluateShipmentImpactQuery = { evaluateShipmentImpact: { willAffectShipment: boolean, willCreateNewShipment: boolean, shipmentId: string | null, portOfLoading: string | null, vesselName: string | null, voyage: string | null, shippingLine: string | null, client: string | null } };

export type MoveSlisToNewShipmentMutationVariables = Exact<{
  sliIds: Array<string | number> | string | number;
  shipmentId?: string | number | null | undefined;
}>;


export type MoveSlisToNewShipmentMutation = { moveSlisToNewShipment: { shipment: { id: string } | null, shipmentLineItems: Array<{ id: string, shipmentId: number | null }> | null } | null };

export type PalletInFieldsFragment = { id: string | null, loadOutInstructionId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null };

export type LoiErrorFieldsFragment = { attribute: string, type: string, cartonGroupingIds: Array<string> | null, orchards: Array<string> | null, orchardResults: Array<{ id: string | null, farmCode: string, orchardName: string, currentEuStatus: string, eu: string, bd: string, cbs: string, fms: string, applied: string, verified: string, phytoData: string }> | null };

export type LoiCommonFieldsFragment = { bookingReference: string | null, transportType: Types.TransportTypeEnum | null, containerNumber: string | null, estimatedTimeOfDelivery: string | null, exportersReference: string | null, id: string | null, loadOutReference: string | null, notes: string | null, portOfDestinationName: string | null, portOfLoadingName: string | null, printedDate: string | null, q67Reference: string | null, shippingLine: string | null, stuffDate: string | null, temperatureSetting: string | null, voyage: string | null, truckReference: string | null, fileNumber: string | null, airWaybillNo: string | null, shipper: string | null, destination: string | null, allocatedWeight: number | null, routing: string | null, flightDate: string | null, connectingFlightDate: string | null, equipment: string | null, phytoCertificate: string | null, orderPreparedBy: string | null, orderPickedBy: string | null, checked: string | null, stockTransfer: boolean | null, consignmentReference: string | null, transporterCompany: string | null, estimatedDispatchDate: string | null, loadDate: string | null, orderReference: string | null, contacts: Array<{ id: number | null, name: string | null, info: string | null, contactType: Types.ContactTypeEnum | null, createdByUserId: string | null }> | null, exporter: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, portOfLoading: { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string } | null, stuffLocation: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, vessel: { id: number | null, vesselName: string | null } | null, templateOutput: { id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null, palletIn: { id: string | null, loadOutInstructionId: string | null, state: string | null, updatedAt: string | null, outputFile: { contentType: string | null, filename: string | null, v2Url: string | null, id: string | null, url: string | null } | null } | null, loadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null, offloadingPoint: { id: number | null, name: string | null, createdAt: string, updatedAt: string } | null };

export type CgCommonFieldsFragment = { batchNumber: string | null, cartons: number | null, consignmentNumber: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletGrossMass: number | null, palletNumber: string | null, sequenceNumber: number | null, sizeCount: string | null, state: string | null, targetCountry: string | null, targetMarket: string | null, targetRegion: string | null, palletAge: number | null, buyer: { name: string | null } | null, seller: { name: string | null } | null, variety: { name: string | null, commodity: { name: string | null } | null, subCommodity: { name: string | null } | null } | null };

export type LoiPortFieldsFragment = { id: number | null, name: string | null, country: string | null, createdAt: string, updatedAt: string };

export type VesselMapFragment = { vesselName: string | null, voyageNumber: string | null, lat: number | null, long: number | null };

export type SeaPortMapFragment = { id: number | null, name: string | null, country: string | null, unLocode: string | null, latitude: number | null, longitude: number | null, createdAt: string, updatedAt: string };

export type FboMapFragment = { id: number | null, name: string | null, fboCode: string | null, typeOfBusiness: string | null, latitude: number | null, longitude: number | null, createdAt: string, updatedAt: string };

export type CurrentMapPointsForOrderQueryVariables = Exact<{
  id: number;
}>;


export type CurrentMapPointsForOrderQuery = { currentMapPointsForOrder: Array<{ totalCartons: number | null, containers: Array<{ id: number | null, containerNumber: string | null, orderId: number | null, otherPartyName: string | null, vesselName: string | null, portOfDestination: string | null, eta: string | null }> | null, orders: Array<{ orderId: number | null, otherPartyName: string | null, totalCartons: number | null }> | null, location:
      | { __typename: 'FoodBusinessOperator', id: number | null, name: string | null, fboCode: string | null, typeOfBusiness: string | null, latitude: number | null, longitude: number | null, createdAt: string, updatedAt: string }
      | { __typename: 'SeaPort', id: number | null, name: string | null, country: string | null, unLocode: string | null, latitude: number | null, longitude: number | null, createdAt: string, updatedAt: string }
      | { __typename: 'Vessel', vesselName: string | null, voyageNumber: string | null, lat: number | null, long: number | null }
     | null }> | null };

export type CartonConversionsQueryVariables = Exact<{
  filterAttributes?: Types.CartonConversionFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type CartonConversionsQuery = { cartonConversions: Array<{ id: string, commodityName: string | null, conversionFactor: number | null, actualMass: number | null, massConversion: number | null, pack: string | null, sizeCount: string | null, convertedSizeCount: string | null, conversionType: string | null }> };

export type CreateCartonConversionsMutationVariables = Exact<{
  actualMass?: number | null | undefined;
  commodityId?: string | number | null | undefined;
  conversionFactor?: number | null | undefined;
  conversionType?: string | null | undefined;
  convertedSizeCount?: string | null | undefined;
  massConversion?: number | null | undefined;
  pack?: string | null | undefined;
  sizeCount?: string | null | undefined;
}>;


export type CreateCartonConversionsMutation = { createCartonConversion: { cartonConversion: { id: string, commodityName: string | null, conversionFactor: number | null, actualMass: number | null, massConversion: number | null, pack: string | null, sizeCount: string | null, convertedSizeCount: string | null, conversionType: string | null } | null } | null };

export type UpdateCartonConversionsMutationVariables = Exact<{
  id: string | number;
  actualMass?: number | null | undefined;
  conversionFactor?: number | null | undefined;
  convertedSizeCount?: string | null | undefined;
  massConversion?: number | null | undefined;
}>;


export type UpdateCartonConversionsMutation = { updateCartonConversion: { cartonConversion: { id: string, commodityName: string | null, conversionFactor: number | null, actualMass: number | null, massConversion: number | null, pack: string | null, sizeCount: string | null, convertedSizeCount: string | null, conversionType: string | null } | null } | null };

export type DeleteCartonConversionsMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteCartonConversionsMutation = { deleteCartonConversion: { cartonConversion: { id: string, commodityName: string | null, conversionFactor: number | null, actualMass: number | null, massConversion: number | null, pack: string | null, sizeCount: string | null, convertedSizeCount: string | null, conversionType: string | null } | null } | null };

export type CartonConversionFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CartonConversionFilterAttributesQuery = { cartonConversionFilterAttributes: Array<{ conversionType: Array<string> | null, commodityName: Array<string> | null }> | null };

export type CgErrorsQueryVariables = Exact<{
  filterAttributes?: Types.CgErrorFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type CgErrorsQuery = { cgErrors: Array<{ id: string | null, errorContext: any, errorMessage: string | null, errorType: string | null, errorSubtype: string | null, state: string | null }> };

export type ResolveCgErrorMutationVariables = Exact<{
  id: string | number;
  resolution: Types.CgErrorResolutionInput;
  userContext?: string | null | undefined;
}>;


export type ResolveCgErrorMutation = { resolveCgError: { cgError: { state: string | null } } | null };

export type CgErrorFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CgErrorFilterAttributesQuery = { cgErrorFilterAttributes: Array<{ errorType: Array<string> | null, state: Array<string> | null }> | null };

export type CreateIgnoreErrorRequestMutationVariables = Exact<{
  action: string;
  errorToIgnore: string;
}>;


export type CreateIgnoreErrorRequestMutation = { createIgnoreErrorRequest: { clientChangeRequest: { id: string | null } | null } | null };

export type CreateClientChangeRequestMutationVariables = Exact<{
  action: string;
  userContext?: string | null | undefined;
  modelId: string | number;
}>;


export type CreateClientChangeRequestMutation = { createClientChangeRequest: { clientChangeRequest: { id: string | null } | null } | null };

export type MasterfileFarmVarietiesQueryVariables = Exact<{
  filterAttributes?: Types.FarmVarietyFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type MasterfileFarmVarietiesQuery = { masterfileFarmVarieties: Array<
    | { id: number | null, varietyCode: string | null, commodityName: string | null, hectares: number | null, peakCount: string | null, packingStart: string | null, packingEnd: string | null, status: string | null, name: string | null }
    | { modelId: string | null, name: string | null, commodityName: string | null, varietyCode: string | null, status: string | null }
  > | null };

export type ListVarietiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListVarietiesQuery = { listVarieties: Array<{ id: number | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null }> | null };

export type FarmVarietyFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmVarietyFilterAttributesQuery = { farmVarietyFilterAttributes: { status: Array<string> | null, commodityName: Array<string> | null } | null };

export type CreateFarmVarietyClienChangeRequestMutationVariables = Exact<{
  modelId: number;
  name: string;
  varietyId: number;
  varietyCode: string;
  commodityName: string;
  commodityId: number;
  action: string;
}>;


export type CreateFarmVarietyClienChangeRequestMutation = { createFarmVarietyClientChangeRequest: { clientChangeRequest: { id: string | null, status: string | null, name: string | null, varietyCode: string | null, commodityName: string | null } | null } | null };

export type FarmVarietiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmVarietiesQuery = { farmVarieties: Array<{ id: number | null, varietyCode: string | null, commodityName: string | null, hectares: number | null, peakCount: string | null, packingStart: string | null, packingEnd: string | null, updatedAt: string | null, name: string | null }> };

export type FarmVarietyClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type FarmVarietyClientChangeRequestsQuery = { farmVarietyClientChangeRequests: Array<{ name: string | null, status: string | null, varietyCode: string | null, commodityName: string | null }> };

export type MasterfileFoodBusinessOperatorsQueryVariables = Exact<{
  filterAttributes?: Types.FoodBusinessOperatorFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type MasterfileFoodBusinessOperatorsQuery = { masterfileFoodBusinessOperators: Array<
    | { id: number | null, name: string | null, fboCode: string | null, typeOfBusiness: string | null, producerName: string | null, latitude: number | null, longitude: number | null, globalGapNumber: string | null, productionRegion: string | null, updatedAt: string, status: string | null }
    | { fboCode: string | null, name: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, modelId: number | null, status: string | null, producerName: string | null, productionRegion: string | null, typeOfBusiness: string | null }
  > | null };

export type FoodBusinessOperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodBusinessOperatorsQuery = { foodBusinessOperators: Array<{ id: number | null, name: string | null, fboCode: string | null, typeOfBusiness: string | null, producerName: string | null, latitude: number | null, longitude: number | null, globalGapNumber: string | null, productionRegion: string | null, updatedAt: string }> | null };

export type FoodBusinessOperatorClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodBusinessOperatorClientChangeRequestsQuery = { foodBusinessOperatorClientChangeRequests: Array<{ fboCode: string | null, name: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, modelId: number | null, status: string | null, producerName: string | null, productionRegion: string | null, typeOfBusiness: string | null }> | null };

export type CreateFoodBusinessOperatorClientChangeRequestMutationVariables = Exact<{
  modelId: number;
  name: string;
  action: string;
  fboCode: string;
  globalGapNumber: string;
  latitude: number;
  longitude: number;
  producerName: string;
  productionRegion: string;
  typeOfBusiness: string;
}>;


export type CreateFoodBusinessOperatorClientChangeRequestMutation = { createFoodBusinessOperatorClientChangeRequest: { clientChangeRequest: { id: string, fboCode: string | null, name: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, modelId: number | null, producerName: string | null, productionRegion: string | null, status: string | null, typeOfBusiness: string | null } | null } | null };

export type FoodBusinessOperatorFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FoodBusinessOperatorFilterAttributesQuery = { foodBusinessOperatorFilterAttributes: { status: Array<string> | null, typeOfBusiness: Array<string> | null } | null };

export type ProductionRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductionRegionsQuery = { productionRegions: Array<{ id: string, name: string | null, countryCode: string }> | null };

export type ListFoodBusinessOperatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFoodBusinessOperatorsQuery = { listFoodBusinessOperators: Array<{ fboCode: string | null }> | null };

export type FoodBusinessOperatorsByTypeQueryVariables = Exact<{
  typeOfBusiness: number;
}>;


export type FoodBusinessOperatorsByTypeQuery = { foodBusinessOperatorsByType: Array<{ id: number | null, name: string | null, producerName: string | null, fboCode: string | null, productionRegion: string | null, createdAt: string, updatedAt: string, company: { id: number | null } | null, locationMappings: Array<{ locationCode: string | null }> | null }> | null };

export type FarmVarietyFieldsFragment = { id: number | null, name: string | null, varietyCode: string | null, hectares: number | null, commodityName: string | null, packingStart: string | null, packingEnd: string | null, peakCount: string | null, variety: { id: number | null, varietyName: string | null, commodity: { id: number | null, name: string | null } | null } | null, commodity: { id: number | null, name: string | null } | null };

export type AddressFieldsFragment = { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null };

export type FoodBusinessOperatorFieldsFragment = { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null };

export type SoftwareUpdateReportFieldsFragment = { id: number | null, softwareUpdateReport: Array<string> | null, company: { id: number | null, name: string | null } | null };

export type PackhouseConnectionFieldsFragment = { id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null };

export type CompanyAssociationFieldsFragment = { id: number | null, name: string | null };

export type MasterfileConfigFieldsFragment = { id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null };

export type MasterfileConfigsQueryVariables = Exact<{
  filterAttributes?: Types.MasterfileConfigFilterAttributes | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type MasterfileConfigsQuery = { masterfileConfigs: Array<{ id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null, masterfileEntity:
      | { id: number | null, name: string | null }
      | { id: number | null, name: string | null, varietyCode: string | null, hectares: number | null, commodityName: string | null, packingStart: string | null, packingEnd: string | null, peakCount: string | null, variety: { id: number | null, varietyName: string | null, commodity: { id: number | null, name: string | null } | null } | null, commodity: { id: number | null, name: string | null } | null }
      | { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null }
      | Record<PropertyKey, never>
     | null }> | null };

export type InternalPackhouseClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalPackhouseClientChangeRequestsQuery = { internalPackhouseClientChangeRequests: Array<{ id: number | null, status: string | null, company: { id: number | null, name: string | null } | null, packhouse: { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null } | null }> | null };

export type CreateSoftwareUpdateReportMutationVariables = Exact<{
  softwareUpdateReport: Array<string> | string;
}>;


export type CreateSoftwareUpdateReportMutation = { createSoftwareUpdateReport: { errors: Array<string> | null, clientChangeRequest: { id: number | null, softwareUpdateReport: Array<string> | null, company: { id: number | null, name: string | null } | null } | null } | null };

export type PackhouseSoftwareUpdateReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackhouseSoftwareUpdateReportsQuery = { packhouseSoftwareUpdateReports: Array<{ id: number | null, softwareUpdateReport: Array<string> | null, company: { id: number | null, name: string | null } | null }> | null };

export type ConfirmMasterfileConfigFboMutationVariables = Exact<{
  masterfileConfigs: Array<Types.MasterfileConfigFboInput> | Types.MasterfileConfigFboInput;
}>;


export type ConfirmMasterfileConfigFboMutation = { confirmMasterfileConfigFbo: { errors: Array<string> | null, masterfileConfigs: Array<{ id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null, masterfileEntity:
        | { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null }
        | Record<PropertyKey, never>
       | null }> | null } | null };

export type ConfirmMasterfileConfigPackhouseConnectionsMutationVariables = Exact<{
  masterfileConfigs: Array<Types.MasterfileConfigPackhouseConnectionAttributes> | Types.MasterfileConfigPackhouseConnectionAttributes;
}>;


export type ConfirmMasterfileConfigPackhouseConnectionsMutation = { confirmMasterfileConfigPackhouseConnections: { errors: Array<string> | null, masterfileConfigs: Array<{ id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null, masterfileEntity:
        | { id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }
        | Record<PropertyKey, never>
       | null }> | null } | null };

export type ConfirmMasterfileConfigFarmVarietiesMutationVariables = Exact<{
  masterfileConfigs: Array<Types.MasterfileConfigFarmVarietyInput> | Types.MasterfileConfigFarmVarietyInput;
}>;


export type ConfirmMasterfileConfigFarmVarietiesMutation = { confirmMasterfileConfigFarmVarieties: { errors: Array<string> | null, masterfileConfigs: Array<{ id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null, masterfileEntity:
        | { id: number | null, name: string | null, varietyCode: string | null, hectares: number | null, commodityName: string | null, packingStart: string | null, packingEnd: string | null, peakCount: string | null, variety: { id: number | null, varietyName: string | null, commodity: { id: number | null, name: string | null } | null } | null, commodity: { id: number | null, name: string | null } | null }
        | Record<PropertyKey, never>
       | null }> | null } | null };

export type CreateFarmFboMutationVariables = Exact<{
  attributes: Types.CreateFarmAttribute;
}>;


export type CreateFarmFboMutation = { createFarmFbo: { errors: Array<string> | null, foodBusinessOperator: { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null } | null, masterfileConfig: { id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null } | null } | null };

export type AddInternalPackhouseMutationVariables = Exact<{
  attributes: Types.AddInternalPackhouseAttributes;
}>;


export type AddInternalPackhouseMutation = { addInternalPackhouse: { errors: Array<string> | null, clientChangeRequest: { id: number | null, status: string | null, company: { id: number | null, name: string | null } | null, packhouse: { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null } | null } | null } | null };

export type MetabaseReportFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type MetabaseReportFilterAttributesQuery = { metabaseReportFilterAttributes: { badges: Array<{ id: number | null, text: string | null }> | null } | null };

export type MetabaseReportsQueryVariables = Exact<{
  filters: Types.MetabaseReportFilters;
  searchTerm: string;
  searchField: string;
}>;


export type MetabaseReportsQuery = { metabaseReports: Array<{ chartSource: string | null, description: string | null, domain: Types.MetabaseDomainEnum | null, id: number | null, name: string | null, displayName: string | null, scope: Types.MetabaseScopeEnum | null, url: string | null, badges: Array<{ color: Types.ColorEnum | null, text: string | null }> | null, powerbiEmbedAttributes: { embedToken: string | null, embedUrl: string | null, reportId: string | null } | null }> | null };

export type MetabaseReportQueryVariables = Exact<{
  id: number;
}>;


export type MetabaseReportQuery = { metabaseReport: { chartSource: string | null, description: string | null, domain: Types.MetabaseDomainEnum | null, id: number | null, name: string | null, displayName: string | null, scope: Types.MetabaseScopeEnum | null, url: string | null, badges: Array<{ color: Types.ColorEnum | null, text: string | null }> | null, powerbiEmbedAttributes: { embedToken: string | null, embedUrl: string | null, reportId: string | null } | null } | null };

export type MetabaseReportFieldsFragment = { chartSource: string | null, description: string | null, domain: Types.MetabaseDomainEnum | null, id: number | null, name: string | null, displayName: string | null, scope: Types.MetabaseScopeEnum | null, url: string | null, badges: Array<{ color: Types.ColorEnum | null, text: string | null }> | null, powerbiEmbedAttributes: { embedToken: string | null, embedUrl: string | null, reportId: string | null } | null };

export type NetReturnProgramPortFieldsFragment = { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string };

export type NetReturnProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type NetReturnProgramsQuery = { netReturnPrograms: Array<{ additionalFields: string | null, buyerId: string | null, batchNumber: string | null, cartonTypeName: string, cartonTypeId: string, commodityId: string, commodityName: string, configuredCurrency: string | null, configuredUnit: string | null, createdAt: string, currency: string, id: string, incoterm: string, inventoryCode: string | null, packingWeek: string, priceMinorUnit: number, priceTerm: string, priceUnit: string, programId: string, programName: string, programVisibility: string, quantity: number, quantityUnit: string, referenceNumber: string | null, sizeCounts: string, stackSize: number, sellerId: string | null, targetMarket: string | null, tradeCountryId: string | null, tradeCountryName: string | null, tradeRegionId: string, tradeRegionName: string, updatedAt: string, varietyId: string, varietyName: string, departurePort: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null };

export type CreateNetReturnProgramMutationVariables = Exact<{
  attributes: Types.NetReturnProgramAttributes;
}>;


export type CreateNetReturnProgramMutation = { createNetReturnProgram: { errors: Array<string> | null, netReturnProgram: { id: string, programName: string } | null } | null };

export type UpdateNetReturnProgramMutationVariables = Exact<{
  attributes: Types.NetReturnProgramAttributes;
}>;


export type UpdateNetReturnProgramMutation = { updateNetReturnProgram: { errors: Array<string> | null, netReturnProgram: { id: string, programName: string } | null } | null };

export type DeleteNetReturnProgramMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteNetReturnProgramMutation = { deleteNetReturnProgram: { errors: Array<string> | null, netReturnProgram: { id: string, programName: string } | null } | null };

export type NotificationRuleFieldsFragment = { id: string | null, name: string | null, description: string | null, notificationSlug: Types.NotificationSlugEnum | null, severity: Types.NotificationRuleSeverityEnum | null, defaultThresholds: any, notificationRuleSubscription: { id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any } | null };

export type NotificationItemFieldsFragment = { id: string | null, entityType: string | null, entityId: string | null };

export type ChannelNotificationFieldsFragment = { id: string | null, channelMetadata: any, sentAt: string | null, readAt: string | null, archivedAt: string | null, deliveredAt: string | null, title: string | null, body: string | null, notificationRule: { id: string | null, name: string | null, description: string | null, notificationSlug: Types.NotificationSlugEnum | null, severity: Types.NotificationRuleSeverityEnum | null, defaultThresholds: any, notificationRuleSubscription: { id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any } | null } | null, notificationItems: Array<{ id: string | null, entityType: string | null, entityId: string | null }> | null };

export type NotificationRuleSubscriptionFieldsFragment = { id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any };

export type OnNotificationEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotificationEventSubscription = { newInAppNotification: { id: string } };

export type GetChannelNotificationsQueryVariables = Exact<{
  filterAttributes: Types.ChannelNotificationFilterAttributes;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type GetChannelNotificationsQuery = { channelNotifications: { totalCount: number, nodes: Array<{ id: string | null, channelMetadata: any, sentAt: string | null, readAt: string | null, archivedAt: string | null, deliveredAt: string | null, title: string | null, body: string | null, notificationRule: { id: string | null, name: string | null, description: string | null, notificationSlug: Types.NotificationSlugEnum | null, severity: Types.NotificationRuleSeverityEnum | null, defaultThresholds: any, notificationRuleSubscription: { id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any } | null } | null, notificationItems: Array<{ id: string | null, entityType: string | null, entityId: string | null }> | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type GetUnreadChannelNotificationsCountQueryVariables = Exact<{
  severity?: Types.NotificationRuleSeverityEnum | null | undefined;
}>;


export type GetUnreadChannelNotificationsCountQuery = { unreadChannelNotificationsCount: number | null };

export type GetTotalChannelNotificationsCountQueryVariables = Exact<{
  severity?: Types.NotificationRuleSeverityEnum | null | undefined;
}>;


export type GetTotalChannelNotificationsCountQuery = { channelNotificationsCount: number | null };

export type GetChannelNotificationQueryVariables = Exact<{
  id: string | number;
}>;


export type GetChannelNotificationQuery = { channelNotificationById: { id: string | null, channelMetadata: any, sentAt: string | null, readAt: string | null, archivedAt: string | null, deliveredAt: string | null, title: string | null, body: string | null, notificationRule: { id: string | null, name: string | null, description: string | null, notificationSlug: Types.NotificationSlugEnum | null, severity: Types.NotificationRuleSeverityEnum | null, defaultThresholds: any, notificationRuleSubscription: { id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any } | null } | null, notificationItems: Array<{ id: string | null, entityType: string | null, entityId: string | null }> | null } | null };

export type NotificationRulesQueryVariables = Exact<{
  notificationSlugs: Array<Types.NotificationSlugEnum> | Types.NotificationSlugEnum;
}>;


export type NotificationRulesQuery = { notificationRules: Array<{ id: string | null, name: string | null, description: string | null, notificationSlug: Types.NotificationSlugEnum | null, severity: Types.NotificationRuleSeverityEnum | null, defaultThresholds: any, notificationRuleSubscription: { id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any } | null }> | null };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type MarkNotificationsAsReadMutation = { markNotificationsAsRead: { ids: Array<string> | null, errors: string | null } | null };

export type MarkNotificationsAsUnreadMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type MarkNotificationsAsUnreadMutation = { markNotificationsAsUnread: { ids: Array<string> | null, errors: string | null } | null };

export type ArchiveNotificationsMutationVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type ArchiveNotificationsMutation = { archiveNotifications: { ids: Array<string> | null, errors: string | null } | null };

export type SubscribeToNotificationRulesMutationVariables = Exact<{
  notificationRuleSubscriptionAttributes: Array<Types.NotificationRuleSubscriptionAttributes> | Types.NotificationRuleSubscriptionAttributes;
}>;


export type SubscribeToNotificationRulesMutation = { subscribeToNotificationRules: { errors: string | null, notificationRuleSubscriptions: Array<{ id: string | null, enabled: boolean, notifyEmail: boolean, notifyWeb: boolean, notifyMobile: boolean, notifyWhatsapp: boolean, config: any }> } | null };

export type OfferFieldsFragment = { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null };

export type OfferItemFieldsFragment = { id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null };

export type OfferRecipientFieldsFragment = { id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null };

export type OfferItemPriceFieldsFragment = { id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null };

export type OfferItemPriceExpectedReturnFieldsFragment = { incoterm: string | null, unit: string | null, currency: string | null, conversionPriceAmountMajorUnit: string | null };

export type PortDisplayFieldsFragment = { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string };

export type RecentRootOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentRootOffersQuery = { recentRootOffers: Array<{ id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null }> | null };

export type OffersQueryVariables = Exact<{
  filterAttributes: Types.OfferFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type OffersQuery = { offers: { totalCount: number, nodes: Array<{ id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type CounterOffersQueryVariables = Exact<{
  filterAttributes: Types.OfferFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  currency?: Types.CurrencyEnum | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
  unit?: string | null | undefined;
}>;


export type CounterOffersQuery = { counterOffers: { totalCount: number, nodes: Array<{ id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, expectedReturnSummary: { incoterm: string | null, unit: string | null, currency: string | null, conversionPriceAmountMajorUnit: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type OfferFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferFilterAttributesQuery = { offerFilterAttributes: { buyers: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null, varietyCode: string | null }> | null, tradeRegions: Array<{ id: number | null, name: string | null, code: string | null }> | null, portsOfDestination: Array<{ id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string }> | null } | null };

export type OfferByIdQueryVariables = Exact<{
  id: string | number;
}>;


export type OfferByIdQuery = { offerById: { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, rootOffer: { id: string, companyId: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null } | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null };

export type OfferHistoryByIdQueryVariables = Exact<{
  id: string | number;
}>;


export type OfferHistoryByIdQuery = { offerHistoryById: Array<{ id: string, currency: Types.CurrencyEnum | null, companyId: string | null, createdAt: string | null, quantity: number | null, company: { id: number | null, name: string | null } | null, offerItems: Array<{ id: string, sizeCounts: Array<string> | null, offerItemPrices: Array<{ id: string, cifPriceAmountMajorUnit: string | null, portOfDestinationId: string | null }> | null }> | null, offerRecipients: Array<{ id: string, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null }> | null }> | null };

export type CreateOfferAsSupplierMutationVariables = Exact<{
  attributes: Types.OfferAttributes;
}>;


export type CreateOfferAsSupplierMutation = { createOfferAsSupplier: { errors: Array<string> | null, offer: { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null } | null };

export type CloseOfferAsSupplierMutationVariables = Exact<{
  offerId: string | number;
}>;


export type CloseOfferAsSupplierMutation = { closeOfferAsSupplier: { errors: Array<string> | null, offer: { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null } | null };

export type RejectOfferAsSupplierMutationVariables = Exact<{
  counterOfferId: string | number;
}>;


export type RejectOfferAsSupplierMutation = { rejectOfferAsSupplier: { errors: Array<string> | null, counterOffer: { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null } | null };

export type AcceptOfferAsSupplierMutationVariables = Exact<{
  counterOfferId: string | number;
}>;


export type AcceptOfferAsSupplierMutation = { acceptOfferAsSupplier: { errors: Array<string> | null, counterOffer: { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null } | null };

export type CreateCounterOfferAsSupplierMutationVariables = Exact<{
  previousOfferId: string | number;
  attributes: Types.CounterOfferAttributes;
}>;


export type CreateCounterOfferAsSupplierMutation = { createCounterOfferAsSupplier: { errors: Array<string> | null, counterOffer: { id: string, isRootOfferOpenPrice: boolean | null, isRootOfferOpenQuantity: boolean | null, state: Types.OfferStateEnum | null, title: string | null, description: string | null, currency: Types.CurrencyEnum | null, packingWeek: string | null, rootOfferId: string | null, previousOfferId: string | null, orderId: string | null, incoterm: Types.IncotermEnum | null, companyId: string | null, packType: string | null, palletStack: number | null, priceTerm: Types.OfferPriceTermEnum | null, expiresAt: string | null, initialQuantity: number | null, quantity: number | null, quantityUnit: Types.OfferQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItems: Array<{ id: string, offerId: string | null, sizeCounts: Array<string> | null, grade: string | null, quantity: number | null, quantityUnit: Types.OfferItemQuantityUnitEnum | null, createdAt: string | null, updatedAt: string | null, offerItemPrices: Array<{ id: string, portOfDestinationId: string | null, dipPriceAmountMajorUnit: string | null, cifPriceAmountMajorUnit: string | null, priceUnit: Types.OfferItemPricePriceUnitEnum | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, offerRecipients: Array<{ id: string, state: Types.OfferRecipientStateEnum | null, contactUserId: string | null, portOfDestinationId: string | null, buyer: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, country: string | null, createdAt: string, updatedAt: string } | null }> | null, rootOffer: { id: string, companyId: string | null } | null, buyer: { id: number | null, name: string | null } | null, tradeRegion: { id: number | null, name: string | null, code: string | null } | null, variety: { id: number | null, name: string | null, varietyName: string | null, varietyCode: string | null, commodity: { id: number | null } | null } | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null, company: { id: number | null, name: string | null } | null } | null } | null };

export type OnWhatsappInteractionFailedToDeliverSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnWhatsappInteractionFailedToDeliverSubscription = { onWhatsappInteractionFailedToDeliver: { id: string, offerRecipientId: string, buyerName: string, buyerId: string } };

export type UpdateCompanyOnboardingStepMutationVariables = Exact<{
  onboardingStep: Types.CompanyOnboardingStepEnum;
}>;


export type UpdateCompanyOnboardingStepMutation = { updateCompanyOnboardingStep: { errors: Array<string> | null, company: { id: number | null, onboardingStep: Types.CompanyOnboardingStepEnum | null } | null } | null };

export type OrderProgramsQueryVariables = Exact<{
  filterAttributes: Types.OrderProgramFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  orderProgramIds?: Array<string | number> | string | number | null | undefined;
}>;


export type OrderProgramsQuery = { orderPrograms: Array<{ batchNumber: string | null, cartonCountId: string | null, cartonTypeId: string | null, cartonTypeName: string | null, commodityId: string | null, commodityName: string | null, companyId: string | null, companyLogoImageUrl: string | null, companyName: string | null, createdAt: string | null, currency: string | null, grade: string | null, hiddenFields: Array<string> | null, id: string | null, incoterm: string | null, inventoryCode: string | null, mark: string | null, portOfDestinationId: string | null, portOfDestinationName: string | null, portOfLoadingId: string | null, portOfLoadingName: string | null, priceTerm: string | null, priceUnit: string | null, priceAmountMajorUnit: string | null, priority: string | null, programId: string | null, programName: string | null, programVisibility: Types.ProgramVisibilityEnum | null, quantityUnit: string | null, quantity: number | null, referenceNumber: string | null, sizeCounts: Array<string> | null, stackSize: number | null, targetMarket: string | null, tradeCountryId: string | null, tradeCountryCode: string | null, tradeCountryName: string | null, tradeRegionId: string | null, tradeRegionCode: string | null, tradeRegionName: string | null, updatedAt: string | null, varietyCode: string | null, varietyId: string | null, varietyName: string | null, additionalFields: any, commodity: { id: number | null, name: string | null } | null, portOfDestination: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, portOfLoading: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, variety: { id: number | null, name: string | null, varietyCode: string | null } | null }> | null };

export type OrderProgramCommoditiesQueryVariables = Exact<{
  onlyOperational?: boolean | null | undefined;
}>;


export type OrderProgramCommoditiesQuery = { commodities: Array<{ id: number | null, name: string | null }> | null };

export type OrderProgramVarietiesQueryVariables = Exact<{
  onlyOperational?: boolean | null | undefined;
  skipMixedVarieties?: boolean | null | undefined;
  commodityId?: string | number | null | undefined;
}>;


export type OrderProgramVarietiesQuery = { varieties: Array<{ id: number | null, name: string | null, varietyCode: string | null }> | null };

export type OrderProgramSeaPortQueryVariables = Exact<{
  seaPortId: string | number;
}>;


export type OrderProgramSeaPortQuery = { seaPort: { id: number | null, name: string | null, country: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null };

export type OrderProgramSeaPortsQueryVariables = Exact<{
  filterAttributes: Types.SeaPortFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type OrderProgramSeaPortsQuery = { seaPortsV2: Array<{ id: number | null, name: string | null, country: string | null, displayName: string | null, createdAt: string, updatedAt: string }> | null };

export type OrderProgramTradeCountriesQueryVariables = Exact<{
  tradeRegionId?: string | number | null | undefined;
}>;


export type OrderProgramTradeCountriesQuery = { tradeCountries: Array<{ id: number | null, code: string | null, name: string | null }> | null };

export type CreateOrderProgramMutationVariables = Exact<{
  attributes: Types.OrderProgramAttributes;
}>;


export type CreateOrderProgramMutation = { createOrderProgram: { errors: Array<string> | null, orderProgram: { id: string | null } | null } | null };

export type UpdateOrderProgramMutationVariables = Exact<{
  orderProgramId: string | number;
  attributes: Types.OrderProgramAttributes;
}>;


export type UpdateOrderProgramMutation = { updateOrderProgram: { errors: Array<string> | null, orderProgram: { id: string | null } | null } | null };

export type DeleteOrderProgramMutationVariables = Exact<{
  orderProgramId: string | number;
}>;


export type DeleteOrderProgramMutation = { deleteOrderProgram: { errors: Array<string> | null, orderProgram: { id: string | null } | null } | null };

export type LineItemsQueryVariables = Exact<{
  filterAttributes: Types.LineItemFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
  currency?: Types.CurrencyEnum | null | undefined;
  unit?: string | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type LineItemsQuery = { lineItems: { totalCount: number, nodes: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type OrdersV3QueryVariables = Exact<{
  filterAttributes: Types.OrderFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type OrdersV3Query = { ordersV3: { totalCount: number, nodes: Array<{ id: number | null, state: string | null, updatedAt: string | null, createdAt: string | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, lineItemGroupings: Array<{ commonFields: Array<string> | null, cumulativeQuantity: number | null, cumulativeTooltip: string | null, deleted: boolean | null, id: number | null, numberCumulativeSiblings: number | null, quantityType: string | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type LineItemsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineItemsFilterAttributesQuery = { lineItemsFilterAttributes: { buyers: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null, varietyCode: string | null }> | null } | null };

export type OrdersFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersFilterAttributesQuery = { ordersFilterAttributes: { buyers: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null, varietyCode: string | null }> | null } | null };

export type ShipmentDocumentFieldsFragment = { id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null };

export type SingleLineItemFieldsFragment = { id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null };

export type StatesDistributionFieldsFragment = { statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null };

export type ExpectedNetReturnFieldsFragment = { expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null };

export type QuantityTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type QuantityTypeQuery = { quantityType: Types.Quantity | null };

export type SingleOrderFieldsWithNetReturnFragment = { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null };

export type SingleOrderFieldsFragment = { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null };

export type MultipleOrderFieldsFragment = { id: number | null, state: string | null, isPackhouseRun: boolean | null, updatedAt: string | null, createdAt: string | null, lineItemGroupings: Array<{ commonFields: Array<string> | null, cumulativeQuantity: number | null, cumulativeTooltip: string | null, deleted: boolean | null, id: number | null, numberCumulativeSiblings: number | null, quantityType: string | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null, expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null }> | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null };

export type SellerCompanyFieldsFragment = { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null };

export type DuplicateOrderFieldsFragment = { id: number | null, isPackhouseRun: boolean | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null };

export type CreateOrderMutationVariables = Exact<{
  attributes: Types.CreateOrderAttributes;
  lineItemStates?: Array<string> | string | null | undefined;
  packingWeekStart?: string | null | undefined;
  packingWeekEnd?: string | null | undefined;
  varietyIds?: Array<number> | number | null | undefined;
  commodityIds?: Array<number> | number | null | undefined;
  subCommodityIds?: Array<number> | number | null | undefined;
  states?: Array<Types.StateFilter> | Types.StateFilter | null | undefined;
  currency?: Types.CurrencyEnum | null | undefined;
  unit?: string | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type CreateOrderMutation = { createOrder: { errors: string | null, order: { id: number | null, state: string | null, isPackhouseRun: boolean | null, updatedAt: string | null, createdAt: string | null, lineItemGroupings: Array<{ commonFields: Array<string> | null, cumulativeQuantity: number | null, cumulativeTooltip: string | null, deleted: boolean | null, id: number | null, numberCumulativeSiblings: number | null, quantityType: string | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null, expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null }> | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null } | null } | null };

export type OrdersSearchQueryVariables = Exact<{
  limit: number;
  skip: number;
  filter: Types.OrderFilter;
  lineItemStates?: Array<string> | string | null | undefined;
  packingWeekStart?: string | null | undefined;
  packingWeekEnd?: string | null | undefined;
  varietyIds?: Array<number> | number | null | undefined;
  commodityIds?: Array<number> | number | null | undefined;
  subCommodityIds?: Array<number> | number | null | undefined;
  states?: Array<Types.StateFilter> | Types.StateFilter | null | undefined;
  currency?: Types.CurrencyEnum | null | undefined;
  unit?: string | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type OrdersSearchQuery = { ordersSearch: { totalOrders: number | null, totalFiltered: number | null, orders: Array<{ id: number | null, state: string | null, isPackhouseRun: boolean | null, updatedAt: string | null, createdAt: string | null, lineItemGroupings: Array<{ commonFields: Array<string> | null, cumulativeQuantity: number | null, cumulativeTooltip: string | null, deleted: boolean | null, id: number | null, numberCumulativeSiblings: number | null, quantityType: string | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null, expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null }> | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null }> | null } | null };

export type OrdersSearchFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersSearchFilterAttributesQuery = { ordersSearchFilterAttributes: { commodities: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null }> | null, subCommodities: Array<{ id: number | null, name: string | null }> | null, companies: Array<{ id: number | null, name: string | null }> | null } | null };

export type OrderQueryVariables = Exact<{
  id: string | number;
  currency?: Types.CurrencyEnum | null | undefined;
  unit?: string | null | undefined;
  incoterm?: Types.IncotermWithNscEnum | null | undefined;
}>;


export type OrderQuery = { order: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, expectedReturnSummary: { unit: string | null, error: string | null, equivalentPrice: { incoterm: Types.IncotermWithNscEnum, moneyAmount: { displayString: string } } | null, pricePoints: Array<{ incoterm: Types.IncotermWithNscEnum, moneyAmount: { amount: number, currency: { symbol: string } }, chargesApplied: Array<{ name: string, moneyAmount: { amount: number } }> | null }> | null } | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null };

export type DuplicateOrderQueryVariables = Exact<{
  id: string | number;
}>;


export type DuplicateOrderQuery = { order: { id: number | null, isPackhouseRun: boolean | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null } | null };

export type UpdateOrderMutationVariables = Exact<{
  attributes: Types.UpdateOrderAttributes;
}>;


export type UpdateOrderMutation = { updateOrder: { errors: string | null, order: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type UpdateLineItemsMutationVariables = Exact<{
  attributes: Array<Types.UpdateLineItemAttributes> | Types.UpdateLineItemAttributes;
}>;


export type UpdateLineItemsMutation = { updateLineItems: { errors: string | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null } | null };

export type AcceptLineItemsMutationVariables = Exact<{
  ids: Array<number> | number;
}>;


export type AcceptLineItemsMutation = { acceptLineItems: { orders: Array<{ id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null }> | null } | null };

export type WontPackLineItemsMutationVariables = Exact<{
  ids: Array<number> | number;
}>;


export type WontPackLineItemsMutation = { wontPackLineItems: { orders: Array<{ id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null }> | null } | null };

export type RevertLineItemsToCreatedMutationVariables = Exact<{
  ids: Array<number> | number;
}>;


export type RevertLineItemsToCreatedMutation = { revertLineItemsToCreated: { orders: Array<{ id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null }> | null } | null };

export type RevertOrderChangeMutationVariables = Exact<{
  startid: number;
  endid: number;
  orderid: number;
}>;


export type RevertOrderChangeMutation = { revertOrderChange: { errors: string | null, order: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type UploadOrderShipmentDocumentMutationVariables = Exact<{
  orderid: number;
  type: string;
  file: File;
}>;


export type UploadOrderShipmentDocumentMutation = { uploadOrderShipmentDocument: { order: { shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type NewOrderSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewOrderSubscription = { newOrder: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } };

export type OnAcceptLineItemsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAcceptLineItemsSubscription = { onAcceptLineItems: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } };

export type OnWontPackLineItemsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnWontPackLineItemsSubscription = { onWontPackLineItems: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } };

export type OnRevertLineItemsToCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnRevertLineItemsToCreatedSubscription = { onRevertLineItemsToCreated: { id: number | null, state: string | null, isPackhouseRun: boolean | null, createdAt: string | null, updatedAt: string | null, comments: Array<{ id: number | null, commentText: string | null, isDeleted: boolean | null, createdAt: string | null, updatedAt: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null, buyer: { id: number | null, name: string | null, logoFile: { id: string | null, v2Url: string | null } | null, additionalFields: Array<{ id: number | null, name: string | null }> | null, sellerVarieties: Array<{ id: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null } | null, seller: { id: number | null, name: string | null, logoFile: { id: string | null, filename: string | null, v2Url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null } | null }> | null, additionalFields: Array<{ id: number | null, name: string | null }> | null } | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null }> | null, lineItemGroupings: Array<{ id: number | null, cumulativeQuantity: number | null, quantityType: string | null, commonFields: Array<string> | null, deleted: boolean | null, rank: number | null, lineItems: Array<{ id: number | null, additionalFields: any, packingWeek: string | null, startWeek: string | null, endWeek: string | null, targetRegion: string | null, targetCountry: string | null, targetMarket: string | null, quantity: number | null, plannedQuantity: number | null, plannedQuantityUnit: string | null, incoterm: string | null, pack: string | null, palletStack: number | null, priority: number | null, quantityUnit: string | null, priceMinorUnit: number | null, sizeCounts: Array<string> | null, priceTerm: string | null, currency: string | null, state: string | null, priceUnit: string | null, grade: string | null, mark: string | null, commodityId: number | null, varietyId: number | null, packedCartons: number | null, packedPallets: number | null, referenceNumber: string | null, rank: number | null, batchNumber: string | null, inventoryCode: string | null, unlimited: boolean | null, orderId: number | null, lineItemGroupingId: number | null, createdAt: string | null, updatedAt: string | null, departurePortId: number | null, destinationPortId: number | null, cumulativeQuantity: number | null, variety: { id: number | null, name: string | null, varietyCode: string | null, commodity: { id: number | null, name: string | null } | null, subCommodity: { id: number | null, name: string | null } | null } | null, seller: { id: number | null, name: string | null } | null, buyer: { id: number | null, name: string | null } | null, departurePort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, destinationPort: { id: number | null, name: string | null, displayName: string | null, createdAt: string, updatedAt: string } | null, statesDistribution: Array<{ quantity: number | null, quantityTotal: number | null, palletQuantity: number | null, palletQuantityTotal: number | null, state: string | null, supplyChainOrder: number | null }> | null }> | null }> | null, audits: Array<{ id: number | null, action: string | null, auditableType: string | null, auditableId: number | null, associatedType: string | null, associatedId: number | null, createdAt: string | null, auditedChanges: Array<any> | null, version: number | null, user: { id: number | null, firstName: string | null, company: { id: number | null, name: string | null } | null } | null }> | null, shipmentDocuments: Array<{ id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } };

export type PackInstructionsLineItemsQueryVariables = Exact<{
  attributes: Types.PackInstructionsAttributes;
}>;


export type PackInstructionsLineItemsQuery = { packInstructions: Array<{ groupId: number | null, priority: number | null, batchNumber: string | null, buyer: string | null, commodity: string | null, grade: string | null, id: number | null, inventoryCode: string | null, mark: string | null, orderId: number | null, pack: string | null, packingWeek: string | null, palletStack: number | null, quantitesPacked: Array<number> | null, quantityRequested: number | null, quantityUnit: string | null, referenceNumber: string | null, seller: string | null, sizeCounts: Array<string> | null, state: string | null, subCommodity: string | null, targetMarket: string | null, targetRegion: string | null, targetCountry: string | null, variety: string | null, varietyCode: string | null, additionalFields: any, incoterm: string | null, priceUnit: string | null, priceMajorUnit: string | null, currency: string | null, priceTerm: string | null, formattedPrice: string | null, comments: Array<{ commentText: string | null, id: number | null, userId: number | null, commentableType: string | null, updatedAt: string | null, isDeleted: boolean | null, createdAt: string | null, commentableId: number | null, user: { firstName: string | null, lastName: string | null, id: number | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null }> | null }> | null };

export type PackInstructionsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type PackInstructionsFilterAttributesQuery = { packInstructionsFilterAttributes: { buyers: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, subCommodities: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null }> | null } | null };

export type OnePackClientCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type OnePackClientCodesQuery = { onepackClientCodes: Array<{ id: string, clientCode: string, label: string }> };

export type OnepackSyncCallsQueryVariables = Exact<{
  clientCode?: string | null | undefined;
  limit?: number | null | undefined;
}>;


export type OnepackSyncCallsQuery = { onepackPackInstructionSyncCalls: Array<{ id: string, clientCode: string | null, url: string, message: string | null, statusCode: string | null, syncSucceeded: boolean, itemsCount: number, createdAt: string }> };

export type UpdatePackInstructionLineItemPriorityMutationVariables = Exact<{
  packInstructionLineItemId: string | number;
  priority?: number | null | undefined;
}>;


export type UpdatePackInstructionLineItemPriorityMutation = { updatePackInstructionLineItemPriority: { errors: string | null } | null };

export type PushPackInstructionsToOnepackMutationVariables = Exact<{
  clientCode: string;
  packInstructionsAttributes: Types.PackInstructionsAttributes;
}>;


export type PushPackInstructionsToOnepackMutation = { pushPackInstructionsToOnepack: { success: boolean, message: string | null, isPlatformError: boolean, packInstructionRef: string | null } | null };

export type CompanyFieldsFragment = { id: number | null, name: string | null };

export type PackhouseConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackhouseConnectionsQuery = { packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null, company: { id: number | null, name: string | null }, foodBusinessOperator: { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, globalGapNumber: string | null, latitude: number | null, longitude: number | null, status: string | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null, placeId: string | null } | null, company: { id: number | null, name: string | null } | null, packhouseConnections: Array<{ id: string, name: string, state: string, scheduledFor: string | null, scheduledAt: string | null, createdAt: string, updatedAt: string, apiUserId: number, connected: boolean, lastProcessedDatetime: string | null, onPremSystem: string | null }> | null }, masterfileConfig: { id: string | null, state: Types.MasterfileConfigStateEnum | null, masterfileEntityType: Types.MasterfileEntityTypeEnum | null, masterfileEntityId: number | null, companyId: number | null } | null }> | null };

export type PackhouseConnectionsClientChangeRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackhouseConnectionsClientChangeRequestsQuery = { packhouseConnectionsClientChangeRequests: Array<{ id: string | null, createdAt: string | null, updatedAt: string | null, foodBusinessOperator: { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, createdAt: string, updatedAt: string, company: { id: number | null, name: string | null } | null } | null, company: { id: number | null, name: string | null } | null }> | null };

export type CreatePackhouseConnectionsRequestMutationVariables = Exact<{
  attributes: Types.CreatePackhouseConnectionsAttribute;
}>;


export type CreatePackhouseConnectionsRequestMutation = { createPackhouseConnectionsRequest: { errors: Array<string> | null, clientChangeRequests: Array<{ id: string | null, createdAt: string | null, updatedAt: string | null, foodBusinessOperator: { id: number | null, name: string | null, fboCode: string | null, producerName: string | null, typeOfBusiness: string | null, productionRegion: string | null, createdAt: string, updatedAt: string, company: { id: number | null, name: string | null } | null } | null, company: { id: number | null, name: string | null } | null }> | null } | null };

export type PaymentQueryVariables = Exact<{
  id: string | number;
}>;


export type PaymentQuery = { payment: { totalAmountMajorUnit: string | null, allocatedAmountMajorUnit: string | null, remainingAmountMajorUnit: string | null, bankChargesMajorUnit: string | null, bankChargesSplit: Types.BankChargeSplitEnum | null, cashbookReference: string | null, companyName: string | null, companyId: string | null, createdAt: string | null, currency: string | null, description: string | null, id: string | null, contactName: string | null, contactId: string | null, paymentDate: string | null, paymentType: Types.PaymentTypeEnum | null, updatedAt: string | null, state: Types.PaymentStateEnum | null, invoices: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, currency: Types.CurrencyEnum | null, allocatedAmountMajorUnit: number | null, remainingAmountMajorUnit: number | null, containerNumbers: string | null, state: Types.InvoiceStateEnum | null, totalIncoterm: string | null, remittableAmountMajorUnit: number | null, updatedAt: string | null, invoicePayments: Array<{ id: string, invoiceId: string, paymentId: string, amountMajorUnit: number }> | null }> | null, invoicePaymentAllocations: Array<{ invoiceId: string, totalAmountMajorUnit: number }> | null, currencyExchangeRate: { id: string, fromCurrency: string, toCurrency: string, exchangeRate: string, exchangeRateDate: string, exchangeRateType: string, currencyConversion: { id: string | null, rates: any, timestamp: string | null } | null } | null } | null };

export type PaymentsQueryVariables = Exact<{
  filterAttributes?: Types.PaymentsFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type PaymentsQuery = { payments: { totalCount: number, nodes: Array<{ totalAmountMajorUnit: string | null, allocatedAmountMajorUnit: string | null, remainingAmountMajorUnit: string | null, bankChargesMajorUnit: string | null, bankChargesSplit: Types.BankChargeSplitEnum | null, cashbookReference: string | null, companyName: string | null, companyId: string | null, createdAt: string | null, currency: string | null, description: string | null, id: string | null, contactName: string | null, contactId: string | null, paymentDate: string | null, paymentType: Types.PaymentTypeEnum | null, updatedAt: string | null, state: Types.PaymentStateEnum | null, exchangeRate: string | null, currencyExchangeRate: { id: string, fromCurrency: string, toCurrency: string, exchangeRate: string, exchangeRateDate: string, exchangeRateType: string, currencyConversion: { id: string | null, rates: any, timestamp: string | null } | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type PaymentsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentsFilterAttributesQuery = { paymentsFilterAttributes: { contacts: Array<{ id: number | null, name: string | null }> | null } | null };

export type CompanyPaymentsQueryVariables = Exact<{
  filterAttributes?: Types.CompanyPaymentFilters | null | undefined;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type CompanyPaymentsQuery = { companyPayments: Array<{ incomingAmountDueMajorUnit: number | null, outgoingAmountDueMajorUnit: number | null, currency: string | null, companyName: string | null, companyId: string | null, invoicesDue: number | null, contactName: string | null, contactId: string | null, incomingUnallocatedAmountMajorUnit: number | null, outgoingUnallocatedAmountMajorUnit: number | null, unallocatedPayments: number | null, updatedAt: string | null, contact: { id: number | null, name: string | null } | null }> | null };

export type CompanyPaymentsFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyPaymentsFilterAttributesQuery = { companyPaymentsFilterAttributes: { contacts: Array<{ id: number | null, name: string | null }> | null } | null };

export type InvoicesQueryVariables = Exact<{
  filterAttributes: Types.InvoicesFilters;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  page: string;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type InvoicesQuery = { invoices: { totalCount: number, nodes: Array<{ id: string | null, invoiceNumber: string | null, documentType: Types.InvoiceDocumentTypeEnum | null, currency: Types.CurrencyEnum | null, allocatedAmountMajorUnit: number | null, remainingAmountMajorUnit: number | null, remittableAmountMajorUnit: number | null, containerNumbers: string | null, state: Types.InvoiceStateEnum | null, totalIncoterm: string | null, updatedAt: string | null, invoicePayments: Array<{ id: string, invoiceId: string, paymentId: string, amountMajorUnit: number }> | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type CreatePaymentMutationVariables = Exact<{
  attributes: Types.PaymentAttributes;
  currencyExchangeRateAttributes?: Types.CurrencyExchangeRateAttributes | null | undefined;
}>;


export type CreatePaymentMutation = { createPayment: { errors: Array<string> | null, payment: { id: string | null } | null } | null };

export type UpdatePaymentMutationVariables = Exact<{
  paymentId: string | number;
  attributes: Types.PaymentAttributes;
  currencyExchangeRateAttributes?: Types.CurrencyExchangeRateAttributes | null | undefined;
}>;


export type UpdatePaymentMutation = { updatePayment: { errors: Array<string> | null, payment: { id: string | null } | null } | null };

export type DeletePaymentMutationVariables = Exact<{
  paymentId: string | number;
}>;


export type DeletePaymentMutation = { deletePayment: { errors: Array<string> | null, payment: { id: string | null } | null } | null };

export type AllocatePaymentsMutationVariables = Exact<{
  paymentAllocations: Array<Types.PaymentAllocationAttributes> | Types.PaymentAllocationAttributes;
}>;


export type AllocatePaymentsMutation = { allocatePayments: { errors: Array<string> | null, success: boolean | null } | null };

export type PnlLinkedRecordsQueryVariables = Exact<{
  cartonGroupingIds?: Array<number> | number | null | undefined;
  containerIds?: Array<number> | number | null | undefined;
  breakBulkContainerIds?: Array<number> | number | null | undefined;
  reportingCurrency?: string | null | undefined;
  fxEnabled?: boolean | null | undefined;
}>;


export type PnlLinkedRecordsQuery = { pnlLinkedRecords: Array<{ id: string, recordType: string, invoiceNumber: string | null, documentType: string | null, rawDocumentType: string | null, state: string | null, date: string | null, currency: string | null, amountMajorUnit: number | null, isPayment: boolean, contactName: string | null, exchangeRateToReporting: number | null, invoiceExchangeRate: number | null, cartons: number | null, cgCount: number | null, downloadUrl: string | null }> };

export type ProfitAndLossReportQueryVariables = Exact<{
  filters: Types.ProfitAndLossFilters;
}>;


export type ProfitAndLossReportQuery = { profitAndLossReport: { nodes: Array<{ farmCode: string | null, orchard: string | null, containerNumber: string | null, commodity: string | null, variety: string | null, packType: string | null, sizeCount: string | null, grade: string | null, targetRegion: string | null, targetMarket: string | null, targetCountry: string | null, buyerName: string | null, sellerName: string | null, batchNumber: string | null, palletNumber: string | null, exporterCode: string | null, mark: string | null, inventoryCode: string | null, packingWeek: string | null, voyageNumber: string | null, extendedFields: any, totalCartons: number | null, totalStdCartons: number | null, totalKilograms: number | null, cgCount: number | null, palletCount: number | null, shippingWeek: string | null, arrivalWeek: string | null, dischargePort: string | null, vesselName: string | null, incoterm: string | null, contractCurrency: string | null, invoiceExchangeRate: number | null, paymentAdviceNumber: string | null, poNumber: string | null, allOnStatement: boolean | null, paymentAdviceDownloadUrl: string | null, revenue: number | null, cifCosts: number | null, netCif: number | null, fobCosts: number | null, netFob: number | null, dipCosts: number | null, netDip: number | null, exwCosts: number | null, netExw: number | null, growerFinalPayment: number | null, overseasCosts: number | null, localCosts: number | null, revenueAdvance: number | null, revenueFinal: number | null, revenueCreditNote: number | null, revenueDebitNote: number | null, revenuePerCarton: number | null, revenuePerStdCarton: number | null, revenuePerKg: number | null, netCifPerCarton: number | null, netCifPerStdCarton: number | null, netFobPerCarton: number | null, netFobPerStdCarton: number | null, netDipPerCarton: number | null, netDipPerStdCarton: number | null, netExwPerCarton: number | null, netExwPerStdCarton: number | null, cashReceived: number | null, accountsReceivable: number | null, cashReceivedPerCarton: number | null, cashReceivedPerStdCarton: number | null, revenueInclVat: number | null, cifCostsInclVat: number | null, fobCostsInclVat: number | null, dipCostsInclVat: number | null, exwCostsInclVat: number | null, netCifInclVat: number | null, netFobInclVat: number | null, netDipInclVat: number | null, netExwInclVat: number | null, overseasCostsInclVat: number | null, localCostsInclVat: number | null, vatTotalRevenue: number | null, vatTotalCosts: number | null, revenueInclVatPerCarton: number | null, revenueInclVatPerStdCarton: number | null, revenueInclVatPerKg: number | null, netCifInclVatPerCarton: number | null, netCifInclVatPerStdCarton: number | null, netFobInclVatPerCarton: number | null, netFobInclVatPerStdCarton: number | null, netDipInclVatPerCarton: number | null, netDipInclVatPerStdCarton: number | null, netExwInclVatPerCarton: number | null, netExwInclVatPerStdCarton: number | null, costBreakdown: any, linkedRecordsCount: number | null, linkedCgIds: Array<number> | null, linkedContainerIds: Array<number> | null, linkedBbcIds: Array<number> | null }> | null, pageInfo: { hasNextPage: boolean } | null, meta: { rowCount: number | null, sqlMs: number | null, totalMs: number | null, reportingCurrency: string | null, extendedFieldKeys: Array<string> | null, costCategories: Array<{ key: string, label: string | null, section: string | null }> | null } | null } | null };

export type ProfitAndLossReportFieldsFragment = { nodes: Array<{ farmCode: string | null, orchard: string | null, containerNumber: string | null, commodity: string | null, variety: string | null, packType: string | null, sizeCount: string | null, grade: string | null, targetRegion: string | null, targetMarket: string | null, targetCountry: string | null, buyerName: string | null, sellerName: string | null, batchNumber: string | null, palletNumber: string | null, exporterCode: string | null, mark: string | null, inventoryCode: string | null, packingWeek: string | null, voyageNumber: string | null, extendedFields: any, totalCartons: number | null, totalStdCartons: number | null, totalKilograms: number | null, cgCount: number | null, palletCount: number | null, shippingWeek: string | null, arrivalWeek: string | null, dischargePort: string | null, vesselName: string | null, incoterm: string | null, contractCurrency: string | null, invoiceExchangeRate: number | null, paymentAdviceNumber: string | null, poNumber: string | null, allOnStatement: boolean | null, paymentAdviceDownloadUrl: string | null, revenue: number | null, cifCosts: number | null, netCif: number | null, fobCosts: number | null, netFob: number | null, dipCosts: number | null, netDip: number | null, exwCosts: number | null, netExw: number | null, growerFinalPayment: number | null, overseasCosts: number | null, localCosts: number | null, revenueAdvance: number | null, revenueFinal: number | null, revenueCreditNote: number | null, revenueDebitNote: number | null, revenuePerCarton: number | null, revenuePerStdCarton: number | null, revenuePerKg: number | null, netCifPerCarton: number | null, netCifPerStdCarton: number | null, netFobPerCarton: number | null, netFobPerStdCarton: number | null, netDipPerCarton: number | null, netDipPerStdCarton: number | null, netExwPerCarton: number | null, netExwPerStdCarton: number | null, cashReceived: number | null, accountsReceivable: number | null, cashReceivedPerCarton: number | null, cashReceivedPerStdCarton: number | null, revenueInclVat: number | null, cifCostsInclVat: number | null, fobCostsInclVat: number | null, dipCostsInclVat: number | null, exwCostsInclVat: number | null, netCifInclVat: number | null, netFobInclVat: number | null, netDipInclVat: number | null, netExwInclVat: number | null, overseasCostsInclVat: number | null, localCostsInclVat: number | null, vatTotalRevenue: number | null, vatTotalCosts: number | null, revenueInclVatPerCarton: number | null, revenueInclVatPerStdCarton: number | null, revenueInclVatPerKg: number | null, netCifInclVatPerCarton: number | null, netCifInclVatPerStdCarton: number | null, netFobInclVatPerCarton: number | null, netFobInclVatPerStdCarton: number | null, netDipInclVatPerCarton: number | null, netDipInclVatPerStdCarton: number | null, netExwInclVatPerCarton: number | null, netExwInclVatPerStdCarton: number | null, costBreakdown: any, linkedRecordsCount: number | null, linkedCgIds: Array<number> | null, linkedContainerIds: Array<number> | null, linkedBbcIds: Array<number> | null }> | null, pageInfo: { hasNextPage: boolean } | null, meta: { rowCount: number | null, sqlMs: number | null, totalMs: number | null, reportingCurrency: string | null, extendedFieldKeys: Array<string> | null, costCategories: Array<{ key: string, label: string | null, section: string | null }> | null } | null };

export type QueueProfitAndLossReportMutationVariables = Exact<{
  requestId: string;
  filters: Types.ProfitAndLossFilters;
}>;


export type QueueProfitAndLossReportMutation = { queueProfitAndLossReport: { __typename: 'ProfitAndLossReportPending', requestId: string } };

export type ProfitAndLossReportOutcomeQueryVariables = Exact<{
  requestId: string;
}>;


export type ProfitAndLossReportOutcomeQuery = { profitAndLossReportOutcome:
    | { __typename: 'ProfitAndLossReportCompleted', requestId: string, report: { nodes: Array<{ farmCode: string | null, orchard: string | null, containerNumber: string | null, commodity: string | null, variety: string | null, packType: string | null, sizeCount: string | null, grade: string | null, targetRegion: string | null, targetMarket: string | null, targetCountry: string | null, buyerName: string | null, sellerName: string | null, batchNumber: string | null, palletNumber: string | null, exporterCode: string | null, mark: string | null, inventoryCode: string | null, packingWeek: string | null, voyageNumber: string | null, extendedFields: any, totalCartons: number | null, totalStdCartons: number | null, totalKilograms: number | null, cgCount: number | null, palletCount: number | null, shippingWeek: string | null, arrivalWeek: string | null, dischargePort: string | null, vesselName: string | null, incoterm: string | null, contractCurrency: string | null, invoiceExchangeRate: number | null, paymentAdviceNumber: string | null, poNumber: string | null, allOnStatement: boolean | null, paymentAdviceDownloadUrl: string | null, revenue: number | null, cifCosts: number | null, netCif: number | null, fobCosts: number | null, netFob: number | null, dipCosts: number | null, netDip: number | null, exwCosts: number | null, netExw: number | null, growerFinalPayment: number | null, overseasCosts: number | null, localCosts: number | null, revenueAdvance: number | null, revenueFinal: number | null, revenueCreditNote: number | null, revenueDebitNote: number | null, revenuePerCarton: number | null, revenuePerStdCarton: number | null, revenuePerKg: number | null, netCifPerCarton: number | null, netCifPerStdCarton: number | null, netFobPerCarton: number | null, netFobPerStdCarton: number | null, netDipPerCarton: number | null, netDipPerStdCarton: number | null, netExwPerCarton: number | null, netExwPerStdCarton: number | null, cashReceived: number | null, accountsReceivable: number | null, cashReceivedPerCarton: number | null, cashReceivedPerStdCarton: number | null, revenueInclVat: number | null, cifCostsInclVat: number | null, fobCostsInclVat: number | null, dipCostsInclVat: number | null, exwCostsInclVat: number | null, netCifInclVat: number | null, netFobInclVat: number | null, netDipInclVat: number | null, netExwInclVat: number | null, overseasCostsInclVat: number | null, localCostsInclVat: number | null, vatTotalRevenue: number | null, vatTotalCosts: number | null, revenueInclVatPerCarton: number | null, revenueInclVatPerStdCarton: number | null, revenueInclVatPerKg: number | null, netCifInclVatPerCarton: number | null, netCifInclVatPerStdCarton: number | null, netFobInclVatPerCarton: number | null, netFobInclVatPerStdCarton: number | null, netDipInclVatPerCarton: number | null, netDipInclVatPerStdCarton: number | null, netExwInclVatPerCarton: number | null, netExwInclVatPerStdCarton: number | null, costBreakdown: any, linkedRecordsCount: number | null, linkedCgIds: Array<number> | null, linkedContainerIds: Array<number> | null, linkedBbcIds: Array<number> | null }> | null, pageInfo: { hasNextPage: boolean } | null, meta: { rowCount: number | null, sqlMs: number | null, totalMs: number | null, reportingCurrency: string | null, extendedFieldKeys: Array<string> | null, costCategories: Array<{ key: string, label: string | null, section: string | null }> | null } | null } }
    | { __typename: 'ProfitAndLossReportError', requestId: string, error: string }
    | { __typename: 'ProfitAndLossReportNotFound', requestId: string }
    | { __typename: 'ProfitAndLossReportPending', requestId: string }
   };

export type OnProfitAndLossReportCompleteSubscriptionVariables = Exact<{
  requestId: string;
}>;


export type OnProfitAndLossReportCompleteSubscription = { onProfitAndLossReportComplete:
    | { __typename: 'ProfitAndLossReportCompleted', requestId: string, report: { nodes: Array<{ farmCode: string | null, orchard: string | null, containerNumber: string | null, commodity: string | null, variety: string | null, packType: string | null, sizeCount: string | null, grade: string | null, targetRegion: string | null, targetMarket: string | null, targetCountry: string | null, buyerName: string | null, sellerName: string | null, batchNumber: string | null, palletNumber: string | null, exporterCode: string | null, mark: string | null, inventoryCode: string | null, packingWeek: string | null, voyageNumber: string | null, extendedFields: any, totalCartons: number | null, totalStdCartons: number | null, totalKilograms: number | null, cgCount: number | null, palletCount: number | null, shippingWeek: string | null, arrivalWeek: string | null, dischargePort: string | null, vesselName: string | null, incoterm: string | null, contractCurrency: string | null, invoiceExchangeRate: number | null, paymentAdviceNumber: string | null, poNumber: string | null, allOnStatement: boolean | null, paymentAdviceDownloadUrl: string | null, revenue: number | null, cifCosts: number | null, netCif: number | null, fobCosts: number | null, netFob: number | null, dipCosts: number | null, netDip: number | null, exwCosts: number | null, netExw: number | null, growerFinalPayment: number | null, overseasCosts: number | null, localCosts: number | null, revenueAdvance: number | null, revenueFinal: number | null, revenueCreditNote: number | null, revenueDebitNote: number | null, revenuePerCarton: number | null, revenuePerStdCarton: number | null, revenuePerKg: number | null, netCifPerCarton: number | null, netCifPerStdCarton: number | null, netFobPerCarton: number | null, netFobPerStdCarton: number | null, netDipPerCarton: number | null, netDipPerStdCarton: number | null, netExwPerCarton: number | null, netExwPerStdCarton: number | null, cashReceived: number | null, accountsReceivable: number | null, cashReceivedPerCarton: number | null, cashReceivedPerStdCarton: number | null, revenueInclVat: number | null, cifCostsInclVat: number | null, fobCostsInclVat: number | null, dipCostsInclVat: number | null, exwCostsInclVat: number | null, netCifInclVat: number | null, netFobInclVat: number | null, netDipInclVat: number | null, netExwInclVat: number | null, overseasCostsInclVat: number | null, localCostsInclVat: number | null, vatTotalRevenue: number | null, vatTotalCosts: number | null, revenueInclVatPerCarton: number | null, revenueInclVatPerStdCarton: number | null, revenueInclVatPerKg: number | null, netCifInclVatPerCarton: number | null, netCifInclVatPerStdCarton: number | null, netFobInclVatPerCarton: number | null, netFobInclVatPerStdCarton: number | null, netDipInclVatPerCarton: number | null, netDipInclVatPerStdCarton: number | null, netExwInclVatPerCarton: number | null, netExwInclVatPerStdCarton: number | null, costBreakdown: any, linkedRecordsCount: number | null, linkedCgIds: Array<number> | null, linkedContainerIds: Array<number> | null, linkedBbcIds: Array<number> | null }> | null, pageInfo: { hasNextPage: boolean } | null, meta: { rowCount: number | null, sqlMs: number | null, totalMs: number | null, reportingCurrency: string | null, extendedFieldKeys: Array<string> | null, costCategories: Array<{ key: string, label: string | null, section: string | null }> | null } | null } }
    | { __typename: 'ProfitAndLossReportError', requestId: string, error: string }
    | { __typename: 'ProfitAndLossReportNotFound', requestId: string }
    | { __typename: 'ProfitAndLossReportPending', requestId: string }
   };

export type ProfitAndLossFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfitAndLossFilterAttributesQuery = { profitAndLossFilterAttributes: { farmCodes: Array<string> | null, orchards: Array<string> | null, grades: Array<string> | null, targetRegions: Array<string> | null, targetMarkets: Array<string> | null, targetCountries: Array<string> | null, packTypes: Array<string> | null, sizeCounts: Array<string> | null, marks: Array<string> | null, exporterCodes: Array<string> | null, inventoryCodes: Array<string> | null, poNumbers: Array<string> | null, extendedFieldKeys: Array<{ key: string, label: string | null, values: Array<string> | null }> | null, containers: Array<{ id: string, name: string | null }> | null, vessels: Array<{ id: string, name: string | null }> | null, commodities: Array<{ id: string, name: string | null }> | null, varieties: Array<{ id: string, name: string | null }> | null, buyers: Array<{ id: string, name: string | null }> | null, sellers: Array<{ id: string, name: string | null }> | null, financialYearOptions: Array<{ year: number, label: string, startDate: string, endDate: string }> | null } | null };

export type RunReportQueryVariables = Exact<{
  reportId: number;
  gridRequest?: Types.GridRequest | null | undefined;
  reportFilters?: Array<Types.Filter> | Types.Filter | null | undefined;
  outputType?: Types.RunReportOutputTypeEnum | null | undefined;
}>;


export type RunReportQuery = { runReport: any };

export type RunReportAsyncQueryVariables = Exact<{
  reportId: number;
  gridRequest?: Types.GridRequest | null | undefined;
  reportFilters?: Array<Types.Filter> | Types.Filter | null | undefined;
  requestUuid: string;
}>;


export type RunReportAsyncQuery = { runReportAsync: any };

export type ReportQueryVariables = Exact<{
  reportId: number;
}>;


export type ReportQuery = { report: { createdAt: string | null, dataPreparationId: number | null, description: string | null, id: string | null, name: string | null, updatedAt: string | null, configs: Array<{ name: string | null, value: string | null }> | null } | null };

export type ReportGroupsQueryVariables = Exact<{
  filterAttributes: Types.ReportGroupFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
}>;


export type ReportGroupsQuery = { reportGroups: Array<{ name: string | null, description: string | null, id: number | null, domain: Types.ReportGroupDomainEnum | null, scope: Types.ReportGroupScopeEnum | null, badges: Array<{ id: number | null, text: string | null, color: Types.ColorEnum | null }> | null }> | null };

export type ReportGroupQueryVariables = Exact<{
  reportGroupId: number;
}>;


export type ReportGroupQuery = { reportGroup: { id: number | null, layout: string | null, name: string | null, description: string | null, configs: Array<{ name: string | null, value: string | null }> | null, reports: Array<{ id: string | null, reportType: string | null, name: string | null }> | null, switchUnit: { id: string | null, name: string | null, defaultValue: string | null, switchUnitOptions: Array<{ id: string | null, label: string | null, value: string | null, sortOrder: number | null }> | null } | null } | null };

export type FetchReportResultQueryVariables = Exact<{
  requestUuid: string;
}>;


export type FetchReportResultQuery = { fetchReportResult: any };

export type ReportGroupCycleQueryVariables = Exact<{
  id: string | number;
}>;


export type ReportGroupCycleQuery = { reportGroupCycle: { id: number | null, name: string | null, description: string | null, durationSeconds: number | null, items: Array<{ id: number | null, reportGroupId: number | null, params: string | null, reportGroup: { id: number | null, name: string | null, description: string | null } | null }> | null } | null };

export type CreateReportGroupMutationVariables = Exact<{
  attributes: Types.ReportGroupAttributes;
}>;


export type CreateReportGroupMutation = { createReportGroup: { errors: string | null, reportGroup: { description: string | null, id: number | null, name: string | null } | null } | null };

export type UpdateReportGroupMutationVariables = Exact<{
  attributes: Types.ReportGroupAttributes;
}>;


export type UpdateReportGroupMutation = { updateReportGroup: { errors: string | null, reportGroup: { description: string | null, id: number | null, name: string | null } | null } | null };

export type DeleteReportGroupMutationVariables = Exact<{
  id: number;
}>;


export type DeleteReportGroupMutation = { deleteReportGroup: { success: boolean | null, errors: string | null } | null };

export type OnReportCompleteSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnReportCompleteSubscription = { onReportComplete: { requestUuid: string, status: string | null } };

export type OnRefreshReportSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnRefreshReportSubscription = { onRefreshReport: { chartSource: string | null, description: string | null, domain: Types.MetabaseDomainEnum | null, id: number | null, name: string | null, displayName: string | null, scope: Types.MetabaseScopeEnum | null, url: string | null, powerbiEmbedAttributes: { embedToken: string | null, embedUrl: string | null, reportId: string | null } | null } };

export type QueueReportGroupOutputFileMutationVariables = Exact<{
  reportGroupId: string | number;
  requestId: string;
  queryParams?: string | null | undefined;
}>;


export type QueueReportGroupOutputFileMutation = { queueReportGroupOutputFile: { requestId: string, status: string, errors: Array<string> } | null };

export type OnReportOutputFileCompleteSubscriptionVariables = Exact<{
  requestId: string;
}>;


export type OnReportOutputFileCompleteSubscription = { onReportOutputFileComplete: { requestId: string, status: string, pdfUrl: string | null, error: string | null } };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = { myUser: { id: number | null, firstName: string | null, lastName: string | null, phoneNumber: string | null, email: string | null, state: string | null, notifyEmail: boolean | null, notifyBrowserPush: boolean | null, createdAt: string | null, updatedAt: string | null, useV2: boolean | null, avatar: string | null, role: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null, company: { id: number | null, name: string | null } | null, roles: Array<{ name: string | null }> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  id: number;
  firstname: string;
  lastname: string;
  phonenumber: string;
  notifyemail: boolean;
  notifybrowserpush: boolean;
  usev2: boolean;
}>;


export type UpdateUserMutation = { updateUser: { user: { id: number | null, firstName: string | null, lastName: string | null, phoneNumber: string | null, state: string | null, notifyEmail: boolean | null, notifyBrowserPush: boolean | null, useV2: boolean | null } | null } | null };

export type UpdateUserNotificationsMutationVariables = Exact<{
  id: number;
  notifyEmail: boolean;
  notifyBrowserPush: boolean;
}>;


export type UpdateUserNotificationsMutation = { updateUserNotifications: { errors: Array<string> | null, user: { id: number | null, notifyEmail: boolean | null, notifyBrowserPush: boolean | null } | null } | null };

export type UploadUserAvatarMutationVariables = Exact<{
  file: File;
}>;


export type UploadUserAvatarMutation = { uploadUserAvatar: { user: { avatarFile: { id: string | null, filename: string | null, url: string | null } | null } | null } | null };

export type UpdateShipmentDocumentMutationVariables = Exact<{
  id: number;
  type: string;
}>;


export type UpdateShipmentDocumentMutation = { updateShipmentDocument: { shipmentDocument: { id: number | null, documentType: string | null, state: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null } | null } | null };

export type DeleteShipmentDocumentMutationVariables = Exact<{
  id: number;
}>;


export type DeleteShipmentDocumentMutation = { deleteShipmentDocument: { id: number | null } | null };

export type CreateShipmentMutationVariables = Exact<{
  attributes: Types.ShipmentAttributes;
}>;


export type CreateShipmentMutation = { createShipment: { errors: Array<string> | null, shipment: { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null } | null } | null };

export type UpdateShipmentMutationVariables = Exact<{
  attributes: Types.ShipmentAttributes;
}>;


export type UpdateShipmentMutation = { updateShipment: { errors: Array<string> | null, shipment: { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null } | null } | null };

export type CreateShipmentLineItemMutationVariables = Exact<{
  attributes: Types.ShipmentLineItemAttributes;
}>;


export type CreateShipmentLineItemMutation = { createShipmentLineItem: { errors: Array<string> | null, shipmentLineItem: { id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null } | null } | null };

export type DuplicateShipmentLineItemMutationVariables = Exact<{
  id: string | number;
}>;


export type DuplicateShipmentLineItemMutation = { duplicateShipmentLineItem: { shipmentLineItems: Array<{ id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null } | null };

export type UpdateShipmentLineItemMutationVariables = Exact<{
  attributes: Types.ShipmentLineItemAttributes;
}>;


export type UpdateShipmentLineItemMutation = { updateShipmentLineItem: { errors: Array<string> | null, shipmentLineItem: { id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null } | null } | null };

export type CreateExportNotificationBookingMutationVariables = Exact<{
  id: number;
}>;


export type CreateExportNotificationBookingMutation = { createExportNotificationBooking: { errors: string | null } | null };

export type CreateExportNotificationLineItemMutationVariables = Exact<{
  id: number;
}>;


export type CreateExportNotificationLineItemMutation = { createExportNotificationLineItem: { errors: string | null } | null };

export type UpdateAddendumMutationVariables = Exact<{
  addendumLineItems: Array<Types.AddendumLineItemAttributes> | Types.AddendumLineItemAttributes;
  addendumHeader: Types.AddendumHeaderAttributes;
}>;


export type UpdateAddendumMutation = { updateAddendum: { errors: string | null } | null };

export type GenerateAddendumMutationVariables = Exact<{
  sliIds?: Array<number> | number | null | undefined;
  bookingReference?: string | null | undefined;
  shipmentId?: string | number | null | undefined;
}>;


export type GenerateAddendumMutation = { generateAddendum: { errors: string | null, addendumHeader: { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, regimeCode: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null } | null } | null };

export type CancelAddendumMutationVariables = Exact<{
  id: number;
  deleteAddendum: boolean;
}>;


export type CancelAddendumMutation = { cancelAddendum: { id: number | null, message: string | null } | null };

export type ConfirmExportNotificationLineItemMutationVariables = Exact<{
  id: number;
}>;


export type ConfirmExportNotificationLineItemMutation = { confirmExportNotificationLineItem: { errors: string | null, shipment: { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null, portOfLoading: { id: number | null, name: string | null, unLocode: string | null } | null, shipmentLineItems: Array<{ id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null } | null } | null };

export type CompleteShipmentMutationVariables = Exact<{
  id: string | number;
}>;


export type CompleteShipmentMutation = { completeShipment: { errors: Array<string> | null } | null };

export type CompleteShipmentLineItemMutationVariables = Exact<{
  id: string | number;
}>;


export type CompleteShipmentLineItemMutation = { completeShipmentLineItem: { errors: Array<string> | null } | null };

export type SubmitAddendumMutationVariables = Exact<{
  id: number;
}>;


export type SubmitAddendumMutation = { submitAddendum: { errors: string | null, validation: string | null, addendumHeader: { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, regimeCode: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null } | null } | null };

export type QueryAddendumMutationVariables = Exact<{
  id: number;
}>;


export type QueryAddendumMutation = { queryAddendum: { errors: string | null } | null };

export type AllocateSliContainerMutationVariables = Exact<{
  sliId: number;
  sliContainerId?: number | null | undefined;
  isBreakBulk: boolean;
}>;


export type AllocateSliContainerMutation = { allocateSliContainer: { errors: string | null } | null };

export type DeleteShipmentLineItemMutationVariables = Exact<{
  id: number;
}>;


export type DeleteShipmentLineItemMutation = { deleteShipmentLineItem: { id: number | null, errors: Array<string> | null } | null };

export type DeleteAddendumLineItemMutationVariables = Exact<{
  id: number;
}>;


export type DeleteAddendumLineItemMutation = { deleteAddendumLineItem: { errors: string | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null } | null };

export type DuplicateAddendumLineItemMutationVariables = Exact<{
  id: number;
}>;


export type DuplicateAddendumLineItemMutation = { duplicateAddendumLineItem: { addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null } | null };

export type DeleteExportDocumentMutationVariables = Exact<{
  id: number;
}>;


export type DeleteExportDocumentMutation = { deleteExportDocument: { id: number | null } | null };

export type UploadExportDocumentMutationVariables = Exact<{
  attributes: Types.ShipmentLineItemAttributes;
  file: File;
}>;


export type UploadExportDocumentMutation = { uploadExportDocument: { errors: string | null, shipmentLineItem: { exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null } | null } | null };

export type UpdateExportDocumentMutationVariables = Exact<{
  id: number;
  type: string;
}>;


export type UpdateExportDocumentMutation = { updateExportDocument: { exportDocument: { id: number | null, documentType: string | null, user: { id: number | null, firstName: string | null, lastName: string | null, company: { id: number | null } | null } | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null } | null } | null };

export type ExportDocumentFieldsFragment = { id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null };

export type ShipmentCommonFieldsFragment = { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null };

export type SliCommonFieldsFragment = { id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null };

export type IndexShipmentLineItemFieldssFragment = { id: string, shipmentType: Types.ShipmentTypeEnum | null, containerNumber: string | null, sealNumber: string | null, grossWeight: number | null, nettWeight: number | null, comments: string | null, shippingLineReference: string | null, customerReference: string | null, consignee: string | null, serviceContractNumber: string | null, clientReference: string | null, voyageNumber: string | null, finalPortOfDischarge: string | null, state: string | null, status: string | null, totalCartons: number | null, productCodes: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, createdAt: string, portOfDestination: { name: string | null, unLocode: string | null } | null, portOfDischarge: { name: string | null, unLocode: string | null } | null, shipment: { id: string, controller: string | null, client: string | null, vesselName: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, shipmentType: Types.ShipmentTypeEnum | null, portOfLoading: { name: string | null } | null } | null, sliContainer: { id: string, container: { containerNumber: string | null, containerSize: string | null, containerType: string | null, cartonGroupings: Array<{ commodity: { name: string | null } | null }> | null } | null } | null, sliBreakBulk: { id: string, breakBulkContainer: { name: string | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, documentId: number | null, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null };

export type AddendumHeaderFieldsFragment = { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, regimeCode: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null };

export type AddendumLineItemFieldsFragment = { id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null };

export type ShipmentLineItemFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentLineItemFilterAttributesQuery = { shipmentLineItemFilterAttributes: { controllers: Array<string> | null, shippingLineReferences: Array<string> | null, clients: Array<string> | null, vessels: Array<string> | null, states: Array<string> | null, stackDatesStatus: Array<string> | null, shipmentTypes: Array<string> | null } | null };

export type ShipmentPpecbVoyageNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbVoyageNumbersQuery = { ppecbVoyageNumbers: Array<{ id: string, voyageNumber: string | null, vesselName: string | null, ppecbVoyageNumber: string | null }> | null };

export type ShipmentPpecbCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbCountriesQuery = { ppecbCountries: Array<{ code: string | null, name: string | null }> | null };

export type ShipmentPpecbActivityPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbActivityPointsQuery = { ppecbActivityPoints: Array<{ code: string | null, name: string | null }> | null };

export type ShipmentPpecbWorldPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbWorldPortsQuery = { ppecbWorldPorts: Array<{ id: string, portCode: string | null, portName: string | null }> | null };

export type ShipmentPpecbContainerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbContainerTypesQuery = { ppecbContainerTypes: Array<{ description: string | null }> | null };

export type ShipmentPpecbProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbProductsQuery = { ppecbProducts: Array<{ code: string | null, name: string | null }> | null };

export type ShipmentPpecbVentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbVentsQuery = { ppecbVents: Array<{ code: string | null, description: string | null }> | null };

export type ShipmentPpecbRegimeCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbRegimeCodesQuery = { ppecbRegimeCodes: Array<{ regimeCode: string | null }> | null };

export type ShipmentPpecbPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentPpecbPortsQuery = { ppecbPorts: Array<{ id: string, portCode: string | null, portName: string | null }> | null };

export type ShipmentTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentTerminalsQuery = { terminals: Array<{ id: string, name: string | null, code: string | null }> | null };

export type SliContainersQueryVariables = Exact<{ [key: string]: never; }>;


export type SliContainersQuery = { sliContainers: Array<{ id: string, container: { id: number | null, containerNumber: string | null } | null }> | null };

export type SliBreakBulksQueryVariables = Exact<{ [key: string]: never; }>;


export type SliBreakBulksQuery = { sliBreakBulks: Array<{ id: string, breakBulkContainer: { id: string, name: string | null } | null }> | null };

export type SeaShipmentControllersQueryVariables = Exact<{ [key: string]: never; }>;


export type SeaShipmentControllersQuery = { seaShipmentControllers: Array<{ id: number | null, firstName: string | null, lastName: string | null }> | null };

export type AllocateShipmentControllerMutationVariables = Exact<{
  shipmentId: number;
  userId?: number | null | undefined;
}>;


export type AllocateShipmentControllerMutation = { allocateShipmentController: { errors: string | null } | null };

export type ShipmentContainerDepotsQueryVariables = Exact<{
  typeOfBusiness: number;
}>;


export type ShipmentContainerDepotsQuery = { foodBusinessOperatorsByType: Array<{ id: number | null, name: string | null, producerName: string | null, fboCode: string | null }> | null };

export type AddendumHeaderByIdQueryVariables = Exact<{
  id: number;
}>;


export type AddendumHeaderByIdQuery = { addendumHeaderById: { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, regimeCode: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null } | null };

export type AddendumLineItemsByHeaderIdQueryVariables = Exact<{
  addendumHeaderId: number;
}>;


export type AddendumLineItemsByHeaderIdQuery = { addendumLineItemsByHeaderId: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null };

export type AddendumsOnShipmentQueryVariables = Exact<{
  shipmentId: number;
}>;


export type AddendumsOnShipmentQuery = { addendumsOnShipment: Array<{ id: string, shippingBookingReference: string | null, verificationStatus: string | null, state: Types.AddendumHeaderStateEnum | null, addendumStatus: string | null }> | null };

export type NonAddendumShipmentLineItemsQueryVariables = Exact<{
  shipmentId: number;
  bookingRef?: string | null | undefined;
}>;


export type NonAddendumShipmentLineItemsQuery = { nonAddendumShipmentLineItems: Array<{ id: string, containerNumber: string | null, breakBulkContainerNamesIn: string | null, customerReference: string | null, shippingLineReference: string | null }> | null };

export type SliContainersByBookingReferenceQueryVariables = Exact<{
  bookingReference: string;
}>;


export type SliContainersByBookingReferenceQuery = { sliContainersByBookingReference: Array<{ id: string, container: { containerNumber: string | null } | null }> | null };

export type ShipmentLineItemsQueryVariables = Exact<{
  filterAttributes: Types.ShipmentLineItemFilterAttributes;
  searchAttributes: Types.SearchAttributes;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type ShipmentLineItemsQuery = { shipmentLineItems: { totalCount: number, nodes: Array<{ id: string, shipmentType: Types.ShipmentTypeEnum | null, containerNumber: string | null, sealNumber: string | null, grossWeight: number | null, nettWeight: number | null, comments: string | null, shippingLineReference: string | null, customerReference: string | null, consignee: string | null, serviceContractNumber: string | null, clientReference: string | null, voyageNumber: string | null, finalPortOfDischarge: string | null, state: string | null, status: string | null, totalCartons: number | null, productCodes: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, createdAt: string, portOfDestination: { name: string | null, unLocode: string | null } | null, portOfDischarge: { name: string | null, unLocode: string | null } | null, shipment: { id: string, controller: string | null, client: string | null, vesselName: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, shipmentType: Types.ShipmentTypeEnum | null, portOfLoading: { name: string | null } | null } | null, sliContainer: { id: string, container: { containerNumber: string | null, containerSize: string | null, containerType: string | null, cartonGroupings: Array<{ commodity: { name: string | null } | null }> | null } | null } | null, sliBreakBulk: { id: string, breakBulkContainer: { name: string | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, documentId: number | null, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null };

export type ShipmentLineItemsByShipmentQueryVariables = Exact<{
  id: number;
}>;


export type ShipmentLineItemsByShipmentQuery = { shipmentLineItemsByShipment: Array<{ hasLoadOutInstruction: boolean | null, id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null };

export type ShipmentLineItemGroupingsByShipmentQueryVariables = Exact<{
  id: string | number;
}>;


export type ShipmentLineItemGroupingsByShipmentQuery = { shipmentLineItemGroupingsByShipment: Array<{ companyId: string, id: string, shipmentId: string, sligFields: any, totalCartons: number | null, totalGrossWeight: number | null, totalNettWeight: number | null, updatedAt: string, createdAt: string | null }> | null };

export type ShipmentLineItemsBySligQueryVariables = Exact<{
  id: string | number;
}>;


export type ShipmentLineItemsBySligQuery = { shipmentLineItemsBySlig: Array<{ id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, sliContainer: { id: string } | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null };

export type ReassignShipmentLineItemGroupingMutationVariables = Exact<{
  id: string | number;
  sligId: string | number;
}>;


export type ReassignShipmentLineItemGroupingMutation = { reassignShipmentLineItemGrouping: { errors: string | null } | null };

export type ShipmentBookingReferencesQueryVariables = Exact<{
  id: number;
}>;


export type ShipmentBookingReferencesQuery = { shipmentBookingReferences: Array<string> | null };

export type PpecbUserByUserIdQueryVariables = Exact<{
  id: number;
}>;


export type PpecbUserByUserIdQuery = { ppecbUserByUserId: { id: string, agentFboCode: string | null, ppecbRegisteredAgentCode: string | null, ppecbExporters: Array<{ id: string, exporterFboCode: string | null, ppecbRegisteredExporterCode: string | null, company: { name: string | null } | null }> | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null } | null };

export type PpecbExporterByShipmentQueryVariables = Exact<{
  id: string | number;
}>;


export type PpecbExporterByShipmentQuery = { ppecbExporterByShipment: { id: string, exporterFboCode: string | null, ppecbRegisteredExporterCode: string | null, company: { name: string | null } | null } | null };

export type CurrentShipmentClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentShipmentClientsQuery = { currentShipmentClients: Array<string> | null };

export type CurrentShipmentControllersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentShipmentControllersQuery = { currentShipmentControllers: Array<string> | null };

export type CurrentTruckReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTruckReferencesQuery = { currentTruckReferences: Array<string> | null };

export type CurrentTransportCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentTransportCompaniesQuery = { currentTransportCompanies: Array<string> | null };

export type PpecbUserByShipmentQueryVariables = Exact<{
  id: string | number;
}>;


export type PpecbUserByShipmentQuery = { ppecbUserByShipment: { id: string, agentFboCode: string | null, ppecbRegisteredAgentCode: string | null, ppecbExporters: Array<{ id: string, exporterFboCode: string | null, ppecbRegisteredExporterCode: string | null, company: { name: string | null } | null }> | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null } | null };

export type PpecbUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type PpecbUsersQuery = { ppecbUsers: Array<{ id: string, agentFboCode: string | null, ppecbRegisteredAgentCode: string | null, ppecbExporters: Array<{ id: string, exporterFboCode: string | null, ppecbRegisteredExporterCode: string | null, company: { name: string | null } | null }> | null, user: { id: number | null, firstName: string | null, lastName: string | null } | null }> | null };

export type ShipmentQueryVariables = Exact<{
  id: number;
}>;


export type ShipmentQuery = { shipment: { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null, portOfLoading: { id: number | null, name: string | null, unLocode: string | null } | null, terminal: { id: string, name: string | null, code: string | null } | null, shipmentLineItems: Array<{ id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null };

export type ShipmentLineItemQueryVariables = Exact<{
  id: number;
}>;


export type ShipmentLineItemQuery = { shipmentLineItemById: { shipmentId: number | null, id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, shipment: { id: string, ppecbBookingReference: number | null } | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null } | null };

export type ShipmentSeaPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipmentSeaPortsQuery = { seaPorts: Array<{ id: number | null, name: string | null, country: string | null, unLocode: string | null }> | null };

export type OnAddendumHeaderStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnAddendumHeaderStateChangeSubscription = { onAddendumHeaderStateChange: { id: string, requestId: string | null, exporterCode: string | null, cfCode: string | null, lspCode: string | null, transportType: string | null, vesselName: string | null, vesselType: string | null, voyageNumber: string | null, regimeCode: string | null, shippingBookingReference: string | null, loadPort: string | null, dischargePort: string | null, shippedTargetCountry: string | null, shippedTargetRegion: string | null, locationOfIssue: string | null, estimatedDepartureDate: string | null, eCertAgreementCode: string | null, verificationStatus: string | null, addendumStatus: string | null, ecertStatus: string | null, transactionId: number | null, errorReason: string | null, state: Types.AddendumHeaderStateEnum | null, addendumLineItems: Array<{ id: string, stuffLoadDate: string | null, loadPointFboCode: string | null, consignmentNumber: string | null, phc: string | null, inspectedSscc: string | null, clientRef: string | null, upn: string | null, inspectedTargetRegion: string | null, inspectedTargetCountry: string | null, commodityCode: string | null, varietyCode: string | null, productClass: string | null, nettWeight: number | null, grossWeight: number | null, ssccNettWeight: number | null, ssccGrossWeight: number | null, cartonQuantity: number | null, inspectionPoint: string | null, inspectorCode: string | null, inspectionDate: string | null, inspectionManifestNumber: string | null, containerNumber: string | null, sequenceNumberOfInspectedSscc: number | null, puc: string | null, orchard: string | null, productionArea: string | null, phytoData: string | null, sizeCountBerrySize: string | null, packCode: string | null, palletQuantity: number | null }> | null } };

export type OnShipmentStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnShipmentStateChangeSubscription = { onShipmentStateChange: { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null, shipmentLineItems: Array<{ id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null } };

export type SubmitShipmentExportNotificationMutationVariables = Exact<{
  id: string | number;
}>;


export type SubmitShipmentExportNotificationMutation = { submitShipmentExportNotification: { errors: string | null, shipment: { id: string, shipmentType: Types.ShipmentTypeEnum | null, ppecbBookingReference: number | null, shippingLine: string | null, voyageNumber: string | null, shippingLineVoyageNumber: string | null, loadPort: string | null, billToParty: string | null, exporterCode: string | null, cfCode: string | null, ppecbRegisteredExporterCode: string | null, ppecbRegisteredAgentCode: string | null, phoneNumber: string | null, userName: string | null, dateCreated: string | null, vesselOriginalEstimatedDateOfDeparture: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, shipper: string | null, status: string | null, vesselName: string | null, vesselCode: string | null, ppecbVoyageNumber: string | null, controller: string | null, client: string | null, comments: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, exportNotificationError: string | null, shipmentLineItems: Array<{ id: string, ppecbBookingReference: number | null, ppecbBookingItemReference: number | null, shippingLineReference: string | null, customerReference: string | null, truckReference: string | null, orderReference: string | null, loadDate: string | null, consignmentReference: string | null, regimeCode: string | null, finalCountryOfDestination: string | null, importPermitNumber: string | null, exporterOnCertificate: string | null, isGensetRequired: boolean | null, isTranshipment: boolean | null, isColdTreatment: boolean | null, transhipmentVesselName: string | null, transhipmentVoyageNumber: string | null, transhipmentPort: string | null, finalPortOfDischarge: string | null, tempSensor: string | null, userName: string | null, dateCreated: string | null, isConventionalShipping: boolean | null, depot: string | null, collectionDate: string | null, loadingInstructionNumber: string | null, haulageType: string | null, transporter: string | null, receiver: string | null, cargoVgm: string | null, solas: string | null, tempDevice: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, containerAndSealNumber: string | null, paymentTerms: string | null, shippingLineContactNumber: string | null, humidity: string | null, voidPlugs: string | null, ventSetting: string | null, protocolTemperature: number | null, protocolDays: number | null, specialInstruction: string | null, status: string | null, productCodes: string | null, containerNumber: string | null, sealNumber: string | null, nettWeight: number | null, grossWeight: number | null, state: string | null, comments: string | null, consignee: string | null, fruitOriginCode: string | null, fruitOriginName: string | null, radiation: boolean | null, fumigation: string | null, treatmentType: string | null, serviceContractNumber: string | null, totalCartons: number | null, exportNotificationError: string | null, tareWeight: number | null, clientReference: string | null, shipmentLineItemGroupingId: string | null, loadingPoints: Array<{ activityPointCode: string | null, loadingDate: string | null, quantity: number | null, containerType: string | null, unitOfMeasure: string | null }> | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, portOfDischarge: { id: number | null, name: string | null, unLocode: string | null } | null, emptyDepot: { id: number | null, producerName: string | null, name: string | null, fboCode: string | null } | null, exportDocuments: Array<{ id: number | null, documentType: string | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null }> | null, certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, file: { id: string | null, filename: string | null, v2Url: string | null } | null, templateOutput: { outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null, checklist: { emailSubject: string | null, title: string | null } | null }> | null } | null } | null };

export type UpdateLoadOutInstructionsFromSlisMutationVariables = Exact<{
  sliIds: Array<string | number> | string | number;
}>;


export type UpdateLoadOutInstructionsFromSlisMutation = { updateLoadOutInstructionsFromSlis: { loadOutInstructions: Array<{ id: string | null, voyage: string | null, shippingLine: string | null, vessel: { id: number | null, vesselName: string | null } | null, portOfLoading: { id: number | null, name: string | null } | null }> | null } | null };

export type GenerateShipmentExportNotificationOutputFilesMutationVariables = Exact<{
  shipmentId: string | number;
}>;


export type GenerateShipmentExportNotificationOutputFilesMutation = { generateShipmentExportNotificationOutputFiles: { shipment: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null } | null };

export type CertificateTransportInstructionQueryVariables = Exact<{
  id: number;
}>;


export type CertificateTransportInstructionQuery = { certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null };

export type UpsertCertificateTransportInstructionMutationVariables = Exact<{
  shipmentLineItemId: string | number;
}>;


export type UpsertCertificateTransportInstructionMutation = { upsertCertificateTransportInstruction: { certificateTransportInstruction: { id: string, templateOutput: { state: string | null, id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } | null } | null } | null };

export type ShipmentsToChooseFromQueryVariables = Exact<{
  shipmentId: number;
}>;


export type ShipmentsToChooseFromQuery = { shipmentsToChooseFrom: Array<{ id: string, vesselName: string | null, client: string | null, voyageNumber: string | null }> | null };

export type ShipmentsAndShipmentLineItemsQueryVariables = Exact<{
  filterAttributes?: Types.ShipmentLineItemFilterAttributes | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderByFields?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  shipmentId?: number | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type ShipmentsAndShipmentLineItemsQuery = { shipmentsAndShipmentLineItems: { shipments: Array<{ id: string, vesselName: string | null, voyageNumber: string | null, client: string | null, truckReference: string | null }>, shipmentLineItems: { totalCount: number, nodes: Array<{ id: string, vesselName: string | null, voyageNumber: string | null, truckReference: string | null, consignmentReference: string | null, portOfLoadingName: string | null, portOfDischargeName: string | null, stackDates: string | null, stackDatesClose: string | null, stackDatesOpenStatus: string | null, stackDatesCloseStatus: string | null, estimatedDispatchDate: string | null, estimatedDeliveryDate: string | null, bookingReference: string | null, documentCount: number | null, clientReference: string | null, customerReference: string | null, shippingLineReference: string | null, containerNumber: string | null, consignmentGroupName: string | null, palletCount: number | null, state: string | null, updatedAt: string, portOfDestinationName: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, loadingPoint: { name: string | null } | null, offloadingPoint: { name: string | null } | null, checklist: { emailSubject: string | null, title: string | null } | null, taskCompletion: { complete: number | null, inProgress: number | null, notStarted: number | null, total: number | null } | null, portOfDestination: { id: number | null, name: string | null, unLocode: string | null } | null, shipment: { id: string, ppecbVoyageNumber: string | null, vesselName: string | null, voyageNumber: string | null, client: string | null, controller: string | null, shipmentType: Types.ShipmentTypeEnum | null, stackDates: string | null, stackDatesClose: string | null, estimatedTimeOfDeparture: string | null, actualTimeOfDeparture: string | null, estimatedTimeOfArrival: string | null, actualTimeOfArrival: string | null, comments: string | null, state: string | null, terminal: { id: string, name: string | null, code: string | null } | null, portOfLoading: { id: number | null, name: string | null, unLocode: string | null } | null } | null, sliContainer: { id: string, container: { containerNumber: string | null } | null } | null, sliBreakBulk: { id: string, breakBulkContainer: { name: string | null } | null } | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } } | null };

export type StockAtLocationQueryVariables = Exact<{
  filterAttributes?: Types.StockFilterInputAttributes | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderAttributes?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  millerAttributes?: Types.MillerCollapsibleInLocationInput | null | undefined;
}>;


export type StockAtLocationQuery = { stockAtLocation: { allLocations: Array<{ locationType: string | null, totalPallets: number | null, name: string | null, id: string | null }> | null, allVessels: Array<{ name: string | null, id: string | null, totalPallets: number | null, vesselEta: string | null }> | null, millerCollapsibleForLocation: Array<{ field: string | null, value: string | null, totalPallets: number | null }> | null, results: Array<{ previousLocationName: string | null, currentLocationName: string | null, nextLocationName: string | null, extendedFields: any, commodityId: string | null, batchNumber: string | null, buyerId: string | null, buyerName: string | null, consignmentNumber: string | null, subCommodityName: string | null, varietyVarietyCode: string | null, cartons: number | null, commodityName: string | null, documentStatus: string | null, exporterCode: string | null, farmCode: string | null, grade: string | null, id: number | null, inspectionDate: string | null, inventoryCode: string | null, loadOutReference: string | null, loadOutInstructionId: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletNumber: string | null, palletAge: number | null, palletGrossMass: number | null, productCharacteristic: string | null, sequenceNumber: number | null, state: string | null, status: string | null, sizeCount: string | null, sellerName: string | null, targetMarket: string | null, targetRegion: string | null, targetCountry: string | null, varietyName: string | null, varietyId: string | null, fileUpdates: Array<{ changeDescription: string | null, currentValue: string | null, id: string | null, oldValue: string | null, viewedByIds: Array<string> | null }> | null }> | null } | null };

export type StockFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type StockFilterAttributesQuery = { stockFilterAttributes: { batchNumbers: Array<string> | null, documentStatuses: Array<string> | null, exporterCodes: Array<string> | null, grades: Array<string> | null, inventoryCodes: Array<string> | null, marks: Array<string> | null, packTypes: Array<string> | null, sizeCounts: Array<string> | null, states: Array<string> | null, targetMarkets: Array<string> | null, buyers: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, subCommodities: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null, varietyCode: string | null }> | null } | null };

export type StockErrorsQueryVariables = Exact<{ [key: string]: never; }>;


export type StockErrorsQuery = { stockErrors: Array<{ errorMessage: string | null, errorCount: number | null, status: string | null }> | null };

export type UploadedStockFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type UploadedStockFilesQuery = { uploadedStockFiles: Array<{ documentId: string | null, filename: string | null, filesize: string | null, filetype: string | null, status: string | null, updatedAt: string | null }> | null };

export type UploadStockFileMutationMutationVariables = Exact<{
  file: File;
}>;


export type UploadStockFileMutationMutation = { uploadStockFile: { errors: string | null, success: boolean } | null };

export type MarkAuditsAsViewedMutationMutationVariables = Exact<{
  auditIds: Array<string | number> | string | number;
}>;


export type MarkAuditsAsViewedMutationMutation = { markAuditsAsViewed: { errors: string | null, success: boolean } | null };

export type StockOnVesselQueryVariables = Exact<{
  vesselId?: number | null | undefined;
  filterAttributes?: Types.StockFilterInputAttributes | null | undefined;
  searchAttributes?: Types.SearchAttributes | null | undefined;
  orderAttributes?: Array<Types.ColumnOrderAttributes> | Types.ColumnOrderAttributes | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
  after?: string | null | undefined;
  before?: string | null | undefined;
}>;


export type StockOnVesselQuery = { stockOnVessel: { allVessels: Array<{ name: string | null, id: string | null, totalPallets: number | null, vesselEta: string | null }> | null, results: { totalCount: number, nodes: Array<{ previousLocationName: string | null, currentLocationName: string | null, nextLocationName: string | null, commodityId: string | null, batchNumber: string | null, buyerId: string | null, buyerName: string | null, consignmentNumber: string | null, containerNumber: string | null, subCommodityName: string | null, loadOutReference: string | null, varietyVarietyCode: string | null, cartons: number | null, commodityName: string | null, exporterCode: string | null, extendedFields: any, farmCode: string | null, grade: string | null, id: number | null, inspectionDate: string | null, inventoryCode: string | null, mark: string | null, netMass: number | null, orchard: string | null, pack: string | null, packhouseCode: string | null, packingWeek: string | null, palletNumber: string | null, palletAge: number | null, palletGrossMass: number | null, productCharacteristic: string | null, sequenceNumber: number | null, state: string | null, status: string | null, sizeCount: string | null, sellerName: string | null, targetMarket: string | null, targetRegion: string | null, targetCountry: string | null, varietyName: string | null, varietyId: string | null, vesselId: number | null, vesselName: string | null } | null> | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } | null } | null };

export type ShippedStockFilterAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippedStockFilterAttributesQuery = { shippedStockFilterAttributes: { batchNumbers: Array<string> | null, exporterCodes: Array<string> | null, grades: Array<string> | null, inventoryCodes: Array<string> | null, marks: Array<string> | null, packTypes: Array<string> | null, sizeCounts: Array<string> | null, states: Array<string> | null, targetMarkets: Array<string> | null, buyers: Array<{ id: number | null, name: string | null }> | null, commodities: Array<{ id: number | null, name: string | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, subCommodities: Array<{ id: number | null, name: string | null }> | null, varieties: Array<{ id: number | null, name: string | null, varietyCode: string | null }> | null } | null };

export type TasksByShipmentLineItemQueryVariables = Exact<{
  sliId: number;
}>;


export type TasksByShipmentLineItemQuery = { tasksByShipmentLineItem: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, state: Types.TaskStateEnum | null, dateOfCompletion: string | null, taskableId: string, taskableType: string, platformDocuments: Array<{ id: string, blobId: string, filename: string, contentType: string, v2Url: string, uploadedAt: string | null }> | null, file: { id: string | null, filename: string | null, v2Url: string | null, uploadedAt: string | null } | null, templateOutput: { updatedAt: string | null, outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> };

export type UploadTaskDocumentMutationVariables = Exact<{
  taskId: number;
  file: File;
  uploadDate?: string | null | undefined;
  customDate?: string | null | undefined;
}>;


export type UploadTaskDocumentMutation = { uploadTaskDocument: { errors: string | null, task: { id: string, customDate: string | null, uploadedAt: string | null, documentId: number | null, file: { filename: string | null, v2Url: string | null } | null } | null } | null };

export type DeleteTaskDocumentMutationVariables = Exact<{
  id: string | number;
  shipmentLineItemId: string | number;
}>;


export type DeleteTaskDocumentMutation = { deleteTaskDocument: { errors: Array<string> | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, state: Types.TaskStateEnum | null, dateOfCompletion: string | null, taskableId: string, taskableType: string, platformDocuments: Array<{ id: string, blobId: string, filename: string, contentType: string, v2Url: string, uploadedAt: string | null }> | null, file: { id: string | null, filename: string | null, v2Url: string | null, uploadedAt: string | null } | null, templateOutput: { updatedAt: string | null, outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null } | null };

export type UpdateTasksDatesMutationVariables = Exact<{
  updateValues: any;
}>;


export type UpdateTasksDatesMutation = { updateTasksDates: { errors: string | null } | null };

export type UpdateCustomTaskDateMutationVariables = Exact<{
  taskId: string | number;
  customDate?: string | null | undefined;
  shipmentLineItemId: string | number;
}>;


export type UpdateCustomTaskDateMutation = { updateCustomTaskDate: { errors: Array<string> | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, state: Types.TaskStateEnum | null, dateOfCompletion: string | null, taskableId: string, taskableType: string, platformDocuments: Array<{ id: string, blobId: string, filename: string, contentType: string, v2Url: string, uploadedAt: string | null }> | null, file: { id: string | null, filename: string | null, v2Url: string | null, uploadedAt: string | null } | null, templateOutput: { updatedAt: string | null, outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null } | null };

export type UploadTaskDocumentPerSliMutationVariables = Exact<{
  taskId: string | number;
  shipmentLineItemId: string | number;
  file: File;
  selectedSliIds: Array<string | number> | string | number;
}>;


export type UploadTaskDocumentPerSliMutation = { uploadTaskDocumentPerSli: { errors: Array<string> | null, tasks: Array<{ id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, state: Types.TaskStateEnum | null, dateOfCompletion: string | null, taskableId: string, taskableType: string, platformDocuments: Array<{ id: string, blobId: string, filename: string, contentType: string, v2Url: string, uploadedAt: string | null }> | null, file: { id: string | null, filename: string | null, v2Url: string | null, uploadedAt: string | null } | null, templateOutput: { updatedAt: string | null, outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null }> | null } | null };

export type TaskCommonFieldsFragment = { id: string, index: number, taskLevel: Types.TaskLevelEnum, uploadedAt: string | null, customDate: string | null, hasDocument: boolean | null, platformTask: boolean, title: string, documentId: number | null, state: Types.TaskStateEnum | null, dateOfCompletion: string | null, taskableId: string, taskableType: string, platformDocuments: Array<{ id: string, blobId: string, filename: string, contentType: string, v2Url: string, uploadedAt: string | null }> | null, file: { id: string | null, filename: string | null, v2Url: string | null, uploadedAt: string | null } | null, templateOutput: { updatedAt: string | null, outputFiles: Array<{ id: string | null, filename: string | null, v2Url: string | null }> | null } | null };

export type OnTemplateOutputStateChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnTemplateOutputStateChangeSubscription = { onTemplateOutputStateChange: { id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null } };

export type TemplateOutputFieldsFragment = { id: string | null, updatedAt: string | null, templateDataSourceType: string | null, templateDataSourceId: string | null, templateVariant: string | null, outputFiles: Array<{ id: string | null, v2Url: string | null, filename: string | null, contentType: string | null }> | null };

export type TemplateOutputFilesQueryVariables = Exact<{
  templateOutputFilesId: number;
}>;


export type TemplateOutputFilesQuery = { templateOutputFiles: { errorReason: string | null, id: string | null, state: string | null, templateDataSourceId: string | null, templateDataSourceType: string | null, updatedAt: string | null, outputFiles: Array<{ contentType: string | null, filename: string | null, id: string | null, url: string | null, v2Url: string | null }> | null } | null };

export type TemplateOutputFilesBySourceQueryVariables = Exact<{
  dataSourceId: number;
  dataSourceType: string;
}>;


export type TemplateOutputFilesBySourceQuery = { templateOutputFilesBySource: Array<{ errorReason: string | null, id: string | null, state: string | null, templateDataSourceId: string | null, templateDataSourceType: string | null, updatedAt: string | null, outputFiles: Array<{ contentType: string | null, filename: string | null, id: string | null, url: string | null, v2Url: string | null }> | null }> | null };

export type TradePartnerQueryVariables = Exact<{
  id: string | number;
}>;


export type TradePartnerQuery = { company: { id: number | null, name: string | null, about: string | null, isBuyer: boolean | null, isSeller: boolean | null, registrationNumber: string | null, vatNumber: string | null, createdAt: string | null, logoFile: { id: string | null, filename: string | null, url: string | null } | null, address: { addressLine1: string | null, addressLine2: string | null, city: string | null, postalCode: string | null, country: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, packingStart: string | null, packingEnd: string | null, peakCount: string | null, hectares: number | null, images: Array<{ id: number | null, url: string | null, thumbnailUrl: string | null }> | null, commodity: { id: number | null, name: string | null, icon: { v2Url: string | null } | null } | null }> | null, certificates: Array<{ id: number | null, companyId: number | null, expiryDate: string | null, certificate: { url: string | null, filename: string | null } | null, certificateType: { name: string | null, id: number | null } | null }> | null, tradeRegions: Array<{ name: string | null, code: string | null }> | null } | null };

export type CompanyInformationFragment = { id: number | null, name: string | null, logoFile: { id: string | null, url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null, icon: { v2Url: string | null } | null } | null }> | null, certificates: Array<{ certificateType: { name: string | null } | null }> | null, tradeRegions: Array<{ name: string | null, code: string | null }> | null };

export type TradePartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type TradePartnersQuery = { myCompany: { id: number | null, isBuyer: boolean | null, isSeller: boolean | null, buyers: Array<{ id: number | null, name: string | null, logoFile: { id: string | null, url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null, icon: { v2Url: string | null } | null } | null }> | null, certificates: Array<{ certificateType: { name: string | null } | null }> | null, tradeRegions: Array<{ name: string | null, code: string | null }> | null }> | null, sellers: Array<{ id: number | null, name: string | null, logoFile: { id: string | null, url: string | null } | null, varieties: Array<{ id: number | null, varietyId: number | null, name: string | null, commodity: { id: number | null, name: string | null, icon: { v2Url: string | null } | null } | null }> | null, certificates: Array<{ certificateType: { name: string | null } | null }> | null, tradeRegions: Array<{ name: string | null, code: string | null }> | null }> | null } | null };

export type OneswitchBuyersQueryVariables = Exact<{ [key: string]: never; }>;


export type OneswitchBuyersQuery = { oneswitchBuyers: Array<{ id: number | null, name: string | null, companyLogoImageUrl: string | null, tradeRegions: Array<{ id: number | null, name: string | null, code: string | null }> | null }> | null };

export type AllTradeRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTradeRegionsQuery = { tradeRegions: Array<{ id: number | null, name: string | null, code: string | null, countries: Array<{ id: number | null, code: string | null, name: string | null }> | null }> | null };

export type UiConfigsQueryVariables = Exact<{
  visibility?: Types.UiConfigVisibilityEnum | null | undefined;
  configType?: string | null | undefined;
}>;


export type UiConfigsQuery = { uiConfigs: Array<{ id: number, configType: string, visibility: Types.UiConfigVisibilityEnum, data: any, readonly: boolean }> | null, myUser: { email: string | null } | null };

export type UiConfigQueryVariables = Exact<{
  id: string | number;
}>;


export type UiConfigQuery = { uiConfig: { id: number, configType: string, visibility: Types.UiConfigVisibilityEnum, data: any, readonly: boolean } | null, myUser: { email: string | null } | null };

export type CreateUiConfigMutationVariables = Exact<{
  attributes: Types.CreateUpdateUiConfigAttributes;
}>;


export type CreateUiConfigMutation = { createUiConfig: { config: { id: number, configType: string, visibility: Types.UiConfigVisibilityEnum, data: any, readonly: boolean } | null } | null };

export type DeleteUiConfigMutationVariables = Exact<{
  deleteUiConfigId: number;
}>;


export type DeleteUiConfigMutation = { deleteUiConfig: { id: number | null } | null };

export type UpdateUiConfigMutationVariables = Exact<{
  attributes: Types.CreateUpdateUiConfigAttributes;
}>;


export type UpdateUiConfigMutation = { updateUiConfig: { config: { id: number, configType: string, visibility: Types.UiConfigVisibilityEnum, data: any, readonly: boolean } | null } | null };

export type UserFeedItemFragment = { id: number | null, message: string | null, read: boolean | null, seen: boolean | null, createdAt: string | null, notifiable: { __typename: 'Comment', id: number | null, commentable:
      | { __typename: 'Order', id: number | null }
      | Record<PropertyKey, never>
     | null } | null };

export type UserFeedItemsConnectionQueryVariables = Exact<{
  last?: number | null | undefined;
  after?: string | null | undefined;
  first?: number | null | undefined;
  before?: string | null | undefined;
}>;


export type UserFeedItemsConnectionQuery = { userFeedConnection: { pageInfo: { endCursor: string | null, startCursor: string | null, hasPreviousPage: boolean, hasNextPage: boolean }, edges: Array<{ cursor: string, node: { id: number | null, message: string | null, read: boolean | null, seen: boolean | null, createdAt: string | null, notifiable: { __typename: 'Comment', id: number | null, commentable:
            | { __typename: 'Order', id: number | null }
            | Record<PropertyKey, never>
           | null } | null } | null } | null> | null } };

export type UserFeedUnseenCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFeedUnseenCountQuery = { userFeedUnseenCount: number };

export type UpdateUserFeedItemMutationVariables = Exact<{
  attributes: Types.UpdateUserFeedItemAttributes;
}>;


export type UpdateUserFeedItemMutation = { updateUserFeedItem: { userFeedItem: { id: number | null, seen: boolean | null, read: boolean | null } | null } | null };

export type UpdateUserFeedItemsMutationVariables = Exact<{
  attributes: Array<Types.UpdateUserFeedItemAttributes> | Types.UpdateUserFeedItemAttributes;
}>;


export type UpdateUserFeedItemsMutation = { updateUserFeedItems: { userFeedItems: Array<{ id: number | null, seen: boolean | null, read: boolean | null }> | null } | null };

export type NewUserFeedItemSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewUserFeedItemSubscription = { newUserFeedItem: { id: number | null } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { myUser: { id: number | null, firstName: string | null, lastName: string | null, phoneNumber: string | null, email: string | null, state: string | null, notifyEmail: boolean | null, notifyBrowserPush: boolean | null, pastEmailRecipients: Array<string> | null, createdAt: string | null, updatedAt: string | null, useV2: boolean | null, locale: string | null, externalIdentifier: string | null, role: string | null, avatarFile: { id: string | null, filename: string | null, url: string | null } | null, company: { id: number | null, name: string | null } | null, roles: Array<{ name: string | null }> | null, permissions: { landingPage: Types.PermissionEnum | null, permissions: Array<{ key: Types.PermissionEnum | null, value: boolean | null }> | null } | null } | null, myCompany: { id: number | null, name: string | null, defaultLocale: string | null, isBuyer: boolean | null, isSeller: boolean | null, state: Types.CompanyStateEnum | null, onboardingStep: Types.CompanyOnboardingStepEnum | null, certificates: Array<{ id: number | null, expiryDate: string | null, createdAt: string | null, updatedAt: string | null, certificate: { id: string | null, filename: string | null, url: string | null } | null, certificateType: { id: number | null, name: string | null } | null }> | null, sellers: Array<{ id: number | null, name: string | null }> | null, buyers: Array<{ id: number | null, name: string | null }> | null } | null };

export type DeleteEmployeeMutationVariables = Exact<{
  employeeid: number;
}>;


export type DeleteEmployeeMutation = { deleteEmployee: { employeeId: number | null } | null };

export type FindOrCreateVesselMutationVariables = Exact<{
  vesselName: string;
}>;


export type FindOrCreateVesselMutation = { findOrCreateVessel: { errors: string | null, vessel: { id: number | null, vesselName: string | null } | null } | null };

export const AccountStatementTemplateOutputFieldsFragmentDoc = gql`
    fragment accountStatementTemplateOutputFields on TemplateOutput {
  outputFiles {
    v2Url
  }
  state
  errorReason
}
    `;
export const ExportErrorFieldsFragmentDoc = gql`
    fragment exportErrorFields on AccountingExportError {
  invoiceId
  invoiceNumber
  errorMessage
  errorType
}
    `;
export const TemplateOutputFieldsFragmentDoc = gql`
    fragment templateOutputFields on TemplateOutput {
  id
  updatedAt
  templateDataSourceType
  templateDataSourceId
  templateVariant
  outputFiles {
    id
    v2Url
    filename
    contentType
  }
}
    `;
export const PalletOutFieldsFragmentDoc = gql`
    fragment palletOutFields on PalletOut {
  id
  addendumHeaderId
  state
  updatedAt
  outputFile {
    contentType
    filename
    v2Url
    id
    url
  }
}
    `;
export const AirAddendumHeaderFieldsFragmentDoc = gql`
    fragment airAddendumHeaderFields on AddendumHeader {
  templateOutput {
    ...templateOutputFields
  }
  palletOut {
    ...palletOutFields
  }
  id
  requestId
  exporterCode
  cfCode
  lspCode
  transportType
  vesselName
  vesselType
  voyageNumber
  exportCertificateNumber
  exportFromCapeTown
  exportFromDurban
  exportFromMaputo
  exportFromOther
  exportFromPortElizabeth
  exporterAgentDate
  exporterAgentName
  forwardingAgentDate
  forwardingAgentName
  disAgentDate
  disAgentName
  inlandInspectorDate
  inlandInspectorName
  portInspectorDate
  portInspectorName
  shippingBookingReference
  loadPort
  dischargePort
  shippedTargetCountry
  shippedTargetRegion
  locationOfIssue
  estimatedDepartureDate
  regimeCode
  eCertAgreementCode
  verificationStatus
  addendumStatus
  ecertStatus
  transactionId
  errorReason
  state
  printedName
  ppecbCertificateNumber
}
    ${TemplateOutputFieldsFragmentDoc}
${PalletOutFieldsFragmentDoc}`;
export const AirAddendumLineItemFieldsFragmentDoc = gql`
    fragment airAddendumLineItemFields on AddendumLineItem {
  id
  stuffLoadDate
  loadPointFboCode
  consignmentNumber
  phc
  inspectedSscc
  clientRef
  upn
  inspectedTargetRegion
  inspectedTargetCountry
  commodityCode
  varietyCode
  productClass
  nettWeight
  grossWeight
  ssccNettWeight
  ssccGrossWeight
  cartonQuantity
  inspectionPoint
  inspectorCode
  inspectionDate
  containerNumber
  sequenceNumberOfInspectedSscc
  puc
  orchard
  productionArea
  phytoData
  sizeCountBerrySize
  packCode
  palletQuantity
  fleshColor
  inspectionManifestNumber
}
    `;
export const AirFreightShipmentFieldsFragmentDoc = gql`
    fragment airFreightShipmentFields on AirFreightShipment {
  id
  externalTransportMasterId
  createdAt
  updatedAt
  shipmentType
  carrierName
  flightNumber
  masterWaybillNumber
  shipper
  consignor
  consignee
  portOfLoadingCode
  portOfLoadingLocation
  forwarderName
  departureAirport
  estimatedDepartureTime
  actualDepartureTime
  portOfDestination
  estimatedArrivalTime
  actualArrivalTime
  controller
  userName
  phoneNumber
  state
  billToParty
  exporterCode
  fboCode
}
    `;
export const AirFreightShipmentLineItemFieldsFragmentDoc = gql`
    fragment airFreightShipmentLineItemFields on AirFreightShipmentLineItem {
  id
  externalShipmentId
  orderReference
  bookingReference
  consignee
  consignor
  finalPortOfDischargeCode
  finalPortOfDischargeLocation
  finalDestinationCode
  finalDestinationLocation
  eta
  collectionDate
  isTransshipment
  transshipmentCarrierName
  transshipmentFlightNumber
  transshipmentPort
  specialHandling
  comments
  packageType
  packageQuantity
  commodityCode
  goodsDescription
  natureOfGoods
  grossWeight
  volume
  grossDimensions
  housebill
  lastStatusMessage
  state
}
    `;
export const BaseCartonGroupingFieldsFragmentDoc = gql`
    fragment baseCartonGroupingFields on CartonGrouping {
  id
  containerNumber
  state
  cartons
  palletNumber
  grade
  batchNumber
  sizeCount
  advancePrice
  finalPrice
  advanceDueDate
  finalDueDate
  lineItem {
    currency
    incoterm
    mark
    orderId
    priceMinorUnit
    priceUnit
    referenceNumber
  }
  buyer {
    id
    name
  }
  seller {
    id
    name
  }
}
    `;
export const CartonGroupingFragmentDoc = gql`
    fragment cartonGrouping on CartonGrouping {
  ...baseCartonGroupingFields
  targetRegion
  targetMarket
  targetCountry
  pack
  palletStack
  packhouseCode
  orchard
  containerNumber
  exporterCode
  farmCode
  packingWeek
  lineItemId
  consignmentNumber
  inventoryCode
  sequenceNumber
  coldStore
  productCharacteristic
  variety {
    id
    name
    commodity {
      id
      name
    }
  }
}
    ${BaseCartonGroupingFieldsFragmentDoc}`;
export const CashFlowCartonGroupingFragmentDoc = gql`
    fragment cashFlowCartonGrouping on CartonGrouping {
  ...baseCartonGroupingFields
  targetRegion
  targetMarket
  palletGrossMass
}
    ${BaseCartonGroupingFieldsFragmentDoc}`;
export const ContainerClaimFieldsFragmentDoc = gql`
    fragment ContainerClaimFields on ContainerClaim {
  id
  completedAt
  state
  companyId
  containerArrivalDate
  notes
  container {
    containerNumber
  }
  arrivalQcDatetime
  updatedAt
  containerableType
  vesselName
  voyageNumber
  containerableId
  photos {
    id
    filename
    v2Url
    contentType
  }
  documents {
    id
    filename
    v2Url
    contentType
  }
  counterParty {
    id
    name
  }
}
    `;
export const DefectFieldsFragmentDoc = gql`
    fragment DefectFields on Defect {
  id
  name
  category
}
    `;
export const ClaimLineItemDefectFieldsFragmentDoc = gql`
    fragment ClaimLineItemDefectFields on ClaimLineItemDefect {
  defect {
    ...DefectFields
  }
  defectPercentage
}
    ${DefectFieldsFragmentDoc}`;
export const ClaimLineItemGroupingFieldsFragmentDoc = gql`
    fragment ClaimLineItemGroupingFields on ClaimLineItemGrouping {
  id
  palletCount
  commodity {
    id
    name
  }
  variety {
    name
  }
  farmCode
  sizeCount
  grade
  arrivalQcGrade
  expectedClaims
  comment
  progressiveClaimLineItemDefects {
    ...ClaimLineItemDefectFields
  }
  progressiveDefectOptions {
    ...DefectFields
  }
  cosmeticClaimLineItemDefects {
    ...ClaimLineItemDefectFields
  }
  cosmeticDefectOptions {
    ...DefectFields
  }
  otherClaimLineItemDefects {
    ...ClaimLineItemDefectFields
  }
  otherDefectOptions {
    ...DefectFields
  }
  progressiveDefectPercentage
  cosmeticDefectPercentage
  otherDefectPercentage
}
    ${ClaimLineItemDefectFieldsFragmentDoc}
${DefectFieldsFragmentDoc}`;
export const CommercialTermChangeRequestFieldsFragmentDoc = gql`
    fragment CommercialTermChangeRequestFields on CommercialTermChangeRequest {
  id
  message
  flag
  commercialTerm {
    id
  }
}
    `;
export const CommercialTermFragmentDoc = gql`
    fragment commercialTerm on CommercialTerm {
  id
  startDate
  endDate
  targetRegion
  advanceType
  advanceUnit
  buyerId
  deleted
  pack
  grade
  paymentTerm
  advanceCreditTerm
  finalCreditTerm
  advanceEvent
  finalEvent
  advanceAmount
  rankOneAdvanceEvent
  rankOneFinalEvent
  advanceCurrency
  finalCurrency
  targetCountry
  exporterCode
  commodityName
  varietyName
  buyerName
  commodity {
    id
    name
  }
  buyer {
    id
    name
  }
  variety {
    id
    name
  }
}
    `;
export const CommoditySeasonFragmentDoc = gql`
    fragment commoditySeason on CommoditySeason {
  id
  startDate
  endDate
  commodity {
    id
    name
    icon {
      v2Url
    }
    commodityGroup
  }
  createdAt
  updatedAt
}
    `;
export const EphytoCommonFieldsFragmentDoc = gql`
    fragment ephytoCommonFields on Ephyto {
  id
  applicationReferenceNo
  applicationType
  applicationStatus
  cbrId
  cbrBillingId
  customReferenceNo
  agreementCode
  desiredIssueLocation
  notificationEmail
  consignorId
  consignorName
  consignorAddressLine1
  consignorAddressLine2
  consignorAddressLine3
  consigneeId
  consigneeName
  consigneeAddressLine1
  consigneeAddressLine2
  consigneeAddressLine3
  consigneeCountryId
  importCountryId
  targetCountryId
  unloadingBaseportLocation
  transportModeCode
  transportMeans
  paymentType
  dalrrdAccNum
  loadSeaPoint
  targetCountry
  targetRegion
  portOfEntry
  bookingRef
  vessel
  voyageNumber
  departureDate
  numberAndDescriptionOfPackage
  botanicalName
  distinguishingMarks
  placeOfOrigin
  declaredMeansOfConveyance
  declaredPointOfEntry
  nameOfProductAndDeclaredQuantity
  treatmentDate
  treatment
  chemical
  durationAndTemperature
  concentration
  additionalInformation
  state
  errorReason
  stuffDate
  temperatureRegime
  originalPhytoDate
  originalPhytoNo
  reexportPlaceOfOrigin
  originalPhyto
  rePacked
  originalContainer
  basedOnOriginalPhyto
  additionalInspection
  cbsFreeArea
  vatNo
  regimeCode
  importPermitNo
  importPermitDate
}
    `;
export const EphytoTradeUnitCommonFieldsFragmentDoc = gql`
    fragment ephytoTradeUnitCommonFields on EphytoTradeUnit {
  id
  tradeUnitId
  clientRef
  orchard
  phc
  productionArea
  commodity
  marketingIndication
  fleshColour
  tuClass
  containerNumber
  numberOfPackagedItems
  netTradeUnitWeight
  nettPalletWeight
  ppecbInspectionDate
  stuffDate
  inspectionManifestNo
  inspectionPointLocationCode
}
    `;
export const EphytoConsignmentItemCommonFieldsFragmentDoc = gql`
    fragment ephytoConsignmentItemCommonFields on EphytoConsignmentItem {
  id
  description
  commonName
  scientificName
  netWeightMeasureCode
  netWeightMeasure
  grossWeightMeasureCode
  grossWeightMeasure
  customsHarmonizedSystemClass
  commodityVegetablePart
  commodityConditionClass
  commodityIntentOfUseClass
  appliedProcessStartDate
  appliedProcessEndDate
  durationMeasureCode
  durationMeasure
  appliedProcessTreatmentTypeLevel1
  appliedProcessTreatmentTypeLevel2
  appliedProcessChemicalCode
  appliedProcessTemperatureUnitCode
  appliedProcessTemperature
  appliedProcessConcentrationUnitCode
  appliedProcessConcentration
  appliedProcessAdditionalNote
  fullTreatmentInformation
  packageLevelCode
  packageTypeCode
  packageItemUnitCode
  packageItemQuantity
  packageShippingMarks
  additionalConsignmentNotes
  sequenceNumeric
}
    `;
export const EphytoDocumentFieldsFragmentDoc = gql`
    fragment ephytoDocumentFields on EphytoDocument {
  id
  documentType
  file {
    id
    filename
    v2Url
  }
}
    `;
export const DocumentFieldsFragmentDoc = gql`
    fragment documentFields on EtlDocument {
  createdAt
  updatedAt
  errorReason
  erroredRows
  fileUrl
  filename
  id
  processedRows
  rows
  state
  source
  documentType
  invoices {
    id
    invoiceNumber
    invoiceDate
    state
    currency
    netAmountMajorUnit
    remittableAmountMajorUnit
    documentType
  }
  invoiceEtlStates {
    invoiceId
    state
    processOutput
  }
}
    `;
export const FarmVarietyFragmentDoc = gql`
    fragment farmVariety on FarmVariety {
  id
  varietyId
  name
  peakCount
  hectares
  packingStart
  packingEnd
  commodity {
    id
    name
  }
  images {
    id
    url
    v2Url
    filename
    thumbnailUrl
    v2ThumbnailUrl
  }
}
    `;
export const InvPortFieldsFragmentDoc = gql`
    fragment invPortFields on SeaPort {
  id
  name
  country
  createdAt
  updatedAt
}
    `;
export const InvoicesSummaryFieldsFragmentDoc = gql`
    fragment invoicesSummaryFields on Invoice {
  invoiceNumber
  invoiceDate
  portOfLoading {
    ...invPortFields
  }
  portOfDestination {
    ...invPortFields
  }
  vessel {
    id
    vesselName
  }
  incoterm
  containers {
    containerNumber
  }
  contacts {
    name
    contactType
    createdByUserId
  }
  id
  currency
  totalIncoterm
  totalCostsMajorUnit
  netAmountMajorUnit
  advancePayment
  finalPayment
  exchangeRate
  allocatedAmountMajorUnit
  remainingAmountMajorUnit
  remittableAmountMajorUnit
  palletCount
  transportType
  documentType
  state
  updatedAt
  createdAt
  templateOutput {
    ...templateOutputFields
  }
  linkedRecords {
    id
    invoiceNumber
    documentType
    finalPayment
    state
    invoiceDate
    currency
    netAmountMajorUnit
  }
  invoicePayments {
    id
    amountMajorUnit
    createdAt
    payment {
      id
      description
      paymentDate
      totalAmountMajorUnit
      currency
      paymentType
      state
    }
  }
  costs
  childInvoices {
    id
    invoiceNumber
    documentType
    finalPayment
    state
  }
  parentInvoice {
    id
    invoiceNumber
    documentType
    state
  }
  sentEmailList {
    id
    createdAt
    recipient
    attachments
  }
  attachedDocuments {
    id
    v2Url
    filename
    contentType
    uploadedAt
  }
  dueDate
  dueDateFinal
  dueDateAdvance
  exchangeRate
  poNumber
  accountingExports {
    id
    exportedAt
    user {
      id
      firstName
      lastName
    }
  }
}
    ${InvPortFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;
export const InvCommonCgFieldsFragmentDoc = gql`
    fragment invCommonCGFields on CartonGrouping {
  batchNumber
  buyer {
    name
  }
  invoiceLineItems {
    invoiceId
    priceUnit
    currency
    documentType
  }
  containerNumber
  cartons
  consignmentNumber
  exporterCode
  farmCode
  grade
  id
  inventoryCode
  lineItem {
    priceUnit
    priceMinorUnit
    currency
    orderId
  }
  mark
  netMass
  orchard
  pack
  packhouseCode
  packingWeek
  palletGrossMass
  palletNumber
  seller {
    name
  }
  sequenceNumber
  sizeCount
  state
  targetCountry
  targetMarket
  targetRegion
  variety {
    id
    commodity {
      id
      name
    }
    name
    subCommodity {
      name
    }
  }
  advancePrice
  finalPrice
}
    `;
export const CgtCommonFieldsFragmentDoc = gql`
    fragment cgtCommonFields on CartonGroupingTransaction {
  id
  transactionDate
  amountMajorUnit
  currency
  exchangeRate
  exchangeCurrency
  externalReferenceNum
  isActual
  createdAt
  updatedAt
  quantityType
  quantityPriceMajorUnit
  quantityAmount
  netMass
  palletGrossMass
  accountType
  cartons
  targetMarket
  advanceTransactionUnitPrice
  cartonGrouping {
    ...invCommonCGFields
  }
}
    ${InvCommonCgFieldsFragmentDoc}`;
export const InvliCommonFieldsFragmentDoc = gql`
    fragment invliCommonFields on InvoiceLineItem {
  cartonGroupingTransactions {
    ...cgtCommonFields
  }
  id
  cartons
  currency
  netMass
  palletGrossMass
  priceUnit
  targetMarket
  sizeCount
  grade
  mark
  pack
  priceMinorUnit
  quantityAmount
  amount
  variety {
    id
    name
    commodity {
      id
      name
    }
  }
  costCode {
    id
    name
    costType
    fieldName
  }
  vatType {
    id
    name
  }
}
    ${CgtCommonFieldsFragmentDoc}`;
export const InvCommonFieldsFragmentDoc = gql`
    fragment invCommonFields on Invoice {
  cartonCount
  invoiceCustomFields {
    customFieldId
    name
    required
    value
    defaultValue
    isDefault
    customFieldDeleted
  }
  convertTonToKg
  countryOfOrigin {
    id
    name
  }
  currency
  localCosts
  insuranceCost
  freightCost
  invoiceNumber
  invoiceDate
  incoterm
  totalFob
  advancePayment
  advanceCreditTerm
  finalPayment
  allocatedAmountMajorUnit
  finalCreditTerm
  dueDateFinal
  subTotal
  vat
  contacts {
    id
    info
    name
    contactType
    createdByUserId
  }
  containers {
    containerNumber
    id
  }
  id
  palletCount
  poNumber
  portOfLoading {
    ...invPortFields
  }
  portOfDestination {
    ...invPortFields
  }
  totalIncoterm
  totalCostsMajorUnit
  netAmountMajorUnit
  ucrNumber
  vessel {
    id
    vesselName
  }
  voyage
  templateOutput {
    ...templateOutputFields
  }
  transportType
  documentType
  state
  airWaybillNo
  shipper
  destination
  allocatedWeight
  routing
  flightDate
  connectingFlightDate
  vehicleNumber
  saleType
  parentInvoiceId
  childInvoices {
    id
    invoiceNumber
    documentType
    finalPayment
    state
  }
  stuffLocation {
    id
    name
  }
  loadingPoint {
    id
    name
  }
  offloadingPoint {
    id
    name
  }
  vatType {
    id
    name
    percentage
  }
  parentInvoice {
    id
    invoiceNumber
    documentType
    advancePayment
    finalPayment
    state
  }
  commercialTerm {
    id
    paymentTerm
    advanceAmount
    advanceCreditTerm
    advanceType
    advanceUnit
    finalCreditTerm
  }
}
    ${InvPortFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;
export const ExpectedReturnSummaryFieldsFragmentDoc = gql`
    fragment expectedReturnSummaryFields on ExpectedReturnSummary {
  unit
  error
  pricePoints {
    incoterm
    moneyAmount {
      currency {
        symbol
        isoCode
        smallestDenomination
        subunitToUnit
      }
      displayString
      fractional
      amount
    }
    chargesApplied {
      name
      moneyAmount {
        currency {
          symbol
          isoCode
          smallestDenomination
          subunitToUnit
        }
        displayString
        fractional
        amount
      }
    }
  }
}
    `;
export const LoiErrorFieldsFragmentDoc = gql`
    fragment LoiErrorFields on LoadOutInstructionError {
  attribute
  type
  cartonGroupingIds
  orchards
  orchardResults {
    id
    farmCode
    orchardName
    currentEuStatus
    eu
    bd
    cbs
    fms
    applied
    verified
    phytoData
  }
}
    `;
export const LoiPortFieldsFragmentDoc = gql`
    fragment loiPortFields on SeaPort {
  id
  name
  country
  createdAt
  updatedAt
}
    `;
export const PalletInFieldsFragmentDoc = gql`
    fragment palletInFields on PalletIn {
  id
  loadOutInstructionId
  state
  updatedAt
  outputFile {
    contentType
    filename
    v2Url
    id
    url
  }
}
    `;
export const LoiCommonFieldsFragmentDoc = gql`
    fragment LoiCommonFields on LoadOutInstruction {
  bookingReference
  transportType
  contacts {
    id
    name
    info
    contactType
    createdByUserId
  }
  containerNumber
  estimatedTimeOfDelivery
  exporter {
    id
    name
  }
  exportersReference
  id
  loadOutReference
  notes
  portOfDestination {
    ...loiPortFields
  }
  portOfDestinationName
  portOfLoading {
    ...loiPortFields
  }
  portOfLoadingName
  printedDate
  q67Reference
  shippingLine
  stuffDate
  stuffLocation {
    id
    name
    createdAt
    updatedAt
  }
  temperatureSetting
  vessel {
    id
    vesselName
  }
  voyage
  templateOutput {
    ...templateOutputFields
  }
  palletIn {
    ...palletInFields
  }
  truckReference
  loadingPoint {
    id
    name
    createdAt
    updatedAt
  }
  offloadingPoint {
    id
    name
    createdAt
    updatedAt
  }
  fileNumber
  airWaybillNo
  shipper
  destination
  allocatedWeight
  routing
  flightDate
  connectingFlightDate
  equipment
  phytoCertificate
  orderPreparedBy
  orderPickedBy
  checked
  stockTransfer
  consignmentReference
  transporterCompany
  estimatedDispatchDate
  loadDate
  orderReference
}
    ${LoiPortFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}
${PalletInFieldsFragmentDoc}`;
export const CgCommonFieldsFragmentDoc = gql`
    fragment cgCommonFields on CartonGrouping {
  batchNumber
  buyer {
    name
  }
  cartons
  consignmentNumber
  exporterCode
  farmCode
  grade
  id
  inventoryCode
  mark
  netMass
  orchard
  pack
  packhouseCode
  packingWeek
  palletGrossMass
  palletNumber
  seller {
    name
  }
  sequenceNumber
  sizeCount
  state
  targetCountry
  targetMarket
  targetRegion
  variety {
    commodity {
      name
    }
    name
    subCommodity {
      name
    }
  }
  palletAge
}
    `;
export const VesselMapFragmentDoc = gql`
    fragment vesselMap on Vessel {
  vesselName
  voyageNumber
  lat
  long
}
    `;
export const SeaPortMapFragmentDoc = gql`
    fragment seaPortMap on SeaPort {
  id
  name
  country
  unLocode
  latitude
  longitude
  createdAt
  updatedAt
}
    `;
export const FboMapFragmentDoc = gql`
    fragment fboMap on FoodBusinessOperator {
  id
  name
  fboCode
  typeOfBusiness
  latitude
  longitude
  createdAt
  updatedAt
}
    `;
export const FarmVarietyFieldsFragmentDoc = gql`
    fragment farmVarietyFields on FarmVariety {
  id
  name
  varietyCode
  hectares
  commodityName
  packingStart
  packingEnd
  peakCount
  variety {
    id
    varietyName
    commodity {
      id
      name
    }
  }
  commodity {
    id
    name
  }
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  addressLine1
  addressLine2
  city
  postalCode
  country
  placeId
}
    `;
export const FoodBusinessOperatorFieldsFragmentDoc = gql`
    fragment foodBusinessOperatorFields on FoodBusinessOperator {
  id
  name
  fboCode
  producerName
  typeOfBusiness
  productionRegion
  globalGapNumber
  latitude
  longitude
  status
  address {
    ...addressFields
  }
  company {
    id
    name
  }
  packhouseConnections {
    id
    name
    state
    scheduledFor
    scheduledAt
    createdAt
    updatedAt
    apiUserId
    connected
    lastProcessedDatetime
    onPremSystem
  }
}
    ${AddressFieldsFragmentDoc}`;
export const SoftwareUpdateReportFieldsFragmentDoc = gql`
    fragment softwareUpdateReportFields on SoftwareUpdateReportRequest {
  id
  company {
    id
    name
  }
  softwareUpdateReport
}
    `;
export const PackhouseConnectionFieldsFragmentDoc = gql`
    fragment packhouseConnectionFields on PackhouseConnection {
  id
  name
  state
  scheduledFor
  scheduledAt
  createdAt
  updatedAt
  apiUserId
  connected
  lastProcessedDatetime
  onPremSystem
}
    `;
export const CompanyAssociationFieldsFragmentDoc = gql`
    fragment companyAssociationFields on CompanyAssociation {
  id
  name
}
    `;
export const MasterfileConfigFieldsFragmentDoc = gql`
    fragment masterfileConfigFields on MasterfileConfig {
  id
  state
  masterfileEntityType
  masterfileEntityId
  companyId
}
    `;
export const MetabaseReportFieldsFragmentDoc = gql`
    fragment MetabaseReportFields on MetabaseReport {
  badges {
    color
    text
  }
  chartSource
  description
  domain
  id
  name
  displayName
  scope
  url
  powerbiEmbedAttributes {
    embedToken
    embedUrl
    reportId
  }
}
    `;
export const NetReturnProgramPortFieldsFragmentDoc = gql`
    fragment netReturnProgramPortFields on SeaPort {
  id
  name
  displayName
  country
  createdAt
  updatedAt
}
    `;
export const NotificationRuleSubscriptionFieldsFragmentDoc = gql`
    fragment NotificationRuleSubscriptionFields on NotificationRuleSubscription {
  id
  enabled
  notifyEmail
  notifyWeb
  notifyMobile
  notifyWhatsapp
  config
}
    `;
export const NotificationRuleFieldsFragmentDoc = gql`
    fragment NotificationRuleFields on NotificationRule {
  id
  name
  description
  notificationSlug
  severity
  defaultThresholds
  notificationRuleSubscription {
    ...NotificationRuleSubscriptionFields
  }
}
    ${NotificationRuleSubscriptionFieldsFragmentDoc}`;
export const NotificationItemFieldsFragmentDoc = gql`
    fragment NotificationItemFields on NotificationItem {
  id
  entityType
  entityId
}
    `;
export const ChannelNotificationFieldsFragmentDoc = gql`
    fragment ChannelNotificationFields on ChannelNotification {
  id
  channelMetadata
  sentAt
  readAt
  archivedAt
  deliveredAt
  title
  body
  notificationRule {
    ...NotificationRuleFields
  }
  notificationItems {
    ...NotificationItemFields
  }
}
    ${NotificationRuleFieldsFragmentDoc}
${NotificationItemFieldsFragmentDoc}`;
export const PortDisplayFieldsFragmentDoc = gql`
    fragment portDisplayFields on SeaPort {
  id
  name
  displayName
  country
  createdAt
  updatedAt
}
    `;
export const OfferItemPriceFieldsFragmentDoc = gql`
    fragment offerItemPriceFields on OfferItemPrice {
  id
  portOfDestination {
    ...portDisplayFields
  }
  portOfDestinationId
  dipPriceAmountMajorUnit
  cifPriceAmountMajorUnit
  priceUnit
}
    ${PortDisplayFieldsFragmentDoc}`;
export const OfferItemFieldsFragmentDoc = gql`
    fragment offerItemFields on OfferItem {
  id
  offerId
  sizeCounts
  grade
  quantity
  quantityUnit
  offerItemPrices {
    ...offerItemPriceFields
  }
  createdAt
  updatedAt
}
    ${OfferItemPriceFieldsFragmentDoc}`;
export const OfferRecipientFieldsFragmentDoc = gql`
    fragment offerRecipientFields on OfferRecipient {
  id
  state
  contactUserId
  buyer {
    id
    name
  }
  portOfDestination {
    ...portDisplayFields
  }
  portOfDestinationId
}
    ${PortDisplayFieldsFragmentDoc}`;
export const OfferFieldsFragmentDoc = gql`
    fragment offerFields on Offer {
  id
  isRootOfferOpenPrice
  isRootOfferOpenQuantity
  state
  title
  description
  currency
  packingWeek
  rootOfferId
  previousOfferId
  orderId
  offerItems {
    ...offerItemFields
  }
  offerRecipients {
    ...offerRecipientFields
  }
  rootOffer {
    id
    companyId
  }
  incoterm
  buyer {
    id
    name
  }
  tradeRegion {
    id
    name
    code
  }
  variety {
    id
    name
    varietyName
    varietyCode
    commodity {
      id
    }
  }
  user {
    id
    firstName
    lastName
  }
  company {
    id
    name
  }
  companyId
  packType
  palletStack
  priceTerm
  expiresAt
  initialQuantity
  quantity
  quantityUnit
  createdAt
  updatedAt
}
    ${OfferItemFieldsFragmentDoc}
${OfferRecipientFieldsFragmentDoc}`;
export const OfferItemPriceExpectedReturnFieldsFragmentDoc = gql`
    fragment offerItemPriceExpectedReturnFields on OfferItemPriceExpectedReturn {
  incoterm
  unit
  currency
  conversionPriceAmountMajorUnit
}
    `;
export const CommentFieldsFragmentDoc = gql`
    fragment commentFields on Comment {
  id
  commentText
  isDeleted
  createdAt
  updatedAt
  user {
    id
    firstName
    lastName
    avatarFile {
      id
      filename
      url
    }
  }
}
    `;
export const SellerCompanyFieldsFragmentDoc = gql`
    fragment sellerCompanyFields on Company {
  id
  name
  logoFile {
    id
    filename
    v2Url
  }
  varieties {
    id
    varietyId
    name
    commodity {
      id
      name
    }
  }
  additionalFields {
    id
    name
  }
}
    `;
export const SingleLineItemFieldsFragmentDoc = gql`
    fragment singleLineItemFields on LineItem {
  id
  additionalFields
  packingWeek
  startWeek
  endWeek
  targetRegion
  targetCountry
  targetMarket
  quantity
  plannedQuantity
  plannedQuantityUnit
  incoterm
  pack
  palletStack
  priority
  quantityUnit
  priceMinorUnit
  sizeCounts
  priceTerm
  currency
  state
  priceUnit
  grade
  mark
  commodityId
  varietyId
  packedCartons
  packedPallets
  variety {
    id
    commodity {
      id
      name
    }
    subCommodity {
      id
      name
    }
    name
    varietyCode
  }
  referenceNumber
  rank
  batchNumber
  inventoryCode
  unlimited
  orderId
  lineItemGroupingId
  createdAt
  updatedAt
  seller {
    id
    name
  }
  buyer {
    id
    name
  }
  departurePortId
  departurePort {
    id
    name
    displayName
    createdAt
    updatedAt
  }
  destinationPortId
  destinationPort {
    id
    name
    displayName
    createdAt
    updatedAt
  }
  cumulativeQuantity
}
    `;
export const StatesDistributionFieldsFragmentDoc = gql`
    fragment statesDistributionFields on LineItem {
  statesDistribution {
    quantity
    quantityTotal
    palletQuantity
    palletQuantityTotal
    state
    supplyChainOrder
  }
}
    `;
export const ShipmentDocumentFieldsFragmentDoc = gql`
    fragment shipmentDocumentFields on ShipmentDocument {
  id
  documentType
  user {
    id
    firstName
    lastName
    company {
      id
    }
  }
  file {
    id
    filename
    v2Url
  }
}
    `;
export const SingleOrderFieldsFragmentDoc = gql`
    fragment singleOrderFields on Order {
  id
  state
  isPackhouseRun
  createdAt
  updatedAt
  comments {
    ...commentFields
  }
  buyer {
    id
    name
    logoFile {
      id
      v2Url
    }
    additionalFields {
      id
      name
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  seller {
    ...sellerCompanyFields
  }
  lineItems {
    ...singleLineItemFields
  }
  lineItemGroupings {
    id
    cumulativeQuantity
    quantityType
    commonFields
    deleted
    rank
    lineItems {
      ...singleLineItemFields
      ...statesDistributionFields
    }
  }
  audits {
    id
    action
    auditableType
    auditableId
    associatedType
    associatedId
    createdAt
    auditedChanges
    version
    user {
      id
      firstName
      company {
        id
        name
      }
    }
  }
  shipmentDocuments {
    ...shipmentDocumentFields
  }
}
    ${CommentFieldsFragmentDoc}
${SellerCompanyFieldsFragmentDoc}
${SingleLineItemFieldsFragmentDoc}
${StatesDistributionFieldsFragmentDoc}
${ShipmentDocumentFieldsFragmentDoc}`;
export const ExpectedNetReturnFieldsFragmentDoc = gql`
    fragment expectedNetReturnFields on LineItem {
  expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
    unit
    error
    equivalentPrice {
      incoterm
      moneyAmount {
        displayString
      }
    }
    pricePoints {
      incoterm
      moneyAmount {
        currency {
          symbol
        }
        amount
      }
      chargesApplied {
        name
        moneyAmount {
          amount
        }
      }
    }
  }
}
    `;
export const SingleOrderFieldsWithNetReturnFragmentDoc = gql`
    fragment singleOrderFieldsWithNetReturn on Order {
  ...singleOrderFields
  lineItemGroupings {
    lineItems {
      ...expectedNetReturnFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}
${ExpectedNetReturnFieldsFragmentDoc}`;
export const MultipleOrderFieldsFragmentDoc = gql`
    fragment multipleOrderFields on Order {
  id
  state
  isPackhouseRun
  updatedAt
  createdAt
  lineItemGroupings {
    commonFields
    cumulativeQuantity
    cumulativeTooltip
    deleted
    id
    numberCumulativeSiblings
    quantityType
    rank
    lineItems(
      lineItemStates: $lineItemStates
      packingWeekStart: $packingWeekStart
      packingWeekEnd: $packingWeekEnd
      varietyIds: $varietyIds
      commodityIds: $commodityIds
      subCommodityIds: $subCommodityIds
      states: $states
    ) {
      ...singleLineItemFields
      ...statesDistributionFields
      ...expectedNetReturnFields
    }
  }
  buyer {
    id
    name
    logoFile {
      id
      filename
      v2Url
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  seller {
    ...sellerCompanyFields
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${StatesDistributionFieldsFragmentDoc}
${ExpectedNetReturnFieldsFragmentDoc}
${SellerCompanyFieldsFragmentDoc}`;
export const DuplicateOrderFieldsFragmentDoc = gql`
    fragment duplicateOrderFields on Order {
  id
  isPackhouseRun
  lineItemGroupings {
    id
    cumulativeQuantity
    quantityType
    commonFields
    deleted
    rank
    lineItems {
      ...singleLineItemFields
    }
  }
  buyer {
    id
    name
    logoFile {
      id
      filename
      v2Url
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
  }
  seller {
    ...sellerCompanyFields
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${SellerCompanyFieldsFragmentDoc}`;
export const CompanyFieldsFragmentDoc = gql`
    fragment companyFields on Company {
  id
  name
}
    `;
export const ProfitAndLossReportFieldsFragmentDoc = gql`
    fragment ProfitAndLossReportFields on ProfitAndLossReport {
  nodes {
    farmCode
    orchard
    containerNumber
    commodity
    variety
    packType
    sizeCount
    grade
    targetRegion
    targetMarket
    targetCountry
    buyerName
    sellerName
    batchNumber
    palletNumber
    exporterCode
    mark
    inventoryCode
    packingWeek
    voyageNumber
    extendedFields
    totalCartons
    totalStdCartons
    totalKilograms
    cgCount
    palletCount
    shippingWeek
    arrivalWeek
    dischargePort
    vesselName
    incoterm
    contractCurrency
    invoiceExchangeRate
    paymentAdviceNumber
    poNumber
    allOnStatement
    paymentAdviceDownloadUrl
    revenue
    cifCosts
    netCif
    fobCosts
    netFob
    dipCosts
    netDip
    exwCosts
    netExw
    growerFinalPayment
    overseasCosts
    localCosts
    revenueAdvance
    revenueFinal
    revenueCreditNote
    revenueDebitNote
    revenuePerCarton
    revenuePerStdCarton
    revenuePerKg
    netCifPerCarton
    netCifPerStdCarton
    netFobPerCarton
    netFobPerStdCarton
    netDipPerCarton
    netDipPerStdCarton
    netExwPerCarton
    netExwPerStdCarton
    cashReceived
    accountsReceivable
    cashReceivedPerCarton
    cashReceivedPerStdCarton
    revenueInclVat
    cifCostsInclVat
    fobCostsInclVat
    dipCostsInclVat
    exwCostsInclVat
    netCifInclVat
    netFobInclVat
    netDipInclVat
    netExwInclVat
    overseasCostsInclVat
    localCostsInclVat
    vatTotalRevenue
    vatTotalCosts
    revenueInclVatPerCarton
    revenueInclVatPerStdCarton
    revenueInclVatPerKg
    netCifInclVatPerCarton
    netCifInclVatPerStdCarton
    netFobInclVatPerCarton
    netFobInclVatPerStdCarton
    netDipInclVatPerCarton
    netDipInclVatPerStdCarton
    netExwInclVatPerCarton
    netExwInclVatPerStdCarton
    costBreakdown
    linkedRecordsCount
    linkedCgIds
    linkedContainerIds
    linkedBbcIds
  }
  pageInfo {
    hasNextPage
  }
  meta {
    rowCount
    sqlMs
    totalMs
    reportingCurrency
    costCategories {
      key
      label
      section
    }
    extendedFieldKeys
  }
}
    `;
export const ShipmentCommonFieldsFragmentDoc = gql`
    fragment shipmentCommonFields on Shipment {
  id
  shipmentType
  ppecbBookingReference
  shippingLine
  voyageNumber
  shippingLineVoyageNumber
  loadPort
  billToParty
  exporterCode
  cfCode
  ppecbRegisteredExporterCode
  ppecbRegisteredAgentCode
  phoneNumber
  userName
  dateCreated
  vesselOriginalEstimatedDateOfDeparture
  stackDates
  stackDatesClose
  stackDatesOpenStatus
  stackDatesCloseStatus
  shipper
  status
  vesselName
  vesselCode
  ppecbVoyageNumber
  controller
  client
  comments
  estimatedTimeOfDeparture
  actualTimeOfDeparture
  exportNotificationError
}
    `;
export const ExportDocumentFieldsFragmentDoc = gql`
    fragment exportDocumentFields on ExportDocument {
  id
  documentType
  file {
    id
    filename
    v2Url
  }
}
    `;
export const SliCommonFieldsFragmentDoc = gql`
    fragment sliCommonFields on ShipmentLineItem {
  id
  ppecbBookingReference
  ppecbBookingItemReference
  shippingLineReference
  customerReference
  truckReference
  orderReference
  loadDate
  consignmentReference
  regimeCode
  finalCountryOfDestination
  importPermitNumber
  exporterOnCertificate
  isGensetRequired
  isTranshipment
  isColdTreatment
  transhipmentVesselName
  transhipmentVoyageNumber
  transhipmentPort
  finalPortOfDischarge
  tempSensor
  userName
  dateCreated
  isConventionalShipping
  depot
  collectionDate
  loadingInstructionNumber
  haulageType
  transporter
  receiver
  cargoVgm
  solas
  tempDevice
  estimatedTimeOfDeparture
  actualTimeOfDeparture
  estimatedTimeOfArrival
  actualTimeOfArrival
  containerAndSealNumber
  paymentTerms
  shippingLineContactNumber
  humidity
  voidPlugs
  ventSetting
  protocolTemperature
  protocolDays
  specialInstruction
  status
  productCodes
  containerNumber
  sealNumber
  nettWeight
  grossWeight
  state
  comments
  consignee
  fruitOriginCode
  fruitOriginName
  radiation
  fumigation
  treatmentType
  serviceContractNumber
  customerReference
  totalCartons
  exportNotificationError
  tareWeight
  loadingPoints {
    activityPointCode
    loadingDate
    quantity
    containerType
    unitOfMeasure
  }
  portOfDestination {
    id
    name
    unLocode
  }
  portOfDischarge {
    id
    name
    unLocode
  }
  emptyDepot {
    id
    producerName
    name
    fboCode
  }
  clientReference
  exportDocuments {
    ...exportDocumentFields
  }
  certificateTransportInstruction {
    id
    templateOutput {
      state
      ...templateOutputFields
    }
  }
  shipmentLineItemGroupingId
  tasks {
    id
    index
    taskLevel
    uploadedAt
    customDate
    hasDocument
    platformTask
    title
    documentId
    file {
      id
      filename
      v2Url
    }
    templateOutput {
      outputFiles {
        id
        filename
        v2Url
      }
    }
  }
  checklist {
    emailSubject
    title
  }
}
    ${ExportDocumentFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;
export const IndexShipmentLineItemFieldssFragmentDoc = gql`
    fragment indexShipmentLineItemFieldss on ShipmentLineItem {
  id
  shipmentType
  containerNumber
  sealNumber
  grossWeight
  nettWeight
  comments
  shippingLineReference
  customerReference
  consignee
  serviceContractNumber
  clientReference
  voyageNumber
  portOfDestination {
    name
    unLocode
  }
  finalPortOfDischarge
  portOfDischarge {
    name
    unLocode
  }
  state
  status
  totalCartons
  productCodes
  estimatedTimeOfDeparture
  actualTimeOfDeparture
  estimatedTimeOfArrival
  actualTimeOfArrival
  shipment {
    id
    controller
    client
    vesselName
    portOfLoading {
      name
    }
    stackDates
    stackDatesClose
    stackDatesOpenStatus
    stackDatesCloseStatus
    estimatedTimeOfDeparture
    actualTimeOfDeparture
    estimatedTimeOfArrival
    actualTimeOfArrival
    shipmentType
  }
  sliContainer {
    id
    container {
      containerNumber
      containerSize
      containerType
      cartonGroupings {
        commodity {
          name
        }
      }
    }
  }
  sliBreakBulk {
    id
    breakBulkContainer {
      name
    }
  }
  tasks {
    id
    index
    taskLevel
    documentId
    uploadedAt
    customDate
    hasDocument
    platformTask
    title
    file {
      id
      filename
      v2Url
    }
    templateOutput {
      outputFiles {
        id
        filename
        v2Url
      }
    }
  }
  checklist {
    emailSubject
    title
  }
  createdAt
}
    `;
export const AddendumHeaderFieldsFragmentDoc = gql`
    fragment addendumHeaderFields on AddendumHeader {
  id
  requestId
  exporterCode
  cfCode
  lspCode
  transportType
  vesselName
  vesselType
  voyageNumber
  regimeCode
  shippingBookingReference
  loadPort
  dischargePort
  shippedTargetCountry
  shippedTargetRegion
  locationOfIssue
  estimatedDepartureDate
  eCertAgreementCode
  verificationStatus
  addendumStatus
  ecertStatus
  transactionId
  errorReason
  state
}
    `;
export const AddendumLineItemFieldsFragmentDoc = gql`
    fragment addendumLineItemFields on AddendumLineItem {
  id
  stuffLoadDate
  loadPointFboCode
  consignmentNumber
  phc
  inspectedSscc
  clientRef
  upn
  inspectedTargetRegion
  inspectedTargetCountry
  commodityCode
  varietyCode
  productClass
  nettWeight
  grossWeight
  ssccNettWeight
  ssccGrossWeight
  cartonQuantity
  inspectionPoint
  inspectorCode
  inspectionDate
  inspectionManifestNumber
  containerNumber
  sequenceNumberOfInspectedSscc
  puc
  orchard
  productionArea
  phytoData
  sizeCountBerrySize
  packCode
  palletQuantity
}
    `;
export const TaskCommonFieldsFragmentDoc = gql`
    fragment taskCommonFields on TaskableTask {
  id
  index
  taskLevel
  uploadedAt
  customDate
  hasDocument
  platformTask
  platformDocuments {
    id
    blobId
    filename
    contentType
    v2Url
    uploadedAt
  }
  title
  documentId
  state
  dateOfCompletion
  taskableId
  taskableType
  file {
    id
    filename
    v2Url
    uploadedAt
  }
  templateOutput {
    outputFiles {
      id
      filename
      v2Url
    }
    updatedAt
  }
}
    `;
export const CompanyInformationFragmentDoc = gql`
    fragment companyInformation on Company {
  id
  name
  logoFile {
    id
    url
  }
  varieties {
    id
    varietyId
    name
    commodity {
      id
      name
      icon {
        v2Url
      }
    }
  }
  certificates {
    certificateType {
      name
    }
  }
  tradeRegions {
    name
    code
  }
}
    `;
export const UserFeedItemFragmentDoc = gql`
    fragment userFeedItem on UserFeedItem {
  id
  message
  read
  seen
  createdAt
  notifiable {
    ... on Comment {
      id
      __typename
      commentable {
        ... on Order {
          id
          __typename
        }
      }
    }
  }
}
    `;
export const GenerateAccountStatementOutputFilesDocument = gql`
    mutation generateAccountStatementOutputFiles($companyId: ID!, $contactId: ID!, $fromDate: ISO8601Date) {
  generateAccountStatementOutputFiles(
    companyId: $companyId
    contactId: $contactId
    fromDate: $fromDate
  ) {
    accountStatement {
      id
      templateOutput {
        ...accountStatementTemplateOutputFields
      }
    }
  }
}
    ${AccountStatementTemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAccountStatementOutputFilesGQL extends Apollo.Mutation<GenerateAccountStatementOutputFilesMutation, GenerateAccountStatementOutputFilesMutationVariables> {
    document = GenerateAccountStatementOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAccountStatementStateChangeDocument = gql`
    subscription onAccountStatementStateChange {
  onAccountStatementStateChange {
    id
    templateOutput {
      ...accountStatementTemplateOutputFields
    }
  }
}
    ${AccountStatementTemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAccountStatementStateChangeGQL extends Apollo.Subscription<OnAccountStatementStateChangeSubscription, OnAccountStatementStateChangeSubscriptionVariables> {
    document = OnAccountStatementStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountStatementDocument = gql`
    query accountStatement($id: ID!) {
  accountStatement(id: $id) {
    id
    templateOutput {
      ...accountStatementTemplateOutputFields
    }
  }
}
    ${AccountStatementTemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountStatementGQL extends Apollo.Query<AccountStatementQuery, AccountStatementQueryVariables> {
    document = AccountStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAccountingExportDocument = gql`
    mutation generateAccountingExport($invoiceIds: [ID!]!) {
  generateAccountingExport(invoiceIds: $invoiceIds) {
    accountingExport {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAccountingExportGQL extends Apollo.Mutation<GenerateAccountingExportMutation, GenerateAccountingExportMutationVariables> {
    document = GenerateAccountingExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountingExportDocument = gql`
    query accountingExport($id: ID!) {
  accountingExport(id: $id) {
    id
    exportStatus
    exportedAt
    exportFile {
      v2Url
    }
    exportErrors {
      ...exportErrorFields
    }
  }
}
    ${ExportErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountingExportGQL extends Apollo.Query<AccountingExportQuery, AccountingExportQueryVariables> {
    document = AccountingExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAccountingExportStateChangeDocument = gql`
    subscription onAccountingExportStateChange {
  onAccountingExportStateChange {
    id
    exportStatus
    exportedAt
    exportFile {
      v2Url
    }
    exportErrors {
      ...exportErrorFields
    }
  }
}
    ${ExportErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAccountingExportStateChangeGQL extends Apollo.Subscription<OnAccountingExportStateChangeSubscription, OnAccountingExportStateChangeSubscriptionVariables> {
    document = OnAccountingExportStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAdditionalFieldDocument = gql`
    mutation CreateAdditionalField($attributes: CreateAdditionalFieldAttributes!) {
  createAdditionalField(attributes: $attributes) {
    additionalField {
      id
      companyId
      name
      description
      fieldType
      parameters
      isPackingInstruction
      private
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAdditionalFieldGQL extends Apollo.Mutation<CreateAdditionalFieldMutation, CreateAdditionalFieldMutationVariables> {
    document = CreateAdditionalFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAdditionalFieldDocument = gql`
    mutation DeleteAdditionalField($id: Int!) {
  deleteAdditionalField(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAdditionalFieldGQL extends Apollo.Mutation<DeleteAdditionalFieldMutation, DeleteAdditionalFieldMutationVariables> {
    document = DeleteAdditionalFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAdditionalFieldDocument = gql`
    mutation UpdateAdditionalField($id: Int!, $attributes: UpdateAdditionalFieldAttributes!) {
  updateAdditionalField(id: $id, attributes: $attributes) {
    additionalField {
      id
      name
      description
      fieldType
      parameters
      isPackingInstruction
      private
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAdditionalFieldGQL extends Apollo.Mutation<UpdateAdditionalFieldMutation, UpdateAdditionalFieldMutationVariables> {
    document = UpdateAdditionalFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdditionalFieldsDocument = gql`
    query AdditionalFields($companyids: [Int!]!) {
  additionalFields(companyIds: $companyids) {
    id
    name
    description
    fieldType
    parameters
    isPackingInstruction
    private
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdditionalFieldsGQL extends Apollo.Query<AdditionalFieldsQuery, AdditionalFieldsQueryVariables> {
    document = AdditionalFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NetReturnFieldsDocument = gql`
    query NetReturnFields($packingWeek: String!) {
  netReturnStandardFields(packingWeek: $packingWeek)
  netReturnAdditionalFields(packingWeek: $packingWeek) {
    companyId
    createdAt
    description
    fieldType
    id
    isPackingInstruction
    name
    parameters
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NetReturnFieldsGQL extends Apollo.Query<NetReturnFieldsQuery, NetReturnFieldsQueryVariables> {
    document = NetReturnFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAg1TableOutputFileDocument = gql`
    mutation GenerateAg1TableOutputFile($data: Json!, $fields: [Ag1TableFieldAttribute!]!, $fileformat: TemplateFileFormatEnum!, $tablename: String!, $filtervalues: String, $requestId: String!) {
  generateAg1TableOutputFile(
    data: $data
    fields: $fields
    fileFormat: $fileformat
    tableName: $tablename
    filterValues: $filtervalues
    requestId: $requestId
  ) {
    requestId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAg1TableOutputFileGQL extends Apollo.Mutation<GenerateAg1TableOutputFileMutation, GenerateAg1TableOutputFileMutationVariables> {
    document = GenerateAg1TableOutputFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAg1TableOutputFileCompleteDocument = gql`
    subscription OnAg1TableOutputFileComplete($requestId: String!) {
  onAg1TableOutputFileComplete(requestId: $requestId) {
    requestId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAg1TableOutputFileCompleteGQL extends Apollo.Subscription<OnAg1TableOutputFileCompleteSubscription, OnAg1TableOutputFileCompleteSubscriptionVariables> {
    document = OnAg1TableOutputFileCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Ag1TableOutputFileResultDocument = gql`
    query Ag1TableOutputFileResult($requestId: String!) {
  ag1TableOutputFileResult(requestId: $requestId) {
    fileUrl
    requestId
    tableName
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Ag1TableOutputFileResultGQL extends Apollo.Query<Ag1TableOutputFileResultQuery, Ag1TableOutputFileResultQueryVariables> {
    document = Ag1TableOutputFileResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirAddendumHeaderByIdDocument = gql`
    query AirAddendumHeaderById($id: Int!) {
  addendumHeaderById(id: $id) {
    ...airAddendumHeaderFields
    addendumLineItems {
      ...airAddendumLineItemFields
    }
  }
}
    ${AirAddendumHeaderFieldsFragmentDoc}
${AirAddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirAddendumHeaderByIdGQL extends Apollo.Query<AirAddendumHeaderByIdQuery, AirAddendumHeaderByIdQueryVariables> {
    document = AirAddendumHeaderByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumsOnAirFreightShipmentDocument = gql`
    query AddendumsOnAirFreightShipment($airFreightShipmentId: Int!) {
  addendumsOnAirFreightShipment(airFreightShipmentId: $airFreightShipmentId) {
    id
    loadOutInstructions {
      id
      loadOutReference
      airFreightShipmentLineItem {
        externalShipmentId
        airFreightShipment {
          masterWaybillNumber
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumsOnAirFreightShipmentGQL extends Apollo.Query<AddendumsOnAirFreightShipmentQuery, AddendumsOnAirFreightShipmentQueryVariables> {
    document = AddendumsOnAirFreightShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentLoisDocument = gql`
    query AirFreightShipmentLois($airFreightShipmentId: ID!) {
  airFreightShipmentLois(airFreightShipmentId: $airFreightShipmentId) {
    id
    loadOutReference
    airWaybillNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentLoisGQL extends Apollo.Query<AirFreightShipmentLoisQuery, AirFreightShipmentLoisQueryVariables> {
    document = AirFreightShipmentLoisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAirAddendumDocument = gql`
    mutation GenerateAirAddendum($loiIds: [ID!]!) {
  generateAirAddendum(loiIds: $loiIds) {
    errors
    addendumHeader {
      ...airAddendumHeaderFields
      addendumLineItems {
        ...airAddendumLineItemFields
      }
    }
  }
}
    ${AirAddendumHeaderFieldsFragmentDoc}
${AirAddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAirAddendumGQL extends Apollo.Mutation<GenerateAirAddendumMutation, GenerateAirAddendumMutationVariables> {
    document = GenerateAirAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAirAddendumDocument = gql`
    mutation UpdateAirAddendum($addendumLineItems: [AddendumLineItemAttributes!]!, $addendumHeader: AddendumHeaderAttributes!) {
  updateAirAddendum(
    addendumLineItems: $addendumLineItems
    addendumHeader: $addendumHeader
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAirAddendumGQL extends Apollo.Mutation<UpdateAirAddendumMutation, UpdateAirAddendumMutationVariables> {
    document = UpdateAirAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelAirAddendumDocument = gql`
    mutation CancelAirAddendum($id: Int!) {
  cancelAirAddendum(id: $id) {
    id
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelAirAddendumGQL extends Apollo.Mutation<CancelAirAddendumMutation, CancelAirAddendumMutationVariables> {
    document = CancelAirAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAddendumHeaderOutputFilesDocument = gql`
    mutation GenerateAddendumHeaderOutputFiles($addendumHeaderId: ID!) {
  generateAddendumHeaderOutputFiles(addendumHeaderId: $addendumHeaderId) {
    templateOutput {
      errorReason
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAddendumHeaderOutputFilesGQL extends Apollo.Mutation<GenerateAddendumHeaderOutputFilesMutation, GenerateAddendumHeaderOutputFilesMutationVariables> {
    document = GenerateAddendumHeaderOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratePalletOutOutputFilesDocument = gql`
    mutation GeneratePalletOutOutputFiles($addendumHeaderId: ID!) {
  generatePalletOutOutputFiles(addendumHeaderId: $addendumHeaderId) {
    palletOutId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratePalletOutOutputFilesGQL extends Apollo.Mutation<GeneratePalletOutOutputFilesMutation, GeneratePalletOutOutputFilesMutationVariables> {
    document = GeneratePalletOutOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnPalletOutOutputStateChangeDocument = gql`
    subscription onPalletOutOutputStateChange {
  onPalletOutOutputStateChange {
    ...palletOutFields
  }
}
    ${PalletOutFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnPalletOutOutputStateChangeGQL extends Apollo.Subscription<OnPalletOutOutputStateChangeSubscription, OnPalletOutOutputStateChangeSubscriptionVariables> {
    document = OnPalletOutOutputStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentsDocument = gql`
    query AirFreightShipments($filterAttributes: AirFreightShipmentsFilter!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  airFreightShipments(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...airFreightShipmentFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${AirFreightShipmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentsGQL extends Apollo.Query<AirFreightShipmentsQuery, AirFreightShipmentsQueryVariables> {
    document = AirFreightShipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentsFilterAttributesDocument = gql`
    query AirFreightShipmentsFilterAttributes {
  airFreightShipmentsFilterAttributes {
    carrierNames
    controllers
    flightNumbers
    states
    shippers
    masterWaybillNumbers
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentsFilterAttributesGQL extends Apollo.Query<AirFreightShipmentsFilterAttributesQuery, AirFreightShipmentsFilterAttributesQueryVariables> {
    document = AirFreightShipmentsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentLineItemsByShipmentDocument = gql`
    query airFreightShipmentLineItemsByShipment($id: Int!) {
  airFreightShipmentLineItemsByShipment(id: $id) {
    ...airFreightShipmentLineItemFields
    airFreightShipment {
      id
    }
  }
}
    ${AirFreightShipmentLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentLineItemsByShipmentGQL extends Apollo.Query<AirFreightShipmentLineItemsByShipmentQuery, AirFreightShipmentLineItemsByShipmentQueryVariables> {
    document = AirFreightShipmentLineItemsByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentByIdDocument = gql`
    query airFreightShipmentById($id: Int!) {
  airFreightShipmentById(id: $id) {
    ...airFreightShipmentFields
    airFreightShipmentLineItems {
      ...airFreightShipmentLineItemFields
    }
  }
}
    ${AirFreightShipmentFieldsFragmentDoc}
${AirFreightShipmentLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentByIdGQL extends Apollo.Query<AirFreightShipmentByIdQuery, AirFreightShipmentByIdQueryVariables> {
    document = AirFreightShipmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NestedAirFreightShipmentLineItemsDocument = gql`
    query NestedAirFreightShipmentLineItems($airFreightShipmentId: ID!) {
  nestedAirFreightShipmentLineItems(airFreightShipmentId: $airFreightShipmentId) {
    bookingReference
    collectionDate
    comments
    commodityCode
    consignee
    consignor
    eta
    externalShipmentId
    finalDestinationCode
    finalDestinationLocation
    finalPortOfDischargeCode
    finalPortOfDischargeLocation
    goodsDescription
    grossDimensions
    grossWeight
    housebill
    id
    isTransshipment
    natureOfGoods
    packageQuantity
    packageType
    orderReference
    specialHandling
    transshipmentPort
    transshipmentCarrierName
    transshipmentFlightNumber
    volume
    lastStatusMessage
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NestedAirFreightShipmentLineItemsGQL extends Apollo.Query<NestedAirFreightShipmentLineItemsQuery, NestedAirFreightShipmentLineItemsQueryVariables> {
    document = NestedAirFreightShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnallocatedAirFreightShipmentLineItemsDocument = gql`
    query UnallocatedAirFreightShipmentLineItems($orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  unallocatedAirFreightShipmentLineItems(
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      bookingReference
      collectionDate
      comments
      commodityCode
      consignee
      consignor
      createdAt
      eta
      externalShipmentId
      finalDestinationCode
      finalDestinationLocation
      finalPortOfDischargeCode
      finalPortOfDischargeLocation
      goodsDescription
      grossDimensions
      grossWeight
      housebill
      id
      isTransshipment
      natureOfGoods
      packageQuantity
      packageType
      orderReference
      specialHandling
      lastStatusMessage
      state
      transshipmentPort
      transshipmentCarrierName
      transshipmentFlightNumber
      updatedAt
      volume
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnallocatedAirFreightShipmentLineItemsGQL extends Apollo.Query<UnallocatedAirFreightShipmentLineItemsQuery, UnallocatedAirFreightShipmentLineItemsQueryVariables> {
    document = UnallocatedAirFreightShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmployeesDocument = gql`
    query Employees {
  employees {
    id
    userFirstName
    userLastName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmployeesGQL extends Apollo.Query<EmployeesQuery, EmployeesQueryVariables> {
    document = EmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteAirFreightShipmentDocument = gql`
    mutation CompleteAirFreightShipment($completeAirFreightShipmentId: Int!) {
  completeAirFreightShipment(id: $completeAirFreightShipmentId) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteAirFreightShipmentGQL extends Apollo.Mutation<CompleteAirFreightShipmentMutation, CompleteAirFreightShipmentMutationVariables> {
    document = CompleteAirFreightShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAirFreightShipmentControllerDocument = gql`
    mutation UpdateAirFreightShipmentController($airFreightShipmentId: Int!, $controllerId: Int, $controllerName: String) {
  updateAirFreightShipmentController(
    airFreightShipmentId: $airFreightShipmentId
    controllerId: $controllerId
    controllerName: $controllerName
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAirFreightShipmentControllerGQL extends Apollo.Mutation<UpdateAirFreightShipmentControllerMutation, UpdateAirFreightShipmentControllerMutationVariables> {
    document = UpdateAirFreightShipmentControllerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransnetVisitsByShipmentIdDocument = gql`
    mutation fetchTransnetVisitsByShipmentId($shipmentId: ID!) {
  fetchTransnetVisitsByShipment(shipmentId: $shipmentId) {
    visitList {
      arrivalNumber
      vesselName
      port
      vesselCallSign
      imoNumber
      arrivalDate
      departureDate
      voyageNumberIn
      voyageNumberOut
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransnetVisitsByShipmentIdGQL extends Apollo.Mutation<FetchTransnetVisitsByShipmentIdMutation, FetchTransnetVisitsByShipmentIdMutationVariables> {
    document = FetchTransnetVisitsByShipmentIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransnetContainerOperatorsDocument = gql`
    mutation fetchTransnetContainerOperators {
  fetchTransnetContainerOperators {
    containerOperators
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransnetContainerOperatorsGQL extends Apollo.Mutation<FetchTransnetContainerOperatorsMutation, FetchTransnetContainerOperatorsMutationVariables> {
    document = FetchTransnetContainerOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchTransnetAccountsDocument = gql`
    query fetchTransnetAccounts {
  transnetAccounts {
    id
    number
    seaPort {
      id
      unLocode
      name
      country
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchTransnetAccountsGQL extends Apollo.Query<FetchTransnetAccountsQuery, FetchTransnetAccountsQueryVariables> {
    document = FetchTransnetAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCargoDueDocument = gql`
    mutation createCargoDue($cargoDueData: Json!, $sliIds: [ID!]!, $transnetVisit: Json!) {
  createCargoDue(
    cargoDueData: $cargoDueData
    sliIds: $sliIds
    transnetVisit: $transnetVisit
  ) {
    cargoDue {
      id
      status
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCargoDueGQL extends Apollo.Mutation<CreateCargoDueMutation, CreateCargoDueMutationVariables> {
    document = CreateCargoDueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CargoDuesDocument = gql`
    query cargoDues($filterAttributes: CargoDuesFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  cargoDues(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      shipmentId
      clientReference
      shippingLineReference
      estimatedTimeOfDeparture
      actualTimeOfDeparture
      sliContainer {
        id
      }
      numberOfContainers
      cargoDue {
        id
        status
        submissionDate
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CargoDuesGQL extends Apollo.Query<CargoDuesQuery, CargoDuesQueryVariables> {
    document = CargoDuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransnetTerminalsDocument = gql`
    query transnetTerminals {
  transnetTerminals {
    name
    code
    portName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransnetTerminalsGQL extends Apollo.Query<TransnetTerminalsQuery, TransnetTerminalsQueryVariables> {
    document = TransnetTerminalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonCountsDocument = gql`
    query CartonCounts {
  cartonCounts {
    id
    name
    commodityId
    cartonTypeId
    counts
    priceMetric
    stackSizes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonCountsGQL extends Apollo.Query<CartonCountsQuery, CartonCountsQueryVariables> {
    document = CartonCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonGroupingsDocument = gql`
    query CartonGroupings($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      ...cartonGrouping
    }
  }
}
    ${CartonGroupingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonGroupingsGQL extends Apollo.Query<CartonGroupingsQuery, CartonGroupingsQueryVariables> {
    document = CartonGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CashFlowCartonGroupingsDocument = gql`
    query CashFlowCartonGroupings($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      ...cashFlowCartonGrouping
    }
  }
}
    ${CashFlowCartonGroupingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CashFlowCartonGroupingsGQL extends Apollo.Query<CashFlowCartonGroupingsQuery, CashFlowCartonGroupingsQueryVariables> {
    document = CashFlowCartonGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainerClaimsDocument = gql`
    query ContainerClaims($containerClaimId: ID, $claimLineItemGroupingId: ID, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $tab: ArrivalQcTabEnum!, $first: Int, $last: Int, $after: String, $before: String) {
  claims(
    containerClaimId: $containerClaimId
    claimLineItemGroupingId: $claimLineItemGroupingId
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    tab: $tab
  ) {
    containerClaims(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        ...ContainerClaimFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainerClaimsGQL extends Apollo.Query<ContainerClaimsQuery, ContainerClaimsQueryVariables> {
    document = ContainerClaimsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClaimLineItemGroupingsDocument = gql`
    query ClaimLineItemGroupings($containerClaimId: ID, $claimLineItemGroupingId: ID, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $tab: ArrivalQcTabEnum!, $first: Int, $last: Int, $after: String, $before: String) {
  claims(
    containerClaimId: $containerClaimId
    claimLineItemGroupingId: $claimLineItemGroupingId
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    tab: $tab
  ) {
    containerClaims(first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
    claimLineItemGroupings {
      ...ClaimLineItemGroupingFields
    }
  }
}
    ${ClaimLineItemGroupingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClaimLineItemGroupingsGQL extends Apollo.Query<ClaimLineItemGroupingsQuery, ClaimLineItemGroupingsQueryVariables> {
    document = ClaimLineItemGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClaimLineItemPalletsDocument = gql`
    query ClaimLineItemPallets($containerClaimId: ID, $claimLineItemGroupingId: ID, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $tab: ArrivalQcTabEnum!, $first: Int, $last: Int, $after: String, $before: String) {
  claims(
    containerClaimId: $containerClaimId
    claimLineItemGroupingId: $claimLineItemGroupingId
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    tab: $tab
  ) {
    containerClaims(first: $first, last: $last, after: $after, before: $before) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
    claimLineItemPallets {
      id
      palletNumber
      arrivalQcGrade
      expectedClaim
      claimLineItemGroupingId
      claimLineItems {
        id
      }
      progressiveClaimLineItemDefects {
        ...ClaimLineItemDefectFields
      }
      progressiveDefectOptions {
        ...DefectFields
      }
      cosmeticClaimLineItemDefects {
        ...ClaimLineItemDefectFields
      }
      cosmeticDefectOptions {
        ...DefectFields
      }
      otherClaimLineItemDefects {
        ...ClaimLineItemDefectFields
      }
      otherDefectOptions {
        ...DefectFields
      }
      commodity {
        id
        name
      }
    }
  }
}
    ${ClaimLineItemDefectFieldsFragmentDoc}
${DefectFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClaimLineItemPalletsGQL extends Apollo.Query<ClaimLineItemPalletsQuery, ClaimLineItemPalletsQueryVariables> {
    document = ClaimLineItemPalletsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainersForArrivalQcDocument = gql`
    query ContainersForArrivalQc($searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!]) {
  containersForArrivalQc(
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    containerNumber
    vesselName
    voyageNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainersForArrivalQcGQL extends Apollo.Query<ContainersForArrivalQcQuery, ContainersForArrivalQcQueryVariables> {
    document = ContainersForArrivalQcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BreakBulkContainersForArrivalQcDocument = gql`
    query BreakBulkContainersForArrivalQc($searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!]) {
  breakBulkContainersForArrivalQc(
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    voyageNumber
    vesselName
    counterParty {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BreakBulkContainersForArrivalQcGQL extends Apollo.Query<BreakBulkContainersForArrivalQcQuery, BreakBulkContainersForArrivalQcQueryVariables> {
    document = BreakBulkContainersForArrivalQcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArrivalQcClaimLineItemPalletGradeDocument = gql`
    mutation UpdateArrivalQcClaimLineItemPalletGrade($claimLineItemIds: [ID!]!, $arrivalQcGrade: ArrivalQcGradeEnum!) {
  updateArrivalQcClaimLineItemPalletGrade(
    claimLineItemIds: $claimLineItemIds
    arrivalQcGrade: $arrivalQcGrade
  ) {
    containerClaim {
      ...ContainerClaimFields
    }
    errors
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArrivalQcClaimLineItemPalletGradeGQL extends Apollo.Mutation<UpdateArrivalQcClaimLineItemPalletGradeMutation, UpdateArrivalQcClaimLineItemPalletGradeMutationVariables> {
    document = UpdateArrivalQcClaimLineItemPalletGradeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArrivalQcClaimLineItemGroupingGradeDocument = gql`
    mutation UpdateArrivalQcClaimLineItemGroupingGrade($claimLineItemGroupingId: ID!, $arrivalQcGrade: ArrivalQcGradeEnum!) {
  updateArrivalQcClaimLineItemGroupingGrade(
    claimLineItemGroupingId: $claimLineItemGroupingId
    arrivalQcGrade: $arrivalQcGrade
  ) {
    containerClaim {
      ...ContainerClaimFields
    }
    errors
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArrivalQcClaimLineItemGroupingGradeGQL extends Apollo.Mutation<UpdateArrivalQcClaimLineItemGroupingGradeMutation, UpdateArrivalQcClaimLineItemGroupingGradeMutationVariables> {
    document = UpdateArrivalQcClaimLineItemGroupingGradeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemGroupingExpectedClaimDocument = gql`
    mutation UpdateClaimLineItemGroupingExpectedClaim($claimLineItemGroupingId: ID!, $expectedClaim: ExpectedClaimEnum!) {
  updateClaimLineItemGroupingExpectedClaim(
    claimLineItemGroupingId: $claimLineItemGroupingId
    expectedClaim: $expectedClaim
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemGroupingExpectedClaimGQL extends Apollo.Mutation<UpdateClaimLineItemGroupingExpectedClaimMutation, UpdateClaimLineItemGroupingExpectedClaimMutationVariables> {
    document = UpdateClaimLineItemGroupingExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemPalletExpectedClaimDocument = gql`
    mutation UpdateClaimLineItemPalletExpectedClaim($claimLineItemIds: [ID!]!, $expectedClaim: ExpectedClaimEnum!) {
  updateClaimLineItemPalletExpectedClaim(
    claimLineItemIds: $claimLineItemIds
    expectedClaim: $expectedClaim
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemPalletExpectedClaimGQL extends Apollo.Mutation<UpdateClaimLineItemPalletExpectedClaimMutation, UpdateClaimLineItemPalletExpectedClaimMutationVariables> {
    document = UpdateClaimLineItemPalletExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemGroupingCommentDocument = gql`
    mutation UpdateClaimLineItemGroupingComment($claimLineItemGroupingId: ID!, $comment: String) {
  updateClaimLineItemGroupingComment(
    claimLineItemGroupingId: $claimLineItemGroupingId
    comment: $comment
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemGroupingCommentGQL extends Apollo.Mutation<UpdateClaimLineItemGroupingCommentMutation, UpdateClaimLineItemGroupingCommentMutationVariables> {
    document = UpdateClaimLineItemGroupingCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemGroupingDefectDocument = gql`
    mutation UpdateClaimLineItemGroupingDefect($claimLineItemGroupingId: ID!, $defectId: ID!) {
  updateClaimLineItemGroupingDefect(
    claimLineItemGroupingId: $claimLineItemGroupingId
    defectId: $defectId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemGroupingDefectGQL extends Apollo.Mutation<UpdateClaimLineItemGroupingDefectMutation, UpdateClaimLineItemGroupingDefectMutationVariables> {
    document = UpdateClaimLineItemGroupingDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateClaimLineItemPalletDefectDocument = gql`
    mutation UpdateClaimLineItemPalletDefect($claimLineItemIds: [ID!]!, $defectId: ID!) {
  updateClaimLineItemPalletDefect(
    claimLineItemIds: $claimLineItemIds
    defectId: $defectId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateClaimLineItemPalletDefectGQL extends Apollo.Mutation<UpdateClaimLineItemPalletDefectMutation, UpdateClaimLineItemPalletDefectMutationVariables> {
    document = UpdateClaimLineItemPalletDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContainerClaimNoteDocument = gql`
    mutation UpdateContainerClaimNote($containerClaimId: ID!, $note: String) {
  updateContainerClaimNote(containerClaimId: $containerClaimId, note: $note) {
    errors
    containerClaim {
      ...ContainerClaimFields
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContainerClaimNoteGQL extends Apollo.Mutation<UpdateContainerClaimNoteMutation, UpdateContainerClaimNoteMutationVariables> {
    document = UpdateContainerClaimNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateArrivalQcCaptureDatetimeDocument = gql`
    mutation UpdateArrivalQcCaptureDatetime($containerClaimId: ID!, $arrivalQcCaptureDatetime: ISO8601DateTime) {
  updateArrivalQcCaptureDatetime(
    containerClaimId: $containerClaimId
    arrivalQcCaptureDatetime: $arrivalQcCaptureDatetime
  ) {
    errors
    containerClaim {
      ...ContainerClaimFields
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateArrivalQcCaptureDatetimeGQL extends Apollo.Mutation<UpdateArrivalQcCaptureDatetimeMutation, UpdateArrivalQcCaptureDatetimeMutationVariables> {
    document = UpdateArrivalQcCaptureDatetimeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkContainerClaimAsCompletedDocument = gql`
    mutation MarkContainerClaimAsCompleted($containerClaimId: ID!) {
  markContainerClaimAsCompleted(containerClaimId: $containerClaimId) {
    errors
    containerClaimId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkContainerClaimAsCompletedGQL extends Apollo.Mutation<MarkContainerClaimAsCompletedMutation, MarkContainerClaimAsCompletedMutationVariables> {
    document = MarkContainerClaimAsCompletedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContainerClaimGradeDocument = gql`
    mutation UpdateContainerClaimGrade($containerClaimId: ID!, $arrivalQcState: ArrivalQcStateEnum!, $arrivalQcGrade: ArrivalQcGradeEnum!) {
  updateContainerClaimGrade(
    containerClaimId: $containerClaimId
    arrivalQcState: $arrivalQcState
    arrivalQcGrade: $arrivalQcGrade
  ) {
    containerClaim {
      ...ContainerClaimFields
    }
    errors
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContainerClaimGradeGQL extends Apollo.Mutation<UpdateContainerClaimGradeMutation, UpdateContainerClaimGradeMutationVariables> {
    document = UpdateContainerClaimGradeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaptureDefectPercentagesDocument = gql`
    mutation CaptureDefectPercentages($attributes: DefectPercentageCaptureAttributes!) {
  captureDefectPercentages(attributes: $attributes) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaptureDefectPercentagesGQL extends Apollo.Mutation<CaptureDefectPercentagesMutation, CaptureDefectPercentagesMutationVariables> {
    document = CaptureDefectPercentagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemGroupingDefectDocument = gql`
    mutation RemoveClaimLineItemGroupingDefect($claimLineItemGroupingId: ID!, $defectId: ID!) {
  removeClaimLineItemGroupingDefect(
    claimLineItemGroupingId: $claimLineItemGroupingId
    defectId: $defectId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemGroupingDefectGQL extends Apollo.Mutation<RemoveClaimLineItemGroupingDefectMutation, RemoveClaimLineItemGroupingDefectMutationVariables> {
    document = RemoveClaimLineItemGroupingDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemPalletDefectDocument = gql`
    mutation RemoveClaimLineItemPalletDefect($claimLineItemIds: [ID!]!, $defectId: ID!, $claimLineItemGroupingId: ID!) {
  removeClaimLineItemPalletDefect(
    claimLineItemIds: $claimLineItemIds
    defectId: $defectId
    claimLineItemGroupingId: $claimLineItemGroupingId
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemPalletDefectGQL extends Apollo.Mutation<RemoveClaimLineItemPalletDefectMutation, RemoveClaimLineItemPalletDefectMutationVariables> {
    document = RemoveClaimLineItemPalletDefectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemGroupingExpectedClaimDocument = gql`
    mutation RemoveClaimLineItemGroupingExpectedClaim($claimLineItemGroupingId: ID!, $expectedClaim: ExpectedClaimEnum!) {
  removeClaimLineItemGroupingExpectedClaim(
    claimLineItemGroupingId: $claimLineItemGroupingId
    expectedClaim: $expectedClaim
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemGroupingExpectedClaimGQL extends Apollo.Mutation<RemoveClaimLineItemGroupingExpectedClaimMutation, RemoveClaimLineItemGroupingExpectedClaimMutationVariables> {
    document = RemoveClaimLineItemGroupingExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveClaimLineItemPalletExpectedClaimDocument = gql`
    mutation RemoveClaimLineItemPalletExpectedClaim($claimLineItemIds: [ID!]!) {
  removeClaimLineItemPalletExpectedClaim(claimLineItemIds: $claimLineItemIds) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveClaimLineItemPalletExpectedClaimGQL extends Apollo.Mutation<RemoveClaimLineItemPalletExpectedClaimMutation, RemoveClaimLineItemPalletExpectedClaimMutationVariables> {
    document = RemoveClaimLineItemPalletExpectedClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SoftDeleteContainerClaimDocument = gql`
    mutation softDeleteContainerClaim($containerClaimId: ID!) {
  softDeleteContainerClaim(containerClaimId: $containerClaimId) {
    error
    containerClaimId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SoftDeleteContainerClaimGQL extends Apollo.Mutation<SoftDeleteContainerClaimMutation, SoftDeleteContainerClaimMutationVariables> {
    document = SoftDeleteContainerClaimDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadClaimFilesDocument = gql`
    mutation UploadClaimFiles($containerClaimId: ID!, $files: [Upload!]!) {
  uploadClaimFiles(containerClaimId: $containerClaimId, files: $files) {
    errors
    containerClaim {
      ...ContainerClaimFields
    }
  }
}
    ${ContainerClaimFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadClaimFilesGQL extends Apollo.Mutation<UploadClaimFilesMutation, UploadClaimFilesMutationVariables> {
    document = UploadClaimFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateArrivalQcsDocument = gql`
    mutation GenerateArrivalQcs($containerableIds: [ID!]!, $containerableType: ContainerableTypeEnum!) {
  generateArrivalQcs(
    containerableIds: $containerableIds
    containerableType: $containerableType
  ) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateArrivalQcsGQL extends Apollo.Mutation<GenerateArrivalQcsMutation, GenerateArrivalQcsMutationVariables> {
    document = GenerateArrivalQcsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnArrivalQcGenerationStateChangeDocument = gql`
    subscription OnArrivalQcGenerationStateChange {
  onArrivalQcGenerationStateChange {
    containerableId
    containerableType
    containerNumber
    vesselName
    voyageNumber
    status
    errorMessage
    containerClaimId
    counterParty {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnArrivalQcGenerationStateChangeGQL extends Apollo.Subscription<OnArrivalQcGenerationStateChangeSubscription, OnArrivalQcGenerationStateChangeSubscriptionVariables> {
    document = OnArrivalQcGenerationStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommentDocument = gql`
    mutation CreateComment($attributes: CreateCommentAttributes!) {
  createComment(attributes: $attributes) {
    comment {
      ...commentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommentGQL extends Apollo.Mutation<CreateCommentMutation, CreateCommentMutationVariables> {
    document = CreateCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentid: Int!) {
  deleteComment(commentId: $commentid) {
    comment {
      ...commentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommentGQL extends Apollo.Mutation<DeleteCommentMutation, DeleteCommentMutationVariables> {
    document = DeleteCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommercialTermChangeRequestDocument = gql`
    mutation CreateCommercialTermChangeRequest($attributes: CreateCommercialTermChangeRequestAttributes!) {
  createCommercialTermChangeRequest(attributes: $attributes) {
    changeRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommercialTermChangeRequestGQL extends Apollo.Mutation<CreateCommercialTermChangeRequestMutation, CreateCommercialTermChangeRequestMutationVariables> {
    document = CreateCommercialTermChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommercialTermsDocument = gql`
    query CommercialTerms($filterAttributes: CommercialTermFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  commercialTerms(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...commercialTerm
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${CommercialTermFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommercialTermsGQL extends Apollo.Query<CommercialTermsQuery, CommercialTermsQueryVariables> {
    document = CommercialTermsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommercialTermFilterAttributesDocument = gql`
    query CommercialTermFilterAttributes {
  commercialTermFilterAttributes {
    targetRegions
    advanceTypes
    advanceUnits
    commodities {
      id
      name
    }
    buyers {
      id
      name
    }
    events
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommercialTermFilterAttributesGQL extends Apollo.Query<CommercialTermFilterAttributesQuery, CommercialTermFilterAttributesQueryVariables> {
    document = CommercialTermFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonTypesByCommodityDocument = gql`
    query CartonTypesByCommodity($commodityId: ID!) {
  cartonTypesByCommodity(commodityId: $commodityId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonTypesByCommodityGQL extends Apollo.Query<CartonTypesByCommodityQuery, CartonTypesByCommodityQueryVariables> {
    document = CartonTypesByCommodityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCommercialTermDocument = gql`
    mutation UpsertCommercialTerm($attributes: CommercialTermAttributes!) {
  upsertCommercialTerm(attributes: $attributes) {
    errors
    commercialTerm {
      ...commercialTerm
    }
  }
}
    ${CommercialTermFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertCommercialTermGQL extends Apollo.Mutation<UpsertCommercialTermMutation, UpsertCommercialTermMutationVariables> {
    document = UpsertCommercialTermDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommoditiesDocument = gql`
    query Commodities {
  commodities {
    id
    name
    varieties {
      id
      name
      varietyName
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommoditiesGQL extends Apollo.Query<CommoditiesQuery, CommoditiesQueryVariables> {
    document = CommoditiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportersDocument = gql`
    query Exporters {
  supplierExporters {
    supplierExporters {
      id
      name
      exporterCodes {
        id
        exporterCode
      }
      exporter {
        id
        name
      }
      foodBusinessOperators {
        id
        fboCode
        createdAt
        updatedAt
      }
      coldStores {
        id
        name
        fboCode
        createdAt
        updatedAt
      }
      coldStoreClientChangeRequests {
        id
        status
        companyAssociation {
          id
          name
          createdAt
          updatedAt
        }
        coldStore {
          id
          name
          fboCode
          createdAt
          updatedAt
        }
      }
      exporterLogoImageUrl
      masterfileConfig {
        id
        state
      }
      isPackhouseContainerised
    }
    clientChangeRequests {
      id
      supplier {
        id
        name
      }
      exporter {
        id
        name
      }
      exporterCodes {
        id
        exporterCode
      }
      foodBusinessOperators {
        id
        fboCode
        createdAt
        updatedAt
      }
      coldStores {
        id
        name
        fboCode
        createdAt
        updatedAt
      }
      exporterLogoImageUrl
      relation
      oneswitchFacilitated
      exporterName
      fboId
      isPackhouseContainerised
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportersGQL extends Apollo.Query<ExportersQuery, ExportersQueryVariables> {
    document = ExportersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExporterFbosDocument = gql`
    query ExporterFbos {
  exporterFbos {
    id
    name
    fboCode
    company {
      id
      companyLogoImageUrl
      exporterCodes {
        id
        exporterCode
      }
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExporterFbosGQL extends Apollo.Query<ExporterFbosQuery, ExporterFbosQueryVariables> {
    document = ExporterFbosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExporterAndColdStoreClientRequestDocument = gql`
    mutation CreateExporterAndColdStoreClientRequest($exporterFboId: ID!, $coldStoreIds: [ID!]!, $isPackhouseContainerised: Boolean) {
  createExporterAndColdStoreClientRequest(
    exporterFboId: $exporterFboId
    coldStoreIds: $coldStoreIds
    isPackhouseContainerised: $isPackhouseContainerised
  ) {
    errors
    clientChangeRequest {
      id
      fboId
      isPackhouseContainerised
      coldStores {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExporterAndColdStoreClientRequestGQL extends Apollo.Mutation<CreateExporterAndColdStoreClientRequestMutation, CreateExporterAndColdStoreClientRequestMutationVariables> {
    document = CreateExporterAndColdStoreClientRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigCompanyAssociationsDocument = gql`
    mutation ConfirmMasterfileConfigCompanyAssociations($masterfileConfigs: [MasterfileConfigCompanyAssociationInput!]!) {
  confirmMasterfileConfigCompanyAssociations(
    masterfileConfigs: $masterfileConfigs
  ) {
    errors
    masterfileConfigs {
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigCompanyAssociationsGQL extends Apollo.Mutation<ConfirmMasterfileConfigCompanyAssociationsMutation, ConfirmMasterfileConfigCompanyAssociationsMutationVariables> {
    document = ConfirmMasterfileConfigCompanyAssociationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSupplierExporterRequestDocument = gql`
    mutation CreateSupplierExporterRequest($attributes: CreateSupplierExporterRequestAttribute!) {
  createSupplierExporterRequest(attributes: $attributes) {
    clientChangeRequests {
      id
      supplier {
        id
        name
      }
      exporter {
        id
        name
      }
      exporterCodes {
        id
        exporterCode
      }
      foodBusinessOperators {
        id
        fboCode
        createdAt
        updatedAt
      }
      exporterLogoImageUrl
      exporterName
      relation
      oneswitchFacilitated
      isPackhouseContainerised
      fboId
      createdAt
      updatedAt
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSupplierExporterRequestGQL extends Apollo.Mutation<CreateSupplierExporterRequestMutation, CreateSupplierExporterRequestMutationVariables> {
    document = CreateSupplierExporterRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmExporterColdStoresDocument = gql`
    mutation ConfirmExporterColdStores($companyAssociationExportColdStoreAttributes: [CompanyAssociationExportColdStoreAttributes!]!, $clientChangeRequestExportColdStoreAttributes: [ClientChangeRequestExportColdStoreAttributes!]!) {
  confirmExporterColdStores(
    companyAssociationExportColdStoreAttributes: $companyAssociationExportColdStoreAttributes
    clientChangeRequestExportColdStoreAttributes: $clientChangeRequestExportColdStoreAttributes
  ) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmExporterColdStoresGQL extends Apollo.Mutation<ConfirmExporterColdStoresMutation, ConfirmExporterColdStoresMutationVariables> {
    document = ConfirmExporterColdStoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExporterColdStoreRequestDocument = gql`
    mutation CreateExporterColdStoreRequest($companyAssociationId: ID!, $coldStoreIds: [ID!]!, $isPackhouseContainerisation: Boolean!) {
  createExporterColdStoreRequest(
    companyAssociationId: $companyAssociationId
    coldStoreIds: $coldStoreIds
    isPackhouseContainerisation: $isPackhouseContainerisation
  ) {
    success
    errors
    clientChangeRequests {
      status
      companyAssociation {
        id
      }
      coldStore {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExporterColdStoreRequestGQL extends Apollo.Mutation<CreateExporterColdStoreRequestMutation, CreateExporterColdStoreRequestMutationVariables> {
    document = CreateExporterColdStoreRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadCompanyCertificateDocument = gql`
    mutation UploadCompanyCertificate($file: Upload!, $expirydate: String!, $companyid: Int!, $certificatetypeid: Int!) {
  uploadCompanyCertificate(
    file: $file
    expiryDate: $expirydate
    companyId: $companyid
    certificateTypeId: $certificatetypeid
  ) {
    certificate {
      id
      expiryDate
      createdAt
      certificate {
        id
        filename
        url
        v2Url
      }
      certificateType {
        name
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadCompanyCertificateGQL extends Apollo.Mutation<UploadCompanyCertificateMutation, UploadCompanyCertificateMutationVariables> {
    document = UploadCompanyCertificateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyCertificateDocument = gql`
    mutation DeleteCompanyCertificate($id: Int!) {
  deleteCompanyCertificate(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyCertificateGQL extends Apollo.Mutation<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables> {
    document = DeleteCompanyCertificateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificateTypeDocument = gql`
    query CertificateType {
  certificateTypes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificateTypeGQL extends Apollo.Query<CertificateTypeQuery, CertificateTypeQueryVariables> {
    document = CertificateTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyCompanyDocument = gql`
    query MyCompany {
  myCompany {
    id
    name
    about
    registrationNumber
    vatNumber
    createdAt
    state
    onboardingStep
    logoFile {
      id
      filename
      url
    }
    address {
      addressLine1
      addressLine2
      city
      postalCode
      country
    }
    tradeRegions {
      id
      name
      code
      countries {
        id
        name
        code
      }
    }
    certificates {
      id
      expiryDate
      createdAt
      updatedAt
      certificate {
        id
        filename
        url
        v2Url
      }
      certificateType {
        name
        id
      }
    }
    varieties {
      id
      varietyId
      variety {
        id
        name
        varietyCode
      }
      name
      peakCount
      hectares
      packingStart
      packingEnd
      commodity {
        id
        name
        icon {
          v2Url
        }
      }
      images {
        id
        url
        v2Url
        filename
        thumbnailUrl
        v2ThumbnailUrl
      }
    }
    sellerVarieties {
      id
      name
      commodity {
        id
        name
      }
    }
    additionalFields {
      id
      companyId
      name
      description
      fieldType
      parameters
      createdAt
      updatedAt
      isPackingInstruction
      private
    }
    activeUsers {
      id
      firstName
      lastName
      phoneNumber
      email
      state
      role
      roles {
        id
        name
        resourceType
        resourceId
        createdAt
        updatedAt
      }
      employee {
        id
      }
    }
    invites {
      id
      email
      state
    }
    defaultLocale
    sellers {
      id
      name
    }
    isSeller
    buyers {
      id
      name
    }
    isBuyer
    commoditySeasons {
      ...commoditySeason
    }
  }
}
    ${CommoditySeasonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyCompanyGQL extends Apollo.Query<MyCompanyQuery, MyCompanyQueryVariables> {
    document = MyCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradePartnersForMyCompanyDocument = gql`
    query tradePartnersForMyCompany {
  myCompany {
    buyers {
      id
      name
    }
    sellers {
      id
      name
    }
    isBuyer
    isSeller
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TradePartnersForMyCompanyGQL extends Apollo.Query<TradePartnersForMyCompanyQuery, TradePartnersForMyCompanyQueryVariables> {
    document = TradePartnersForMyCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDetailsDocument = gql`
    mutation UpdateCompanyDetails($attributes: UpdateCompanyAttributes!) {
  updateCompanyDetails(attributes: $attributes) {
    company {
      id
      name
      about
      registrationNumber
      vatNumber
      address {
        addressLine1
        addressLine2
        city
        postalCode
        country
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyDetailsGQL extends Apollo.Mutation<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables> {
    document = UpdateCompanyDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadCompanyLogoDocument = gql`
    mutation UploadCompanyLogo($file: Upload!, $companyid: Int!) {
  uploadCompanyLogo(file: $file, companyId: $companyid) {
    company {
      logoFile {
        id
        filename
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadCompanyLogoGQL extends Apollo.Mutation<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables> {
    document = UploadCompanyLogoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyTradeRegionsDocument = gql`
    mutation UpdateCompanyTradeRegions($addtraderegions: [TradeRegionAttributes!]!, $removetraderegions: [TradeRegionAttributes!]!) {
  updateCompanyTradeRegions(
    addTradeRegions: $addtraderegions
    removeTradeRegions: $removetraderegions
  ) {
    company {
      tradeRegions {
        id
        name
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyTradeRegionsGQL extends Apollo.Mutation<UpdateCompanyTradeRegionsMutation, UpdateCompanyTradeRegionsMutationVariables> {
    document = UpdateCompanyTradeRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrencyConversionDocument = gql`
    query CurrencyConversion($currencyConversionAttributes: CurrencyConversionAttributes!) {
  currencyConversion(currencyConversionAttributes: $currencyConversionAttributes) {
    id
    rates
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrencyConversionGQL extends Apollo.Query<CurrencyConversionQuery, CurrencyConversionQueryVariables> {
    document = CurrencyConversionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrencyConversionByIdDocument = gql`
    query CurrencyConversionById($currencyConversionId: ID!) {
  currencyConversionById(currencyConversionId: $currencyConversionId) {
    id
    rates
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrencyConversionByIdGQL extends Apollo.Query<CurrencyConversionByIdQuery, CurrencyConversionByIdQueryVariables> {
    document = CurrencyConversionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCurrencyExchangeRateDocument = gql`
    mutation UpsertCurrencyExchangeRate($currencyExchangeRateAttributes: CurrencyExchangeRateAttributes!) {
  upsertCurrencyExchangeRate(
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    currencyExchangeRate {
      id
      toCurrency
      fromCurrency
      exchangeRate
      exchangeRateType
      exchangeRateDate
      currencyConversionId
      exchangeableId
      exchangeableType
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertCurrencyExchangeRateGQL extends Apollo.Mutation<UpsertCurrencyExchangeRateMutation, UpsertCurrencyExchangeRateMutationVariables> {
    document = UpsertCurrencyExchangeRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCurrencyExchangeRateDocument = gql`
    mutation DeleteCurrencyExchangeRate($currencyExchangeRateId: ID!) {
  deleteCurrencyExchangeRate(currencyExchangeRateId: $currencyExchangeRateId) {
    currencyExchangeRateId
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCurrencyExchangeRateGQL extends Apollo.Mutation<DeleteCurrencyExchangeRateMutation, DeleteCurrencyExchangeRateMutationVariables> {
    document = DeleteCurrencyExchangeRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrencyExchangeRateDocument = gql`
    query CurrencyExchangeRate($exchangeableId: ID!, $exchangeableType: String!) {
  currencyExchangeRate(
    exchangeableId: $exchangeableId
    exchangeableType: $exchangeableType
  ) {
    id
    toCurrency
    fromCurrency
    exchangeRate
    exchangeRateType
    exchangeRateDate
    currencyConversionId
    exchangeableId
    exchangeableType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrencyExchangeRateGQL extends Apollo.Query<CurrencyExchangeRateQuery, CurrencyExchangeRateQueryVariables> {
    document = CurrencyExchangeRateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardQueryDocument = gql`
    query DashboardQuery($locationId: Int, $containerId: Int, $commoditygroups: [CommodityGroupEnum!], $forExport: Boolean) {
  dashboardTrackingData(
    locationId: $locationId
    containerId: $containerId
    commoditygroups: $commoditygroups
    forExport: $forExport
  ) {
    cartonGroupings {
      batchNumber
      cartons
      commodityName
      consignmentNumber
      containerId
      exporterCode
      farmCode
      grade
      id
      inspectionDate
      inventoryCode
      locationId
      mark
      netMass
      orchard
      packhouseCode
      packingWeek
      palletGrossMass
      palletNumber
      productCharacteristic
      sequenceNumber
      state
      targetMarket
      targetCountry
      targetRegion
      varietyName
    }
    containers {
      arrivalDate
      arrivalEventClassifier
      cartons
      cartonsInTransit
      containerId
      containerNumber
      containerType
      departureDate
      departureEventClassifier
      finalDestinationId
      finalDeliveryDatetime
      finalDestinationName
      finalDestinationType
      locationId
      id
      nextDeliveryDatetime
      nextDestinationId
      nextDestinationName
      nextDestinationType
      pallets
      palletsInTransit
      state
      stateInTransit
    }
    locations {
      id
      cartons
      cartonsInTransit
      containers
      containersInTransit
      geoLocation {
        lat
        lon
      }
      locationId
      locationType
      name
      pallets
      palletsInTransit
      unallocated
      unallocatedInTransit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardQueryGQL extends Apollo.Query<DashboardQueryQuery, DashboardQueryQueryVariables> {
    document = DashboardQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardSearchDocument = gql`
    query DashboardSearch($fields: [DashboardSearchFieldsEnum!], $searchTerm: String, $commodityGroups: [CommodityGroupEnum!]) {
  dashboardSearch(
    fields: $fields
    searchTerm: $searchTerm
    commodityGroups: $commodityGroups
  ) {
    raw
    hits {
      score
      highlight
      source {
        ... on DashboardCartonGrouping {
          batchNumber
          cartons
          commodityName
          consignmentNumber
          containerId
          containerNumber
          exporterCode
          farmCode
          grade
          id
          inspectionDate
          inventoryCode
          locationId
          mark
          netMass
          orchard
          packhouseCode
          packingWeek
          palletGrossMass
          palletNumber
          productCharacteristic
          sequenceNumber
          state
          targetCountry
          targetMarket
          targetRegion
          varietyName
        }
        ... on DashboardContainer {
          arrivalDate
          cartons
          cartonsInTransit
          collectionDatetime
          containerId
          containerNumber
          containerType
          departureDate
          finalDeliveryDatetime
          finalDestinationId
          finalDestinationLatitude
          finalDestinationLongitude
          finalDestinationName
          finalDestinationType
          id
          locationId
          nextDeliveryDatetime
          nextDestinationId
          nextDestinationLatitude
          nextDestinationLongitude
          nextDestinationName
          nextDestinationType
          pallets
          palletsInTransit
          state
          stateInTransit
        }
        ... on DashboardLocation {
          cartons
          cartonsInTransit
          containers
          containersInTransit
          id
          locationId
          locationType
          name
          pallets
          palletsInTransit
          unallocated
          unallocatedInTransit
        }
      }
    }
    total {
      relation
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardSearchGQL extends Apollo.Query<DashboardSearchQuery, DashboardSearchQueryVariables> {
    document = DashboardSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardFiltersDocument = gql`
    query DashboardFilters {
  dashboardFilters {
    commodities {
      id
      name
      commodityGroup
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardFiltersGQL extends Apollo.Query<DashboardFiltersQuery, DashboardFiltersQueryVariables> {
    document = DashboardFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DataPreparationsDocument = gql`
    query DataPreparations {
  dataPreparations {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataPreparationsGQL extends Apollo.Query<DataPreparationsQuery, DataPreparationsQueryVariables> {
    document = DataPreparationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DataPreparationDocument = gql`
    query DataPreparation($id: ID!) {
  dataPreparation(id: $id) {
    dataOutputs {
      createdAt
      downloadedAt
      fileType
      id
      outputFile {
        contentType
        filename
        id
        url
        v2Url
      }
    }
    error
    id
    description
    name
    status
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataPreparationGQL extends Apollo.Query<DataPreparationQuery, DataPreparationQueryVariables> {
    document = DataPreparationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateDataOutputFilesDocument = gql`
    mutation GenerateDataOutputFiles($id: ID!) {
  generateDataOutputFiles(id: $id) {
    dataPreparation {
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateDataOutputFilesGQL extends Apollo.Mutation<GenerateDataOutputFilesMutation, GenerateDataOutputFilesMutationVariables> {
    document = GenerateDataOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDataOutputDocument = gql`
    mutation UpdateDataOutput($attributes: DataOutputAttributes!) {
  updateDataOutput(attributes: $attributes) {
    dataOutput {
      id
      downloadedAt
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDataOutputGQL extends Apollo.Mutation<UpdateDataOutputMutation, UpdateDataOutputMutationVariables> {
    document = UpdateDataOutputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefaultCostsDocument = gql`
    query DefaultCosts($filterAttributes: DefaultCostFilters, $first: Int, $last: Int, $after: String, $before: String) {
  defaultCosts(
    filterAttributes: $filterAttributes
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      cartonGroupingTransaction {
        id
        cartonGrouping {
          palletNumber
          containerNumber
        }
        currency
        amountMajorUnit
        isActual
        quantityPriceMajorUnit
        quantityAmount
        quantityType
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DefaultCostsGQL extends Apollo.Query<DefaultCostsQuery, DefaultCostsQueryVariables> {
    document = DefaultCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinanceRuleDocument = gql`
    query financeRule($id: ID!) {
  financeRule(id: $id) {
    id
    name
    amountCents
    ruleDescription
    createdAt
    endDate
    enabled
    isDefaultCost
    defaultCgtsFinalised
    defaultCgtsPendingReview
    currency
    unit
    percentage
    humanReadableExpression
    incotermForPercentageCalculation
    costCode {
      id
      name
    }
    groupedCostCodes {
      costCode {
        id
        name
      }
      startDate
      endDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinanceRuleGQL extends Apollo.Query<FinanceRuleQuery, FinanceRuleQueryVariables> {
    document = FinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDefaultCostsDocument = gql`
    mutation RemoveDefaultCosts($attributes: RemoveDefaultCostAttributes!) {
  removeDefaultCosts(attributes: $attributes) {
    errors
    cgtIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultCostsGQL extends Apollo.Mutation<RemoveDefaultCostsMutation, RemoveDefaultCostsMutationVariables> {
    document = RemoveDefaultCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinaliseDefaultCostsDocument = gql`
    mutation FinaliseDefaultCosts($attributes: FinaliseDefaultCostAttributes!) {
  finaliseDefaultCosts(attributes: $attributes) {
    errors
    cgtIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinaliseDefaultCostsGQL extends Apollo.Mutation<FinaliseDefaultCostsMutation, FinaliseDefaultCostsMutationVariables> {
    document = FinaliseDefaultCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainersForFinanceRuleDocument = gql`
    query ContainersForFinanceRule($financeRuleId: ID!) {
  containersForFinanceRule(financeRuleId: $financeRuleId) {
    id
    containerNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainersForFinanceRuleGQL extends Apollo.Query<ContainersForFinanceRuleQuery, ContainersForFinanceRuleQueryVariables> {
    document = ContainersForFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadDocumentsDocument = gql`
    mutation DownloadDocuments($documentAttributes: [DownloadDocumentAttributes!]!, $zippedFilename: String!) {
  downloadDocuments(
    documentAttributes: $documentAttributes
    zippedFilename: $zippedFilename
  ) {
    url
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadDocumentsGQL extends Apollo.Mutation<DownloadDocumentsMutation, DownloadDocumentsMutationVariables> {
    document = DownloadDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendEmailDocument = gql`
    mutation SendEmail($attributes: SendEmailAttributes!) {
  sendEmail(attributes: $attributes) {
    errors
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendEmailGQL extends Apollo.Mutation<SendEmailMutation, SendEmailMutationVariables> {
    document = SendEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmailDocumentsDocument = gql`
    mutation EmailDocuments($attributes: EmailDocumentsAttributes!) {
  emailDocuments(attributes: $attributes) {
    errors
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmailDocumentsGQL extends Apollo.Mutation<EmailDocumentsMutation, EmailDocumentsMutationVariables> {
    document = EmailDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EmailTaskDocumentsDocument = gql`
    mutation EmailTaskDocuments($attributes: EmailTaskDocumentsAttributes!) {
  emailTaskDocuments(attributes: $attributes) {
    errors
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EmailTaskDocumentsGQL extends Apollo.Mutation<EmailTaskDocumentsMutation, EmailTaskDocumentsMutationVariables> {
    document = EmailTaskDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateEphytoDocument = gql`
    mutation DuplicateEphyto($id: Int!, $applicationType: Int!) {
  duplicateEphyto(id: $id, applicationType: $applicationType) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateEphytoGQL extends Apollo.Mutation<DuplicateEphytoMutation, DuplicateEphytoMutationVariables> {
    document = DuplicateEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEphytoDocument = gql`
    mutation DeleteEphyto($id: Int!) {
  deleteEphyto(id: $id) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEphytoGQL extends Apollo.Mutation<DeleteEphytoMutation, DeleteEphytoMutationVariables> {
    document = DeleteEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEphytoDocumentDocument = gql`
    mutation UpdateEphytoDocument($id: Int!, $type: String!) {
  updateEphytoDocument(id: $id, type: $type) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEphytoDocumentGQL extends Apollo.Mutation<UpdateEphytoDocumentMutation, UpdateEphytoDocumentMutationVariables> {
    document = UpdateEphytoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadEphytoDocumentDocument = gql`
    mutation UploadEphytoDocument($ephytoId: Int!, $file: Upload!) {
  uploadEphytoDocument(ephytoId: $ephytoId, file: $file) {
    errors
    ephytoDocuments {
      ...ephytoDocumentFields
    }
  }
}
    ${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadEphytoDocumentGQL extends Apollo.Mutation<UploadEphytoDocumentMutation, UploadEphytoDocumentMutationVariables> {
    document = UploadEphytoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEphytoDocumentDocument = gql`
    mutation DeleteEphytoDocument($id: Int!) {
  deleteEphytoDocument(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEphytoDocumentGQL extends Apollo.Mutation<DeleteEphytoDocumentMutation, DeleteEphytoDocumentMutationVariables> {
    document = DeleteEphytoDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDraftEphytoDocument = gql`
    mutation UpdateDraftEphyto($ephytoId: Int!) {
  updateDraftEphyto(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDraftEphytoGQL extends Apollo.Mutation<UpdateDraftEphytoMutation, UpdateDraftEphytoMutationVariables> {
    document = UpdateDraftEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitEphytoDocument = gql`
    mutation SubmitEphyto($ephytoId: Int!) {
  submitEphyto(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitEphytoGQL extends Apollo.Mutation<SubmitEphytoMutation, SubmitEphytoMutationVariables> {
    document = SubmitEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DraftEphytoDocument = gql`
    mutation DraftEphyto($ephytoId: Int!) {
  draftEphyto(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DraftEphytoGQL extends Apollo.Mutation<DraftEphytoMutation, DraftEphytoMutationVariables> {
    document = DraftEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchEphytoStatusDocument = gql`
    mutation FetchEphytoStatus($ephytoId: Int!) {
  fetchEphytoStatus(ephytoId: $ephytoId) {
    errors
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchEphytoStatusGQL extends Apollo.Mutation<FetchEphytoStatusMutation, FetchEphytoStatusMutationVariables> {
    document = FetchEphytoStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateEphytoDocument = gql`
    mutation GenerateEphyto($isEntireBooking: Boolean!, $shipmentType: String!, $bookingReference: String, $ephytoId: Int, $sliIds: [Int!]) {
  generateEphyto(
    isEntireBooking: $isEntireBooking
    shipmentType: $shipmentType
    bookingReference: $bookingReference
    ephytoId: $ephytoId
    sliIds: $sliIds
  ) {
    ephyto {
      ...ephytoCommonFields
      ephytoTradeUnits {
        ...ephytoTradeUnitCommonFields
      }
      ephytoConsignmentItems {
        ...ephytoConsignmentItemCommonFields
      }
      ephytoDocuments {
        ...ephytoDocumentFields
      }
    }
    errors
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateEphytoGQL extends Apollo.Mutation<GenerateEphytoMutation, GenerateEphytoMutationVariables> {
    document = GenerateEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateEphytoTradeUnitDocument = gql`
    mutation GenerateEphytoTradeUnit($shipmentType: String!, $ephytoId: Int) {
  generateEphytoTradeUnit(shipmentType: $shipmentType, ephytoId: $ephytoId) {
    errors
    ephytoTradeUnits {
      ...ephytoTradeUnitCommonFields
    }
  }
}
    ${EphytoTradeUnitCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateEphytoTradeUnitGQL extends Apollo.Mutation<GenerateEphytoTradeUnitMutation, GenerateEphytoTradeUnitMutationVariables> {
    document = GenerateEphytoTradeUnitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEphytoDocument = gql`
    mutation UpdateEphyto($ephyto: EphytoAttributes!, $ephytoConsignmentItems: [EphytoConsignmentItemAttributes!]!) {
  updateEphyto(ephyto: $ephyto, ephytoConsignmentItems: $ephytoConsignmentItems) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEphytoGQL extends Apollo.Mutation<UpdateEphytoMutation, UpdateEphytoMutationVariables> {
    document = UpdateEphytoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoPackageTypesDocument = gql`
    query EphytoPackageTypes {
  ephytoPackageTypes {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoPackageTypesGQL extends Apollo.Query<EphytoPackageTypesQuery, EphytoPackageTypesQueryVariables> {
    document = EphytoPackageTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoAppliedChemicalsDocument = gql`
    query EphytoAppliedChemicals {
  ephytoAppliedChemicals
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoAppliedChemicalsGQL extends Apollo.Query<EphytoAppliedChemicalsQuery, EphytoAppliedChemicalsQueryVariables> {
    document = EphytoAppliedChemicalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoTransportMeansDocument = gql`
    query EphytoTransportMeans {
  ephytoTransportMeans
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoTransportMeansGQL extends Apollo.Query<EphytoTransportMeansQuery, EphytoTransportMeansQueryVariables> {
    document = EphytoTransportMeansDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoUnitOfMeasureCodesDocument = gql`
    query EphytoUnitOfMeasureCodes {
  ephytoUnitOfMeasureCodes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoUnitOfMeasureCodesGQL extends Apollo.Query<EphytoUnitOfMeasureCodesQuery, EphytoUnitOfMeasureCodesQueryVariables> {
    document = EphytoUnitOfMeasureCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoTreatmentsDocument = gql`
    query EphytoTreatments {
  ephytoTreatments {
    firstLevel
    firstLevelCode
    secondLevel
    secondLevelCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoTreatmentsGQL extends Apollo.Query<EphytoTreatmentsQuery, EphytoTreatmentsQueryVariables> {
    document = EphytoTreatmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoCountriesDocument = gql`
    query EphytoCountries {
  ephytoCountries {
    isoCode
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoCountriesGQL extends Apollo.Query<EphytoCountriesQuery, EphytoCountriesQueryVariables> {
    document = EphytoCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoAgreementCodesDocument = gql`
    query EphytoAgreementCodes {
  ephytoAgreementCodes {
    agreementCode
    agreementName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoAgreementCodesGQL extends Apollo.Query<EphytoAgreementCodesQuery, EphytoAgreementCodesQueryVariables> {
    document = EphytoAgreementCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoLocationsDocument = gql`
    query EphytoLocations($countryCodes: [String!]!) {
  ephytoLocations(countryCodes: $countryCodes) {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoLocationsGQL extends Apollo.Query<EphytoLocationsQuery, EphytoLocationsQueryVariables> {
    document = EphytoLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoPortOfEntriesDocument = gql`
    query EphytoPortOfEntries($countryCodes: [String!]!) {
  ephytoPortOfEntries(countryCodes: $countryCodes) {
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoPortOfEntriesGQL extends Apollo.Query<EphytoPortOfEntriesQuery, EphytoPortOfEntriesQueryVariables> {
    document = EphytoPortOfEntriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoContactsDocument = gql`
    query EphytoContacts {
  contacts {
    id
    name
    info
    contactType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoContactsGQL extends Apollo.Query<EphytoContactsQuery, EphytoContactsQueryVariables> {
    document = EphytoContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NonEphytoShipmentLineItemsDocument = gql`
    query nonEphytoShipmentLineItems($shipmentId: Int!, $type: String!) {
  nonEphytoShipmentLineItems(shipmentId: $shipmentId, type: $type) {
    id
    labelDisplay
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NonEphytoShipmentLineItemsGQL extends Apollo.Query<NonEphytoShipmentLineItemsQuery, NonEphytoShipmentLineItemsQueryVariables> {
    document = NonEphytoShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytosDocument = gql`
    query ephytos($filterAttributes: EphytoFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  ephytos(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      id
      agreementCode
      applicationStatus
      state
      targetCountry
      unloadingBaseportLocation
      customReferenceNo
      applicationReferenceNo
      desiredIssueLocation
      departureDate
      applicationType
      consignorName
      consigneeName
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytosGQL extends Apollo.Query<EphytosQuery, EphytosQueryVariables> {
    document = EphytosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoFilterAttributesDocument = gql`
    query EphytoFilterAttributes {
  ephytoFilterAttributes {
    statuses
    customerReferences
    entryPorts
    consignees
    consignors
    vessels
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoFilterAttributesGQL extends Apollo.Query<EphytoFilterAttributesQuery, EphytoFilterAttributesQueryVariables> {
    document = EphytoFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoCertificateUrlDocument = gql`
    query EphytoCertificateUrl($id: Int!) {
  ephytoCertificateUrl(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoCertificateUrlGQL extends Apollo.Query<EphytoCertificateUrlQuery, EphytoCertificateUrlQueryVariables> {
    document = EphytoCertificateUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportDocumentTypesDocument = gql`
    query ExportDocumentTypes {
  exportDocumentTypes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportDocumentTypesGQL extends Apollo.Query<ExportDocumentTypesQuery, ExportDocumentTypesQueryVariables> {
    document = ExportDocumentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoDocumentTypesDocument = gql`
    query EphytoDocumentTypes {
  ephytoDocumentTypes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoDocumentTypesGQL extends Apollo.Query<EphytoDocumentTypesQuery, EphytoDocumentTypesQueryVariables> {
    document = EphytoDocumentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EphytoByIdDocument = gql`
    query EphytoById($id: Int!) {
  ephytoById(id: $id) {
    ...ephytoCommonFields
    ephytoTradeUnits {
      ...ephytoTradeUnitCommonFields
    }
    ephytoConsignmentItems {
      ...ephytoConsignmentItemCommonFields
    }
    ephytoDocuments {
      ...ephytoDocumentFields
    }
  }
}
    ${EphytoCommonFieldsFragmentDoc}
${EphytoTradeUnitCommonFieldsFragmentDoc}
${EphytoConsignmentItemCommonFieldsFragmentDoc}
${EphytoDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EphytoByIdGQL extends Apollo.Query<EphytoByIdQuery, EphytoByIdQueryVariables> {
    document = EphytoByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimateConfigDocument = gql`
    query estimateConfig {
  uiConfigs(configType: "estimate-config", visibility: Company) {
    id
    data
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimateConfigGQL extends Apollo.Query<EstimateConfigQuery, EstimateConfigQueryVariables> {
    document = EstimateConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimateOptionsDocument = gql`
    query estimateOptions($season: Int!) {
  myCompany {
    id
    name
    sellers {
      id
      name
    }
    allCompanies {
      id
      name
    }
  }
  commodities(onlyOperational: true) {
    id
    name
  }
  varieties(onlyOperational: true, skipMixedVarieties: true) {
    id
    name
    commodity {
      id
    }
  }
  productionUnits: foodBusinessOperators(businessTypes: [0], includeSellers: true) {
    id
    name
    typeOfBusiness
    fboCode
    company {
      id
      name
    }
  }
  packhouses: foodBusinessOperators(
    businessTypes: [1, 5]
    includeSellers: true
    includeThirdPartyPackhouses: true
  ) {
    id
    name
    typeOfBusiness
    fboCode
    company {
      id
    }
  }
  fboOrchards(includeSellers: true) {
    id
    hectares(season: $season)
    orchard
    block
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    foodBusinessOperator {
      id
      fboCode
      name
      company {
        id
        name
      }
    }
  }
  cartonCounts {
    id
    name
    commodityId
    cartonTypeId
    counts
    priceMetric
    stackSizes
  }
  commodityDefaultSeasons {
    commodityId
    minWeek(year: $season)
    maxWeek(year: $season)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimateOptionsGQL extends Apollo.Query<EstimateOptionsQuery, EstimateOptionsQueryVariables> {
    document = EstimateOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimatesDocument = gql`
    query Estimates($endWeek: String, $startWeek: String, $weeks: Boolean, $season: Int, $matchCols: [EstimateMatchModeEnum!], $commodityIds: [Int!], $subCommodityIds: [Int!], $varietyIds: [Int!], $onlyEditableEstimates: Boolean) {
  estimates(
    endWeek: $endWeek
    startWeek: $startWeek
    weeks: $weeks
    season: $season
    commodityIds: $commodityIds
    subCommodityIds: $subCommodityIds
    varietyIds: $varietyIds
    onlyEditableEstimates: $onlyEditableEstimates
  ) {
    id
    week
    season
    provider {
      id
      name
    }
    fboOrchard {
      id
      orchard
      hectares(season: $season)
      foodBusinessOperator {
        company {
          id
        }
      }
    }
    cartonType {
      id
      name
    }
    commodity {
      id
      name
    }
    variety {
      id
      name
      subCommodity {
        name
      }
    }
    productionUnit {
      id
      name
      fboCode
      typeOfBusiness
    }
    packHouse {
      id
      name
      fboCode
      typeOfBusiness
    }
    visibleCompanies {
      id
      name
    }
    estimateValues {
      id
      estType
      value
      conversionWeight
      grade
      sizeCounts
      acceptedValue(matchCols: $matchCols)
      inSeasonValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimatesGQL extends Apollo.Query<EstimatesQuery, EstimatesQueryVariables> {
    document = EstimatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrchardSeasonsDocument = gql`
    query OrchardSeasons($season: Int!) {
  orchardSeasons(season: $season) {
    id
    startDate
    endDate
    hectares
    plantedDate
    fboOrchard {
      orchard
      foodBusinessOperator {
        fboCode
      }
      variety {
        name
        commodity {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrchardSeasonsGQL extends Apollo.Query<OrchardSeasonsQuery, OrchardSeasonsQueryVariables> {
    document = OrchardSeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrchardYieldsDocument = gql`
    query OrchardYields($orchardSeasonId: ID, $capturedBefore: ISO8601DateTime!, $capturedAfter: ISO8601DateTime!) {
  orchardYields(
    orchardSeasonId: $orchardSeasonId
    capturedBefore: $capturedBefore
    capturedAfter: $capturedAfter
  ) {
    id
    weight
    weightPerBin
    orchardSeasonId
    captureDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrchardYieldsGQL extends Apollo.Query<OrchardYieldsQuery, OrchardYieldsQueryVariables> {
    document = OrchardYieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrchardSeasonsDocument = gql`
    mutation UpdateOrchardSeasons($updateData: [OrchardSeasonAttributes!], $deleteData: [Int!]) {
  updateOrchardSeasons(updateData: $updateData, deleteData: $deleteData) {
    createSummary {
      succeeded
      failed
      errors
    }
    updateSummary {
      succeeded
      failed
      errors
    }
    deleteSummary {
      succeeded
      failed
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrchardSeasonsGQL extends Apollo.Mutation<UpdateOrchardSeasonsMutation, UpdateOrchardSeasonsMutationVariables> {
    document = UpdateOrchardSeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateCommoditySeasonsDocument = gql`
    mutation GenerateCommoditySeasons($season: Int!) {
  generateCommoditySeasons(seasonYear: $season) {
    error
    failures
    successes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateCommoditySeasonsGQL extends Apollo.Mutation<GenerateCommoditySeasonsMutation, GenerateCommoditySeasonsMutationVariables> {
    document = GenerateCommoditySeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrchardYieldsDocument = gql`
    mutation UpdateOrchardYields($createData: [OrchardYieldAttributes!], $updateData: [OrchardYieldAttributes!], $deleteData: [Int!]) {
  updateOrchardYields(
    createData: $createData
    updateData: $updateData
    deleteData: $deleteData
  ) {
    createSummary {
      errors
      failed
      succeeded
    }
    updateSummary {
      succeeded
      failed
      errors
    }
    deleteSummary {
      succeeded
      failed
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrchardYieldsGQL extends Apollo.Mutation<UpdateOrchardYieldsMutation, UpdateOrchardYieldsMutationVariables> {
    document = UpdateOrchardYieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEstimatesDocument = gql`
    mutation UpdateEstimates($createData: [EstimateAttributes!], $deleteData: [Int!], $updateData: [EstimateAttributes!]) {
  updateEstimates(
    createData: $createData
    deleteData: $deleteData
    updateData: $updateData
  ) {
    createSummary {
      succeeded
      failed
      errors
    }
    updateSummary {
      succeeded
      failed
      errors
    }
    deleteSummary {
      succeeded
      failed
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEstimatesGQL extends Apollo.Mutation<UpdateEstimatesMutation, UpdateEstimatesMutationVariables> {
    document = UpdateEstimatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsDocument = gql`
    query Documents($first: Int, $last: Int, $after: String, $before: String, $dateAfter: ISO8601DateTime, $dateBefore: ISO8601DateTime, $states: [EtlDocumentStateEnum!], $emailFrom: String, $emailTo: String, $documentTypes: [String!], $orderByFields: [ColumnOrderAttributes!]) {
  documents(
    first: $first
    last: $last
    after: $after
    before: $before
    dateAfter: $dateAfter
    dateBefore: $dateBefore
    states: $states
    emailFrom: $emailFrom
    emailTo: $emailTo
    documentTypes: $documentTypes
    orderByFields: $orderByFields
  ) {
    nodes {
      ...documentFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsGQL extends Apollo.Query<DocumentsQuery, DocumentsQueryVariables> {
    document = DocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentDocument = gql`
    query Document($documentId: Int!) {
  document(id: $documentId) {
    ...documentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentGQL extends Apollo.Query<DocumentQuery, DocumentQueryVariables> {
    document = DocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentRowsDocument = gql`
    query DocumentRows($after: String, $before: String, $first: Int, $last: Int, $documentId: Int!, $states: [EtlDocumentRowStateEnum!]) {
  documentRows(
    after: $after
    before: $before
    first: $first
    last: $last
    documentId: $documentId
    states: $states
  ) {
    nodes {
      createdAt
      errorReason
      id
      processOutput
      state
      value
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentRowsGQL extends Apollo.Query<DocumentRowsQuery, DocumentRowsQueryVariables> {
    document = DocumentRowsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadEtlDocumentDocument = gql`
    mutation UploadEtlDocument($documentId: Int!, $file: Upload!) {
  uploadEtlDocument(documentId: $documentId, file: $file) {
    document {
      ...documentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadEtlDocumentGQL extends Apollo.Mutation<UploadEtlDocumentMutation, UploadEtlDocumentMutationVariables> {
    document = UploadEtlDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessEtlDocumentDocument = gql`
    mutation ProcessEtlDocument($documentId: Int!) {
  processEtlDocument(documentId: $documentId) {
    document {
      ...documentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessEtlDocumentGQL extends Apollo.Mutation<ProcessEtlDocumentMutation, ProcessEtlDocumentMutationVariables> {
    document = ProcessEtlDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFarmVarietyDocument = gql`
    mutation CreateFarmVariety($attributes: CreateFarmVarietyAttributes!) {
  createFarmVariety(attributes: $attributes) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFarmVarietyGQL extends Apollo.Mutation<CreateFarmVarietyMutation, CreateFarmVarietyMutationVariables> {
    document = CreateFarmVarietyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFarmVarietyDocument = gql`
    mutation UpdateFarmVariety($attributes: UpdateFarmVarietyAttributes!) {
  updateFarmVariety(attributes: $attributes) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFarmVarietyGQL extends Apollo.Mutation<UpdateFarmVarietyMutation, UpdateFarmVarietyMutationVariables> {
    document = UpdateFarmVarietyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFarmVarietyDocument = gql`
    mutation DeleteFarmVariety($varietyid: Int!, $companyId: Int!) {
  deleteFarmVariety(varietyId: $varietyid, companyId: $companyId) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFarmVarietyGQL extends Apollo.Mutation<DeleteFarmVarietyMutation, DeleteFarmVarietyMutationVariables> {
    document = DeleteFarmVarietyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadFarmVarietyImageDocument = gql`
    mutation UploadFarmVarietyImage($id: Int!, $image: Upload!) {
  uploadFarmVarietyImage(id: $id, image: $image) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadFarmVarietyImageGQL extends Apollo.Mutation<UploadFarmVarietyImageMutation, UploadFarmVarietyImageMutationVariables> {
    document = UploadFarmVarietyImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFarmVarietyImageDocument = gql`
    mutation DeleteFarmVarietyImage($varietyid: Int!, $imageid: Int!) {
  deleteFarmVarietyImage(varietyId: $varietyid, imageId: $imageid) {
    farmVariety {
      ...farmVariety
    }
  }
}
    ${FarmVarietyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFarmVarietyImageGQL extends Apollo.Mutation<DeleteFarmVarietyImageMutation, DeleteFarmVarietyImageMutationVariables> {
    document = DeleteFarmVarietyImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinanceReportDocument = gql`
    query FinanceReport($attributes: FinanceReportFilterAttributes!) {
  financeReport(attributes: $attributes) {
    items {
      commodity
      variety
      amount
      amountPerCarton
      batchNumber
      buyer
      packType
      cartons
      stdCartons
      containerNumber
      currency
      exchangeRate
      exporterCode
      farmCode
      grade
      incoterm
      isActual
      palletNumber
      liReferenceNumber
      txReferenceNumber
      seller
      sizeCount
      state
      targetMarket
      targetRegion
      transactionDate
      transactionType
      transactionWeek
      shippingWeek
      packingWeek
      generalLedgerName
      secondaryCategory
      primaryCategory
      zarAmount
      zarPerCarton
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinanceReportGQL extends Apollo.Query<FinanceReportQuery, FinanceReportQueryVariables> {
    document = FinanceReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LatestCurrencyConversionDocument = gql`
    query LatestCurrencyConversion {
  latestCurrencyConversion {
    rates
    timestamp
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LatestCurrencyConversionGQL extends Apollo.Query<LatestCurrencyConversionQuery, LatestCurrencyConversionQueryVariables> {
    document = LatestCurrencyConversionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFinanceRulesDocument = gql`
    query GetFinanceRules($filterAttributes: FinanceRuleFilters!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String, $grouped: Boolean = false, $groupType: String) {
  financeRules(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
    grouped: $grouped
    groupType: $groupType
  ) {
    nodes {
      id
      name
      amountCents
      company {
        id
        name
      }
      costCode {
        id
        name
      }
      matchCondition {
        id
      }
      groupedCostCodes {
        financeRuleId
        costCode {
          id
          name
        }
        startDate
        endDate
        financeRuleId
      }
      createdAt
      currency
      enabled
      endDate
      incotermForPercentageCalculation
      simpleExpression
      simpleExpressionFields
      simpleExpressionMatchTypes
      simpleExpressionValues
      humanReadableExpression
      percentage
      startDate
      unit
      isDefaultCost
      ruleDescription
      updatedAt
      defaultCgtsPendingReview
      defaultCgtsFinalised
      formattedCost
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFinanceRulesGQL extends Apollo.Query<GetFinanceRulesQuery, GetFinanceRulesQueryVariables> {
    document = GetFinanceRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinanceRulesFilterAttributesDocument = gql`
    query FinanceRulesFilterAttributes {
  financeRulesFilterAttributes {
    ruleNames
    costCodes {
      id
      name
    }
    currencies
    units
    startDates
    endDates
    enabled
    isDefaultCost
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinanceRulesFilterAttributesGQL extends Apollo.Query<FinanceRulesFilterAttributesQuery, FinanceRulesFilterAttributesQueryVariables> {
    document = FinanceRulesFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertFinanceRulesDocument = gql`
    mutation UpsertFinanceRules($attributesList: [FinanceRuleAttributes!]!) {
  upsertFinanceRule(attributesList: $attributesList) {
    success
    errors {
      message
    }
    financeRules {
      id
      name
      unit
      amountCents
      currency
      incotermForPercentageCalculation
      percentage
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertFinanceRulesGQL extends Apollo.Mutation<UpsertFinanceRulesMutation, UpsertFinanceRulesMutationVariables> {
    document = UpsertFinanceRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFinanceRuleDocument = gql`
    mutation DeleteFinanceRule($ids: [ID!]!) {
  deleteFinanceRule(ids: $ids) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFinanceRuleGQL extends Apollo.Mutation<DeleteFinanceRuleMutation, DeleteFinanceRuleMutationVariables> {
    document = DeleteFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllowedOptionsDocument = gql`
    query GetAllowedOptions {
  allowedUnits
  allowedIncoterms
  allowedCurrencies
  allowedMatchTypes
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllowedOptionsGQL extends Apollo.Query<GetAllowedOptionsQuery, GetAllowedOptionsQueryVariables> {
    document = GetAllowedOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFinanceRuleDocument = gql`
    mutation CreateFinanceRule($attributes: [FinanceRuleAttributes!]!) {
  createFinanceRule(attributes: $attributes) {
    financeRules {
      id
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFinanceRuleGQL extends Apollo.Mutation<CreateFinanceRuleMutation, CreateFinanceRuleMutationVariables> {
    document = CreateFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFinanceRuleDocument = gql`
    mutation UpdateFinanceRule($attributes: [FinanceRuleAttributes!]!, $deleteIds: [ID!]) {
  updateFinanceRule(attributes: $attributes, deleteIds: $deleteIds) {
    financeRules {
      id
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFinanceRuleGQL extends Apollo.Mutation<UpdateFinanceRuleMutation, UpdateFinanceRuleMutationVariables> {
    document = UpdateFinanceRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFinanceRuleEnabledStateDocument = gql`
    mutation UpdateFinanceRuleEnabledState($updateIds: [ID!]!, $state: Boolean!) {
  updateFinanceRuleEnabledState(updateIds: $updateIds, state: $state) {
    financeRules {
      id
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFinanceRuleEnabledStateGQL extends Apollo.Mutation<UpdateFinanceRuleEnabledStateMutation, UpdateFinanceRuleEnabledStateMutationVariables> {
    document = UpdateFinanceRuleEnabledStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradeCompaniesDocument = gql`
    query TradeCompanies($id: ID!) {
  company(id: $id) {
    id
    buyers {
      id
      name
    }
    sellers {
      id
      name
    }
    varieties {
      id
      name
    }
    commodities {
      id
      name
    }
    tradeRegions {
      id
      name
      code
      countries {
        id
        name
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TradeCompaniesGQL extends Apollo.Query<TradeCompaniesQuery, TradeCompaniesQueryVariables> {
    document = TradeCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateProducerStatementDocument = gql`
    mutation GenerateProducerStatement($cartonGroupingIds: [Int!]!, $fileFormat: TemplateFileFormatEnum!, $reportingCurrency: String) {
  generateProducerStatement(
    cartonGroupingIds: $cartonGroupingIds
    fileFormat: $fileFormat
    reportingCurrency: $reportingCurrency
  ) {
    fileUrl
    statementNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateProducerStatementGQL extends Apollo.Mutation<GenerateProducerStatementMutation, GenerateProducerStatementMutationVariables> {
    document = GenerateProducerStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteUserDocument = gql`
    mutation InviteUser($email: String!, $firstName: String, $lastName: String) {
  inviteUser(email: $email, firstName: $firstName, lastName: $lastName) {
    invite {
      id
      email
      state
      message
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteUserGQL extends Apollo.Mutation<InviteUserMutation, InviteUserMutationVariables> {
    document = InviteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($id: Int!) {
  revokeInvite(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeInviteGQL extends Apollo.Mutation<RevokeInviteMutation, RevokeInviteMutationVariables> {
    document = RevokeInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInviteDocument = gql`
    mutation ResendInvite($id: Int!) {
  resendInvite(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInviteGQL extends Apollo.Mutation<ResendInviteMutation, ResendInviteMutationVariables> {
    document = ResendInviteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoicesSummaryDocument = gql`
    query invoicesSummary($filterAttributes: InvoicesFilters!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $page: String!, $first: Int, $last: Int, $after: String, $before: String) {
  invoices(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    page: $page
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...invoicesSummaryFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${InvoicesSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoicesSummaryGQL extends Apollo.Query<InvoicesSummaryQuery, InvoicesSummaryQueryVariables> {
    document = InvoicesSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PopulateInvoiceContainerDataDocument = gql`
    query populateInvoiceContainerData($containerId: Int!, $selectedCurrency: String!, $invoiceType: String!, $cgIds: [Int!]!, $commercialTermId: Int) {
  populateInvoiceContainerData(
    containerId: $containerId
    selectedCurrency: $selectedCurrency
    invoiceType: $invoiceType
    cgIds: $cgIds
    commercialTermId: $commercialTermId
  ) {
    invoiceLineItems {
      ...invliCommonFields
    }
    portOfLoading {
      ...invPortFields
    }
    portOfDestination {
      ...invPortFields
    }
    vessel {
      id
      vesselName
    }
    voyage
    commercialTerm {
      id
      paymentTerm
      advanceAmount
      advanceCreditTerm
      advanceType
      advanceUnit
      finalCreditTerm
    }
  }
}
    ${InvliCommonFieldsFragmentDoc}
${InvPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PopulateInvoiceContainerDataGQL extends Apollo.Query<PopulateInvoiceContainerDataQuery, PopulateInvoiceContainerDataQueryVariables> {
    document = PopulateInvoiceContainerDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceDocument = gql`
    query invoice($id: Int!) {
  invoice(id: $id) {
    invoiceLineItems {
      ...invliCommonFields
    }
    ...invCommonFields
    currencyExchangeRate {
      id
      fromCurrency
      toCurrency
      exchangeRate
      exchangeRateDate
      exchangeRateType
      currencyConversion {
        id
        rates
        timestamp
      }
    }
    attachedDocuments {
      id
      v2Url
      filename
      contentType
    }
    linkedAdvanceInvoice {
      id
      invoiceNumber
      advancePayment
    }
    overRecoveryCreditNote {
      id
      invoiceNumber
      totalIncoterm
    }
  }
}
    ${InvliCommonFieldsFragmentDoc}
${InvCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceGQL extends Apollo.Query<InvoiceQuery, InvoiceQueryVariables> {
    document = InvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PopulateInvoiceFromParentDocument = gql`
    query populateInvoiceFromParent($parentInvoiceId: Int!, $documentType: String!) {
  populateInvoiceFromParent(
    parentInvoiceId: $parentInvoiceId
    documentType: $documentType
  ) {
    invoice {
      ...invCommonFields
    }
    revenueLineItems {
      ...invliCommonFields
    }
    errors
  }
}
    ${InvCommonFieldsFragmentDoc}
${InvliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PopulateInvoiceFromParentGQL extends Apollo.Query<PopulateInvoiceFromParentQuery, PopulateInvoiceFromParentQueryVariables> {
    document = PopulateInvoiceFromParentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncomeInvoiceLineItemsDocument = gql`
    query IncomeInvoiceLineItems($id: ID!) {
  incomeInvoiceLineItems(id: $id) {
    ...invliCommonFields
  }
}
    ${InvliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IncomeInvoiceLineItemsGQL extends Apollo.Query<IncomeInvoiceLineItemsQuery, IncomeInvoiceLineItemsQueryVariables> {
    document = IncomeInvoiceLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CostInvoiceLineItemsDocument = gql`
    query CostInvoiceLineItems($id: ID!) {
  costInvoiceLineItems(id: $id) {
    ...invliCommonFields
  }
}
    ${InvliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CostInvoiceLineItemsGQL extends Apollo.Query<CostInvoiceLineItemsQuery, CostInvoiceLineItemsQueryVariables> {
    document = CostInvoiceLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceCartonGroupingTransactionsDocument = gql`
    query InvoiceCartonGroupingTransactions($id: Int!) {
  invoiceCartonGroupingTransactions(id: $id) {
    cartonGrouping {
      palletNumber
      cartons
    }
    amountMajorUnit
    currency
    quantityType
    quantityPriceMajorUnit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceCartonGroupingTransactionsGQL extends Apollo.Query<InvoiceCartonGroupingTransactionsQuery, InvoiceCartonGroupingTransactionsQueryVariables> {
    document = InvoiceCartonGroupingTransactionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceFilterAttributesDocument = gql`
    query invoiceFilterAttributes($page: String!) {
  invoicesFilterAttributes(page: $page) {
    vessels {
      id
      vesselName
    }
    contacts {
      id
      name
      contactType
      createdByUserId
    }
    incoterms
    varieties {
      id
      name
    }
    commodities {
      id
      name
    }
    documentTypes {
      type
      name
    }
    states
    targetCountries
    invoiceNumbers
    transportTypes
    containers
    palletNumbers
    costCodes
    exportStatuses
    financialYearOptions {
      year
      label
      startDate
      endDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceFilterAttributesGQL extends Apollo.Query<InvoiceFilterAttributesQuery, InvoiceFilterAttributesQueryVariables> {
    document = InvoiceFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceNumberDocument = gql`
    query invoiceNumber($documenttype: String) {
  invoiceNumber(documenttype: $documenttype)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceNumberGQL extends Apollo.Query<InvoiceNumberQuery, InvoiceNumberQueryVariables> {
    document = InvoiceNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceSeaPortsDocument = gql`
    query invoiceSeaPorts($limit: Int, $seaportname: String, $isportofloading: Boolean, $orderbyinv: Boolean) {
  seaPorts(
    limit: $limit
    seaportname: $seaportname
    isportofloading: $isportofloading
    orderbyinv: $orderbyinv
  ) {
    ...invPortFields
  }
}
    ${InvPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceSeaPortsGQL extends Apollo.Query<InvoiceSeaPortsQuery, InvoiceSeaPortsQueryVariables> {
    document = InvoiceSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceScrollTradeCountriesDocument = gql`
    query invoiceScrollTradeCountries($first: Int, $last: Int, $after: String, $before: String, $searchTerm: String) {
  invoiceScrollTradeCountries(
    first: $first
    last: $last
    after: $after
    before: $before
    searchTerm: $searchTerm
  ) {
    nodes {
      id
      name
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceScrollTradeCountriesGQL extends Apollo.Query<InvoiceScrollTradeCountriesQuery, InvoiceScrollTradeCountriesQueryVariables> {
    document = InvoiceScrollTradeCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceVesselsDocument = gql`
    query invoiceVessels($limit: Int, $seaportid: Int, $vesselname: String) {
  vessels(limit: $limit, seaportid: $seaportid, vesselname: $vesselname) {
    id
    vesselName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceVesselsGQL extends Apollo.Query<InvoiceVesselsQuery, InvoiceVesselsQueryVariables> {
    document = InvoiceVesselsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceVoyagesDocument = gql`
    query invoiceVoyages($vesselid: Int!, $seaportid: Int) {
  voyages(vesselid: $vesselid, seaportid: $seaportid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceVoyagesGQL extends Apollo.Query<InvoiceVoyagesQuery, InvoiceVoyagesQueryVariables> {
    document = InvoiceVoyagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceContactsDocument = gql`
    query invoiceContacts {
  contacts {
    id
    name
    info
    contactType
    createdByUserId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceContactsGQL extends Apollo.Query<InvoiceContactsQuery, InvoiceContactsQueryVariables> {
    document = InvoiceContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VatTypesDocument = gql`
    query vatTypes {
  vatTypes {
    id
    name
    percentage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VatTypesGQL extends Apollo.Query<VatTypesQuery, VatTypesQueryVariables> {
    document = VatTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceContainersDocument = gql`
    query invoiceContainers($limit: Int, $port: Int, $containernumber: String, $excludesassignedinvlis: Boolean, $onlytrackingenabled: Boolean) {
  containers(
    limit: $limit
    originportid: $port
    containernumber: $containernumber
    excludesassignedinvlis: $excludesassignedinvlis
    onlytrackingenabled: $onlytrackingenabled
  ) {
    containerNumber
    id
    stuffDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceContainersGQL extends Apollo.Query<InvoiceContainersQuery, InvoiceContainersQueryVariables> {
    document = InvoiceContainersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceUnassignedCGsDocument = gql`
    query invoiceUnassignedCGs($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      ...invCommonCGFields
    }
    filterValues {
      batchNumber
      consignmentNumber
      packingWeek
      targetMarket
      exporterCode
      voyageNumber
      vessel {
        id
        vesselName
      }
      variety {
        id
        name
      }
      seller {
        id
        name
      }
      buyer {
        id
        name
      }
    }
  }
}
    ${InvCommonCgFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceUnassignedCGsGQL extends Apollo.Query<InvoiceUnassignedCGsQuery, InvoiceUnassignedCGsQueryVariables> {
    document = InvoiceUnassignedCGsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchCgCommercialTermDocument = gql`
    query fetchCgCommercialTerm($cgId: ID!) {
  fetchCgCommercialTerm(cgId: $cgId) {
    id
    paymentTerm
    advanceAmount
    advanceCreditTerm
    advanceType
    advanceUnit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchCgCommercialTermGQL extends Apollo.Query<FetchCgCommercialTermQuery, FetchCgCommercialTermQueryVariables> {
    document = FetchCgCommercialTermDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceCustomFieldsDocument = gql`
    query invoiceCustomFields($excludedCustomFieldIds: [Int!]) {
  customFields(excludedCustomFieldIds: $excludedCustomFieldIds) {
    id
    name
    required
    isDefault
    defaultValue
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceCustomFieldsGQL extends Apollo.Query<InvoiceCustomFieldsQuery, InvoiceCustomFieldsQueryVariables> {
    document = InvoiceCustomFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyCostCodesDocument = gql`
    query CompanyCostCodes {
  companyCostCodes {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyCostCodesGQL extends Apollo.Query<CompanyCostCodesQuery, CompanyCostCodesQueryVariables> {
    document = CompanyCostCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateQuickCostDocument = gql`
    mutation CreateQuickCost($attributes: QuickCostAttributes!) {
  createQuickCost(attributes: $attributes) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateQuickCostGQL extends Apollo.Mutation<CreateQuickCostMutation, CreateQuickCostMutationVariables> {
    document = CreateQuickCostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculatePalletCostsDocument = gql`
    mutation CalculatePalletCosts($cgIds: [Int!]!, $costId: Int!) {
  calculatePalletCosts(cgIds: $cgIds, costId: $costId) {
    estimatePalletCosts
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculatePalletCostsGQL extends Apollo.Mutation<CalculatePalletCostsMutation, CalculatePalletCostsMutationVariables> {
    document = CalculatePalletCostsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContactDocument = gql`
    mutation CreateContact($attributes: ContactAttributes!) {
  createContact(attributes: $attributes) {
    contact {
      id
      name
      info
      contactType
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContactGQL extends Apollo.Mutation<CreateContactMutation, CreateContactMutationVariables> {
    document = CreateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContactDocument = gql`
    mutation UpdateContact($attributes: ContactAttributes!) {
  updateContact(attributes: $attributes) {
    contact {
      id
      name
      info
      contactType
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContactGQL extends Apollo.Mutation<UpdateContactMutation, UpdateContactMutationVariables> {
    document = UpdateContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: Int!) {
  deleteContact(id: $id) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteContactGQL extends Apollo.Mutation<DeleteContactMutation, DeleteContactMutationVariables> {
    document = DeleteContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomFieldDocument = gql`
    mutation CreateCustomField($attributes: CustomFieldAttributes!) {
  createCustomField(attributes: $attributes) {
    customField {
      id
      name
      required
      isDefault
      defaultValue
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomFieldGQL extends Apollo.Mutation<CreateCustomFieldMutation, CreateCustomFieldMutationVariables> {
    document = CreateCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomFieldDocument = gql`
    mutation UpdateCustomField($attributes: CustomFieldAttributes!) {
  updateCustomField(attributes: $attributes) {
    customField {
      id
      name
      required
      isDefault
      defaultValue
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomFieldGQL extends Apollo.Mutation<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables> {
    document = UpdateCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCustomFieldDocument = gql`
    mutation DeleteCustomField($id: Int!) {
  deleteCustomField(id: $id) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCustomFieldGQL extends Apollo.Mutation<DeleteCustomFieldMutation, DeleteCustomFieldMutationVariables> {
    document = DeleteCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($attributes: InvoiceAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  createInvoice(
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    invoice {
      cartonGroupings {
        ...invCommonCGFields
      }
      invoiceLineItems {
        ...invliCommonFields
      }
      ...invCommonFields
    }
  }
}
    ${InvCommonCgFieldsFragmentDoc}
${InvliCommonFieldsFragmentDoc}
${InvCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceGQL extends Apollo.Mutation<CreateInvoiceMutation, CreateInvoiceMutationVariables> {
    document = CreateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateCommercialsDocument = gql`
    mutation CalculateCommercials($attributes: InvoiceAttributes!) {
  calculateCommercials(attributes: $attributes) {
    errors
    advancePayment
    finalPayment
    advanceCreditTerm
    finalCreditTerm
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateCommercialsGQL extends Apollo.Mutation<CalculateCommercialsMutation, CalculateCommercialsMutationVariables> {
    document = CalculateCommercialsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateInvoiceDocument = gql`
    mutation DuplicateInvoice($id: ID!, $documentType: String!, $shouldDuplicateLineItems: Boolean!) {
  duplicateInvoice(
    id: $id
    documentType: $documentType
    shouldDuplicateLineItems: $shouldDuplicateLineItems
  ) {
    errors
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateInvoiceGQL extends Apollo.Mutation<DuplicateInvoiceMutation, DuplicateInvoiceMutationVariables> {
    document = DuplicateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaptureAccountSaleDocument = gql`
    mutation CaptureAccountSale($id: ID!) {
  captureAccountSale(id: $id) {
    errors
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaptureAccountSaleGQL extends Apollo.Mutation<CaptureAccountSaleMutation, CaptureAccountSaleMutationVariables> {
    document = CaptureAccountSaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInvoiceFromBatchDocument = gql`
    mutation CreateInvoiceFromBatch($invoiceIds: [ID!]!, $documentType: String!) {
  createInvoiceFromBatch(invoiceIds: $invoiceIds, documentType: $documentType) {
    errors
    invoice {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceFromBatchGQL extends Apollo.Mutation<CreateInvoiceFromBatchMutation, CreateInvoiceFromBatchMutationVariables> {
    document = CreateInvoiceFromBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($attributes: InvoiceAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  updateInvoice(
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    invoice {
      cartonGroupings {
        ...invCommonCGFields
      }
      invoiceLineItems {
        ...invliCommonFields
      }
      ...invCommonFields
    }
    reconciliationDocuments {
      id
      invoiceNumber
      documentType
    }
  }
}
    ${InvCommonCgFieldsFragmentDoc}
${InvliCommonFieldsFragmentDoc}
${InvCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceGQL extends Apollo.Mutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables> {
    document = UpdateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($id: Int!) {
  deleteInvoice(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInvoiceGQL extends Apollo.Mutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables> {
    document = DeleteInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateInvoiceTotalsDocument = gql`
    mutation CalculateInvoiceTotals($attributes: InvoiceIncotermAttributes!) {
  calculateInvoiceIncoterm(attributes: $attributes) {
    invoice {
      id
      cartonCount
      currency
      freightCost
      insuranceCost
      localCosts
      palletCount
      totalFob
      totalIncoterm
      incoterm
      invoiceDate
      advancePayment
      advanceCreditTerm
      finalPayment
      finalCreditTerm
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateInvoiceTotalsGQL extends Apollo.Mutation<CalculateInvoiceTotalsMutation, CalculateInvoiceTotalsMutationVariables> {
    document = CalculateInvoiceTotalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateInvoiceOutputFilesDocument = gql`
    mutation GenerateInvoiceOutputFiles($invoiceId: ID!) {
  generateInvoiceOutputFiles(invoiceId: $invoiceId) {
    templateOutput {
      errorReason
      id
      state
      templateVariant
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateInvoiceOutputFilesGQL extends Apollo.Mutation<GenerateInvoiceOutputFilesMutation, GenerateInvoiceOutputFilesMutationVariables> {
    document = GenerateInvoiceOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvoiceStateDocument = gql`
    mutation updateInvoiceState($id: Int!, $state: String!) {
  updateInvoiceState(id: $id, state: $state) {
    invoice {
      id
      state
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceStateGQL extends Apollo.Mutation<UpdateInvoiceStateMutation, UpdateInvoiceStateMutationVariables> {
    document = UpdateInvoiceStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadInvoiceDocumentsDocument = gql`
    mutation UploadInvoiceDocuments($invoiceId: ID!, $files: [Upload!]!) {
  uploadInvoiceDocuments(invoiceId: $invoiceId, files: $files) {
    errors
    warnings
    invoice {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadInvoiceDocumentsGQL extends Apollo.Mutation<UploadInvoiceDocumentsMutation, UploadInvoiceDocumentsMutationVariables> {
    document = UploadInvoiceDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInvoiceDocumentDocument = gql`
    mutation DeleteInvoiceDocument($invoiceId: ID!, $documentId: ID!) {
  deleteInvoiceDocument(invoiceId: $invoiceId, documentId: $documentId) {
    errors
    invoice {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInvoiceDocumentGQL extends Apollo.Mutation<DeleteInvoiceDocumentMutation, DeleteInvoiceDocumentMutationVariables> {
    document = DeleteInvoiceDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineItemDocument = gql`
    query LineItem($lineItemId: ID!, $unit: String, $currency: CurrencyEnum, $incoterm: IncotermWithNscEnum) {
  lineItem(lineItemId: $lineItemId) {
    expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
      unit
      error
      pricePoints {
        incoterm
        moneyAmount {
          currency {
            symbol
            isoCode
            smallestDenomination
            subunitToUnit
          }
          displayString
          fractional
          amount
        }
        chargesApplied {
          name
          moneyAmount {
            currency {
              symbol
              isoCode
              smallestDenomination
              subunitToUnit
            }
            displayString
            fractional
            amount
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LineItemGQL extends Apollo.Query<LineItemQuery, LineItemQueryVariables> {
    document = LineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HistoricalMarketVolumesDocument = gql`
    query HistoricalMarketVolumes($companyId: ID!, $commodityId: ID!, $regionCode: String!) {
  historicalMarketVolumes(
    companyId: $companyId
    commodityId: $commodityId
    regionCode: $regionCode
  ) {
    companyName
    targetRegion
    commodityName
    grade
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HistoricalMarketVolumesGQL extends Apollo.Query<HistoricalMarketVolumesQuery, HistoricalMarketVolumesQueryVariables> {
    document = HistoricalMarketVolumesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIncotermLineItemDocument = gql`
    mutation CreateIncotermLineItem($attributes: CreateLineItemAttributes!, $buyerId: ID, $sellerId: ID, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  createIncotermLineItem(
    attributes: $attributes
    buyerId: $buyerId
    sellerId: $sellerId
  ) {
    lineItem {
      expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
        ...expectedReturnSummaryFields
      }
    }
    errors
  }
}
    ${ExpectedReturnSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIncotermLineItemGQL extends Apollo.Mutation<CreateIncotermLineItemMutation, CreateIncotermLineItemMutationVariables> {
    document = CreateIncotermLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIncotermLineItemsDocument = gql`
    mutation CreateIncotermLineItems($lineItemAttributes: [CreateLineItemAttributes!]!, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  createIncotermLineItems(lineItemAttributes: $lineItemAttributes) {
    lineItems {
      expectedReturnSummary(currency: $currency, unit: $unit, incoterm: $incoterm) {
        ...expectedReturnSummaryFields
      }
    }
    errors
  }
}
    ${ExpectedReturnSummaryFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIncotermLineItemsGQL extends Apollo.Mutation<CreateIncotermLineItemsMutation, CreateIncotermLineItemsMutationVariables> {
    document = CreateIncotermLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoisSummaryDocument = gql`
    query LoisSummary($filterAttributes: LoadOutInstructionsFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  loadOutInstructions(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      loadOutReference
      bookingReference
      containerNumber
      transportType
      exportersReference
      shippingLine
      clientReference
      voyage
      portOfLoadingName
      portOfDestinationName
      estimatedTimeOfDelivery
      exporterName
      stuffDate
      contacts {
        name
        contactType
        createdByUserId
      }
      vesselName
      truckReference
      consignmentReference
      orderReference
      loadDate
      loadingPoint {
        name
      }
      offloadingPoint {
        name
      }
      id
      fileNumber
      airWaybillNo
      shipper
      destination
      flightDate
      updatedAt
      createdAt
      sentEmailList {
        id
        createdAt
        recipient
        attachments
      }
      templateOutput {
        outputFiles {
          id
          filename
        }
      }
      palletCount
      stackDates
      stackDatesClose
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoisSummaryGQL extends Apollo.Query<LoisSummaryQuery, LoisSummaryQueryVariables> {
    document = LoisSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiFilterAttributesDocument = gql`
    query LoiFilterAttributes {
  loadOutInstructionsFilterAttributes {
    commodities {
      id
      name
    }
    vessels {
      id
      vesselName
    }
    varieties {
      id
      name
    }
    exporters {
      id
      name
    }
    contacts {
      id
      name
      contactType
      createdByUserId
    }
    loadingPoints {
      id
      name
    }
    offloadingPoints {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiFilterAttributesGQL extends Apollo.Query<LoiFilterAttributesQuery, LoiFilterAttributesQueryVariables> {
    document = LoiFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiReferenceDocument = gql`
    query loiReference {
  loadOutInstructionReference
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiReferenceGQL extends Apollo.Query<LoiReferenceQuery, LoiReferenceQueryVariables> {
    document = LoiReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirFreightShipmentLineItemsWithNoLoiDocument = gql`
    query airFreightShipmentLineItemsWithNoLoi {
  airFreightShipmentLineItemsWithNoLoi {
    id
    orderReference
    bookingReference
    finalDestinationLocation
    externalShipmentId
    eta
    finalDestinationCode
    goodsDescription
    company {
      id
      name
    }
    airFreightShipment {
      masterWaybillNumber
      shipper
      estimatedDepartureTime
      controller
      portOfLoadingCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirFreightShipmentLineItemsWithNoLoiGQL extends Apollo.Query<AirFreightShipmentLineItemsWithNoLoiQuery, AirFreightShipmentLineItemsWithNoLoiQueryVariables> {
    document = AirFreightShipmentLineItemsWithNoLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiExportersDocument = gql`
    query loiExporters($limit: Int, $orderbyloi: Boolean, $companyname: String) {
  exporters(limit: $limit, orderbyloi: $orderbyloi, companyname: $companyname) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiExportersGQL extends Apollo.Query<LoiExportersQuery, LoiExportersQueryVariables> {
    document = LoiExportersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiStuffLocationsDocument = gql`
    query loiStuffLocations($limit: Int, $orderbyloi: Boolean, $fboname: String) {
  stuffLocations(limit: $limit, orderbyloi: $orderbyloi, fboname: $fboname) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiStuffLocationsGQL extends Apollo.Query<LoiStuffLocationsQuery, LoiStuffLocationsQueryVariables> {
    document = LoiStuffLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiTruckingLoadingPointsDocument = gql`
    query loiTruckingLoadingPoints($limit: Int, $orderByLoi: Boolean, $fboName: String) {
  truckingLoadingPoints(limit: $limit, orderByLoi: $orderByLoi, fboName: $fboName) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiTruckingLoadingPointsGQL extends Apollo.Query<LoiTruckingLoadingPointsQuery, LoiTruckingLoadingPointsQueryVariables> {
    document = LoiTruckingLoadingPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiTruckingOffloadingPointsDocument = gql`
    query loiTruckingOffloadingPoints($limit: Int, $orderByLoi: Boolean, $fboName: String) {
  truckingOffloadingPoints(
    limit: $limit
    orderByLoi: $orderByLoi
    fboName: $fboName
  ) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiTruckingOffloadingPointsGQL extends Apollo.Query<LoiTruckingOffloadingPointsQuery, LoiTruckingOffloadingPointsQueryVariables> {
    document = LoiTruckingOffloadingPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiSeaPortsDocument = gql`
    query loiSeaPorts($limit: Int, $orderbyloi: Boolean, $seaportname: String, $isportofloading: Boolean, $stufflocationid: Int) {
  seaPorts(
    limit: $limit
    orderbyloi: $orderbyloi
    seaportname: $seaportname
    isportofloading: $isportofloading
    stufflocationid: $stufflocationid
  ) {
    id
    name
    country
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiSeaPortsGQL extends Apollo.Query<LoiSeaPortsQuery, LoiSeaPortsQueryVariables> {
    document = LoiSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiVesselsDocument = gql`
    query loiVessels($limit: Int, $vesselname: String, $seaportid: Int) {
  vessels(limit: $limit, vesselname: $vesselname, seaportid: $seaportid) {
    id
    vesselName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiVesselsGQL extends Apollo.Query<LoiVesselsQuery, LoiVesselsQueryVariables> {
    document = LoiVesselsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiVoyagesDocument = gql`
    query loiVoyages($vesselid: Int!, $seaportid: Int) {
  voyages(vesselid: $vesselid, seaportid: $seaportid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiVoyagesGQL extends Apollo.Query<LoiVoyagesQuery, LoiVoyagesQueryVariables> {
    document = LoiVoyagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiContactsDocument = gql`
    query loiContacts {
  contacts {
    id
    name
    info
    contactType
    createdByUserId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiContactsGQL extends Apollo.Query<LoiContactsQuery, LoiContactsQueryVariables> {
    document = LoiContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiUnassignedCgFilterAttributesDocument = gql`
    query loiUnassignedCGFilterAttributes($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    filterValues {
      batchNumber
      consignmentNumber
      packingWeek
      targetMarket
      variety {
        id
        name
      }
      seller {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiUnassignedCgFilterAttributesGQL extends Apollo.Query<LoiUnassignedCgFilterAttributesQuery, LoiUnassignedCgFilterAttributesQueryVariables> {
    document = LoiUnassignedCgFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiUnassignedCartonGroupingsDocument = gql`
    query loiUnassignedCartonGroupings($attributes: CartonGroupingSearchAttributes!) {
  loadOutInstructionCgs(attributes: $attributes) {
    id
    batchNumber
    buyerName
    cartons
    consignmentNumber
    commodityName
    exporterCode
    farmCode
    inventoryCode
    mark
    orchard
    grade
    pack
    packingWeek
    palletNumber
    sellerName
    sequenceNumber
    sizeCount
    state
    subCommodityName
    targetMarket
    targetRegion
    varietyName
    palletAge
    netMass
    palletGrossMass
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiUnassignedCartonGroupingsGQL extends Apollo.Query<LoiUnassignedCartonGroupingsQuery, LoiUnassignedCartonGroupingsQueryVariables> {
    document = LoiUnassignedCartonGroupingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiUnassignedCGsDocument = gql`
    query loiUnassignedCGs($attributes: CartonGroupingSearchAttributes!) {
  cartonGroupingsSearch(attributes: $attributes) {
    cartonGroupings {
      batchNumber
      buyer {
        name
      }
      cartons
      consignmentNumber
      exporterCode
      farmCode
      grade
      id
      inventoryCode
      mark
      netMass
      orchard
      pack
      packhouseCode
      packingWeek
      palletGrossMass
      palletNumber
      seller {
        name
      }
      sequenceNumber
      sizeCount
      state
      targetCountry
      targetMarket
      targetRegion
      variety {
        commodity {
          name
        }
        name
        subCommodity {
          name
        }
      }
      loadOutInstructions {
        loadOutReference
        transportType
        loadingPoint {
          id
          name
          createdAt
          updatedAt
        }
        portOfLoading {
          ...loiPortFields
        }
      }
      palletAge
    }
    filterValues {
      batchNumber
      consignmentNumber
      packingWeek
      targetMarket
      variety {
        id
        name
      }
      seller {
        id
        name
      }
    }
    totalCount
    totalCountPallets
  }
}
    ${LoiPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiUnassignedCGsGQL extends Apollo.Query<LoiUnassignedCGsQuery, LoiUnassignedCGsQueryVariables> {
    document = LoiUnassignedCGsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoiDocument = gql`
    query Loi($id: Int!) {
  loadOutInstruction(id: $id) {
    ...LoiCommonFields
    airFreightShipmentLineItem {
      id
      orderReference
      bookingReference
      externalShipmentId
      updatedAt
      createdAt
    }
    shipmentLineItem {
      id
      updatedAt
      createdAt
    }
    cartonGroupings {
      ...cgCommonFields
    }
    loiCartonGroupings {
      id
      batchNumber
      buyerName
      cartons
      consignmentNumber
      commodityName
      exporterCode
      farmCode
      inventoryCode
      mark
      orchard
      grade
      pack
      packingWeek
      palletNumber
      sellerName
      sequenceNumber
      sizeCount
      state
      subCommodityName
      targetMarket
      targetRegion
      varietyName
      palletAge
      netMass
      palletGrossMass
    }
  }
}
    ${LoiCommonFieldsFragmentDoc}
${CgCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoiGQL extends Apollo.Query<LoiQuery, LoiQueryVariables> {
    document = LoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLoiDocument = gql`
    mutation CreateLoi($attributes: LoadOutAttributes!) {
  createLoadOutInstruction(attributes: $attributes) {
    errors {
      ...LoiErrorFields
    }
    loadOutInstruction {
      cartonGroupings {
        id
      }
      ...LoiCommonFields
    }
  }
}
    ${LoiErrorFieldsFragmentDoc}
${LoiCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLoiGQL extends Apollo.Mutation<CreateLoiMutation, CreateLoiMutationVariables> {
    document = CreateLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLoiDocument = gql`
    mutation UpdateLoi($attributes: LoadOutAttributes!) {
  updateLoadOutInstruction(attributes: $attributes) {
    errors {
      ...LoiErrorFields
    }
    loadOutInstruction {
      cartonGroupings {
        id
      }
      ...LoiCommonFields
    }
  }
}
    ${LoiErrorFieldsFragmentDoc}
${LoiCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLoiGQL extends Apollo.Mutation<UpdateLoiMutation, UpdateLoiMutationVariables> {
    document = UpdateLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLoiDocument = gql`
    mutation DeleteLoi($id: Int!) {
  deleteLoadOutInstruction(id: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLoiGQL extends Apollo.Mutation<DeleteLoiMutation, DeleteLoiMutationVariables> {
    document = DeleteLoiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateLoadOutInstructionOutputFilesDocument = gql`
    mutation GenerateLoadOutInstructionOutputFiles($loadoutinstructionid: ID!) {
  generateLoadOutInstructionOutputFiles(
    loadoutinstructionid: $loadoutinstructionid
  ) {
    templateOutput {
      errorReason
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateLoadOutInstructionOutputFilesGQL extends Apollo.Mutation<GenerateLoadOutInstructionOutputFilesMutation, GenerateLoadOutInstructionOutputFilesMutationVariables> {
    document = GenerateLoadOutInstructionOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratePalletInOutputFilesDocument = gql`
    mutation GeneratePalletInOutputFiles($loadOutInstructionId: ID!) {
  generatePalletInOutputFiles(loadOutInstructionId: $loadOutInstructionId) {
    palletInId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratePalletInOutputFilesGQL extends Apollo.Mutation<GeneratePalletInOutputFilesMutation, GeneratePalletInOutputFilesMutationVariables> {
    document = GeneratePalletInOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnPalletInOutputStateChangeDocument = gql`
    subscription onPalletInOutputStateChange {
  onPalletInOutputStateChange {
    ...palletInFields
  }
}
    ${PalletInFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnPalletInOutputStateChangeGQL extends Apollo.Subscription<OnPalletInOutputStateChangeSubscription, OnPalletInOutputStateChangeSubscriptionVariables> {
    document = OnPalletInOutputStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EvaluateShipmentImpactDocument = gql`
    query EvaluateShipmentImpact($sliId: ID!, $loiAttributes: LoadOutAttributes!) {
  evaluateShipmentImpact(sliId: $sliId, loiAttributes: $loiAttributes) {
    willAffectShipment
    willCreateNewShipment
    shipmentId
    portOfLoading
    vesselName
    voyage
    shippingLine
    client
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EvaluateShipmentImpactGQL extends Apollo.Query<EvaluateShipmentImpactQuery, EvaluateShipmentImpactQueryVariables> {
    document = EvaluateShipmentImpactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MoveSlisToNewShipmentDocument = gql`
    mutation MoveSlisToNewShipment($sliIds: [ID!]!, $shipmentId: ID) {
  moveSlisToNewShipment(sliIds: $sliIds, shipmentId: $shipmentId) {
    shipment {
      id
    }
    shipmentLineItems {
      id
      shipmentId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MoveSlisToNewShipmentGQL extends Apollo.Mutation<MoveSlisToNewShipmentMutation, MoveSlisToNewShipmentMutationVariables> {
    document = MoveSlisToNewShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentMapPointsForOrderDocument = gql`
    query CurrentMapPointsForOrder($id: Int!) {
  currentMapPointsForOrder(id: $id) {
    totalCartons
    containers {
      id
      containerNumber
      orderId
      otherPartyName
      vesselName
      portOfDestination
      eta
    }
    orders {
      orderId
      otherPartyName
      totalCartons
    }
    location {
      ...vesselMap
      ...seaPortMap
      ...fboMap
      __typename
    }
  }
}
    ${VesselMapFragmentDoc}
${SeaPortMapFragmentDoc}
${FboMapFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentMapPointsForOrderGQL extends Apollo.Query<CurrentMapPointsForOrderQuery, CurrentMapPointsForOrderQueryVariables> {
    document = CurrentMapPointsForOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonConversionsDocument = gql`
    query CartonConversions($filterAttributes: CartonConversionFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  cartonConversions(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    commodityName
    conversionFactor
    actualMass
    massConversion
    pack
    sizeCount
    convertedSizeCount
    conversionType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonConversionsGQL extends Apollo.Query<CartonConversionsQuery, CartonConversionsQueryVariables> {
    document = CartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCartonConversionsDocument = gql`
    mutation createCartonConversions($actualMass: Float, $commodityId: ID, $conversionFactor: Float, $conversionType: String, $convertedSizeCount: String, $massConversion: Float, $pack: String, $sizeCount: String) {
  createCartonConversion(
    actualMass: $actualMass
    commodityId: $commodityId
    conversionFactor: $conversionFactor
    conversionType: $conversionType
    convertedSizeCount: $convertedSizeCount
    massConversion: $massConversion
    pack: $pack
    sizeCount: $sizeCount
  ) {
    cartonConversion {
      id
      commodityName
      conversionFactor
      actualMass
      massConversion
      pack
      sizeCount
      convertedSizeCount
      conversionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCartonConversionsGQL extends Apollo.Mutation<CreateCartonConversionsMutation, CreateCartonConversionsMutationVariables> {
    document = CreateCartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCartonConversionsDocument = gql`
    mutation updateCartonConversions($id: ID!, $actualMass: Float, $conversionFactor: Float, $convertedSizeCount: String, $massConversion: Float) {
  updateCartonConversion(
    id: $id
    actualMass: $actualMass
    conversionFactor: $conversionFactor
    convertedSizeCount: $convertedSizeCount
    massConversion: $massConversion
  ) {
    cartonConversion {
      id
      commodityName
      conversionFactor
      actualMass
      massConversion
      pack
      sizeCount
      convertedSizeCount
      conversionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCartonConversionsGQL extends Apollo.Mutation<UpdateCartonConversionsMutation, UpdateCartonConversionsMutationVariables> {
    document = UpdateCartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCartonConversionsDocument = gql`
    mutation deleteCartonConversions($id: ID!) {
  deleteCartonConversion(id: $id) {
    cartonConversion {
      id
      commodityName
      conversionFactor
      actualMass
      massConversion
      pack
      sizeCount
      convertedSizeCount
      conversionType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCartonConversionsGQL extends Apollo.Mutation<DeleteCartonConversionsMutation, DeleteCartonConversionsMutationVariables> {
    document = DeleteCartonConversionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartonConversionFilterAttributesDocument = gql`
    query CartonConversionFilterAttributes {
  cartonConversionFilterAttributes {
    conversionType
    commodityName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartonConversionFilterAttributesGQL extends Apollo.Query<CartonConversionFilterAttributesQuery, CartonConversionFilterAttributesQueryVariables> {
    document = CartonConversionFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CgErrorsDocument = gql`
    query CgErrors($filterAttributes: CgErrorFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  cgErrors(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    errorContext
    errorMessage
    errorType
    errorSubtype
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CgErrorsGQL extends Apollo.Query<CgErrorsQuery, CgErrorsQueryVariables> {
    document = CgErrorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResolveCgErrorDocument = gql`
    mutation ResolveCgError($id: ID!, $resolution: CgErrorResolutionInput!, $userContext: String) {
  resolveCgError(id: $id, resolution: $resolution, userContext: $userContext) {
    cgError {
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResolveCgErrorGQL extends Apollo.Mutation<ResolveCgErrorMutation, ResolveCgErrorMutationVariables> {
    document = ResolveCgErrorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CgErrorFilterAttributesDocument = gql`
    query CgErrorFilterAttributes {
  cgErrorFilterAttributes {
    errorType
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CgErrorFilterAttributesGQL extends Apollo.Query<CgErrorFilterAttributesQuery, CgErrorFilterAttributesQueryVariables> {
    document = CgErrorFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIgnoreErrorRequestDocument = gql`
    mutation CreateIgnoreErrorRequest($action: String!, $errorToIgnore: String!) {
  createIgnoreErrorRequest(action: $action, errorToIgnore: $errorToIgnore) {
    clientChangeRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIgnoreErrorRequestGQL extends Apollo.Mutation<CreateIgnoreErrorRequestMutation, CreateIgnoreErrorRequestMutationVariables> {
    document = CreateIgnoreErrorRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateClientChangeRequestDocument = gql`
    mutation CreateClientChangeRequest($action: String!, $userContext: String, $modelId: ID!) {
  createClientChangeRequest(
    action: $action
    userContext: $userContext
    modelId: $modelId
  ) {
    clientChangeRequest {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateClientChangeRequestGQL extends Apollo.Mutation<CreateClientChangeRequestMutation, CreateClientChangeRequestMutationVariables> {
    document = CreateClientChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterfileFarmVarietiesDocument = gql`
    query MasterfileFarmVarieties($filterAttributes: FarmVarietyFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  masterfileFarmVarieties(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    ... on FarmVariety {
      id
      name: varietyName
      varietyCode
      commodityName
      hectares
      peakCount
      packingStart
      packingEnd
      status
    }
    ... on FarmVarietyRequest {
      modelId
      name
      commodityName
      varietyCode
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterfileFarmVarietiesGQL extends Apollo.Query<MasterfileFarmVarietiesQuery, MasterfileFarmVarietiesQueryVariables> {
    document = MasterfileFarmVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListVarietiesDocument = gql`
    query listVarieties {
  listVarieties {
    id
    varietyName
    commodity {
      id
      name
    }
    subCommodity {
      id
      name
    }
    varietyCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListVarietiesGQL extends Apollo.Query<ListVarietiesQuery, ListVarietiesQueryVariables> {
    document = ListVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FarmVarietyFilterAttributesDocument = gql`
    query farmVarietyFilterAttributes {
  farmVarietyFilterAttributes {
    status
    commodityName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FarmVarietyFilterAttributesGQL extends Apollo.Query<FarmVarietyFilterAttributesQuery, FarmVarietyFilterAttributesQueryVariables> {
    document = FarmVarietyFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFarmVarietyClienChangeRequestDocument = gql`
    mutation CreateFarmVarietyClienChangeRequest($modelId: Int!, $name: String!, $varietyId: Int!, $varietyCode: String!, $commodityName: String!, $commodityId: Int!, $action: String!) {
  createFarmVarietyClientChangeRequest(
    modelId: $modelId
    name: $name
    varietyId: $varietyId
    varietyCode: $varietyCode
    commodityName: $commodityName
    commodityId: $commodityId
    action: $action
  ) {
    clientChangeRequest {
      id
      status
      name
      varietyCode
      commodityName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFarmVarietyClienChangeRequestGQL extends Apollo.Mutation<CreateFarmVarietyClienChangeRequestMutation, CreateFarmVarietyClienChangeRequestMutationVariables> {
    document = CreateFarmVarietyClienChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FarmVarietiesDocument = gql`
    query farmVarieties {
  farmVarieties {
    id
    name: varietyName
    varietyCode
    commodityName
    hectares
    peakCount
    packingStart
    packingEnd
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FarmVarietiesGQL extends Apollo.Query<FarmVarietiesQuery, FarmVarietiesQueryVariables> {
    document = FarmVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FarmVarietyClientChangeRequestsDocument = gql`
    query farmVarietyClientChangeRequests {
  farmVarietyClientChangeRequests {
    name
    status
    varietyCode
    commodityName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FarmVarietyClientChangeRequestsGQL extends Apollo.Query<FarmVarietyClientChangeRequestsQuery, FarmVarietyClientChangeRequestsQueryVariables> {
    document = FarmVarietyClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterfileFoodBusinessOperatorsDocument = gql`
    query MasterfileFoodBusinessOperators($filterAttributes: FoodBusinessOperatorFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  masterfileFoodBusinessOperators(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    ... on FoodBusinessOperator {
      id
      name
      fboCode
      typeOfBusiness
      producerName
      latitude
      longitude
      globalGapNumber
      productionRegion
      updatedAt
      status
    }
    ... on FoodBusinessOperatorRequest {
      fboCode
      name
      globalGapNumber
      latitude
      longitude
      modelId
      status
      producerName
      productionRegion
      typeOfBusiness
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterfileFoodBusinessOperatorsGQL extends Apollo.Query<MasterfileFoodBusinessOperatorsQuery, MasterfileFoodBusinessOperatorsQueryVariables> {
    document = MasterfileFoodBusinessOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorsDocument = gql`
    query foodBusinessOperators {
  foodBusinessOperators {
    id
    name
    fboCode
    typeOfBusiness
    producerName
    latitude
    longitude
    globalGapNumber
    productionRegion
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorsGQL extends Apollo.Query<FoodBusinessOperatorsQuery, FoodBusinessOperatorsQueryVariables> {
    document = FoodBusinessOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorClientChangeRequestsDocument = gql`
    query foodBusinessOperatorClientChangeRequests {
  foodBusinessOperatorClientChangeRequests {
    fboCode
    name
    globalGapNumber
    latitude
    longitude
    modelId
    status
    producerName
    productionRegion
    typeOfBusiness
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorClientChangeRequestsGQL extends Apollo.Query<FoodBusinessOperatorClientChangeRequestsQuery, FoodBusinessOperatorClientChangeRequestsQueryVariables> {
    document = FoodBusinessOperatorClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFoodBusinessOperatorClientChangeRequestDocument = gql`
    mutation CreateFoodBusinessOperatorClientChangeRequest($modelId: Int!, $name: String!, $action: String!, $fboCode: String!, $globalGapNumber: String!, $latitude: Float!, $longitude: Float!, $producerName: String!, $productionRegion: String!, $typeOfBusiness: String!) {
  createFoodBusinessOperatorClientChangeRequest(
    modelId: $modelId
    action: $action
    name: $name
    fboCode: $fboCode
    globalGapNumber: $globalGapNumber
    latitude: $latitude
    longitude: $longitude
    producerName: $producerName
    productionRegion: $productionRegion
    typeOfBusiness: $typeOfBusiness
  ) {
    clientChangeRequest {
      id
      fboCode
      name
      globalGapNumber
      latitude
      longitude
      modelId
      producerName
      productionRegion
      status
      typeOfBusiness
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFoodBusinessOperatorClientChangeRequestGQL extends Apollo.Mutation<CreateFoodBusinessOperatorClientChangeRequestMutation, CreateFoodBusinessOperatorClientChangeRequestMutationVariables> {
    document = CreateFoodBusinessOperatorClientChangeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorFilterAttributesDocument = gql`
    query FoodBusinessOperatorFilterAttributes {
  foodBusinessOperatorFilterAttributes {
    status
    typeOfBusiness
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorFilterAttributesGQL extends Apollo.Query<FoodBusinessOperatorFilterAttributesQuery, FoodBusinessOperatorFilterAttributesQueryVariables> {
    document = FoodBusinessOperatorFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionRegionsDocument = gql`
    query productionRegions {
  productionRegions {
    id
    name
    countryCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionRegionsGQL extends Apollo.Query<ProductionRegionsQuery, ProductionRegionsQueryVariables> {
    document = ProductionRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListFoodBusinessOperatorsDocument = gql`
    query listFoodBusinessOperators {
  listFoodBusinessOperators {
    fboCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListFoodBusinessOperatorsGQL extends Apollo.Query<ListFoodBusinessOperatorsQuery, ListFoodBusinessOperatorsQueryVariables> {
    document = ListFoodBusinessOperatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoodBusinessOperatorsByTypeDocument = gql`
    query FoodBusinessOperatorsByType($typeOfBusiness: Int!) {
  foodBusinessOperatorsByType(typeOfBusiness: $typeOfBusiness) {
    id
    name
    producerName
    fboCode
    productionRegion
    company {
      id
    }
    locationMappings {
      locationCode
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoodBusinessOperatorsByTypeGQL extends Apollo.Query<FoodBusinessOperatorsByTypeQuery, FoodBusinessOperatorsByTypeQueryVariables> {
    document = FoodBusinessOperatorsByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterfileConfigsDocument = gql`
    query MasterfileConfigs($filterAttributes: MasterfileConfigFilterAttributes, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!]) {
  masterfileConfigs(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    ...masterfileConfigFields
    masterfileEntity {
      ... on FarmVariety {
        ...farmVarietyFields
      }
      ... on FoodBusinessOperator {
        ...foodBusinessOperatorFields
      }
      ... on CompanyAssociation {
        ...companyAssociationFields
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${FarmVarietyFieldsFragmentDoc}
${FoodBusinessOperatorFieldsFragmentDoc}
${CompanyAssociationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterfileConfigsGQL extends Apollo.Query<MasterfileConfigsQuery, MasterfileConfigsQueryVariables> {
    document = MasterfileConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InternalPackhouseClientChangeRequestsDocument = gql`
    query InternalPackhouseClientChangeRequests {
  internalPackhouseClientChangeRequests {
    id
    status
    company {
      id
      name
    }
    packhouse {
      ...foodBusinessOperatorFields
    }
  }
}
    ${FoodBusinessOperatorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InternalPackhouseClientChangeRequestsGQL extends Apollo.Query<InternalPackhouseClientChangeRequestsQuery, InternalPackhouseClientChangeRequestsQueryVariables> {
    document = InternalPackhouseClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSoftwareUpdateReportDocument = gql`
    mutation CreateSoftwareUpdateReport($softwareUpdateReport: [String!]!) {
  createSoftwareUpdateReport(softwareUpdateReport: $softwareUpdateReport) {
    errors
    clientChangeRequest {
      ...softwareUpdateReportFields
    }
  }
}
    ${SoftwareUpdateReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSoftwareUpdateReportGQL extends Apollo.Mutation<CreateSoftwareUpdateReportMutation, CreateSoftwareUpdateReportMutationVariables> {
    document = CreateSoftwareUpdateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackhouseSoftwareUpdateReportsDocument = gql`
    query PackhouseSoftwareUpdateReports {
  packhouseSoftwareUpdateReports {
    ...softwareUpdateReportFields
  }
}
    ${SoftwareUpdateReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PackhouseSoftwareUpdateReportsGQL extends Apollo.Query<PackhouseSoftwareUpdateReportsQuery, PackhouseSoftwareUpdateReportsQueryVariables> {
    document = PackhouseSoftwareUpdateReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigFboDocument = gql`
    mutation ConfirmMasterfileConfigFbo($masterfileConfigs: [MasterfileConfigFboInput!]!) {
  confirmMasterfileConfigFbo(masterfileConfigs: $masterfileConfigs) {
    errors
    masterfileConfigs {
      ...masterfileConfigFields
      masterfileEntity {
        ... on FoodBusinessOperator {
          ...foodBusinessOperatorFields
        }
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${FoodBusinessOperatorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigFboGQL extends Apollo.Mutation<ConfirmMasterfileConfigFboMutation, ConfirmMasterfileConfigFboMutationVariables> {
    document = ConfirmMasterfileConfigFboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigPackhouseConnectionsDocument = gql`
    mutation ConfirmMasterfileConfigPackhouseConnections($masterfileConfigs: [MasterfileConfigPackhouseConnectionAttributes!]!) {
  confirmMasterfileConfigPackhouseConnections(
    masterfileConfigs: $masterfileConfigs
  ) {
    errors
    masterfileConfigs {
      ...masterfileConfigFields
      masterfileEntity {
        ... on PackhouseConnection {
          ...packhouseConnectionFields
        }
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${PackhouseConnectionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigPackhouseConnectionsGQL extends Apollo.Mutation<ConfirmMasterfileConfigPackhouseConnectionsMutation, ConfirmMasterfileConfigPackhouseConnectionsMutationVariables> {
    document = ConfirmMasterfileConfigPackhouseConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMasterfileConfigFarmVarietiesDocument = gql`
    mutation ConfirmMasterfileConfigFarmVarieties($masterfileConfigs: [MasterfileConfigFarmVarietyInput!]!) {
  confirmMasterfileConfigFarmVarieties(masterfileConfigs: $masterfileConfigs) {
    errors
    masterfileConfigs {
      ...masterfileConfigFields
      masterfileEntity {
        ... on FarmVariety {
          ...farmVarietyFields
        }
      }
    }
  }
}
    ${MasterfileConfigFieldsFragmentDoc}
${FarmVarietyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMasterfileConfigFarmVarietiesGQL extends Apollo.Mutation<ConfirmMasterfileConfigFarmVarietiesMutation, ConfirmMasterfileConfigFarmVarietiesMutationVariables> {
    document = ConfirmMasterfileConfigFarmVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFarmFboDocument = gql`
    mutation CreateFarmFbo($attributes: CreateFarmAttribute!) {
  createFarmFbo(attributes: $attributes) {
    foodBusinessOperator {
      ...foodBusinessOperatorFields
    }
    masterfileConfig {
      ...masterfileConfigFields
    }
    errors
  }
}
    ${FoodBusinessOperatorFieldsFragmentDoc}
${MasterfileConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFarmFboGQL extends Apollo.Mutation<CreateFarmFboMutation, CreateFarmFboMutationVariables> {
    document = CreateFarmFboDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddInternalPackhouseDocument = gql`
    mutation AddInternalPackhouse($attributes: AddInternalPackhouseAttributes!) {
  addInternalPackhouse(attributes: $attributes) {
    errors
    clientChangeRequest {
      id
      status
      company {
        id
        name
      }
      packhouse {
        ...foodBusinessOperatorFields
      }
    }
  }
}
    ${FoodBusinessOperatorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddInternalPackhouseGQL extends Apollo.Mutation<AddInternalPackhouseMutation, AddInternalPackhouseMutationVariables> {
    document = AddInternalPackhouseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetabaseReportFilterAttributesDocument = gql`
    query MetabaseReportFilterAttributes {
  metabaseReportFilterAttributes {
    badges {
      id
      text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MetabaseReportFilterAttributesGQL extends Apollo.Query<MetabaseReportFilterAttributesQuery, MetabaseReportFilterAttributesQueryVariables> {
    document = MetabaseReportFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetabaseReportsDocument = gql`
    query MetabaseReports($filters: MetabaseReportFilters!, $searchTerm: String!, $searchField: String!) {
  metabaseReports(
    filters: $filters
    searchTerm: $searchTerm
    searchField: $searchField
  ) {
    ...MetabaseReportFields
  }
}
    ${MetabaseReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MetabaseReportsGQL extends Apollo.Query<MetabaseReportsQuery, MetabaseReportsQueryVariables> {
    document = MetabaseReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MetabaseReportDocument = gql`
    query MetabaseReport($id: Int!) {
  metabaseReport(id: $id) {
    ...MetabaseReportFields
  }
}
    ${MetabaseReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MetabaseReportGQL extends Apollo.Query<MetabaseReportQuery, MetabaseReportQueryVariables> {
    document = MetabaseReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NetReturnProgramsDocument = gql`
    query NetReturnPrograms {
  netReturnPrograms {
    additionalFields
    buyerId
    batchNumber
    cartonTypeName
    cartonTypeId
    commodityId
    commodityName
    configuredCurrency
    configuredUnit
    createdAt
    currency
    departurePort {
      ...netReturnProgramPortFields
    }
    destinationPort {
      ...netReturnProgramPortFields
    }
    id
    incoterm
    inventoryCode
    packingWeek
    priceMinorUnit
    priceTerm
    priceUnit
    programId
    programName
    programVisibility
    quantity
    quantityUnit
    referenceNumber
    sizeCounts
    stackSize
    sellerId
    targetMarket
    tradeCountryId
    tradeCountryName
    tradeRegionId
    tradeRegionName
    updatedAt
    varietyId
    varietyName
  }
}
    ${NetReturnProgramPortFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NetReturnProgramsGQL extends Apollo.Query<NetReturnProgramsQuery, NetReturnProgramsQueryVariables> {
    document = NetReturnProgramsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNetReturnProgramDocument = gql`
    mutation CreateNetReturnProgram($attributes: NetReturnProgramAttributes!) {
  createNetReturnProgram(attributes: $attributes) {
    netReturnProgram {
      id
      programName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNetReturnProgramGQL extends Apollo.Mutation<CreateNetReturnProgramMutation, CreateNetReturnProgramMutationVariables> {
    document = CreateNetReturnProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNetReturnProgramDocument = gql`
    mutation UpdateNetReturnProgram($attributes: NetReturnProgramAttributes!) {
  updateNetReturnProgram(attributes: $attributes) {
    netReturnProgram {
      id
      programName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNetReturnProgramGQL extends Apollo.Mutation<UpdateNetReturnProgramMutation, UpdateNetReturnProgramMutationVariables> {
    document = UpdateNetReturnProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNetReturnProgramDocument = gql`
    mutation DeleteNetReturnProgram($id: ID!) {
  deleteNetReturnProgram(id: $id) {
    netReturnProgram {
      id
      programName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNetReturnProgramGQL extends Apollo.Mutation<DeleteNetReturnProgramMutation, DeleteNetReturnProgramMutationVariables> {
    document = DeleteNetReturnProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnNotificationEventDocument = gql`
    subscription onNotificationEvent {
  newInAppNotification {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnNotificationEventGQL extends Apollo.Subscription<OnNotificationEventSubscription, OnNotificationEventSubscriptionVariables> {
    document = OnNotificationEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelNotificationsDocument = gql`
    query getChannelNotifications($filterAttributes: ChannelNotificationFilterAttributes!, $first: Int, $last: Int, $after: String, $before: String) {
  channelNotifications(
    filterAttributes: $filterAttributes
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...ChannelNotificationFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${ChannelNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelNotificationsGQL extends Apollo.Query<GetChannelNotificationsQuery, GetChannelNotificationsQueryVariables> {
    document = GetChannelNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnreadChannelNotificationsCountDocument = gql`
    query getUnreadChannelNotificationsCount($severity: NotificationRuleSeverityEnum) {
  unreadChannelNotificationsCount(severity: $severity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnreadChannelNotificationsCountGQL extends Apollo.Query<GetUnreadChannelNotificationsCountQuery, GetUnreadChannelNotificationsCountQueryVariables> {
    document = GetUnreadChannelNotificationsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTotalChannelNotificationsCountDocument = gql`
    query getTotalChannelNotificationsCount($severity: NotificationRuleSeverityEnum) {
  channelNotificationsCount(severity: $severity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTotalChannelNotificationsCountGQL extends Apollo.Query<GetTotalChannelNotificationsCountQuery, GetTotalChannelNotificationsCountQueryVariables> {
    document = GetTotalChannelNotificationsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChannelNotificationDocument = gql`
    query getChannelNotification($id: ID!) {
  channelNotificationById(id: $id) {
    ...ChannelNotificationFields
  }
}
    ${ChannelNotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChannelNotificationGQL extends Apollo.Query<GetChannelNotificationQuery, GetChannelNotificationQueryVariables> {
    document = GetChannelNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationRulesDocument = gql`
    query NotificationRules($notificationSlugs: [NotificationSlugEnum!]!) {
  notificationRules(notificationSlugs: $notificationSlugs) {
    ...NotificationRuleFields
  }
}
    ${NotificationRuleFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationRulesGQL extends Apollo.Query<NotificationRulesQuery, NotificationRulesQueryVariables> {
    document = NotificationRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($ids: [ID!]!) {
  markNotificationsAsRead(ids: $ids) {
    ids
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkNotificationsAsReadGQL extends Apollo.Mutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables> {
    document = MarkNotificationsAsReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkNotificationsAsUnreadDocument = gql`
    mutation MarkNotificationsAsUnread($ids: [ID!]!) {
  markNotificationsAsUnread(ids: $ids) {
    ids
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkNotificationsAsUnreadGQL extends Apollo.Mutation<MarkNotificationsAsUnreadMutation, MarkNotificationsAsUnreadMutationVariables> {
    document = MarkNotificationsAsUnreadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveNotificationsDocument = gql`
    mutation ArchiveNotifications($ids: [ID!]!) {
  archiveNotifications(ids: $ids) {
    ids
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveNotificationsGQL extends Apollo.Mutation<ArchiveNotificationsMutation, ArchiveNotificationsMutationVariables> {
    document = ArchiveNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubscribeToNotificationRulesDocument = gql`
    mutation subscribeToNotificationRules($notificationRuleSubscriptionAttributes: [NotificationRuleSubscriptionAttributes!]!) {
  subscribeToNotificationRules(
    notificationRuleSubscriptionAttributes: $notificationRuleSubscriptionAttributes
  ) {
    notificationRuleSubscriptions {
      ...NotificationRuleSubscriptionFields
    }
    errors
  }
}
    ${NotificationRuleSubscriptionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscribeToNotificationRulesGQL extends Apollo.Mutation<SubscribeToNotificationRulesMutation, SubscribeToNotificationRulesMutationVariables> {
    document = SubscribeToNotificationRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecentRootOffersDocument = gql`
    query RecentRootOffers {
  recentRootOffers {
    ...offerFields
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RecentRootOffersGQL extends Apollo.Query<RecentRootOffersQuery, RecentRootOffersQueryVariables> {
    document = RecentRootOffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OffersDocument = gql`
    query Offers($filterAttributes: OfferFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  offers(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...offerFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OffersGQL extends Apollo.Query<OffersQuery, OffersQueryVariables> {
    document = OffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CounterOffersDocument = gql`
    query CounterOffers($filterAttributes: OfferFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String, $currency: CurrencyEnum, $incoterm: IncotermWithNscEnum, $unit: String) {
  counterOffers(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...offerFields
      offerItems {
        offerItemPrices {
          expectedReturnSummary(currency: $currency, incoterm: $incoterm, unit: $unit) {
            ...offerItemPriceExpectedReturnFields
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${OfferFieldsFragmentDoc}
${OfferItemPriceExpectedReturnFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CounterOffersGQL extends Apollo.Query<CounterOffersQuery, CounterOffersQueryVariables> {
    document = CounterOffersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferFilterAttributesDocument = gql`
    query OfferFilterAttributes {
  offerFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    varieties {
      id
      name
      varietyCode
    }
    tradeRegions {
      id
      name
      code
    }
    portsOfDestination {
      ...portDisplayFields
    }
  }
}
    ${PortDisplayFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferFilterAttributesGQL extends Apollo.Query<OfferFilterAttributesQuery, OfferFilterAttributesQueryVariables> {
    document = OfferFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferByIdDocument = gql`
    query OfferById($id: ID!) {
  offerById(id: $id) {
    ...offerFields
    rootOffer {
      id
      companyId
      offerItems {
        ...offerItemFields
      }
    }
  }
}
    ${OfferFieldsFragmentDoc}
${OfferItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferByIdGQL extends Apollo.Query<OfferByIdQuery, OfferByIdQueryVariables> {
    document = OfferByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OfferHistoryByIdDocument = gql`
    query OfferHistoryById($id: ID!) {
  offerHistoryById(id: $id) {
    id
    currency
    companyId
    company {
      id
      name
    }
    createdAt
    quantity
    offerItems {
      id
      sizeCounts
      offerItemPrices {
        id
        cifPriceAmountMajorUnit
        portOfDestinationId
      }
    }
    offerRecipients {
      id
      buyer {
        id
        name
      }
      portOfDestinationId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OfferHistoryByIdGQL extends Apollo.Query<OfferHistoryByIdQuery, OfferHistoryByIdQueryVariables> {
    document = OfferHistoryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOfferAsSupplierDocument = gql`
    mutation CreateOfferAsSupplier($attributes: OfferAttributes!) {
  createOfferAsSupplier(attributes: $attributes) {
    offer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOfferAsSupplierGQL extends Apollo.Mutation<CreateOfferAsSupplierMutation, CreateOfferAsSupplierMutationVariables> {
    document = CreateOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloseOfferAsSupplierDocument = gql`
    mutation CloseOfferAsSupplier($offerId: ID!) {
  closeOfferAsSupplier(offerId: $offerId) {
    offer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CloseOfferAsSupplierGQL extends Apollo.Mutation<CloseOfferAsSupplierMutation, CloseOfferAsSupplierMutationVariables> {
    document = CloseOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectOfferAsSupplierDocument = gql`
    mutation RejectOfferAsSupplier($counterOfferId: ID!) {
  rejectOfferAsSupplier(counterOfferId: $counterOfferId) {
    counterOffer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectOfferAsSupplierGQL extends Apollo.Mutation<RejectOfferAsSupplierMutation, RejectOfferAsSupplierMutationVariables> {
    document = RejectOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptOfferAsSupplierDocument = gql`
    mutation AcceptOfferAsSupplier($counterOfferId: ID!) {
  acceptOfferAsSupplier(counterOfferId: $counterOfferId) {
    counterOffer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptOfferAsSupplierGQL extends Apollo.Mutation<AcceptOfferAsSupplierMutation, AcceptOfferAsSupplierMutationVariables> {
    document = AcceptOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCounterOfferAsSupplierDocument = gql`
    mutation CreateCounterOfferAsSupplier($previousOfferId: ID!, $attributes: CounterOfferAttributes!) {
  createCounterOfferAsSupplier(
    previousOfferId: $previousOfferId
    attributes: $attributes
  ) {
    counterOffer {
      ...offerFields
    }
    errors
  }
}
    ${OfferFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCounterOfferAsSupplierGQL extends Apollo.Mutation<CreateCounterOfferAsSupplierMutation, CreateCounterOfferAsSupplierMutationVariables> {
    document = CreateCounterOfferAsSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnWhatsappInteractionFailedToDeliverDocument = gql`
    subscription onWhatsappInteractionFailedToDeliver {
  onWhatsappInteractionFailedToDeliver {
    id
    offerRecipientId
    buyerName
    buyerId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnWhatsappInteractionFailedToDeliverGQL extends Apollo.Subscription<OnWhatsappInteractionFailedToDeliverSubscription, OnWhatsappInteractionFailedToDeliverSubscriptionVariables> {
    document = OnWhatsappInteractionFailedToDeliverDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyOnboardingStepDocument = gql`
    mutation UpdateCompanyOnboardingStep($onboardingStep: CompanyOnboardingStepEnum!) {
  updateCompanyOnboardingStep(onboardingStep: $onboardingStep) {
    errors
    company {
      id
      onboardingStep
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyOnboardingStepGQL extends Apollo.Mutation<UpdateCompanyOnboardingStepMutation, UpdateCompanyOnboardingStepMutationVariables> {
    document = UpdateCompanyOnboardingStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramsDocument = gql`
    query OrderPrograms($filterAttributes: OrderProgramFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $orderProgramIds: [ID!]) {
  orderPrograms(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    orderProgramIds: $orderProgramIds
  ) {
    batchNumber
    cartonCountId
    cartonTypeId
    cartonTypeName
    commodity {
      id
      name
    }
    commodityId
    commodityName
    companyId
    companyLogoImageUrl
    companyName
    createdAt
    currency
    grade
    hiddenFields
    id
    incoterm
    inventoryCode
    mark
    portOfDestination {
      id
      name
      displayName
      createdAt
      updatedAt
    }
    portOfDestinationId
    portOfDestinationName
    portOfLoading {
      id
      name
      displayName
      createdAt
      updatedAt
    }
    portOfLoadingId
    portOfLoadingName
    priceTerm
    priceUnit
    priceAmountMajorUnit
    priority
    programId
    programName
    programVisibility
    quantityUnit
    quantity
    referenceNumber
    sizeCounts
    stackSize
    targetMarket
    tradeCountryId
    tradeCountryCode
    tradeCountryName
    tradeRegionId
    tradeRegionCode
    tradeRegionName
    updatedAt
    varietyCode
    varietyId
    varietyName
    variety {
      id
      name
      varietyCode
    }
    additionalFields
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramsGQL extends Apollo.Query<OrderProgramsQuery, OrderProgramsQueryVariables> {
    document = OrderProgramsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramCommoditiesDocument = gql`
    query OrderProgramCommodities($onlyOperational: Boolean) {
  commodities(onlyOperational: $onlyOperational) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramCommoditiesGQL extends Apollo.Query<OrderProgramCommoditiesQuery, OrderProgramCommoditiesQueryVariables> {
    document = OrderProgramCommoditiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramVarietiesDocument = gql`
    query OrderProgramVarieties($onlyOperational: Boolean, $skipMixedVarieties: Boolean, $commodityId: ID) {
  varieties(
    onlyOperational: $onlyOperational
    skipMixedVarieties: $skipMixedVarieties
    commodityId: $commodityId
  ) {
    id
    name
    varietyCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramVarietiesGQL extends Apollo.Query<OrderProgramVarietiesQuery, OrderProgramVarietiesQueryVariables> {
    document = OrderProgramVarietiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramSeaPortDocument = gql`
    query OrderProgramSeaPort($seaPortId: ID!) {
  seaPort(seaPortId: $seaPortId) {
    id
    name
    country
    displayName
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramSeaPortGQL extends Apollo.Query<OrderProgramSeaPortQuery, OrderProgramSeaPortQueryVariables> {
    document = OrderProgramSeaPortDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramSeaPortsDocument = gql`
    query OrderProgramSeaPorts($filterAttributes: SeaPortFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  seaPortsV2(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    id
    name
    country
    displayName
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramSeaPortsGQL extends Apollo.Query<OrderProgramSeaPortsQuery, OrderProgramSeaPortsQueryVariables> {
    document = OrderProgramSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderProgramTradeCountriesDocument = gql`
    query OrderProgramTradeCountries($tradeRegionId: ID) {
  tradeCountries(tradeRegionId: $tradeRegionId) {
    id
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderProgramTradeCountriesGQL extends Apollo.Query<OrderProgramTradeCountriesQuery, OrderProgramTradeCountriesQueryVariables> {
    document = OrderProgramTradeCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderProgramDocument = gql`
    mutation CreateOrderProgram($attributes: OrderProgramAttributes!) {
  createOrderProgram(attributes: $attributes) {
    errors
    orderProgram {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderProgramGQL extends Apollo.Mutation<CreateOrderProgramMutation, CreateOrderProgramMutationVariables> {
    document = CreateOrderProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrderProgramDocument = gql`
    mutation UpdateOrderProgram($orderProgramId: ID!, $attributes: OrderProgramAttributes!) {
  updateOrderProgram(orderProgramId: $orderProgramId, attributes: $attributes) {
    errors
    orderProgram {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrderProgramGQL extends Apollo.Mutation<UpdateOrderProgramMutation, UpdateOrderProgramMutationVariables> {
    document = UpdateOrderProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrderProgramDocument = gql`
    mutation DeleteOrderProgram($orderProgramId: ID!) {
  deleteOrderProgram(orderProgramId: $orderProgramId) {
    errors
    orderProgram {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrderProgramGQL extends Apollo.Mutation<DeleteOrderProgramMutation, DeleteOrderProgramMutationVariables> {
    document = DeleteOrderProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineItemsDocument = gql`
    query LineItems($filterAttributes: LineItemFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  lineItems(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...singleLineItemFields
      ...expectedNetReturnFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${ExpectedNetReturnFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LineItemsGQL extends Apollo.Query<LineItemsQuery, LineItemsQueryVariables> {
    document = LineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersV3Document = gql`
    query OrdersV3($filterAttributes: OrderFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  ordersV3(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      id
      seller {
        id
        name
      }
      state
      updatedAt
      buyer {
        id
        name
      }
      createdAt
      lineItemGroupings {
        commonFields
        cumulativeQuantity
        cumulativeTooltip
        deleted
        id
        lineItems {
          ...singleLineItemFields
          ...statesDistributionFields
        }
        numberCumulativeSiblings
        quantityType
        rank
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${SingleLineItemFieldsFragmentDoc}
${StatesDistributionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersV3GQL extends Apollo.Query<OrdersV3Query, OrdersV3QueryVariables> {
    document = OrdersV3Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LineItemsFilterAttributesDocument = gql`
    query LineItemsFilterAttributes {
  lineItemsFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    sellers {
      id
      name
    }
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LineItemsFilterAttributesGQL extends Apollo.Query<LineItemsFilterAttributesQuery, LineItemsFilterAttributesQueryVariables> {
    document = LineItemsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersFilterAttributesDocument = gql`
    query OrdersFilterAttributes {
  ordersFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    sellers {
      id
      name
    }
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersFilterAttributesGQL extends Apollo.Query<OrdersFilterAttributesQuery, OrdersFilterAttributesQueryVariables> {
    document = OrdersFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuantityTypeDocument = gql`
    query quantityType {
  quantityType
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuantityTypeGQL extends Apollo.Query<QuantityTypeQuery, QuantityTypeQueryVariables> {
    document = QuantityTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation CreateOrder($attributes: CreateOrderAttributes!, $lineItemStates: [String!], $packingWeekStart: String, $packingWeekEnd: String, $varietyIds: [Int!], $commodityIds: [Int!], $subCommodityIds: [Int!], $states: [StateFilter!], $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  createOrder(attributes: $attributes) {
    order {
      ...multipleOrderFields
    }
    errors
  }
}
    ${MultipleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderGQL extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
    document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersSearchDocument = gql`
    query OrdersSearch($limit: Int!, $skip: Int!, $filter: OrderFilter!, $lineItemStates: [String!], $packingWeekStart: String, $packingWeekEnd: String, $varietyIds: [Int!], $commodityIds: [Int!], $subCommodityIds: [Int!], $states: [StateFilter!], $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  ordersSearch(filter: $filter) {
    orders(limit: $limit, skip: $skip) {
      ...multipleOrderFields
    }
    totalOrders
    totalFiltered
  }
}
    ${MultipleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersSearchGQL extends Apollo.Query<OrdersSearchQuery, OrdersSearchQueryVariables> {
    document = OrdersSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersSearchFilterAttributesDocument = gql`
    query ordersSearchFilterAttributes {
  ordersSearchFilterAttributes {
    commodities {
      id
      name
    }
    varieties {
      id
      name
    }
    subCommodities {
      id
      name
    }
    companies {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersSearchFilterAttributesGQL extends Apollo.Query<OrdersSearchFilterAttributesQuery, OrdersSearchFilterAttributesQueryVariables> {
    document = OrdersSearchFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderDocument = gql`
    query Order($id: ID!, $currency: CurrencyEnum, $unit: String, $incoterm: IncotermWithNscEnum) {
  order(id: $id) {
    ...singleOrderFieldsWithNetReturn
  }
}
    ${SingleOrderFieldsWithNetReturnFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderGQL extends Apollo.Query<OrderQuery, OrderQueryVariables> {
    document = OrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateOrderDocument = gql`
    query DuplicateOrder($id: ID!) {
  order(id: $id) {
    ...duplicateOrderFields
  }
}
    ${DuplicateOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateOrderGQL extends Apollo.Query<DuplicateOrderQuery, DuplicateOrderQueryVariables> {
    document = DuplicateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($attributes: UpdateOrderAttributes!) {
  updateOrder(attributes: $attributes) {
    order {
      ...singleOrderFields
    }
    errors
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrderGQL extends Apollo.Mutation<UpdateOrderMutation, UpdateOrderMutationVariables> {
    document = UpdateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLineItemsDocument = gql`
    mutation UpdateLineItems($attributes: [UpdateLineItemAttributes!]!) {
  updateLineItems(attributes: $attributes) {
    lineItems {
      ...singleLineItemFields
    }
    errors
  }
}
    ${SingleLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLineItemsGQL extends Apollo.Mutation<UpdateLineItemsMutation, UpdateLineItemsMutationVariables> {
    document = UpdateLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptLineItemsDocument = gql`
    mutation AcceptLineItems($ids: [Int!]!) {
  acceptLineItems(ids: $ids) {
    orders {
      ...singleOrderFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptLineItemsGQL extends Apollo.Mutation<AcceptLineItemsMutation, AcceptLineItemsMutationVariables> {
    document = AcceptLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WontPackLineItemsDocument = gql`
    mutation WontPackLineItems($ids: [Int!]!) {
  wontPackLineItems(ids: $ids) {
    orders {
      ...singleOrderFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class WontPackLineItemsGQL extends Apollo.Mutation<WontPackLineItemsMutation, WontPackLineItemsMutationVariables> {
    document = WontPackLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevertLineItemsToCreatedDocument = gql`
    mutation RevertLineItemsToCreated($ids: [Int!]!) {
  revertLineItemsToCreated(ids: $ids) {
    orders {
      ...singleOrderFields
    }
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevertLineItemsToCreatedGQL extends Apollo.Mutation<RevertLineItemsToCreatedMutation, RevertLineItemsToCreatedMutationVariables> {
    document = RevertLineItemsToCreatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevertOrderChangeDocument = gql`
    mutation RevertOrderChange($startid: Int!, $endid: Int!, $orderid: Int!) {
  revertOrderChange(startId: $startid, endId: $endid, orderId: $orderid) {
    order {
      ...singleOrderFields
    }
    errors
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevertOrderChangeGQL extends Apollo.Mutation<RevertOrderChangeMutation, RevertOrderChangeMutationVariables> {
    document = RevertOrderChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadOrderShipmentDocumentDocument = gql`
    mutation UploadOrderShipmentDocument($orderid: Int!, $type: String!, $file: Upload!) {
  uploadOrderShipmentDocument(orderid: $orderid, type: $type, file: $file) {
    order {
      shipmentDocuments {
        ...shipmentDocumentFields
      }
    }
  }
}
    ${ShipmentDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadOrderShipmentDocumentGQL extends Apollo.Mutation<UploadOrderShipmentDocumentMutation, UploadOrderShipmentDocumentMutationVariables> {
    document = UploadOrderShipmentDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewOrderDocument = gql`
    subscription NewOrder {
  newOrder {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NewOrderGQL extends Apollo.Subscription<NewOrderSubscription, NewOrderSubscriptionVariables> {
    document = NewOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAcceptLineItemsDocument = gql`
    subscription OnAcceptLineItems {
  onAcceptLineItems {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAcceptLineItemsGQL extends Apollo.Subscription<OnAcceptLineItemsSubscription, OnAcceptLineItemsSubscriptionVariables> {
    document = OnAcceptLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnWontPackLineItemsDocument = gql`
    subscription OnWontPackLineItems {
  onWontPackLineItems {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnWontPackLineItemsGQL extends Apollo.Subscription<OnWontPackLineItemsSubscription, OnWontPackLineItemsSubscriptionVariables> {
    document = OnWontPackLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnRevertLineItemsToCreatedDocument = gql`
    subscription OnRevertLineItemsToCreated {
  onRevertLineItemsToCreated {
    ...singleOrderFields
  }
}
    ${SingleOrderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnRevertLineItemsToCreatedGQL extends Apollo.Subscription<OnRevertLineItemsToCreatedSubscription, OnRevertLineItemsToCreatedSubscriptionVariables> {
    document = OnRevertLineItemsToCreatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackInstructionsLineItemsDocument = gql`
    query PackInstructionsLineItems($attributes: PackInstructionsAttributes!) {
  packInstructions(attributes: $attributes) {
    groupId
    priority
    batchNumber
    buyer
    comments {
      commentText
      id
      userId
      commentableType
      user {
        avatarFile {
          id
          filename
          url
        }
        firstName
        lastName
        id
      }
      updatedAt
      isDeleted
      createdAt
      commentableId
    }
    commodity
    grade
    id
    inventoryCode
    mark
    orderId
    pack
    packingWeek
    palletStack
    quantitesPacked
    quantityRequested
    quantityUnit
    referenceNumber
    seller
    sizeCounts
    state
    subCommodity
    targetMarket
    targetRegion
    targetCountry
    variety
    varietyCode
    additionalFields
    incoterm
    priceUnit
    priceMajorUnit
    currency
    priceTerm
    formattedPrice
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PackInstructionsLineItemsGQL extends Apollo.Query<PackInstructionsLineItemsQuery, PackInstructionsLineItemsQueryVariables> {
    document = PackInstructionsLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackInstructionsFilterAttributesDocument = gql`
    query PackInstructionsFilterAttributes {
  packInstructionsFilterAttributes {
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    sellers {
      id
      name
    }
    subCommodities {
      id
      name
    }
    varieties {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PackInstructionsFilterAttributesGQL extends Apollo.Query<PackInstructionsFilterAttributesQuery, PackInstructionsFilterAttributesQueryVariables> {
    document = PackInstructionsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnePackClientCodesDocument = gql`
    query OnePackClientCodes {
  onepackClientCodes {
    id
    clientCode
    label
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnePackClientCodesGQL extends Apollo.Query<OnePackClientCodesQuery, OnePackClientCodesQueryVariables> {
    document = OnePackClientCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnepackSyncCallsDocument = gql`
    query OnepackSyncCalls($clientCode: String, $limit: Int) {
  onepackPackInstructionSyncCalls(clientCode: $clientCode, limit: $limit) {
    id
    clientCode
    url
    message
    statusCode
    syncSucceeded
    itemsCount
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnepackSyncCallsGQL extends Apollo.Query<OnepackSyncCallsQuery, OnepackSyncCallsQueryVariables> {
    document = OnepackSyncCallsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePackInstructionLineItemPriorityDocument = gql`
    mutation updatePackInstructionLineItemPriority($packInstructionLineItemId: ID!, $priority: Int) {
  updatePackInstructionLineItemPriority(
    packInstructionLineItemId: $packInstructionLineItemId
    priority: $priority
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePackInstructionLineItemPriorityGQL extends Apollo.Mutation<UpdatePackInstructionLineItemPriorityMutation, UpdatePackInstructionLineItemPriorityMutationVariables> {
    document = UpdatePackInstructionLineItemPriorityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PushPackInstructionsToOnepackDocument = gql`
    mutation pushPackInstructionsToOnepack($clientCode: String!, $packInstructionsAttributes: PackInstructionsAttributes!) {
  pushPackInstructionsToOnepack(
    clientCode: $clientCode
    packInstructionsAttributes: $packInstructionsAttributes
  ) {
    success
    message
    isPlatformError
    packInstructionRef
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PushPackInstructionsToOnepackGQL extends Apollo.Mutation<PushPackInstructionsToOnepackMutation, PushPackInstructionsToOnepackMutationVariables> {
    document = PushPackInstructionsToOnepackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackhouseConnectionsDocument = gql`
    query PackhouseConnections {
  packhouseConnections {
    id
    name
    state
    scheduledFor
    scheduledAt
    createdAt
    updatedAt
    apiUserId
    connected
    lastProcessedDatetime
    onPremSystem
    company {
      ...companyFields
    }
    foodBusinessOperator {
      ...foodBusinessOperatorFields
    }
    masterfileConfig {
      ...masterfileConfigFields
    }
  }
}
    ${CompanyFieldsFragmentDoc}
${FoodBusinessOperatorFieldsFragmentDoc}
${MasterfileConfigFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PackhouseConnectionsGQL extends Apollo.Query<PackhouseConnectionsQuery, PackhouseConnectionsQueryVariables> {
    document = PackhouseConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PackhouseConnectionsClientChangeRequestsDocument = gql`
    query PackhouseConnectionsClientChangeRequests {
  packhouseConnectionsClientChangeRequests {
    id
    foodBusinessOperator {
      id
      name
      fboCode
      producerName
      typeOfBusiness
      productionRegion
      company {
        id
        name
      }
      createdAt
      updatedAt
    }
    company {
      ...companyFields
    }
    createdAt
    updatedAt
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PackhouseConnectionsClientChangeRequestsGQL extends Apollo.Query<PackhouseConnectionsClientChangeRequestsQuery, PackhouseConnectionsClientChangeRequestsQueryVariables> {
    document = PackhouseConnectionsClientChangeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePackhouseConnectionsRequestDocument = gql`
    mutation CreatePackhouseConnectionsRequest($attributes: CreatePackhouseConnectionsAttribute!) {
  createPackhouseConnectionsRequest(attributes: $attributes) {
    clientChangeRequests {
      id
      foodBusinessOperator {
        id
        name
        fboCode
        producerName
        typeOfBusiness
        productionRegion
        company {
          id
          name
        }
        createdAt
        updatedAt
      }
      company {
        ...companyFields
      }
      createdAt
      updatedAt
    }
    errors
  }
}
    ${CompanyFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePackhouseConnectionsRequestGQL extends Apollo.Mutation<CreatePackhouseConnectionsRequestMutation, CreatePackhouseConnectionsRequestMutationVariables> {
    document = CreatePackhouseConnectionsRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentDocument = gql`
    query Payment($id: ID!) {
  payment(id: $id) {
    totalAmountMajorUnit
    allocatedAmountMajorUnit
    remainingAmountMajorUnit
    bankChargesMajorUnit
    bankChargesSplit
    cashbookReference
    companyName
    companyId
    createdAt
    currency
    description
    id
    contactName
    contactId
    paymentDate
    paymentType
    updatedAt
    state
    invoices {
      id
      invoiceNumber
      documentType
      currency
      allocatedAmountMajorUnit
      remainingAmountMajorUnit
      containerNumbers
      state
      totalIncoterm
      remittableAmountMajorUnit
      updatedAt
      invoicePayments {
        id
        invoiceId
        paymentId
        amountMajorUnit
      }
    }
    invoicePaymentAllocations {
      invoiceId
      totalAmountMajorUnit
    }
    currencyExchangeRate {
      id
      fromCurrency
      toCurrency
      exchangeRate
      exchangeRateDate
      exchangeRateType
      currencyConversion {
        id
        rates
        timestamp
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentGQL extends Apollo.Query<PaymentQuery, PaymentQueryVariables> {
    document = PaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentsDocument = gql`
    query Payments($filterAttributes: PaymentsFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  payments(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      totalAmountMajorUnit
      allocatedAmountMajorUnit
      remainingAmountMajorUnit
      bankChargesMajorUnit
      bankChargesSplit
      cashbookReference
      companyName
      companyId
      createdAt
      currency
      description
      id
      contactName
      contactId
      paymentDate
      paymentType
      updatedAt
      state
      exchangeRate
      currencyExchangeRate {
        id
        fromCurrency
        toCurrency
        exchangeRate
        exchangeRateDate
        exchangeRateType
        currencyConversion {
          id
          rates
          timestamp
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentsGQL extends Apollo.Query<PaymentsQuery, PaymentsQueryVariables> {
    document = PaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentsFilterAttributesDocument = gql`
    query PaymentsFilterAttributes {
  paymentsFilterAttributes {
    contacts {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentsFilterAttributesGQL extends Apollo.Query<PaymentsFilterAttributesQuery, PaymentsFilterAttributesQueryVariables> {
    document = PaymentsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyPaymentsDocument = gql`
    query CompanyPayments($filterAttributes: CompanyPaymentFilters, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  companyPayments(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    incomingAmountDueMajorUnit
    outgoingAmountDueMajorUnit
    currency
    companyName
    companyId
    invoicesDue
    contactName
    contactId
    incomingUnallocatedAmountMajorUnit
    outgoingUnallocatedAmountMajorUnit
    unallocatedPayments
    contact {
      id
      name
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyPaymentsGQL extends Apollo.Query<CompanyPaymentsQuery, CompanyPaymentsQueryVariables> {
    document = CompanyPaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyPaymentsFilterAttributesDocument = gql`
    query CompanyPaymentsFilterAttributes {
  companyPaymentsFilterAttributes {
    contacts {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyPaymentsFilterAttributesGQL extends Apollo.Query<CompanyPaymentsFilterAttributesQuery, CompanyPaymentsFilterAttributesQueryVariables> {
    document = CompanyPaymentsFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoicesDocument = gql`
    query Invoices($filterAttributes: InvoicesFilters!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $page: String!, $first: Int, $last: Int, $after: String, $before: String) {
  invoices(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    page: $page
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      id
      invoiceNumber
      documentType
      currency
      allocatedAmountMajorUnit
      remainingAmountMajorUnit
      remittableAmountMajorUnit
      containerNumbers
      state
      totalIncoterm
      updatedAt
      invoicePayments {
        id
        invoiceId
        paymentId
        amountMajorUnit
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoicesGQL extends Apollo.Query<InvoicesQuery, InvoicesQueryVariables> {
    document = InvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePaymentDocument = gql`
    mutation CreatePayment($attributes: PaymentAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  createPayment(
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    payment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePaymentGQL extends Apollo.Mutation<CreatePaymentMutation, CreatePaymentMutationVariables> {
    document = CreatePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($paymentId: ID!, $attributes: PaymentAttributes!, $currencyExchangeRateAttributes: CurrencyExchangeRateAttributes) {
  updatePayment(
    paymentId: $paymentId
    attributes: $attributes
    currencyExchangeRateAttributes: $currencyExchangeRateAttributes
  ) {
    errors
    payment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePaymentGQL extends Apollo.Mutation<UpdatePaymentMutation, UpdatePaymentMutationVariables> {
    document = UpdatePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePaymentDocument = gql`
    mutation DeletePayment($paymentId: ID!) {
  deletePayment(paymentId: $paymentId) {
    errors
    payment {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePaymentGQL extends Apollo.Mutation<DeletePaymentMutation, DeletePaymentMutationVariables> {
    document = DeletePaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocatePaymentsDocument = gql`
    mutation AllocatePayments($paymentAllocations: [PaymentAllocationAttributes!]!) {
  allocatePayments(paymentAllocations: $paymentAllocations) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocatePaymentsGQL extends Apollo.Mutation<AllocatePaymentsMutation, AllocatePaymentsMutationVariables> {
    document = AllocatePaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PnlLinkedRecordsDocument = gql`
    query PnlLinkedRecords($cartonGroupingIds: [Int!], $containerIds: [Int!], $breakBulkContainerIds: [Int!], $reportingCurrency: String, $fxEnabled: Boolean) {
  pnlLinkedRecords(
    cartonGroupingIds: $cartonGroupingIds
    containerIds: $containerIds
    breakBulkContainerIds: $breakBulkContainerIds
    reportingCurrency: $reportingCurrency
    fxEnabled: $fxEnabled
  ) {
    id
    recordType
    invoiceNumber
    documentType
    rawDocumentType
    state
    date
    currency
    amountMajorUnit
    isPayment
    contactName
    exchangeRateToReporting
    invoiceExchangeRate
    cartons
    cgCount
    downloadUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PnlLinkedRecordsGQL extends Apollo.Query<PnlLinkedRecordsQuery, PnlLinkedRecordsQueryVariables> {
    document = PnlLinkedRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfitAndLossReportDocument = gql`
    query ProfitAndLossReport($filters: ProfitAndLossFilters!) {
  profitAndLossReport(filters: $filters) {
    nodes {
      farmCode
      orchard
      containerNumber
      commodity
      variety
      packType
      sizeCount
      grade
      targetRegion
      targetMarket
      targetCountry
      buyerName
      sellerName
      batchNumber
      palletNumber
      exporterCode
      mark
      inventoryCode
      packingWeek
      voyageNumber
      extendedFields
      totalCartons
      totalStdCartons
      totalKilograms
      cgCount
      palletCount
      shippingWeek
      arrivalWeek
      dischargePort
      vesselName
      incoterm
      contractCurrency
      invoiceExchangeRate
      paymentAdviceNumber
      poNumber
      allOnStatement
      paymentAdviceDownloadUrl
      revenue
      cifCosts
      netCif
      fobCosts
      netFob
      dipCosts
      netDip
      exwCosts
      netExw
      growerFinalPayment
      overseasCosts
      localCosts
      revenueAdvance
      revenueFinal
      revenueCreditNote
      revenueDebitNote
      revenuePerCarton
      revenuePerStdCarton
      revenuePerKg
      netCifPerCarton
      netCifPerStdCarton
      netFobPerCarton
      netFobPerStdCarton
      netDipPerCarton
      netDipPerStdCarton
      netExwPerCarton
      netExwPerStdCarton
      cashReceived
      accountsReceivable
      cashReceivedPerCarton
      cashReceivedPerStdCarton
      revenueInclVat
      cifCostsInclVat
      fobCostsInclVat
      dipCostsInclVat
      exwCostsInclVat
      netCifInclVat
      netFobInclVat
      netDipInclVat
      netExwInclVat
      overseasCostsInclVat
      localCostsInclVat
      vatTotalRevenue
      vatTotalCosts
      revenueInclVatPerCarton
      revenueInclVatPerStdCarton
      revenueInclVatPerKg
      netCifInclVatPerCarton
      netCifInclVatPerStdCarton
      netFobInclVatPerCarton
      netFobInclVatPerStdCarton
      netDipInclVatPerCarton
      netDipInclVatPerStdCarton
      netExwInclVatPerCarton
      netExwInclVatPerStdCarton
      costBreakdown
      linkedRecordsCount
      linkedCgIds
      linkedContainerIds
      linkedBbcIds
    }
    pageInfo {
      hasNextPage
    }
    meta {
      rowCount
      sqlMs
      totalMs
      reportingCurrency
      costCategories {
        key
        label
        section
      }
      extendedFieldKeys
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfitAndLossReportGQL extends Apollo.Query<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables> {
    document = ProfitAndLossReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueueProfitAndLossReportDocument = gql`
    mutation QueueProfitAndLossReport($requestId: String!, $filters: ProfitAndLossFilters!) {
  queueProfitAndLossReport(requestId: $requestId, filters: $filters) {
    __typename
    requestId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueueProfitAndLossReportGQL extends Apollo.Mutation<QueueProfitAndLossReportMutation, QueueProfitAndLossReportMutationVariables> {
    document = QueueProfitAndLossReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfitAndLossReportOutcomeDocument = gql`
    query ProfitAndLossReportOutcome($requestId: String!) {
  profitAndLossReportOutcome(requestId: $requestId) {
    ... on ProfitAndLossReportPending {
      __typename
      requestId
    }
    ... on ProfitAndLossReportNotFound {
      __typename
      requestId
    }
    ... on ProfitAndLossReportCompleted {
      __typename
      requestId
      report {
        ...ProfitAndLossReportFields
      }
    }
    ... on ProfitAndLossReportError {
      __typename
      requestId
      error
    }
  }
}
    ${ProfitAndLossReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfitAndLossReportOutcomeGQL extends Apollo.Query<ProfitAndLossReportOutcomeQuery, ProfitAndLossReportOutcomeQueryVariables> {
    document = ProfitAndLossReportOutcomeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnProfitAndLossReportCompleteDocument = gql`
    subscription OnProfitAndLossReportComplete($requestId: String!) {
  onProfitAndLossReportComplete(requestId: $requestId) {
    ... on ProfitAndLossReportPending {
      __typename
      requestId
    }
    ... on ProfitAndLossReportNotFound {
      __typename
      requestId
    }
    ... on ProfitAndLossReportCompleted {
      __typename
      requestId
      report {
        ...ProfitAndLossReportFields
      }
    }
    ... on ProfitAndLossReportError {
      __typename
      requestId
      error
    }
  }
}
    ${ProfitAndLossReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnProfitAndLossReportCompleteGQL extends Apollo.Subscription<OnProfitAndLossReportCompleteSubscription, OnProfitAndLossReportCompleteSubscriptionVariables> {
    document = OnProfitAndLossReportCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProfitAndLossFilterAttributesDocument = gql`
    query ProfitAndLossFilterAttributes {
  profitAndLossFilterAttributes {
    extendedFieldKeys {
      key
      label
      values
    }
    farmCodes
    orchards
    containers {
      id
      name
    }
    vessels {
      id
      name
    }
    commodities {
      id
      name
    }
    varieties {
      id
      name
    }
    buyers {
      id
      name
    }
    sellers {
      id
      name
    }
    grades
    targetRegions
    targetMarkets
    targetCountries
    packTypes
    sizeCounts
    marks
    exporterCodes
    inventoryCodes
    poNumbers
    financialYearOptions {
      year
      label
      startDate
      endDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProfitAndLossFilterAttributesGQL extends Apollo.Query<ProfitAndLossFilterAttributesQuery, ProfitAndLossFilterAttributesQueryVariables> {
    document = ProfitAndLossFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunReportDocument = gql`
    query runReport($reportId: Int!, $gridRequest: GridRequest, $reportFilters: [Filter!], $outputType: RunReportOutputTypeEnum) {
  runReport(
    id: $reportId
    gridRequest: $gridRequest
    reportFilters: $reportFilters
    outputType: $outputType
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunReportGQL extends Apollo.Query<RunReportQuery, RunReportQueryVariables> {
    document = RunReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RunReportAsyncDocument = gql`
    query runReportAsync($reportId: Int!, $gridRequest: GridRequest, $reportFilters: [Filter!], $requestUuid: String!) {
  runReportAsync(
    id: $reportId
    gridRequest: $gridRequest
    reportFilters: $reportFilters
    requestUuid: $requestUuid
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RunReportAsyncGQL extends Apollo.Query<RunReportAsyncQuery, RunReportAsyncQueryVariables> {
    document = RunReportAsyncDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportDocument = gql`
    query report($reportId: Int!) {
  report(id: $reportId) {
    createdAt
    dataPreparationId
    description
    id
    name
    configs {
      name
      value
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGQL extends Apollo.Query<ReportQuery, ReportQueryVariables> {
    document = ReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportGroupsDocument = gql`
    query reportGroups($filterAttributes: ReportGroupFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!]) {
  reportGroups(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
  ) {
    name
    description
    id
    domain
    scope
    badges {
      id
      text
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGroupsGQL extends Apollo.Query<ReportGroupsQuery, ReportGroupsQueryVariables> {
    document = ReportGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportGroupDocument = gql`
    query reportGroup($reportGroupId: Int!) {
  reportGroup(id: $reportGroupId) {
    id
    layout
    name
    description
    configs {
      name
      value
    }
    reports {
      id
      reportType
      name
    }
    switchUnit {
      id
      name
      defaultValue
      switchUnitOptions {
        id
        label
        value
        sortOrder
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGroupGQL extends Apollo.Query<ReportGroupQuery, ReportGroupQueryVariables> {
    document = ReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchReportResultDocument = gql`
    query fetchReportResult($requestUuid: String!) {
  fetchReportResult(requestUuid: $requestUuid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReportResultGQL extends Apollo.Query<FetchReportResultQuery, FetchReportResultQueryVariables> {
    document = FetchReportResultDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportGroupCycleDocument = gql`
    query reportGroupCycle($id: ID!) {
  reportGroupCycle(id: $id) {
    id
    name
    description
    durationSeconds
    items {
      id
      reportGroupId
      params
      reportGroup {
        id
        name
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportGroupCycleGQL extends Apollo.Query<ReportGroupCycleQuery, ReportGroupCycleQueryVariables> {
    document = ReportGroupCycleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateReportGroupDocument = gql`
    mutation createReportGroup($attributes: ReportGroupAttributes!) {
  createReportGroup(attributes: $attributes) {
    errors
    reportGroup {
      description
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReportGroupGQL extends Apollo.Mutation<CreateReportGroupMutation, CreateReportGroupMutationVariables> {
    document = CreateReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReportGroupDocument = gql`
    mutation updateReportGroup($attributes: ReportGroupAttributes!) {
  updateReportGroup(attributes: $attributes) {
    errors
    reportGroup {
      description
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReportGroupGQL extends Apollo.Mutation<UpdateReportGroupMutation, UpdateReportGroupMutationVariables> {
    document = UpdateReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteReportGroupDocument = gql`
    mutation deleteReportGroup($id: Int!) {
  deleteReportGroup(id: $id) {
    success
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReportGroupGQL extends Apollo.Mutation<DeleteReportGroupMutation, DeleteReportGroupMutationVariables> {
    document = DeleteReportGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnReportCompleteDocument = gql`
    subscription onReportComplete {
  onReportComplete {
    requestUuid
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnReportCompleteGQL extends Apollo.Subscription<OnReportCompleteSubscription, OnReportCompleteSubscriptionVariables> {
    document = OnReportCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnRefreshReportDocument = gql`
    subscription onRefreshReport {
  onRefreshReport {
    chartSource
    description
    domain
    id
    name
    displayName
    scope
    url
    powerbiEmbedAttributes {
      embedToken
      embedUrl
      reportId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnRefreshReportGQL extends Apollo.Subscription<OnRefreshReportSubscription, OnRefreshReportSubscriptionVariables> {
    document = OnRefreshReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueueReportGroupOutputFileDocument = gql`
    mutation QueueReportGroupOutputFile($reportGroupId: ID!, $requestId: String!, $queryParams: String) {
  queueReportGroupOutputFile(
    reportGroupId: $reportGroupId
    requestId: $requestId
    queryParams: $queryParams
  ) {
    requestId
    status
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueueReportGroupOutputFileGQL extends Apollo.Mutation<QueueReportGroupOutputFileMutation, QueueReportGroupOutputFileMutationVariables> {
    document = QueueReportGroupOutputFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnReportOutputFileCompleteDocument = gql`
    subscription OnReportOutputFileComplete($requestId: String!) {
  onReportOutputFileComplete(requestId: $requestId) {
    requestId
    status
    pdfUrl
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnReportOutputFileCompleteGQL extends Apollo.Subscription<OnReportOutputFileCompleteSubscription, OnReportOutputFileCompleteSubscriptionVariables> {
    document = OnReportOutputFileCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SettingsDocument = gql`
    query Settings {
  myUser {
    id
    firstName
    lastName
    phoneNumber
    email
    state
    notifyEmail
    notifyBrowserPush
    createdAt
    updatedAt
    useV2
    avatar
    avatarFile {
      id
      filename
      url
    }
    company {
      id
      name
    }
    role
    roles {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SettingsGQL extends Apollo.Query<SettingsQuery, SettingsQueryVariables> {
    document = SettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: Int!, $firstname: String!, $lastname: String!, $phonenumber: String!, $notifyemail: Boolean!, $notifybrowserpush: Boolean!, $usev2: Boolean!) {
  updateUser(
    id: $id
    firstName: $firstname
    lastName: $lastname
    phoneNumber: $phonenumber
    notifyEmail: $notifyemail
    notifyBrowserPush: $notifybrowserpush
    useV2: $usev2
  ) {
    user {
      id
      firstName
      lastName
      phoneNumber
      state
      notifyEmail
      notifyBrowserPush
      useV2
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserNotificationsDocument = gql`
    mutation UpdateUserNotifications($id: Int!, $notifyEmail: Boolean!, $notifyBrowserPush: Boolean!) {
  updateUserNotifications(
    id: $id
    notifyEmail: $notifyEmail
    notifyBrowserPush: $notifyBrowserPush
  ) {
    user {
      id
      notifyEmail
      notifyBrowserPush
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserNotificationsGQL extends Apollo.Mutation<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables> {
    document = UpdateUserNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadUserAvatarDocument = gql`
    mutation UploadUserAvatar($file: Upload!) {
  uploadUserAvatar(file: $file) {
    user {
      avatarFile {
        id
        filename
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadUserAvatarGQL extends Apollo.Mutation<UploadUserAvatarMutation, UploadUserAvatarMutationVariables> {
    document = UploadUserAvatarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShipmentDocumentDocument = gql`
    mutation UpdateShipmentDocument($id: Int!, $type: String!) {
  updateShipmentDocument(id: $id, type: $type) {
    shipmentDocument {
      id
      documentType
      state
      user {
        id
        firstName
        lastName
        company {
          id
        }
      }
      file {
        id
        filename
        v2Url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShipmentDocumentGQL extends Apollo.Mutation<UpdateShipmentDocumentMutation, UpdateShipmentDocumentMutationVariables> {
    document = UpdateShipmentDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteShipmentDocumentDocument = gql`
    mutation DeleteShipmentDocument($id: Int!) {
  deleteShipmentDocument(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteShipmentDocumentGQL extends Apollo.Mutation<DeleteShipmentDocumentMutation, DeleteShipmentDocumentMutationVariables> {
    document = DeleteShipmentDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateShipmentDocument = gql`
    mutation CreateShipment($attributes: ShipmentAttributes!) {
  createShipment(attributes: $attributes) {
    errors
    shipment {
      ...shipmentCommonFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateShipmentGQL extends Apollo.Mutation<CreateShipmentMutation, CreateShipmentMutationVariables> {
    document = CreateShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShipmentDocument = gql`
    mutation UpdateShipment($attributes: ShipmentAttributes!) {
  updateShipment(attributes: $attributes) {
    errors
    shipment {
      ...shipmentCommonFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShipmentGQL extends Apollo.Mutation<UpdateShipmentMutation, UpdateShipmentMutationVariables> {
    document = UpdateShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateShipmentLineItemDocument = gql`
    mutation CreateShipmentLineItem($attributes: ShipmentLineItemAttributes!) {
  createShipmentLineItem(attributes: $attributes) {
    errors
    shipmentLineItem {
      ...sliCommonFields
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateShipmentLineItemGQL extends Apollo.Mutation<CreateShipmentLineItemMutation, CreateShipmentLineItemMutationVariables> {
    document = CreateShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateShipmentLineItemDocument = gql`
    mutation duplicateShipmentLineItem($id: ID!) {
  duplicateShipmentLineItem(id: $id) {
    shipmentLineItems {
      ...sliCommonFields
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateShipmentLineItemGQL extends Apollo.Mutation<DuplicateShipmentLineItemMutation, DuplicateShipmentLineItemMutationVariables> {
    document = DuplicateShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShipmentLineItemDocument = gql`
    mutation UpdateShipmentLineItem($attributes: ShipmentLineItemAttributes!) {
  updateShipmentLineItem(attributes: $attributes) {
    errors
    shipmentLineItem {
      ...sliCommonFields
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShipmentLineItemGQL extends Apollo.Mutation<UpdateShipmentLineItemMutation, UpdateShipmentLineItemMutationVariables> {
    document = UpdateShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportNotificationBookingDocument = gql`
    mutation CreateExportNotificationBooking($id: Int!) {
  createExportNotificationBooking(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportNotificationBookingGQL extends Apollo.Mutation<CreateExportNotificationBookingMutation, CreateExportNotificationBookingMutationVariables> {
    document = CreateExportNotificationBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportNotificationLineItemDocument = gql`
    mutation CreateExportNotificationLineItem($id: Int!) {
  createExportNotificationLineItem(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportNotificationLineItemGQL extends Apollo.Mutation<CreateExportNotificationLineItemMutation, CreateExportNotificationLineItemMutationVariables> {
    document = CreateExportNotificationLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAddendumDocument = gql`
    mutation UpdateAddendum($addendumLineItems: [AddendumLineItemAttributes!]!, $addendumHeader: AddendumHeaderAttributes!) {
  updateAddendum(
    addendumLineItems: $addendumLineItems
    addendumHeader: $addendumHeader
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAddendumGQL extends Apollo.Mutation<UpdateAddendumMutation, UpdateAddendumMutationVariables> {
    document = UpdateAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateAddendumDocument = gql`
    mutation GenerateAddendum($sliIds: [Int!], $bookingReference: String, $shipmentId: ID) {
  generateAddendum(
    sliIds: $sliIds
    bookingReference: $bookingReference
    shipmentId: $shipmentId
  ) {
    errors
    addendumHeader {
      ...addendumHeaderFields
      addendumLineItems {
        ...addendumLineItemFields
      }
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateAddendumGQL extends Apollo.Mutation<GenerateAddendumMutation, GenerateAddendumMutationVariables> {
    document = GenerateAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelAddendumDocument = gql`
    mutation CancelAddendum($id: Int!, $deleteAddendum: Boolean!) {
  cancelAddendum(id: $id, deleteAddendum: $deleteAddendum) {
    id
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelAddendumGQL extends Apollo.Mutation<CancelAddendumMutation, CancelAddendumMutationVariables> {
    document = CancelAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmExportNotificationLineItemDocument = gql`
    mutation ConfirmExportNotificationLineItem($id: Int!) {
  confirmExportNotificationLineItem(id: $id) {
    errors
    shipment {
      ...shipmentCommonFields
      portOfLoading {
        id
        name
        unLocode
      }
      shipmentLineItems {
        ...sliCommonFields
      }
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmExportNotificationLineItemGQL extends Apollo.Mutation<ConfirmExportNotificationLineItemMutation, ConfirmExportNotificationLineItemMutationVariables> {
    document = ConfirmExportNotificationLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteShipmentDocument = gql`
    mutation CompleteShipment($id: ID!) {
  completeShipment(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteShipmentGQL extends Apollo.Mutation<CompleteShipmentMutation, CompleteShipmentMutationVariables> {
    document = CompleteShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteShipmentLineItemDocument = gql`
    mutation CompleteShipmentLineItem($id: ID!) {
  completeShipmentLineItem(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteShipmentLineItemGQL extends Apollo.Mutation<CompleteShipmentLineItemMutation, CompleteShipmentLineItemMutationVariables> {
    document = CompleteShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitAddendumDocument = gql`
    mutation SubmitAddendum($id: Int!) {
  submitAddendum(id: $id) {
    errors
    validation
    addendumHeader {
      ...addendumHeaderFields
      addendumLineItems {
        ...addendumLineItemFields
      }
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitAddendumGQL extends Apollo.Mutation<SubmitAddendumMutation, SubmitAddendumMutationVariables> {
    document = SubmitAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueryAddendumDocument = gql`
    mutation QueryAddendum($id: Int!) {
  queryAddendum(id: $id) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryAddendumGQL extends Apollo.Mutation<QueryAddendumMutation, QueryAddendumMutationVariables> {
    document = QueryAddendumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocateSliContainerDocument = gql`
    mutation AllocateSliContainer($sliId: Int!, $sliContainerId: Int, $isBreakBulk: Boolean!) {
  allocateSliContainer(
    sliId: $sliId
    sliContainerId: $sliContainerId
    isBreakBulk: $isBreakBulk
  ) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocateSliContainerGQL extends Apollo.Mutation<AllocateSliContainerMutation, AllocateSliContainerMutationVariables> {
    document = AllocateSliContainerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteShipmentLineItemDocument = gql`
    mutation DeleteShipmentLineItem($id: Int!) {
  deleteShipmentLineItem(id: $id) {
    id
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteShipmentLineItemGQL extends Apollo.Mutation<DeleteShipmentLineItemMutation, DeleteShipmentLineItemMutationVariables> {
    document = DeleteShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAddendumLineItemDocument = gql`
    mutation DeleteAddendumLineItem($id: Int!) {
  deleteAddendumLineItem(id: $id) {
    addendumLineItems {
      ...addendumLineItemFields
    }
    errors
  }
}
    ${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAddendumLineItemGQL extends Apollo.Mutation<DeleteAddendumLineItemMutation, DeleteAddendumLineItemMutationVariables> {
    document = DeleteAddendumLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateAddendumLineItemDocument = gql`
    mutation DuplicateAddendumLineItem($id: Int!) {
  duplicateAddendumLineItem(id: $id) {
    addendumLineItems {
      ...addendumLineItemFields
    }
  }
}
    ${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateAddendumLineItemGQL extends Apollo.Mutation<DuplicateAddendumLineItemMutation, DuplicateAddendumLineItemMutationVariables> {
    document = DuplicateAddendumLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteExportDocumentDocument = gql`
    mutation DeleteExportDocument($id: Int!) {
  deleteExportDocument(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteExportDocumentGQL extends Apollo.Mutation<DeleteExportDocumentMutation, DeleteExportDocumentMutationVariables> {
    document = DeleteExportDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadExportDocumentDocument = gql`
    mutation UploadExportDocument($attributes: ShipmentLineItemAttributes!, $file: Upload!) {
  uploadExportDocument(attributes: $attributes, file: $file) {
    errors
    shipmentLineItem {
      exportDocuments {
        ...exportDocumentFields
      }
    }
  }
}
    ${ExportDocumentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadExportDocumentGQL extends Apollo.Mutation<UploadExportDocumentMutation, UploadExportDocumentMutationVariables> {
    document = UploadExportDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExportDocumentDocument = gql`
    mutation UpdateExportDocument($id: Int!, $type: String!) {
  updateExportDocument(id: $id, type: $type) {
    exportDocument {
      id
      documentType
      user {
        id
        firstName
        lastName
        company {
          id
        }
      }
      file {
        id
        filename
        v2Url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExportDocumentGQL extends Apollo.Mutation<UpdateExportDocumentMutation, UpdateExportDocumentMutationVariables> {
    document = UpdateExportDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemFilterAttributesDocument = gql`
    query ShipmentLineItemFilterAttributes {
  shipmentLineItemFilterAttributes {
    controllers
    shippingLineReferences
    clients
    vessels
    states
    stackDatesStatus
    shipmentTypes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemFilterAttributesGQL extends Apollo.Query<ShipmentLineItemFilterAttributesQuery, ShipmentLineItemFilterAttributesQueryVariables> {
    document = ShipmentLineItemFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbVoyageNumbersDocument = gql`
    query shipmentPpecbVoyageNumbers {
  ppecbVoyageNumbers {
    id
    voyageNumber
    vesselName
    ppecbVoyageNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbVoyageNumbersGQL extends Apollo.Query<ShipmentPpecbVoyageNumbersQuery, ShipmentPpecbVoyageNumbersQueryVariables> {
    document = ShipmentPpecbVoyageNumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbCountriesDocument = gql`
    query shipmentPpecbCountries {
  ppecbCountries {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbCountriesGQL extends Apollo.Query<ShipmentPpecbCountriesQuery, ShipmentPpecbCountriesQueryVariables> {
    document = ShipmentPpecbCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbActivityPointsDocument = gql`
    query shipmentPpecbActivityPoints {
  ppecbActivityPoints {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbActivityPointsGQL extends Apollo.Query<ShipmentPpecbActivityPointsQuery, ShipmentPpecbActivityPointsQueryVariables> {
    document = ShipmentPpecbActivityPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbWorldPortsDocument = gql`
    query shipmentPpecbWorldPorts {
  ppecbWorldPorts {
    id
    portCode
    portName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbWorldPortsGQL extends Apollo.Query<ShipmentPpecbWorldPortsQuery, ShipmentPpecbWorldPortsQueryVariables> {
    document = ShipmentPpecbWorldPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbContainerTypesDocument = gql`
    query shipmentPpecbContainerTypes {
  ppecbContainerTypes {
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbContainerTypesGQL extends Apollo.Query<ShipmentPpecbContainerTypesQuery, ShipmentPpecbContainerTypesQueryVariables> {
    document = ShipmentPpecbContainerTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbProductsDocument = gql`
    query shipmentPpecbProducts {
  ppecbProducts {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbProductsGQL extends Apollo.Query<ShipmentPpecbProductsQuery, ShipmentPpecbProductsQueryVariables> {
    document = ShipmentPpecbProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbVentsDocument = gql`
    query shipmentPpecbVents {
  ppecbVents {
    code
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbVentsGQL extends Apollo.Query<ShipmentPpecbVentsQuery, ShipmentPpecbVentsQueryVariables> {
    document = ShipmentPpecbVentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbRegimeCodesDocument = gql`
    query shipmentPpecbRegimeCodes {
  ppecbRegimeCodes {
    regimeCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbRegimeCodesGQL extends Apollo.Query<ShipmentPpecbRegimeCodesQuery, ShipmentPpecbRegimeCodesQueryVariables> {
    document = ShipmentPpecbRegimeCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentPpecbPortsDocument = gql`
    query shipmentPpecbPorts {
  ppecbPorts {
    id
    portCode
    portName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentPpecbPortsGQL extends Apollo.Query<ShipmentPpecbPortsQuery, ShipmentPpecbPortsQueryVariables> {
    document = ShipmentPpecbPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentTerminalsDocument = gql`
    query shipmentTerminals {
  terminals {
    id
    name
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentTerminalsGQL extends Apollo.Query<ShipmentTerminalsQuery, ShipmentTerminalsQueryVariables> {
    document = ShipmentTerminalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SliContainersDocument = gql`
    query sliContainers {
  sliContainers {
    id
    container {
      id
      containerNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SliContainersGQL extends Apollo.Query<SliContainersQuery, SliContainersQueryVariables> {
    document = SliContainersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SliBreakBulksDocument = gql`
    query sliBreakBulks {
  sliBreakBulks {
    id
    breakBulkContainer {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SliBreakBulksGQL extends Apollo.Query<SliBreakBulksQuery, SliBreakBulksQueryVariables> {
    document = SliBreakBulksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SeaShipmentControllersDocument = gql`
    query SeaShipmentControllers {
  seaShipmentControllers {
    id
    firstName
    lastName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SeaShipmentControllersGQL extends Apollo.Query<SeaShipmentControllersQuery, SeaShipmentControllersQueryVariables> {
    document = SeaShipmentControllersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllocateShipmentControllerDocument = gql`
    mutation AllocateShipmentController($shipmentId: Int!, $userId: Int) {
  allocateShipmentController(shipmentId: $shipmentId, userId: $userId) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocateShipmentControllerGQL extends Apollo.Mutation<AllocateShipmentControllerMutation, AllocateShipmentControllerMutationVariables> {
    document = AllocateShipmentControllerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentContainerDepotsDocument = gql`
    query shipmentContainerDepots($typeOfBusiness: Int!) {
  foodBusinessOperatorsByType(typeOfBusiness: $typeOfBusiness) {
    id
    name
    producerName
    fboCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentContainerDepotsGQL extends Apollo.Query<ShipmentContainerDepotsQuery, ShipmentContainerDepotsQueryVariables> {
    document = ShipmentContainerDepotsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumHeaderByIdDocument = gql`
    query addendumHeaderById($id: Int!) {
  addendumHeaderById(id: $id) {
    ...addendumHeaderFields
    addendumLineItems {
      ...addendumLineItemFields
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumHeaderByIdGQL extends Apollo.Query<AddendumHeaderByIdQuery, AddendumHeaderByIdQueryVariables> {
    document = AddendumHeaderByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumLineItemsByHeaderIdDocument = gql`
    query addendumLineItemsByHeaderId($addendumHeaderId: Int!) {
  addendumLineItemsByHeaderId(addendumHeaderId: $addendumHeaderId) {
    ...addendumLineItemFields
  }
}
    ${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumLineItemsByHeaderIdGQL extends Apollo.Query<AddendumLineItemsByHeaderIdQuery, AddendumLineItemsByHeaderIdQueryVariables> {
    document = AddendumLineItemsByHeaderIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddendumsOnShipmentDocument = gql`
    query addendumsOnShipment($shipmentId: Int!) {
  addendumsOnShipment(shipmentId: $shipmentId) {
    id
    shippingBookingReference
    verificationStatus
    state
    addendumStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddendumsOnShipmentGQL extends Apollo.Query<AddendumsOnShipmentQuery, AddendumsOnShipmentQueryVariables> {
    document = AddendumsOnShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NonAddendumShipmentLineItemsDocument = gql`
    query nonAddendumShipmentLineItems($shipmentId: Int!, $bookingRef: String) {
  nonAddendumShipmentLineItems(shipmentId: $shipmentId, bookingRef: $bookingRef) {
    id
    containerNumber
    breakBulkContainerNamesIn
    customerReference
    shippingLineReference
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NonAddendumShipmentLineItemsGQL extends Apollo.Query<NonAddendumShipmentLineItemsQuery, NonAddendumShipmentLineItemsQueryVariables> {
    document = NonAddendumShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SliContainersByBookingReferenceDocument = gql`
    query sliContainersByBookingReference($bookingReference: String!) {
  sliContainersByBookingReference(bookingReference: $bookingReference) {
    id
    container {
      containerNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SliContainersByBookingReferenceGQL extends Apollo.Query<SliContainersByBookingReferenceQuery, SliContainersByBookingReferenceQueryVariables> {
    document = SliContainersByBookingReferenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemsDocument = gql`
    query shipmentLineItems($filterAttributes: ShipmentLineItemFilterAttributes!, $searchAttributes: SearchAttributes!, $orderByFields: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  shipmentLineItems(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    nodes {
      ...indexShipmentLineItemFieldss
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${IndexShipmentLineItemFieldssFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemsGQL extends Apollo.Query<ShipmentLineItemsQuery, ShipmentLineItemsQueryVariables> {
    document = ShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemsByShipmentDocument = gql`
    query shipmentLineItemsByShipment($id: Int!) {
  shipmentLineItemsByShipment(id: $id) {
    ...sliCommonFields
    hasLoadOutInstruction
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemsByShipmentGQL extends Apollo.Query<ShipmentLineItemsByShipmentQuery, ShipmentLineItemsByShipmentQueryVariables> {
    document = ShipmentLineItemsByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemGroupingsByShipmentDocument = gql`
    query ShipmentLineItemGroupingsByShipment($id: ID!) {
  shipmentLineItemGroupingsByShipment(id: $id) {
    companyId
    id
    shipmentId
    sligFields
    totalCartons
    totalGrossWeight
    totalNettWeight
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemGroupingsByShipmentGQL extends Apollo.Query<ShipmentLineItemGroupingsByShipmentQuery, ShipmentLineItemGroupingsByShipmentQueryVariables> {
    document = ShipmentLineItemGroupingsByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemsBySligDocument = gql`
    query ShipmentLineItemsBySlig($id: ID!) {
  shipmentLineItemsBySlig(id: $id) {
    ...sliCommonFields
    sliContainer {
      id
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemsBySligGQL extends Apollo.Query<ShipmentLineItemsBySligQuery, ShipmentLineItemsBySligQueryVariables> {
    document = ShipmentLineItemsBySligDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReassignShipmentLineItemGroupingDocument = gql`
    mutation ReassignShipmentLineItemGrouping($id: ID!, $sligId: ID!) {
  reassignShipmentLineItemGrouping(id: $id, sligId: $sligId) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReassignShipmentLineItemGroupingGQL extends Apollo.Mutation<ReassignShipmentLineItemGroupingMutation, ReassignShipmentLineItemGroupingMutationVariables> {
    document = ReassignShipmentLineItemGroupingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentBookingReferencesDocument = gql`
    query shipmentBookingReferences($id: Int!) {
  shipmentBookingReferences(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentBookingReferencesGQL extends Apollo.Query<ShipmentBookingReferencesQuery, ShipmentBookingReferencesQueryVariables> {
    document = ShipmentBookingReferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbUserByUserIdDocument = gql`
    query ppecbUserByUserId($id: Int!) {
  ppecbUserByUserId(id: $id) {
    id
    agentFboCode
    ppecbRegisteredAgentCode
    ppecbExporters {
      id
      exporterFboCode
      ppecbRegisteredExporterCode
      company {
        name
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbUserByUserIdGQL extends Apollo.Query<PpecbUserByUserIdQuery, PpecbUserByUserIdQueryVariables> {
    document = PpecbUserByUserIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbExporterByShipmentDocument = gql`
    query ppecbExporterByShipment($id: ID!) {
  ppecbExporterByShipment(id: $id) {
    id
    exporterFboCode
    ppecbRegisteredExporterCode
    company {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbExporterByShipmentGQL extends Apollo.Query<PpecbExporterByShipmentQuery, PpecbExporterByShipmentQueryVariables> {
    document = PpecbExporterByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentShipmentClientsDocument = gql`
    query currentShipmentClients {
  currentShipmentClients
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentShipmentClientsGQL extends Apollo.Query<CurrentShipmentClientsQuery, CurrentShipmentClientsQueryVariables> {
    document = CurrentShipmentClientsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentShipmentControllersDocument = gql`
    query currentShipmentControllers {
  currentShipmentControllers
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentShipmentControllersGQL extends Apollo.Query<CurrentShipmentControllersQuery, CurrentShipmentControllersQueryVariables> {
    document = CurrentShipmentControllersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentTruckReferencesDocument = gql`
    query CurrentTruckReferences {
  currentTruckReferences
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentTruckReferencesGQL extends Apollo.Query<CurrentTruckReferencesQuery, CurrentTruckReferencesQueryVariables> {
    document = CurrentTruckReferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentTransportCompaniesDocument = gql`
    query CurrentTransportCompanies {
  currentTransportCompanies
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentTransportCompaniesGQL extends Apollo.Query<CurrentTransportCompaniesQuery, CurrentTransportCompaniesQueryVariables> {
    document = CurrentTransportCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbUserByShipmentDocument = gql`
    query ppecbUserByShipment($id: ID!) {
  ppecbUserByShipment(id: $id) {
    id
    agentFboCode
    ppecbRegisteredAgentCode
    ppecbExporters {
      id
      exporterFboCode
      ppecbRegisteredExporterCode
      company {
        name
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbUserByShipmentGQL extends Apollo.Query<PpecbUserByShipmentQuery, PpecbUserByShipmentQueryVariables> {
    document = PpecbUserByShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PpecbUsersDocument = gql`
    query ppecbUsers {
  ppecbUsers {
    id
    agentFboCode
    ppecbRegisteredAgentCode
    ppecbExporters {
      id
      exporterFboCode
      ppecbRegisteredExporterCode
      company {
        name
      }
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PpecbUsersGQL extends Apollo.Query<PpecbUsersQuery, PpecbUsersQueryVariables> {
    document = PpecbUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentDocument = gql`
    query shipment($id: Int!) {
  shipment(id: $id) {
    ...shipmentCommonFields
    portOfLoading {
      id
      name
      unLocode
    }
    terminal {
      id
      name
      code
    }
    shipmentLineItems {
      ...sliCommonFields
    }
    templateOutput {
      state
      ...templateOutputFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}
${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentGQL extends Apollo.Query<ShipmentQuery, ShipmentQueryVariables> {
    document = ShipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentLineItemDocument = gql`
    query shipmentLineItem($id: Int!) {
  shipmentLineItemById(id: $id) {
    ...sliCommonFields
    shipmentId
    shipment {
      id
      ppecbBookingReference
    }
  }
}
    ${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentLineItemGQL extends Apollo.Query<ShipmentLineItemQuery, ShipmentLineItemQueryVariables> {
    document = ShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentSeaPortsDocument = gql`
    query shipmentSeaPorts {
  seaPorts {
    id
    name
    country
    unLocode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentSeaPortsGQL extends Apollo.Query<ShipmentSeaPortsQuery, ShipmentSeaPortsQueryVariables> {
    document = ShipmentSeaPortsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnAddendumHeaderStateChangeDocument = gql`
    subscription onAddendumHeaderStateChange {
  onAddendumHeaderStateChange {
    ...addendumHeaderFields
    addendumLineItems {
      ...addendumLineItemFields
    }
  }
}
    ${AddendumHeaderFieldsFragmentDoc}
${AddendumLineItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnAddendumHeaderStateChangeGQL extends Apollo.Subscription<OnAddendumHeaderStateChangeSubscription, OnAddendumHeaderStateChangeSubscriptionVariables> {
    document = OnAddendumHeaderStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnShipmentStateChangeDocument = gql`
    subscription onShipmentStateChange {
  onShipmentStateChange {
    ...shipmentCommonFields
    shipmentLineItems {
      ...sliCommonFields
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnShipmentStateChangeGQL extends Apollo.Subscription<OnShipmentStateChangeSubscription, OnShipmentStateChangeSubscriptionVariables> {
    document = OnShipmentStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitShipmentExportNotificationDocument = gql`
    mutation submitShipmentExportNotification($id: ID!) {
  submitShipmentExportNotification(id: $id) {
    errors
    shipment {
      ...shipmentCommonFields
      shipmentLineItems {
        ...sliCommonFields
      }
    }
  }
}
    ${ShipmentCommonFieldsFragmentDoc}
${SliCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitShipmentExportNotificationGQL extends Apollo.Mutation<SubmitShipmentExportNotificationMutation, SubmitShipmentExportNotificationMutationVariables> {
    document = SubmitShipmentExportNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLoadOutInstructionsFromSlisDocument = gql`
    mutation updateLoadOutInstructionsFromSlis($sliIds: [ID!]!) {
  updateLoadOutInstructionsFromSlis(sliIds: $sliIds) {
    loadOutInstructions {
      id
      vessel {
        id
        vesselName
      }
      voyage
      shippingLine
      portOfLoading {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLoadOutInstructionsFromSlisGQL extends Apollo.Mutation<UpdateLoadOutInstructionsFromSlisMutation, UpdateLoadOutInstructionsFromSlisMutationVariables> {
    document = UpdateLoadOutInstructionsFromSlisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateShipmentExportNotificationOutputFilesDocument = gql`
    mutation generateShipmentExportNotificationOutputFiles($shipmentId: ID!) {
  generateShipmentExportNotificationOutputFiles(shipmentId: $shipmentId) {
    shipment {
      id
      templateOutput {
        state
        ...templateOutputFields
      }
    }
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateShipmentExportNotificationOutputFilesGQL extends Apollo.Mutation<GenerateShipmentExportNotificationOutputFilesMutation, GenerateShipmentExportNotificationOutputFilesMutationVariables> {
    document = GenerateShipmentExportNotificationOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificateTransportInstructionDocument = gql`
    query certificateTransportInstruction($id: Int!) {
  certificateTransportInstruction(id: $id) {
    id
    templateOutput {
      state
      ...templateOutputFields
    }
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificateTransportInstructionGQL extends Apollo.Query<CertificateTransportInstructionQuery, CertificateTransportInstructionQueryVariables> {
    document = CertificateTransportInstructionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertCertificateTransportInstructionDocument = gql`
    mutation upsertCertificateTransportInstruction($shipmentLineItemId: ID!) {
  upsertCertificateTransportInstruction(shipmentLineItemId: $shipmentLineItemId) {
    certificateTransportInstruction {
      id
      templateOutput {
        state
        ...templateOutputFields
      }
    }
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertCertificateTransportInstructionGQL extends Apollo.Mutation<UpsertCertificateTransportInstructionMutation, UpsertCertificateTransportInstructionMutationVariables> {
    document = UpsertCertificateTransportInstructionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentsToChooseFromDocument = gql`
    query ShipmentsToChooseFrom($shipmentId: Int!) {
  shipmentsToChooseFrom(shipmentId: $shipmentId) {
    id
    vesselName
    client
    voyageNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentsToChooseFromGQL extends Apollo.Query<ShipmentsToChooseFromQuery, ShipmentsToChooseFromQueryVariables> {
    document = ShipmentsToChooseFromDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShipmentsAndShipmentLineItemsDocument = gql`
    query shipmentsAndShipmentLineItems($filterAttributes: ShipmentLineItemFilterAttributes, $searchAttributes: SearchAttributes, $orderByFields: [ColumnOrderAttributes!], $shipmentId: Int, $first: Int, $last: Int, $after: String, $before: String) {
  shipmentsAndShipmentLineItems(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderByFields: $orderByFields
    shipmentId: $shipmentId
  ) {
    shipments {
      id
      vesselName
      voyageNumber
      client
      truckReference
    }
    shipmentLineItems(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        id
        vesselName
        voyageNumber
        truckReference
        consignmentReference
        portOfLoadingName
        portOfDischargeName
        stackDates
        stackDatesClose
        stackDatesOpenStatus
        stackDatesCloseStatus
        estimatedDispatchDate
        estimatedDeliveryDate
        bookingReference
        documentCount
        loadingPoint {
          name
        }
        offloadingPoint {
          name
        }
        checklist {
          emailSubject
          title
        }
        clientReference
        customerReference
        shippingLineReference
        containerNumber
        consignmentGroupName
        palletCount
        documentCount
        taskCompletion {
          complete
          inProgress
          notStarted
          total
        }
        state
        updatedAt
        portOfDestinationName
        portOfDestination {
          id
          name
          unLocode
        }
        estimatedTimeOfDeparture
        actualTimeOfDeparture
        estimatedTimeOfArrival
        actualTimeOfArrival
        shipment {
          id
          ppecbVoyageNumber
          vesselName
          voyageNumber
          client
          terminal {
            id
            name
            code
          }
          controller
          shipmentType
          portOfLoading {
            id
            name
            unLocode
          }
          stackDates
          stackDatesClose
          estimatedTimeOfDeparture
          actualTimeOfDeparture
          estimatedTimeOfArrival
          actualTimeOfArrival
          comments
          state
        }
        sliContainer {
          id
          container {
            containerNumber
          }
        }
        sliBreakBulk {
          id
          breakBulkContainer {
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShipmentsAndShipmentLineItemsGQL extends Apollo.Query<ShipmentsAndShipmentLineItemsQuery, ShipmentsAndShipmentLineItemsQueryVariables> {
    document = ShipmentsAndShipmentLineItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockAtLocationDocument = gql`
    query stockAtLocation($filterAttributes: StockFilterInputAttributes, $searchAttributes: SearchAttributes, $orderAttributes: [ColumnOrderAttributes!], $millerAttributes: MillerCollapsibleInLocationInput) {
  stockAtLocation(
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderAttributes: $orderAttributes
    millerAttributes: $millerAttributes
  ) {
    allLocations {
      locationType
      totalPallets
      name
      id
    }
    allVessels {
      name
      id
      totalPallets
      vesselEta
    }
    millerCollapsibleForLocation(millerColumnAttributes: $millerAttributes) {
      field
      value
      totalPallets
    }
    results {
      previousLocationName
      currentLocationName
      nextLocationName
      extendedFields
      commodityId
      batchNumber
      buyerId
      buyerName
      consignmentNumber
      subCommodityName
      varietyVarietyCode
      cartons
      commodityName
      documentStatus
      exporterCode
      extendedFields
      farmCode
      fileUpdates {
        changeDescription
        currentValue
        id
        oldValue
        viewedByIds
      }
      grade
      id
      inspectionDate
      consignmentNumber
      inventoryCode
      loadOutReference
      loadOutInstructionId
      mark
      netMass
      orchard
      pack
      packhouseCode
      packingWeek
      palletNumber
      palletAge
      palletGrossMass
      productCharacteristic
      sequenceNumber
      state
      status
      sizeCount
      sellerName
      targetMarket
      targetRegion
      targetCountry
      varietyName
      varietyId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockAtLocationGQL extends Apollo.Query<StockAtLocationQuery, StockAtLocationQueryVariables> {
    document = StockAtLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockFilterAttributesDocument = gql`
    query stockFilterAttributes {
  stockFilterAttributes {
    batchNumbers
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    documentStatuses
    exporterCodes
    grades
    inventoryCodes
    marks
    packTypes
    sellers {
      id
      name
    }
    sizeCounts
    states
    subCommodities {
      id
      name
    }
    targetMarkets
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockFilterAttributesGQL extends Apollo.Query<StockFilterAttributesQuery, StockFilterAttributesQueryVariables> {
    document = StockFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockErrorsDocument = gql`
    query stockErrors {
  stockErrors {
    errorMessage
    errorCount
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockErrorsGQL extends Apollo.Query<StockErrorsQuery, StockErrorsQueryVariables> {
    document = StockErrorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadedStockFilesDocument = gql`
    query uploadedStockFiles {
  uploadedStockFiles {
    documentId
    filename
    filesize
    filetype
    status
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadedStockFilesGQL extends Apollo.Query<UploadedStockFilesQuery, UploadedStockFilesQueryVariables> {
    document = UploadedStockFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadStockFileMutationDocument = gql`
    mutation UploadStockFileMutation($file: Upload!) {
  uploadStockFile(file: $file) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadStockFileMutationGQL extends Apollo.Mutation<UploadStockFileMutationMutation, UploadStockFileMutationMutationVariables> {
    document = UploadStockFileMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkAuditsAsViewedMutationDocument = gql`
    mutation MarkAuditsAsViewedMutation($auditIds: [ID!]!) {
  markAuditsAsViewed(auditIds: $auditIds) {
    errors
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkAuditsAsViewedMutationGQL extends Apollo.Mutation<MarkAuditsAsViewedMutationMutation, MarkAuditsAsViewedMutationMutationVariables> {
    document = MarkAuditsAsViewedMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StockOnVesselDocument = gql`
    query stockOnVessel($vesselId: Int, $filterAttributes: StockFilterInputAttributes, $searchAttributes: SearchAttributes, $orderAttributes: [ColumnOrderAttributes!], $first: Int, $last: Int, $after: String, $before: String) {
  stockOnVessel(
    vesselId: $vesselId
    filterAttributes: $filterAttributes
    searchAttributes: $searchAttributes
    orderAttributes: $orderAttributes
  ) {
    allVessels {
      name
      id
      totalPallets
      vesselEta
    }
    results(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        previousLocationName
        currentLocationName
        nextLocationName
        commodityId
        batchNumber
        buyerId
        buyerName
        consignmentNumber
        containerNumber
        subCommodityName
        loadOutReference
        varietyVarietyCode
        cartons
        commodityName
        exporterCode
        extendedFields
        farmCode
        grade
        id
        inspectionDate
        consignmentNumber
        inventoryCode
        mark
        netMass
        orchard
        pack
        packhouseCode
        packingWeek
        palletNumber
        palletAge
        palletGrossMass
        productCharacteristic
        sequenceNumber
        state
        status
        sizeCount
        sellerName
        targetMarket
        targetRegion
        targetCountry
        varietyName
        varietyId
        vesselId
        vesselName
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StockOnVesselGQL extends Apollo.Query<StockOnVesselQuery, StockOnVesselQueryVariables> {
    document = StockOnVesselDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShippedStockFilterAttributesDocument = gql`
    query shippedStockFilterAttributes {
  shippedStockFilterAttributes {
    batchNumbers
    buyers {
      id
      name
    }
    commodities {
      id
      name
    }
    exporterCodes
    grades
    inventoryCodes
    marks
    packTypes
    sellers {
      id
      name
    }
    sizeCounts
    states
    subCommodities {
      id
      name
    }
    targetMarkets
    varieties {
      id
      name
      varietyCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShippedStockFilterAttributesGQL extends Apollo.Query<ShippedStockFilterAttributesQuery, ShippedStockFilterAttributesQueryVariables> {
    document = ShippedStockFilterAttributesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TasksByShipmentLineItemDocument = gql`
    query TasksByShipmentLineItem($sliId: Int!) {
  tasksByShipmentLineItem(sliId: $sliId) {
    ...taskCommonFields
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TasksByShipmentLineItemGQL extends Apollo.Query<TasksByShipmentLineItemQuery, TasksByShipmentLineItemQueryVariables> {
    document = TasksByShipmentLineItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadTaskDocumentDocument = gql`
    mutation UploadTaskDocument($taskId: Int!, $file: Upload!, $uploadDate: ISO8601DateTime, $customDate: ISO8601DateTime) {
  uploadTaskDocument(
    taskId: $taskId
    file: $file
    uploadDate: $uploadDate
    customDate: $customDate
  ) {
    errors
    task {
      id
      customDate
      uploadedAt
      documentId
      file {
        filename
        v2Url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadTaskDocumentGQL extends Apollo.Mutation<UploadTaskDocumentMutation, UploadTaskDocumentMutationVariables> {
    document = UploadTaskDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTaskDocumentDocument = gql`
    mutation DeleteTaskDocument($id: ID!, $shipmentLineItemId: ID!) {
  deleteTaskDocument(id: $id, shipmentLineItemId: $shipmentLineItemId) {
    tasks {
      ...taskCommonFields
    }
    errors
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTaskDocumentGQL extends Apollo.Mutation<DeleteTaskDocumentMutation, DeleteTaskDocumentMutationVariables> {
    document = DeleteTaskDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTasksDatesDocument = gql`
    mutation UpdateTasksDates($updateValues: Json!) {
  updateTasksDates(updateValues: $updateValues) {
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTasksDatesGQL extends Apollo.Mutation<UpdateTasksDatesMutation, UpdateTasksDatesMutationVariables> {
    document = UpdateTasksDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomTaskDateDocument = gql`
    mutation UpdateCustomTaskDate($taskId: ID!, $customDate: ISO8601Date, $shipmentLineItemId: ID!) {
  updateCustomTaskDate(
    taskId: $taskId
    customDate: $customDate
    shipmentLineItemId: $shipmentLineItemId
  ) {
    tasks {
      ...taskCommonFields
    }
    errors
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomTaskDateGQL extends Apollo.Mutation<UpdateCustomTaskDateMutation, UpdateCustomTaskDateMutationVariables> {
    document = UpdateCustomTaskDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadTaskDocumentPerSliDocument = gql`
    mutation UploadTaskDocumentPerSli($taskId: ID!, $shipmentLineItemId: ID!, $file: Upload!, $selectedSliIds: [ID!]!) {
  uploadTaskDocumentPerSli(
    taskId: $taskId
    file: $file
    shipmentLineItemId: $shipmentLineItemId
    selectedSliIds: $selectedSliIds
  ) {
    tasks {
      ...taskCommonFields
    }
    errors
  }
}
    ${TaskCommonFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadTaskDocumentPerSliGQL extends Apollo.Mutation<UploadTaskDocumentPerSliMutation, UploadTaskDocumentPerSliMutationVariables> {
    document = UploadTaskDocumentPerSliDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnTemplateOutputStateChangeDocument = gql`
    subscription onTemplateOutputStateChange {
  onTemplateOutputStateChange {
    ...templateOutputFields
  }
}
    ${TemplateOutputFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OnTemplateOutputStateChangeGQL extends Apollo.Subscription<OnTemplateOutputStateChangeSubscription, OnTemplateOutputStateChangeSubscriptionVariables> {
    document = OnTemplateOutputStateChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateOutputFilesDocument = gql`
    query templateOutputFiles($templateOutputFilesId: Int!) {
  templateOutputFiles(id: $templateOutputFilesId) {
    outputFiles {
      contentType
      filename
      id
      url
      v2Url
    }
    errorReason
    id
    state
    templateDataSourceId
    templateDataSourceType
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateOutputFilesGQL extends Apollo.Query<TemplateOutputFilesQuery, TemplateOutputFilesQueryVariables> {
    document = TemplateOutputFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateOutputFilesBySourceDocument = gql`
    query templateOutputFilesBySource($dataSourceId: Int!, $dataSourceType: String!) {
  templateOutputFilesBySource(
    dataSourceId: $dataSourceId
    dataSourceType: $dataSourceType
  ) {
    outputFiles {
      contentType
      filename
      id
      url
      v2Url
    }
    errorReason
    id
    state
    templateDataSourceId
    templateDataSourceType
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateOutputFilesBySourceGQL extends Apollo.Query<TemplateOutputFilesBySourceQuery, TemplateOutputFilesBySourceQueryVariables> {
    document = TemplateOutputFilesBySourceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradePartnerDocument = gql`
    query TradePartner($id: ID!) {
  company(id: $id) {
    id
    name
    about
    isBuyer
    isSeller
    logoFile {
      id
      filename
      url
    }
    registrationNumber
    vatNumber
    createdAt
    address {
      addressLine1
      addressLine2
      city
      postalCode
      country
    }
    varieties {
      id
      varietyId
      name
      packingStart
      packingEnd
      peakCount
      hectares
      images {
        id
        url
        thumbnailUrl
      }
      commodity {
        id
        name
        icon {
          v2Url
        }
      }
    }
    certificates {
      id
      companyId
      expiryDate
      certificate {
        url
        filename
      }
      certificateType {
        name
        id
      }
    }
    tradeRegions {
      name
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TradePartnerGQL extends Apollo.Query<TradePartnerQuery, TradePartnerQueryVariables> {
    document = TradePartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TradePartnersDocument = gql`
    query TradePartners {
  myCompany {
    id
    isBuyer
    buyers {
      ...companyInformation
    }
    isSeller
    sellers {
      ...companyInformation
    }
  }
}
    ${CompanyInformationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TradePartnersGQL extends Apollo.Query<TradePartnersQuery, TradePartnersQueryVariables> {
    document = TradePartnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OneswitchBuyersDocument = gql`
    query OneswitchBuyers {
  oneswitchBuyers {
    id
    name
    companyLogoImageUrl
    tradeRegions {
      id
      name
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OneswitchBuyersGQL extends Apollo.Query<OneswitchBuyersQuery, OneswitchBuyersQueryVariables> {
    document = OneswitchBuyersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllTradeRegionsDocument = gql`
    query AllTradeRegions {
  tradeRegions {
    id
    name
    code
    countries {
      id
      code
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllTradeRegionsGQL extends Apollo.Query<AllTradeRegionsQuery, AllTradeRegionsQueryVariables> {
    document = AllTradeRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UiConfigsDocument = gql`
    query UiConfigs($visibility: UiConfigVisibilityEnum, $configType: String) {
  uiConfigs(visibility: $visibility, configType: $configType) {
    id
    configType
    visibility
    data
    readonly
  }
  myUser {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UiConfigsGQL extends Apollo.Query<UiConfigsQuery, UiConfigsQueryVariables> {
    document = UiConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UiConfigDocument = gql`
    query UiConfig($id: ID!) {
  uiConfig(id: $id) {
    id
    configType
    visibility
    data
    readonly
  }
  myUser {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UiConfigGQL extends Apollo.Query<UiConfigQuery, UiConfigQueryVariables> {
    document = UiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUiConfigDocument = gql`
    mutation CreateUiConfig($attributes: CreateUpdateUiConfigAttributes!) {
  createUiConfig(attributes: $attributes) {
    config {
      id
      configType
      visibility
      data
      readonly
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUiConfigGQL extends Apollo.Mutation<CreateUiConfigMutation, CreateUiConfigMutationVariables> {
    document = CreateUiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUiConfigDocument = gql`
    mutation DeleteUiConfig($deleteUiConfigId: Int!) {
  deleteUiConfig(id: $deleteUiConfigId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUiConfigGQL extends Apollo.Mutation<DeleteUiConfigMutation, DeleteUiConfigMutationVariables> {
    document = DeleteUiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUiConfigDocument = gql`
    mutation UpdateUiConfig($attributes: CreateUpdateUiConfigAttributes!) {
  updateUiConfig(attributes: $attributes) {
    config {
      id
      configType
      visibility
      data
      readonly
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUiConfigGQL extends Apollo.Mutation<UpdateUiConfigMutation, UpdateUiConfigMutationVariables> {
    document = UpdateUiConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFeedItemsConnectionDocument = gql`
    query UserFeedItemsConnection($last: Int, $after: String, $first: Int, $before: String) {
  userFeedConnection(last: $last, after: $after, first: $first, before: $before) {
    pageInfo {
      endCursor
      startCursor
      hasPreviousPage
      hasNextPage
    }
    edges {
      cursor
      node {
        ...userFeedItem
      }
    }
  }
}
    ${UserFeedItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFeedItemsConnectionGQL extends Apollo.Query<UserFeedItemsConnectionQuery, UserFeedItemsConnectionQueryVariables> {
    document = UserFeedItemsConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFeedUnseenCountDocument = gql`
    query UserFeedUnseenCount {
  userFeedUnseenCount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFeedUnseenCountGQL extends Apollo.Query<UserFeedUnseenCountQuery, UserFeedUnseenCountQueryVariables> {
    document = UserFeedUnseenCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserFeedItemDocument = gql`
    mutation UpdateUserFeedItem($attributes: UpdateUserFeedItemAttributes!) {
  updateUserFeedItem(attributes: $attributes) {
    userFeedItem {
      id
      seen
      read
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserFeedItemGQL extends Apollo.Mutation<UpdateUserFeedItemMutation, UpdateUserFeedItemMutationVariables> {
    document = UpdateUserFeedItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserFeedItemsDocument = gql`
    mutation UpdateUserFeedItems($attributes: [UpdateUserFeedItemAttributes!]!) {
  updateUserFeedItems(attributes: $attributes) {
    userFeedItems {
      id
      seen
      read
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserFeedItemsGQL extends Apollo.Mutation<UpdateUserFeedItemsMutation, UpdateUserFeedItemsMutationVariables> {
    document = UpdateUserFeedItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewUserFeedItemDocument = gql`
    subscription newUserFeedItem {
  newUserFeedItem {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewUserFeedItemGQL extends Apollo.Subscription<NewUserFeedItemSubscription, NewUserFeedItemSubscriptionVariables> {
    document = NewUserFeedItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDocument = gql`
    query User {
  myUser {
    id
    firstName
    lastName
    phoneNumber
    email
    state
    notifyEmail
    notifyBrowserPush
    pastEmailRecipients
    createdAt
    updatedAt
    useV2
    locale
    externalIdentifier
    avatarFile {
      id
      filename
      url
    }
    company {
      id
      name
    }
    role
    roles {
      name
    }
    permissions {
      landingPage
      permissions {
        key
        value
      }
    }
  }
  myCompany {
    id
    name
    defaultLocale
    certificates {
      id
      expiryDate
      createdAt
      updatedAt
      certificate {
        id
        filename
        url
      }
      certificateType {
        id
        name
      }
    }
    sellers {
      id
      name
    }
    isBuyer
    buyers {
      id
      name
    }
    isSeller
    state
    onboardingStep
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserGQL extends Apollo.Query<UserQuery, UserQueryVariables> {
    document = UserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($employeeid: Int!) {
  deleteEmployee(employeeId: $employeeid) {
    employeeId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmployeeGQL extends Apollo.Mutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables> {
    document = DeleteEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindOrCreateVesselDocument = gql`
    mutation FindOrCreateVessel($vesselName: String!) {
  findOrCreateVessel(vesselName: $vesselName) {
    vessel {
      id
      vesselName
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindOrCreateVesselGQL extends Apollo.Mutation<FindOrCreateVesselMutation, FindOrCreateVesselMutationVariables> {
    document = FindOrCreateVesselDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }